function fe(i) {
  "@babel/helpers - typeof";
  return fe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, fe(i);
}
var Qe = Uint8Array, tn = Uint16Array, sa = Uint32Array, so = new Qe([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), uo = new Qe([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), ls = new Qe([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), Nu = function(i, e) {
  for (var n = new tn(31), a = 0; a < 31; ++a)
    n[a] = e += 1 << i[a - 1];
  for (var u = new sa(n[30]), a = 1; a < 30; ++a)
    for (var o = n[a]; o < n[a + 1]; ++o)
      u[o] = o - n[a] << 5 | a;
  return [n, u];
}, xu = Nu(so, 2), Su = xu[0], hs = xu[1];
Su[28] = 258, hs[258] = 28;
var _u = Nu(uo, 0), Nc = _u[0], ru = _u[1], fs = new tn(32768);
for (var we = 0; we < 32768; ++we) {
  var Pr = (we & 43690) >>> 1 | (we & 21845) << 1;
  Pr = (Pr & 52428) >>> 2 | (Pr & 13107) << 2, Pr = (Pr & 61680) >>> 4 | (Pr & 3855) << 4, fs[we] = ((Pr & 65280) >>> 8 | (Pr & 255) << 8) >>> 1;
}
var Kn = function(i, e, n) {
  for (var a = i.length, u = 0, o = new tn(e); u < a; ++u)
    ++o[i[u] - 1];
  var l = new tn(e);
  for (u = 0; u < e; ++u)
    l[u] = l[u - 1] + o[u - 1] << 1;
  var h;
  if (n) {
    h = new tn(1 << e);
    var f = 15 - e;
    for (u = 0; u < a; ++u)
      if (i[u])
        for (var g = u << 4 | i[u], b = e - i[u], N = l[i[u] - 1]++ << b, S = N | (1 << b) - 1; N <= S; ++N)
          h[fs[N] >>> f] = g;
  } else
    for (h = new tn(a), u = 0; u < a; ++u)
      h[u] = fs[l[i[u] - 1]++] >>> 15 - i[u];
  return h;
}, Ir = new Qe(288);
for (var we = 0; we < 144; ++we)
  Ir[we] = 8;
for (var we = 144; we < 256; ++we)
  Ir[we] = 9;
for (var we = 256; we < 280; ++we)
  Ir[we] = 7;
for (var we = 280; we < 288; ++we)
  Ir[we] = 8;
var ua = new Qe(32);
for (var we = 0; we < 32; ++we)
  ua[we] = 5;
var xc = /* @__PURE__ */ Kn(Ir, 9, 0), Sc = /* @__PURE__ */ Kn(Ir, 9, 1), _c = /* @__PURE__ */ Kn(ua, 5, 0), Pc = /* @__PURE__ */ Kn(ua, 5, 1), es = function(i) {
  for (var e = i[0], n = 1; n < i.length; ++n)
    i[n] > e && (e = i[n]);
  return e;
}, Bn = function(i, e, n) {
  var a = e / 8 >> 0;
  return (i[a] | i[a + 1] << 8) >>> (e & 7) & n;
}, ns = function(i, e) {
  var n = e / 8 >> 0;
  return (i[n] | i[n + 1] << 8 | i[n + 2] << 16) >>> (e & 7);
}, As = function(i) {
  return (i / 8 >> 0) + (i & 7 && 1);
}, Pu = function(i, e, n) {
  (e == null || e < 0) && (e = 0), (n == null || n > i.length) && (n = i.length);
  var a = new (i instanceof tn ? tn : i instanceof sa ? sa : Qe)(n - e);
  return a.set(i.subarray(e, n)), a;
}, kc = function(i, e, n) {
  var a = i.length, u = !e || n, o = !n || n.i;
  n || (n = {}), e || (e = new Qe(a * 3));
  var l = function(Y) {
    var Q = e.length;
    if (Y > Q) {
      var et = new Qe(Math.max(Q * 2, Y));
      et.set(e), e = et;
    }
  }, h = n.f || 0, f = n.p || 0, g = n.b || 0, b = n.l, N = n.d, S = n.m, d = n.n, O = a * 8;
  do {
    if (!b) {
      n.f = h = Bn(i, f, 1);
      var I = Bn(i, f + 1, 3);
      if (f += 3, I)
        if (I == 1)
          b = Sc, N = Pc, S = 9, d = 5;
        else if (I == 2) {
          var X = Bn(i, f, 31) + 257, ot = Bn(i, f + 10, 15) + 4, ct = X + Bn(i, f + 5, 31) + 1;
          f += 14;
          for (var yt = new Qe(ct), tt = new Qe(19), R = 0; R < ot; ++R)
            tt[ls[R]] = Bn(i, f + R * 3, 7);
          f += ot * 3;
          var gt = es(tt), pt = (1 << gt) - 1;
          if (!o && f + ct * (gt + 7) > O)
            break;
          for (var F = Kn(tt, gt, 1), R = 0; R < ct; ) {
            var P = F[Bn(i, f, pt)];
            f += P & 15;
            var q = P >>> 4;
            if (q < 16)
              yt[R++] = q;
            else {
              var z = 0, D = 0;
              for (q == 16 ? (D = 3 + Bn(i, f, 3), f += 2, z = yt[R - 1]) : q == 17 ? (D = 3 + Bn(i, f, 7), f += 3) : q == 18 && (D = 11 + Bn(i, f, 127), f += 7); D--; )
                yt[R++] = z;
            }
          }
          var at = yt.subarray(0, X), nt = yt.subarray(X);
          S = es(at), d = es(nt), b = Kn(at, S, 1), N = Kn(nt, d, 1);
        } else
          throw "invalid block type";
      else {
        var q = As(f) + 4, _ = i[q - 4] | i[q - 3] << 8, M = q + _;
        if (M > a) {
          if (o)
            throw "unexpected EOF";
          break;
        }
        u && l(g + _), e.set(i.subarray(q, M), g), n.b = g += _, n.p = f = M * 8;
        continue;
      }
      if (f > O)
        throw "unexpected EOF";
    }
    u && l(g + 131072);
    for (var lt = (1 << S) - 1, $ = (1 << d) - 1, ft = S + d + 18; o || f + ft < O; ) {
      var z = b[ns(i, f) & lt], ht = z >>> 4;
      if (f += z & 15, f > O)
        throw "unexpected EOF";
      if (!z)
        throw "invalid length/literal";
      if (ht < 256)
        e[g++] = ht;
      else if (ht == 256) {
        b = null;
        break;
      } else {
        var kt = ht - 254;
        if (ht > 264) {
          var R = ht - 257, A = so[R];
          kt = Bn(i, f, (1 << A) - 1) + Su[R], f += A;
        }
        var j = N[ns(i, f) & $], B = j >>> 4;
        if (!j)
          throw "invalid distance";
        f += j & 15;
        var nt = Nc[B];
        if (B > 3) {
          var A = uo[B];
          nt += ns(i, f) & (1 << A) - 1, f += A;
        }
        if (f > O)
          throw "unexpected EOF";
        u && l(g + 131072);
        for (var W = g + kt; g < W; g += 4)
          e[g] = e[g - nt], e[g + 1] = e[g + 1 - nt], e[g + 2] = e[g + 2 - nt], e[g + 3] = e[g + 3 - nt];
        g = W;
      }
    }
    n.l = b, n.p = f, n.b = g, b && (h = 1, n.m = S, n.d = N, n.n = d);
  } while (!h);
  return g == e.length ? e : Pu(e, 0, g);
}, lr = function(i, e, n) {
  n <<= e & 7;
  var a = e / 8 >> 0;
  i[a] |= n, i[a + 1] |= n >>> 8;
}, ia = function(i, e, n) {
  n <<= e & 7;
  var a = e / 8 >> 0;
  i[a] |= n, i[a + 1] |= n >>> 8, i[a + 2] |= n >>> 16;
}, rs = function(i, e) {
  for (var n = [], a = 0; a < i.length; ++a)
    i[a] && n.push({ s: a, f: i[a] });
  var u = n.length, o = n.slice();
  if (!u)
    return [new Qe(0), 0];
  if (u == 1) {
    var l = new Qe(n[0].s + 1);
    return l[n[0].s] = 1, [l, 1];
  }
  n.sort(function(ct, yt) {
    return ct.f - yt.f;
  }), n.push({ s: -1, f: 25001 });
  var h = n[0], f = n[1], g = 0, b = 1, N = 2;
  for (n[0] = { s: -1, f: h.f + f.f, l: h, r: f }; b != u - 1; )
    h = n[n[g].f < n[N].f ? g++ : N++], f = n[g != b && n[g].f < n[N].f ? g++ : N++], n[b++] = { s: -1, f: h.f + f.f, l: h, r: f };
  for (var S = o[0].s, a = 1; a < u; ++a)
    o[a].s > S && (S = o[a].s);
  var d = new tn(S + 1), O = ps(n[b - 1], d, 0);
  if (O > e) {
    var a = 0, I = 0, q = O - e, _ = 1 << q;
    for (o.sort(function(yt, tt) {
      return d[tt.s] - d[yt.s] || yt.f - tt.f;
    }); a < u; ++a) {
      var M = o[a].s;
      if (d[M] > e)
        I += _ - (1 << O - d[M]), d[M] = e;
      else
        break;
    }
    for (I >>>= q; I > 0; ) {
      var X = o[a].s;
      d[X] < e ? I -= 1 << e - d[X]++ - 1 : ++a;
    }
    for (; a >= 0 && I; --a) {
      var ot = o[a].s;
      d[ot] == e && (--d[ot], ++I);
    }
    O = e;
  }
  return [new Qe(d), O];
}, ps = function(i, e, n) {
  return i.s == -1 ? Math.max(ps(i.l, e, n + 1), ps(i.r, e, n + 1)) : e[i.s] = n;
}, iu = function(i) {
  for (var e = i.length; e && !i[--e]; )
    ;
  for (var n = new tn(++e), a = 0, u = i[0], o = 1, l = function(f) {
    n[a++] = f;
  }, h = 1; h <= e; ++h)
    if (i[h] == u && h != e)
      ++o;
    else {
      if (!u && o > 2) {
        for (; o > 138; o -= 138)
          l(32754);
        o > 2 && (l(o > 10 ? o - 11 << 5 | 28690 : o - 3 << 5 | 12305), o = 0);
      } else if (o > 3) {
        for (l(u), --o; o > 6; o -= 6)
          l(8304);
        o > 2 && (l(o - 3 << 5 | 8208), o = 0);
      }
      for (; o--; )
        l(u);
      o = 1, u = i[h];
    }
  return [n.subarray(0, a), e];
}, aa = function(i, e) {
  for (var n = 0, a = 0; a < e.length; ++a)
    n += i[a] * e[a];
  return n;
}, to = function(i, e, n) {
  var a = n.length, u = As(e + 2);
  i[u] = a & 255, i[u + 1] = a >>> 8, i[u + 2] = i[u] ^ 255, i[u + 3] = i[u + 1] ^ 255;
  for (var o = 0; o < a; ++o)
    i[u + o + 4] = n[o];
  return (u + 4 + a) * 8;
}, au = function(i, e, n, a, u, o, l, h, f, g, b) {
  lr(e, b++, n), ++u[256];
  for (var N = rs(u, 15), S = N[0], d = N[1], O = rs(o, 15), I = O[0], q = O[1], _ = iu(S), M = _[0], X = _[1], ot = iu(I), ct = ot[0], yt = ot[1], tt = new tn(19), R = 0; R < M.length; ++R)
    tt[M[R] & 31]++;
  for (var R = 0; R < ct.length; ++R)
    tt[ct[R] & 31]++;
  for (var gt = rs(tt, 7), pt = gt[0], F = gt[1], P = 19; P > 4 && !pt[ls[P - 1]]; --P)
    ;
  var z = g + 5 << 3, D = aa(u, Ir) + aa(o, ua) + l, at = aa(u, S) + aa(o, I) + l + 14 + 3 * P + aa(tt, pt) + (2 * tt[16] + 3 * tt[17] + 7 * tt[18]);
  if (z <= D && z <= at)
    return to(e, b, i.subarray(f, f + g));
  var nt, lt, $, ft;
  if (lr(e, b, 1 + (at < D)), b += 2, at < D) {
    nt = Kn(S, d, 0), lt = S, $ = Kn(I, q, 0), ft = I;
    var ht = Kn(pt, F, 0);
    lr(e, b, X - 257), lr(e, b + 5, yt - 1), lr(e, b + 10, P - 4), b += 14;
    for (var R = 0; R < P; ++R)
      lr(e, b + 3 * R, pt[ls[R]]);
    b += 3 * P;
    for (var kt = [M, ct], A = 0; A < 2; ++A)
      for (var j = kt[A], R = 0; R < j.length; ++R) {
        var B = j[R] & 31;
        lr(e, b, ht[B]), b += pt[B], B > 15 && (lr(e, b, j[R] >>> 5 & 127), b += j[R] >>> 12);
      }
  } else
    nt = xc, lt = Ir, $ = _c, ft = ua;
  for (var R = 0; R < h; ++R)
    if (a[R] > 255) {
      var B = a[R] >>> 18 & 31;
      ia(e, b, nt[B + 257]), b += lt[B + 257], B > 7 && (lr(e, b, a[R] >>> 23 & 31), b += so[B]);
      var W = a[R] & 31;
      ia(e, b, $[W]), b += ft[W], W > 3 && (ia(e, b, a[R] >>> 5 & 8191), b += uo[W]);
    } else
      ia(e, b, nt[a[R]]), b += lt[a[R]];
  return ia(e, b, nt[256]), b + lt[256];
}, Fc = /* @__PURE__ */ new sa([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), Ic = /* @__PURE__ */ new Qe(0), Cc = function(i, e, n, a, u, o) {
  var l = i.length, h = new Qe(a + l + 5 * (1 + Math.floor(l / 7e3)) + u), f = h.subarray(a, h.length - u), g = 0;
  if (!e || l < 8)
    for (var b = 0; b <= l; b += 65535) {
      var N = b + 65535;
      N < l ? g = to(f, g, i.subarray(b, N)) : (f[b] = o, g = to(f, g, i.subarray(b, l)));
    }
  else {
    for (var S = Fc[e - 1], d = S >>> 13, O = S & 8191, I = (1 << n) - 1, q = new tn(32768), _ = new tn(I + 1), M = Math.ceil(n / 3), X = 2 * M, ot = function(Ut) {
      return (i[Ut] ^ i[Ut + 1] << M ^ i[Ut + 2] << X) & I;
    }, ct = new sa(25e3), yt = new tn(288), tt = new tn(32), R = 0, gt = 0, b = 0, pt = 0, F = 0, P = 0; b < l; ++b) {
      var z = ot(b), D = b & 32767, at = _[z];
      if (q[D] = at, _[z] = D, F <= b) {
        var nt = l - b;
        if ((R > 7e3 || pt > 24576) && nt > 423) {
          g = au(i, f, 0, ct, yt, tt, gt, pt, P, b - P, g), pt = R = gt = 0, P = b;
          for (var lt = 0; lt < 286; ++lt)
            yt[lt] = 0;
          for (var lt = 0; lt < 30; ++lt)
            tt[lt] = 0;
        }
        var $ = 2, ft = 0, ht = O, kt = D - at & 32767;
        if (nt > 2 && z == ot(b - kt))
          for (var A = Math.min(d, nt) - 1, j = Math.min(32767, b), B = Math.min(258, nt); kt <= j && --ht && D != at; ) {
            if (i[b + $] == i[b + $ - kt]) {
              for (var W = 0; W < B && i[b + W] == i[b + W - kt]; ++W)
                ;
              if (W > $) {
                if ($ = W, ft = kt, W > A)
                  break;
                for (var Y = Math.min(kt, W - 2), Q = 0, lt = 0; lt < Y; ++lt) {
                  var et = b - kt + lt + 32768 & 32767, rt = q[et], Nt = et - rt + 32768 & 32767;
                  Nt > Q && (Q = Nt, at = et);
                }
              }
            }
            D = at, at = q[D], kt += D - at + 32768 & 32767;
          }
        if (ft) {
          ct[pt++] = 268435456 | hs[$] << 18 | ru[ft];
          var Lt = hs[$] & 31, Ct = ru[ft] & 31;
          gt += so[Lt] + uo[Ct], ++yt[257 + Lt], ++tt[Ct], F = b + $, ++R;
        } else
          ct[pt++] = i[b], ++yt[i[b]];
      }
    }
    g = au(i, f, o, ct, yt, tt, gt, pt, P, b - P, g), o || (g = to(f, g, Ic));
  }
  return Pu(h, 0, a + As(g) + u);
};
var jc = function() {
  var i = 1, e = 0;
  return {
    p: function(n) {
      for (var a = i, u = e, o = n.length, l = 0; l != o; ) {
        for (var h = Math.min(l + 5552, o); l < h; ++l)
          a += n[l], u += a;
        a %= 65521, u %= 65521;
      }
      i = a, e = u;
    },
    d: function() {
      return (i >>> 8 << 16 | (e & 255) << 8 | e >>> 8) + ((i & 255) << 23) * 2;
    }
  };
}, Oc = function(i, e, n, a, u) {
  return Cc(i, e.level == null ? 6 : e.level, e.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(i.length))) * 1.5) : 12 + e.mem, n, a, !u);
};
var Mc = function(i, e, n) {
  for (; n; ++e)
    i[e] = n, n >>>= 8;
};
var Bc = function(i, e) {
  var n = e.level, a = n == 0 ? 0 : n < 6 ? 1 : n == 9 ? 3 : 2;
  i[0] = 120, i[1] = a << 6 | (a ? 32 - 2 * a : 1);
}, Ec = function(i) {
  if ((i[0] & 15) != 8 || i[0] >>> 4 > 7 || (i[0] << 8 | i[1]) % 31)
    throw "invalid zlib data";
  if (i[1] & 32)
    throw "invalid zlib data: preset dictionaries not supported";
};
function ds(i, e) {
  e === void 0 && (e = {});
  var n = jc();
  n.p(i);
  var a = Oc(i, e, 2, 4);
  return Bc(a, e), Mc(a, a.length - 4, n.d()), a;
}
function qc(i, e) {
  return kc((Ec(i), i.subarray(2, -4)), e);
}
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.5.1 Built on 2022-01-28T15:37:57.791Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */
var Ht = /* @__PURE__ */ function() {
  return typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : this;
}();
function is() {
  Ht.console && typeof Ht.console.log == "function" && Ht.console.log.apply(Ht.console, arguments);
}
var ve = { log: is, warn: function(i) {
  Ht.console && (typeof Ht.console.warn == "function" ? Ht.console.warn.apply(Ht.console, arguments) : is.call(null, arguments));
}, error: function(i) {
  Ht.console && (typeof Ht.console.error == "function" ? Ht.console.error.apply(Ht.console, arguments) : is(i));
} };
function as(i, e, n) {
  var a = new XMLHttpRequest();
  a.open("GET", i), a.responseType = "blob", a.onload = function() {
    Ur(a.response, e, n);
  }, a.onerror = function() {
    ve.error("could not download file");
  }, a.send();
}
function ou(i) {
  var e = new XMLHttpRequest();
  e.open("HEAD", i, !1);
  try {
    e.send();
  } catch {
  }
  return e.status >= 200 && e.status <= 299;
}
function Ka(i) {
  try {
    i.dispatchEvent(new MouseEvent("click"));
  } catch {
    var e = document.createEvent("MouseEvents");
    e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), i.dispatchEvent(e);
  }
}
var oa, gs, Ur = Ht.saveAs || ((typeof window > "u" ? "undefined" : fe(window)) !== "object" || window !== Ht ? function() {
} : typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype ? function(i, e, n) {
  var a = Ht.URL || Ht.webkitURL, u = document.createElement("a");
  e = e || i.name || "download", u.download = e, u.rel = "noopener", typeof i == "string" ? (u.href = i, u.origin !== location.origin ? ou(u.href) ? as(i, e, n) : Ka(u, u.target = "_blank") : Ka(u)) : (u.href = a.createObjectURL(i), setTimeout(function() {
    a.revokeObjectURL(u.href);
  }, 4e4), setTimeout(function() {
    Ka(u);
  }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(i, e, n) {
  if (e = e || i.name || "download", typeof i == "string")
    if (ou(i))
      as(i, e, n);
    else {
      var a = document.createElement("a");
      a.href = i, a.target = "_blank", setTimeout(function() {
        Ka(a);
      });
    }
  else
    navigator.msSaveOrOpenBlob(function(u, o) {
      return o === void 0 ? o = { autoBom: !1 } : fe(o) !== "object" && (ve.warn("Deprecated: Expected third argument to be a object"), o = { autoBom: !o }), o.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(u.type) ? new Blob(["\uFEFF", u], { type: u.type }) : u;
    }(i, n), e);
} : function(i, e, n, a) {
  if ((a = a || open("", "_blank")) && (a.document.title = a.document.body.innerText = "downloading..."), typeof i == "string")
    return as(i, e, n);
  var u = i.type === "application/octet-stream", o = /constructor/i.test(Ht.HTMLElement) || Ht.safari, l = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((l || u && o) && (typeof FileReader > "u" ? "undefined" : fe(FileReader)) === "object") {
    var h = new FileReader();
    h.onloadend = function() {
      var b = h.result;
      b = l ? b : b.replace(/^data:[^;]*;/, "data:attachment/file;"), a ? a.location.href = b : location = b, a = null;
    }, h.readAsDataURL(i);
  } else {
    var f = Ht.URL || Ht.webkitURL, g = f.createObjectURL(i);
    a ? a.location = g : location.href = g, a = null, setTimeout(function() {
      f.revokeObjectURL(g);
    }, 4e4);
  }
});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */
function ku(i) {
  var e;
  i = i || "", this.ok = !1, i.charAt(0) == "#" && (i = i.substr(1, 6)), i = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dodgerblue: "1e90ff", feldspar: "d19275", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslateblue: "8470ff", lightslategray: "778899", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32", linen: "faf0e6", magenta: "ff00ff", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", red: "ff0000", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", violetred: "d02090", wheat: "f5deb3", white: "ffffff", whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32" }[i = (i = i.replace(/ /g, "")).toLowerCase()] || i;
  for (var n = [{ re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/, example: ["rgb(123, 234, 45)", "rgb(255,234,245)"], process: function(h) {
    return [parseInt(h[1]), parseInt(h[2]), parseInt(h[3])];
  } }, { re: /^(\w{2})(\w{2})(\w{2})$/, example: ["#00ff00", "336699"], process: function(h) {
    return [parseInt(h[1], 16), parseInt(h[2], 16), parseInt(h[3], 16)];
  } }, { re: /^(\w{1})(\w{1})(\w{1})$/, example: ["#fb0", "f0f"], process: function(h) {
    return [parseInt(h[1] + h[1], 16), parseInt(h[2] + h[2], 16), parseInt(h[3] + h[3], 16)];
  } }], a = 0; a < n.length; a++) {
    var u = n[a].re, o = n[a].process, l = u.exec(i);
    l && (e = o(l), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
  }
  this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
    return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
  }, this.toHex = function() {
    var h = this.r.toString(16), f = this.g.toString(16), g = this.b.toString(16);
    return h.length == 1 && (h = "0" + h), f.length == 1 && (f = "0" + f), g.length == 1 && (g = "0" + g), "#" + h + f + g;
  };
}
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */
function os(i, e) {
  var n = i[0], a = i[1], u = i[2], o = i[3];
  n = Je(n, a, u, o, e[0], 7, -680876936), o = Je(o, n, a, u, e[1], 12, -389564586), u = Je(u, o, n, a, e[2], 17, 606105819), a = Je(a, u, o, n, e[3], 22, -1044525330), n = Je(n, a, u, o, e[4], 7, -176418897), o = Je(o, n, a, u, e[5], 12, 1200080426), u = Je(u, o, n, a, e[6], 17, -1473231341), a = Je(a, u, o, n, e[7], 22, -45705983), n = Je(n, a, u, o, e[8], 7, 1770035416), o = Je(o, n, a, u, e[9], 12, -1958414417), u = Je(u, o, n, a, e[10], 17, -42063), a = Je(a, u, o, n, e[11], 22, -1990404162), n = Je(n, a, u, o, e[12], 7, 1804603682), o = Je(o, n, a, u, e[13], 12, -40341101), u = Je(u, o, n, a, e[14], 17, -1502002290), n = Xe(n, a = Je(a, u, o, n, e[15], 22, 1236535329), u, o, e[1], 5, -165796510), o = Xe(o, n, a, u, e[6], 9, -1069501632), u = Xe(u, o, n, a, e[11], 14, 643717713), a = Xe(a, u, o, n, e[0], 20, -373897302), n = Xe(n, a, u, o, e[5], 5, -701558691), o = Xe(o, n, a, u, e[10], 9, 38016083), u = Xe(u, o, n, a, e[15], 14, -660478335), a = Xe(a, u, o, n, e[4], 20, -405537848), n = Xe(n, a, u, o, e[9], 5, 568446438), o = Xe(o, n, a, u, e[14], 9, -1019803690), u = Xe(u, o, n, a, e[3], 14, -187363961), a = Xe(a, u, o, n, e[8], 20, 1163531501), n = Xe(n, a, u, o, e[13], 5, -1444681467), o = Xe(o, n, a, u, e[2], 9, -51403784), u = Xe(u, o, n, a, e[7], 14, 1735328473), n = Ke(n, a = Xe(a, u, o, n, e[12], 20, -1926607734), u, o, e[5], 4, -378558), o = Ke(o, n, a, u, e[8], 11, -2022574463), u = Ke(u, o, n, a, e[11], 16, 1839030562), a = Ke(a, u, o, n, e[14], 23, -35309556), n = Ke(n, a, u, o, e[1], 4, -1530992060), o = Ke(o, n, a, u, e[4], 11, 1272893353), u = Ke(u, o, n, a, e[7], 16, -155497632), a = Ke(a, u, o, n, e[10], 23, -1094730640), n = Ke(n, a, u, o, e[13], 4, 681279174), o = Ke(o, n, a, u, e[0], 11, -358537222), u = Ke(u, o, n, a, e[3], 16, -722521979), a = Ke(a, u, o, n, e[6], 23, 76029189), n = Ke(n, a, u, o, e[9], 4, -640364487), o = Ke(o, n, a, u, e[12], 11, -421815835), u = Ke(u, o, n, a, e[15], 16, 530742520), n = Ze(n, a = Ke(a, u, o, n, e[2], 23, -995338651), u, o, e[0], 6, -198630844), o = Ze(o, n, a, u, e[7], 10, 1126891415), u = Ze(u, o, n, a, e[14], 15, -1416354905), a = Ze(a, u, o, n, e[5], 21, -57434055), n = Ze(n, a, u, o, e[12], 6, 1700485571), o = Ze(o, n, a, u, e[3], 10, -1894986606), u = Ze(u, o, n, a, e[10], 15, -1051523), a = Ze(a, u, o, n, e[1], 21, -2054922799), n = Ze(n, a, u, o, e[8], 6, 1873313359), o = Ze(o, n, a, u, e[15], 10, -30611744), u = Ze(u, o, n, a, e[6], 15, -1560198380), a = Ze(a, u, o, n, e[13], 21, 1309151649), n = Ze(n, a, u, o, e[4], 6, -145523070), o = Ze(o, n, a, u, e[11], 10, -1120210379), u = Ze(u, o, n, a, e[2], 15, 718787259), a = Ze(a, u, o, n, e[9], 21, -343485551), i[0] = Fr(n, i[0]), i[1] = Fr(a, i[1]), i[2] = Fr(u, i[2]), i[3] = Fr(o, i[3]);
}
function co(i, e, n, a, u, o) {
  return e = Fr(Fr(e, i), Fr(a, o)), Fr(e << u | e >>> 32 - u, n);
}
function Je(i, e, n, a, u, o, l) {
  return co(e & n | ~e & a, i, e, u, o, l);
}
function Xe(i, e, n, a, u, o, l) {
  return co(e & a | n & ~a, i, e, u, o, l);
}
function Ke(i, e, n, a, u, o, l) {
  return co(e ^ n ^ a, i, e, u, o, l);
}
function Ze(i, e, n, a, u, o, l) {
  return co(n ^ (e | ~a), i, e, u, o, l);
}
function Fu(i) {
  var e, n = i.length, a = [1732584193, -271733879, -1732584194, 271733878];
  for (e = 64; e <= i.length; e += 64)
    os(a, Dc(i.substring(e - 64, e)));
  i = i.substring(e - 64);
  var u = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  for (e = 0; e < i.length; e++)
    u[e >> 2] |= i.charCodeAt(e) << (e % 4 << 3);
  if (u[e >> 2] |= 128 << (e % 4 << 3), e > 55)
    for (os(a, u), e = 0; e < 16; e++)
      u[e] = 0;
  return u[14] = 8 * n, os(a, u), a;
}
function Dc(i) {
  var e, n = [];
  for (e = 0; e < 64; e += 4)
    n[e >> 2] = i.charCodeAt(e) + (i.charCodeAt(e + 1) << 8) + (i.charCodeAt(e + 2) << 16) + (i.charCodeAt(e + 3) << 24);
  return n;
}
oa = Ht.atob.bind(Ht), gs = Ht.btoa.bind(Ht);
var su = "0123456789abcdef".split("");
function Rc(i) {
  for (var e = "", n = 0; n < 4; n++)
    e += su[i >> 8 * n + 4 & 15] + su[i >> 8 * n & 15];
  return e;
}
function Tc(i) {
  return String.fromCharCode((255 & i) >> 0, (65280 & i) >> 8, (16711680 & i) >> 16, (4278190080 & i) >> 24);
}
function ms(i) {
  return Fu(i).map(Tc).join("");
}
var zc = function(i) {
  for (var e = 0; e < i.length; e++)
    i[e] = Rc(i[e]);
  return i.join("");
}(Fu("hello")) != "5d41402abc4b2a76b9719d911017c592";
function Fr(i, e) {
  if (zc) {
    var n = (65535 & i) + (65535 & e);
    return (i >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
  }
  return i + e & 4294967295;
}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */
function vs(i, e) {
  var n, a, u, o;
  if (i !== n) {
    for (var l = (u = i, o = 1 + (256 / i.length >> 0), new Array(o + 1).join(u)), h = [], f = 0; f < 256; f++)
      h[f] = f;
    var g = 0;
    for (f = 0; f < 256; f++) {
      var b = h[f];
      g = (g + b + l.charCodeAt(f)) % 256, h[f] = h[g], h[g] = b;
    }
    n = i, a = h;
  } else
    h = a;
  var N = e.length, S = 0, d = 0, O = "";
  for (f = 0; f < N; f++)
    d = (d + (b = h[S = (S + 1) % 256])) % 256, h[S] = h[d], h[d] = b, l = h[(h[S] + h[d]) % 256], O += String.fromCharCode(e.charCodeAt(f) ^ l);
  return O;
}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */
var uu = { print: 4, modify: 8, copy: 16, "annot-forms": 32 };
function Li(i, e, n, a) {
  this.v = 1, this.r = 2;
  var u = 192;
  i.forEach(function(h) {
    if (uu.perm !== void 0)
      throw new Error("Invalid permission: " + h);
    u += uu[h];
  }), this.padding = "(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";
  var o = (e + this.padding).substr(0, 32), l = (n + this.padding).substr(0, 32);
  this.O = this.processOwnerPassword(o, l), this.P = -(1 + (255 ^ u)), this.encryptionKey = ms(o + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(a)).substr(0, 5), this.U = vs(this.encryptionKey, this.padding);
}
function Ni(i) {
  if (/[^\u0000-\u00ff]/.test(i))
    throw new Error("Invalid PDF Name Object: " + i + ", Only accept ASCII characters.");
  for (var e = "", n = i.length, a = 0; a < n; a++) {
    var u = i.charCodeAt(a);
    u < 33 || u === 35 || u === 37 || u === 40 || u === 41 || u === 47 || u === 60 || u === 62 || u === 91 || u === 93 || u === 123 || u === 125 || u > 126 ? e += "#" + ("0" + u.toString(16)).slice(-2) : e += i[a];
  }
  return e;
}
function cu(i) {
  if (fe(i) !== "object")
    throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
  var e = {};
  this.subscribe = function(n, a, u) {
    if (u = u || !1, typeof n != "string" || typeof a != "function" || typeof u != "boolean")
      throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
    e.hasOwnProperty(n) || (e[n] = {});
    var o = Math.random().toString(35);
    return e[n][o] = [a, !!u], o;
  }, this.unsubscribe = function(n) {
    for (var a in e)
      if (e[a][n])
        return delete e[a][n], Object.keys(e[a]).length === 0 && delete e[a], !0;
    return !1;
  }, this.publish = function(n) {
    if (e.hasOwnProperty(n)) {
      var a = Array.prototype.slice.call(arguments, 1), u = [];
      for (var o in e[n]) {
        var l = e[n][o];
        try {
          l[0].apply(i, a);
        } catch (h) {
          Ht.console && ve.error("jsPDF PubSub Error", h.message, h);
        }
        l[1] && u.push(o);
      }
      u.length && u.forEach(this.unsubscribe);
    }
  }, this.getTopics = function() {
    return e;
  };
}
function ao(i) {
  if (!(this instanceof ao))
    return new ao(i);
  var e = "opacity,stroke-opacity".split(",");
  for (var n in i)
    i.hasOwnProperty(n) && e.indexOf(n) >= 0 && (this[n] = i[n]);
  this.id = "", this.objectNumber = -1;
}
function Iu(i, e) {
  this.gState = i, this.matrix = e, this.id = "", this.objectNumber = -1;
}
function Hr(i, e, n, a, u) {
  if (!(this instanceof Hr))
    return new Hr(i, e, n, a, u);
  this.type = i === "axial" ? 2 : 3, this.coords = e, this.colors = n, Iu.call(this, a, u);
}
function xi(i, e, n, a, u) {
  if (!(this instanceof xi))
    return new xi(i, e, n, a, u);
  this.boundingBox = i, this.xStep = e, this.yStep = n, this.stream = "", this.cloneIndex = 0, Iu.call(this, a, u);
}
function zt(i) {
  var e, n = typeof arguments[0] == "string" ? arguments[0] : "p", a = arguments[1], u = arguments[2], o = arguments[3], l = [], h = 1, f = 16, g = "S", b = null;
  fe(i = i || {}) === "object" && (n = i.orientation, a = i.unit || a, u = i.format || u, o = i.compress || i.compressPdf || o, (b = i.encryption || null) !== null && (b.userPassword = b.userPassword || "", b.ownerPassword = b.ownerPassword || "", b.userPermissions = b.userPermissions || []), h = typeof i.userUnit == "number" ? Math.abs(i.userUnit) : 1, i.precision !== void 0 && (e = i.precision), i.floatPrecision !== void 0 && (f = i.floatPrecision), g = i.defaultPathOperation || "S"), l = i.filters || (o === !0 ? ["FlateEncode"] : l), a = a || "mm", n = ("" + (n || "P")).toLowerCase();
  var N = i.putOnlyUsedFonts || !1, S = {}, d = { internal: {}, __private__: {} };
  d.__private__.PubSub = cu;
  var O = "1.3", I = d.__private__.getPdfVersion = function() {
    return O;
  };
  d.__private__.setPdfVersion = function(s) {
    O = s;
  };
  var q = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
  d.__private__.getPageFormats = function() {
    return q;
  };
  var _ = d.__private__.getPageFormat = function(s) {
    return q[s];
  };
  u = u || "a4";
  var M = { COMPAT: "compat", ADVANCED: "advanced" }, X = M.COMPAT;
  function ot() {
    this.saveGraphicsState(), E(new Tt(It, 0, 0, -It, 0, dr() * It).toString() + " cm"), this.setFontSize(this.getFontSize() / It), g = "n", X = M.ADVANCED;
  }
  function ct() {
    this.restoreGraphicsState(), g = "S", X = M.COMPAT;
  }
  var yt = d.__private__.combineFontStyleAndFontWeight = function(s, v) {
    if (s == "bold" && v == "normal" || s == "bold" && v == 400 || s == "normal" && v == "italic" || s == "bold" && v == "italic")
      throw new Error("Invalid Combination of fontweight and fontstyle");
    return v && (s = v == 400 || v === "normal" ? s === "italic" ? "italic" : "normal" : v != 700 && v !== "bold" || s !== "normal" ? (v == 700 ? "bold" : v) + "" + s : "bold"), s;
  };
  d.advancedAPI = function(s) {
    var v = X === M.COMPAT;
    return v && ot.call(this), typeof s != "function" || (s(this), v && ct.call(this)), this;
  }, d.compatAPI = function(s) {
    var v = X === M.ADVANCED;
    return v && ct.call(this), typeof s != "function" || (s(this), v && ot.call(this)), this;
  }, d.isAdvancedAPI = function() {
    return X === M.ADVANCED;
  };
  var tt, R = function(s) {
    if (X !== M.ADVANCED)
      throw new Error(s + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
  }, gt = d.roundToPrecision = d.__private__.roundToPrecision = function(s, v) {
    var C = e || v;
    if (isNaN(s) || isNaN(C))
      throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
    return s.toFixed(C).replace(/0+$/, "");
  };
  tt = d.hpf = d.__private__.hpf = typeof f == "number" ? function(s) {
    if (isNaN(s))
      throw new Error("Invalid argument passed to jsPDF.hpf");
    return gt(s, f);
  } : f === "smart" ? function(s) {
    if (isNaN(s))
      throw new Error("Invalid argument passed to jsPDF.hpf");
    return gt(s, s > -1 && s < 1 ? 16 : 5);
  } : function(s) {
    if (isNaN(s))
      throw new Error("Invalid argument passed to jsPDF.hpf");
    return gt(s, 16);
  };
  var pt = d.f2 = d.__private__.f2 = function(s) {
    if (isNaN(s))
      throw new Error("Invalid argument passed to jsPDF.f2");
    return gt(s, 2);
  }, F = d.__private__.f3 = function(s) {
    if (isNaN(s))
      throw new Error("Invalid argument passed to jsPDF.f3");
    return gt(s, 3);
  }, P = d.scale = d.__private__.scale = function(s) {
    if (isNaN(s))
      throw new Error("Invalid argument passed to jsPDF.scale");
    return X === M.COMPAT ? s * It : X === M.ADVANCED ? s : void 0;
  }, z = function(s) {
    return X === M.COMPAT ? dr() - s : X === M.ADVANCED ? s : void 0;
  }, D = function(s) {
    return P(z(s));
  };
  d.__private__.setPrecision = d.setPrecision = function(s) {
    typeof parseInt(s, 10) == "number" && (e = parseInt(s, 10));
  };
  var at, nt = "00000000000000000000000000000000", lt = d.__private__.getFileId = function() {
    return nt;
  }, $ = d.__private__.setFileId = function(s) {
    return nt = s !== void 0 && /^[a-fA-F0-9]{32}$/.test(s) ? s.toUpperCase() : nt.split("").map(function() {
      return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
    }).join(""), b !== null && (Ge = new Li(b.userPermissions, b.userPassword, b.ownerPassword, nt)), nt;
  };
  d.setFileId = function(s) {
    return $(s), this;
  }, d.getFileId = function() {
    return lt();
  };
  var ft = d.__private__.convertDateToPDFDate = function(s) {
    var v = s.getTimezoneOffset(), C = v < 0 ? "+" : "-", T = Math.floor(Math.abs(v / 60)), J = Math.abs(v % 60), st = [C, B(T), "'", B(J), "'"].join("");
    return ["D:", s.getFullYear(), B(s.getMonth() + 1), B(s.getDate()), B(s.getHours()), B(s.getMinutes()), B(s.getSeconds()), st].join("");
  }, ht = d.__private__.convertPDFDateToDate = function(s) {
    var v = parseInt(s.substr(2, 4), 10), C = parseInt(s.substr(6, 2), 10) - 1, T = parseInt(s.substr(8, 2), 10), J = parseInt(s.substr(10, 2), 10), st = parseInt(s.substr(12, 2), 10), wt = parseInt(s.substr(14, 2), 10);
    return new Date(v, C, T, J, st, wt, 0);
  }, kt = d.__private__.setCreationDate = function(s) {
    var v;
    if (s === void 0 && (s = /* @__PURE__ */ new Date()), s instanceof Date)
      v = ft(s);
    else {
      if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(s))
        throw new Error("Invalid argument passed to jsPDF.setCreationDate");
      v = s;
    }
    return at = v;
  }, A = d.__private__.getCreationDate = function(s) {
    var v = at;
    return s === "jsDate" && (v = ht(at)), v;
  };
  d.setCreationDate = function(s) {
    return kt(s), this;
  }, d.getCreationDate = function(s) {
    return A(s);
  };
  var j, B = d.__private__.padd2 = function(s) {
    return ("0" + parseInt(s)).slice(-2);
  }, W = d.__private__.padd2Hex = function(s) {
    return ("00" + (s = s.toString())).substr(s.length);
  }, Y = 0, Q = [], et = [], rt = 0, Nt = [], Lt = [], Ct = !1, Mt = et, Ut = function() {
    Y = 0, rt = 0, et = [], Q = [], Nt = [], Qn = Oe(), Nn = Oe();
  };
  d.__private__.setCustomOutputDestination = function(s) {
    Ct = !0, Mt = s;
  };
  var ut = function(s) {
    Ct || (Mt = s);
  };
  d.__private__.resetCustomOutputDestination = function() {
    Ct = !1, Mt = et;
  };
  var E = d.__private__.out = function(s) {
    return s = s.toString(), rt += s.length + 1, Mt.push(s), Mt;
  }, Xt = d.__private__.write = function(s) {
    return E(arguments.length === 1 ? s.toString() : Array.prototype.join.call(arguments, " "));
  }, Et = d.__private__.getArrayBuffer = function(s) {
    for (var v = s.length, C = new ArrayBuffer(v), T = new Uint8Array(C); v--; )
      T[v] = s.charCodeAt(v);
    return C;
  }, At = [["Helvetica", "helvetica", "normal", "WinAnsiEncoding"], ["Helvetica-Bold", "helvetica", "bold", "WinAnsiEncoding"], ["Helvetica-Oblique", "helvetica", "italic", "WinAnsiEncoding"], ["Helvetica-BoldOblique", "helvetica", "bolditalic", "WinAnsiEncoding"], ["Courier", "courier", "normal", "WinAnsiEncoding"], ["Courier-Bold", "courier", "bold", "WinAnsiEncoding"], ["Courier-Oblique", "courier", "italic", "WinAnsiEncoding"], ["Courier-BoldOblique", "courier", "bolditalic", "WinAnsiEncoding"], ["Times-Roman", "times", "normal", "WinAnsiEncoding"], ["Times-Bold", "times", "bold", "WinAnsiEncoding"], ["Times-Italic", "times", "italic", "WinAnsiEncoding"], ["Times-BoldItalic", "times", "bolditalic", "WinAnsiEncoding"], ["ZapfDingbats", "zapfdingbats", "normal", null], ["Symbol", "symbol", "normal", null]];
  d.__private__.getStandardFonts = function() {
    return At;
  };
  var xt = i.fontSize || 16;
  d.__private__.setFontSize = d.setFontSize = function(s) {
    return xt = X === M.ADVANCED ? s / It : s, this;
  };
  var Ft, Pt = d.__private__.getFontSize = d.getFontSize = function() {
    return X === M.COMPAT ? xt : xt * It;
  }, qt = i.R2L || !1;
  d.__private__.setR2L = d.setR2L = function(s) {
    return qt = s, this;
  }, d.__private__.getR2L = d.getR2L = function() {
    return qt;
  };
  var Gt, $t = d.__private__.setZoomMode = function(s) {
    var v = [void 0, null, "fullwidth", "fullheight", "fullpage", "original"];
    if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(s))
      Ft = s;
    else if (isNaN(s)) {
      if (v.indexOf(s) === -1)
        throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + s + '" is not recognized.');
      Ft = s;
    } else
      Ft = parseInt(s, 10);
  };
  d.__private__.getZoomMode = function() {
    return Ft;
  };
  var te, ie = d.__private__.setPageMode = function(s) {
    if ([void 0, null, "UseNone", "UseOutlines", "UseThumbs", "FullScreen"].indexOf(s) == -1)
      throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + s + '" is not recognized.');
    Gt = s;
  };
  d.__private__.getPageMode = function() {
    return Gt;
  };
  var pe = d.__private__.setLayoutMode = function(s) {
    if ([void 0, null, "continuous", "single", "twoleft", "tworight", "two"].indexOf(s) == -1)
      throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + s + '" is not recognized.');
    te = s;
  };
  d.__private__.getLayoutMode = function() {
    return te;
  }, d.__private__.setDisplayMode = d.setDisplayMode = function(s, v, C) {
    return $t(s), pe(v), ie(C), this;
  };
  var Wt = { title: "", subject: "", author: "", keywords: "", creator: "" };
  d.__private__.getDocumentProperty = function(s) {
    if (Object.keys(Wt).indexOf(s) === -1)
      throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
    return Wt[s];
  }, d.__private__.getDocumentProperties = function() {
    return Wt;
  }, d.__private__.setDocumentProperties = d.setProperties = d.setDocumentProperties = function(s) {
    for (var v in Wt)
      Wt.hasOwnProperty(v) && s[v] && (Wt[v] = s[v]);
    return this;
  }, d.__private__.setDocumentProperty = function(s, v) {
    if (Object.keys(Wt).indexOf(s) === -1)
      throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
    return Wt[s] = v;
  };
  var ee, It, Ve, oe, wn, ge = {}, Ae = {}, Rn = [], ue = {}, jr = {}, Ne = {}, An = {}, $n = null, xe = 0, Yt = [], ce = new cu(d), Or = i.hotfixes || [], He = {}, Tn = {}, zn = [], Tt = function s(v, C, T, J, st, wt) {
    if (!(this instanceof s))
      return new s(v, C, T, J, st, wt);
    isNaN(v) && (v = 1), isNaN(C) && (C = 0), isNaN(T) && (T = 0), isNaN(J) && (J = 1), isNaN(st) && (st = 0), isNaN(wt) && (wt = 0), this._matrix = [v, C, T, J, st, wt];
  };
  Object.defineProperty(Tt.prototype, "sx", { get: function() {
    return this._matrix[0];
  }, set: function(s) {
    this._matrix[0] = s;
  } }), Object.defineProperty(Tt.prototype, "shy", { get: function() {
    return this._matrix[1];
  }, set: function(s) {
    this._matrix[1] = s;
  } }), Object.defineProperty(Tt.prototype, "shx", { get: function() {
    return this._matrix[2];
  }, set: function(s) {
    this._matrix[2] = s;
  } }), Object.defineProperty(Tt.prototype, "sy", { get: function() {
    return this._matrix[3];
  }, set: function(s) {
    this._matrix[3] = s;
  } }), Object.defineProperty(Tt.prototype, "tx", { get: function() {
    return this._matrix[4];
  }, set: function(s) {
    this._matrix[4] = s;
  } }), Object.defineProperty(Tt.prototype, "ty", { get: function() {
    return this._matrix[5];
  }, set: function(s) {
    this._matrix[5] = s;
  } }), Object.defineProperty(Tt.prototype, "a", { get: function() {
    return this._matrix[0];
  }, set: function(s) {
    this._matrix[0] = s;
  } }), Object.defineProperty(Tt.prototype, "b", { get: function() {
    return this._matrix[1];
  }, set: function(s) {
    this._matrix[1] = s;
  } }), Object.defineProperty(Tt.prototype, "c", { get: function() {
    return this._matrix[2];
  }, set: function(s) {
    this._matrix[2] = s;
  } }), Object.defineProperty(Tt.prototype, "d", { get: function() {
    return this._matrix[3];
  }, set: function(s) {
    this._matrix[3] = s;
  } }), Object.defineProperty(Tt.prototype, "e", { get: function() {
    return this._matrix[4];
  }, set: function(s) {
    this._matrix[4] = s;
  } }), Object.defineProperty(Tt.prototype, "f", { get: function() {
    return this._matrix[5];
  }, set: function(s) {
    this._matrix[5] = s;
  } }), Object.defineProperty(Tt.prototype, "rotation", { get: function() {
    return Math.atan2(this.shx, this.sx);
  } }), Object.defineProperty(Tt.prototype, "scaleX", { get: function() {
    return this.decompose().scale.sx;
  } }), Object.defineProperty(Tt.prototype, "scaleY", { get: function() {
    return this.decompose().scale.sy;
  } }), Object.defineProperty(Tt.prototype, "isIdentity", { get: function() {
    return this.sx === 1 && this.shy === 0 && this.shx === 0 && this.sy === 1 && this.tx === 0 && this.ty === 0;
  } }), Tt.prototype.join = function(s) {
    return [this.sx, this.shy, this.shx, this.sy, this.tx, this.ty].map(tt).join(s);
  }, Tt.prototype.multiply = function(s) {
    var v = s.sx * this.sx + s.shy * this.shx, C = s.sx * this.shy + s.shy * this.sy, T = s.shx * this.sx + s.sy * this.shx, J = s.shx * this.shy + s.sy * this.sy, st = s.tx * this.sx + s.ty * this.shx + this.tx, wt = s.tx * this.shy + s.ty * this.sy + this.ty;
    return new Tt(v, C, T, J, st, wt);
  }, Tt.prototype.decompose = function() {
    var s = this.sx, v = this.shy, C = this.shx, T = this.sy, J = this.tx, st = this.ty, wt = Math.sqrt(s * s + v * v), jt = (s /= wt) * C + (v /= wt) * T;
    C -= s * jt, T -= v * jt;
    var Dt = Math.sqrt(C * C + T * T);
    return jt /= Dt, s * (T /= Dt) < v * (C /= Dt) && (s = -s, v = -v, jt = -jt, wt = -wt), { scale: new Tt(wt, 0, 0, Dt, 0, 0), translate: new Tt(1, 0, 0, 1, J, st), rotate: new Tt(s, v, -v, s, 0, 0), skew: new Tt(1, 0, jt, 1, 0, 0) };
  }, Tt.prototype.toString = function(s) {
    return this.join(" ");
  }, Tt.prototype.inversed = function() {
    var s = this.sx, v = this.shy, C = this.shx, T = this.sy, J = this.tx, st = this.ty, wt = 1 / (s * T - v * C), jt = T * wt, Dt = -v * wt, Kt = -C * wt, Qt = s * wt;
    return new Tt(jt, Dt, Kt, Qt, -jt * J - Kt * st, -Dt * J - Qt * st);
  }, Tt.prototype.applyToPoint = function(s) {
    var v = s.x * this.sx + s.y * this.shx + this.tx, C = s.x * this.shy + s.y * this.sy + this.ty;
    return new ai(v, C);
  }, Tt.prototype.applyToRectangle = function(s) {
    var v = this.applyToPoint(s), C = this.applyToPoint(new ai(s.x + s.w, s.y + s.h));
    return new Ri(v.x, v.y, C.x - v.x, C.y - v.y);
  }, Tt.prototype.clone = function() {
    var s = this.sx, v = this.shy, C = this.shx, T = this.sy, J = this.tx, st = this.ty;
    return new Tt(s, v, C, T, J, st);
  }, d.Matrix = Tt;
  var Ln = d.matrixMult = function(s, v) {
    return v.multiply(s);
  }, Un = new Tt(1, 0, 0, 1, 0, 0);
  d.unitMatrix = d.identityMatrix = Un;
  var en = function(s, v) {
    if (!jr[s]) {
      var C = (v instanceof Hr ? "Sh" : "P") + (Object.keys(ue).length + 1).toString(10);
      v.id = C, jr[s] = C, ue[C] = v, ce.publish("addPattern", v);
    }
  };
  d.ShadingPattern = Hr, d.TilingPattern = xi, d.addShadingPattern = function(s, v) {
    return R("addShadingPattern()"), en(s, v), this;
  }, d.beginTilingPattern = function(s) {
    R("beginTilingPattern()"), Pa(s.boundingBox[0], s.boundingBox[1], s.boundingBox[2] - s.boundingBox[0], s.boundingBox[3] - s.boundingBox[1], s.matrix);
  }, d.endTilingPattern = function(s, v) {
    R("endTilingPattern()"), v.stream = Lt[j].join(`
`), en(s, v), ce.publish("endTilingPattern", v), zn.pop().restore();
  };
  var qe = d.__private__.newObject = function() {
    var s = Oe();
    return cn(s, !0), s;
  }, Oe = d.__private__.newObjectDeferred = function() {
    return Y++, Q[Y] = function() {
      return rt;
    }, Y;
  }, cn = function(s, v) {
    return v = typeof v == "boolean" && v, Q[s] = rt, v && E(s + " 0 obj"), s;
  }, Gr = d.__private__.newAdditionalObject = function() {
    var s = { objId: Oe(), content: "" };
    return Nt.push(s), s;
  }, Qn = Oe(), Nn = Oe(), xn = d.__private__.decodeColorString = function(s) {
    var v = s.split(" ");
    if (v.length !== 2 || v[1] !== "g" && v[1] !== "G")
      v.length === 5 && (v[4] === "k" || v[4] === "K") && (v = [(1 - v[0]) * (1 - v[3]), (1 - v[1]) * (1 - v[3]), (1 - v[2]) * (1 - v[3]), "r"]);
    else {
      var C = parseFloat(v[0]);
      v = [C, C, C, "r"];
    }
    for (var T = "#", J = 0; J < 3; J++)
      T += ("0" + Math.floor(255 * parseFloat(v[J])).toString(16)).slice(-2);
    return T;
  }, Sn = d.__private__.encodeColorString = function(s) {
    var v;
    typeof s == "string" && (s = { ch1: s });
    var C = s.ch1, T = s.ch2, J = s.ch3, st = s.ch4, wt = s.pdfColorType === "draw" ? ["G", "RG", "K"] : ["g", "rg", "k"];
    if (typeof C == "string" && C.charAt(0) !== "#") {
      var jt = new ku(C);
      if (jt.ok)
        C = jt.toHex();
      else if (!/^\d*\.?\d*$/.test(C))
        throw new Error('Invalid color "' + C + '" passed to jsPDF.encodeColorString.');
    }
    if (typeof C == "string" && /^#[0-9A-Fa-f]{3}$/.test(C) && (C = "#" + C[1] + C[1] + C[2] + C[2] + C[3] + C[3]), typeof C == "string" && /^#[0-9A-Fa-f]{6}$/.test(C)) {
      var Dt = parseInt(C.substr(1), 16);
      C = Dt >> 16 & 255, T = Dt >> 8 & 255, J = 255 & Dt;
    }
    if (T === void 0 || st === void 0 && C === T && T === J)
      if (typeof C == "string")
        v = C + " " + wt[0];
      else
        switch (s.precision) {
          case 2:
            v = pt(C / 255) + " " + wt[0];
            break;
          case 3:
          default:
            v = F(C / 255) + " " + wt[0];
        }
    else if (st === void 0 || fe(st) === "object") {
      if (st && !isNaN(st.a) && st.a === 0)
        return v = ["1.", "1.", "1.", wt[1]].join(" ");
      if (typeof C == "string")
        v = [C, T, J, wt[1]].join(" ");
      else
        switch (s.precision) {
          case 2:
            v = [pt(C / 255), pt(T / 255), pt(J / 255), wt[1]].join(" ");
            break;
          default:
          case 3:
            v = [F(C / 255), F(T / 255), F(J / 255), wt[1]].join(" ");
        }
    } else if (typeof C == "string")
      v = [C, T, J, st, wt[2]].join(" ");
    else
      switch (s.precision) {
        case 2:
          v = [pt(C), pt(T), pt(J), pt(st), wt[2]].join(" ");
          break;
        case 3:
        default:
          v = [F(C), F(T), F(J), F(st), wt[2]].join(" ");
      }
    return v;
  }, Hn = d.__private__.getFilters = function() {
    return l;
  }, dn = d.__private__.putStream = function(s) {
    var v = (s = s || {}).data || "", C = s.filters || Hn(), T = s.alreadyAppliedFilters || [], J = s.addLength1 || !1, st = v.length, wt = s.objectId, jt = function(Ye) {
      return Ye;
    };
    if (b !== null && wt === void 0)
      throw new Error("ObjectId must be passed to putStream for file encryption");
    b !== null && (jt = Ge.encryptor(wt, 0));
    var Dt = {};
    C === !0 && (C = ["FlateEncode"]);
    var Kt = s.additionalKeyValues || [], Qt = (Dt = zt.API.processDataByFilters !== void 0 ? zt.API.processDataByFilters(v, C) : { data: v, reverseChain: [] }).reverseChain + (Array.isArray(T) ? T.join(" ") : T.toString());
    if (Dt.data.length !== 0 && (Kt.push({ key: "Length", value: Dt.data.length }), J === !0 && Kt.push({ key: "Length1", value: st })), Qt.length != 0)
      if (Qt.split("/").length - 1 == 1)
        Kt.push({ key: "Filter", value: Qt });
      else {
        Kt.push({ key: "Filter", value: "[" + Qt + "]" });
        for (var re = 0; re < Kt.length; re += 1)
          if (Kt[re].key === "DecodeParms") {
            for (var Le = [], Se = 0; Se < Dt.reverseChain.split("/").length - 1; Se += 1)
              Le.push("null");
            Le.push(Kt[re].value), Kt[re].value = "[" + Le.join(" ") + "]";
          }
      }
    E("<<");
    for (var Me = 0; Me < Kt.length; Me++)
      E("/" + Kt[Me].key + " " + Kt[Me].value);
    E(">>"), Dt.data.length !== 0 && (E("stream"), E(jt(Dt.data)), E("endstream"));
  }, Wn = d.__private__.putPage = function(s) {
    var v = s.number, C = s.data, T = s.objId, J = s.contentsObjId;
    cn(T, !0), E("<</Type /Page"), E("/Parent " + s.rootDictionaryObjId + " 0 R"), E("/Resources " + s.resourceDictionaryObjId + " 0 R"), E("/MediaBox [" + parseFloat(tt(s.mediaBox.bottomLeftX)) + " " + parseFloat(tt(s.mediaBox.bottomLeftY)) + " " + tt(s.mediaBox.topRightX) + " " + tt(s.mediaBox.topRightY) + "]"), s.cropBox !== null && E("/CropBox [" + tt(s.cropBox.bottomLeftX) + " " + tt(s.cropBox.bottomLeftY) + " " + tt(s.cropBox.topRightX) + " " + tt(s.cropBox.topRightY) + "]"), s.bleedBox !== null && E("/BleedBox [" + tt(s.bleedBox.bottomLeftX) + " " + tt(s.bleedBox.bottomLeftY) + " " + tt(s.bleedBox.topRightX) + " " + tt(s.bleedBox.topRightY) + "]"), s.trimBox !== null && E("/TrimBox [" + tt(s.trimBox.bottomLeftX) + " " + tt(s.trimBox.bottomLeftY) + " " + tt(s.trimBox.topRightX) + " " + tt(s.trimBox.topRightY) + "]"), s.artBox !== null && E("/ArtBox [" + tt(s.artBox.bottomLeftX) + " " + tt(s.artBox.bottomLeftY) + " " + tt(s.artBox.topRightX) + " " + tt(s.artBox.topRightY) + "]"), typeof s.userUnit == "number" && s.userUnit !== 1 && E("/UserUnit " + s.userUnit), ce.publish("putPage", { objId: T, pageContext: Yt[v], pageNumber: v, page: C }), E("/Contents " + J + " 0 R"), E(">>"), E("endobj");
    var st = C.join(`
`);
    return X === M.ADVANCED && (st += `
Q`), cn(J, !0), dn({ data: st, filters: Hn(), objectId: J }), E("endobj"), T;
  }, Mr = d.__private__.putPages = function() {
    var s, v, C = [];
    for (s = 1; s <= xe; s++)
      Yt[s].objId = Oe(), Yt[s].contentsObjId = Oe();
    for (s = 1; s <= xe; s++)
      C.push(Wn({ number: s, data: Lt[s], objId: Yt[s].objId, contentsObjId: Yt[s].contentsObjId, mediaBox: Yt[s].mediaBox, cropBox: Yt[s].cropBox, bleedBox: Yt[s].bleedBox, trimBox: Yt[s].trimBox, artBox: Yt[s].artBox, userUnit: Yt[s].userUnit, rootDictionaryObjId: Qn, resourceDictionaryObjId: Nn }));
    cn(Qn, !0), E("<</Type /Pages");
    var T = "/Kids [";
    for (v = 0; v < xe; v++)
      T += C[v] + " 0 R ";
    E(T + "]"), E("/Count " + xe), E(">>"), E("endobj"), ce.publish("postPutPages");
  }, Yr = function(s) {
    ce.publish("putFont", { font: s, out: E, newObject: qe, putStream: dn }), s.isAlreadyPutted !== !0 && (s.objectNumber = qe(), E("<<"), E("/Type /Font"), E("/BaseFont /" + Ni(s.postScriptName)), E("/Subtype /Type1"), typeof s.encoding == "string" && E("/Encoding /" + s.encoding), E("/FirstChar 32"), E("/LastChar 255"), E(">>"), E("endobj"));
  }, Jr = function() {
    for (var s in ge)
      ge.hasOwnProperty(s) && (N === !1 || N === !0 && S.hasOwnProperty(s)) && Yr(ge[s]);
  }, Xr = function(s) {
    s.objectNumber = qe();
    var v = [];
    v.push({ key: "Type", value: "/XObject" }), v.push({ key: "Subtype", value: "/Form" }), v.push({ key: "BBox", value: "[" + [tt(s.x), tt(s.y), tt(s.x + s.width), tt(s.y + s.height)].join(" ") + "]" }), v.push({ key: "Matrix", value: "[" + s.matrix.toString() + "]" });
    var C = s.pages[1].join(`
`);
    dn({ data: C, additionalKeyValues: v, objectId: s.objectNumber }), E("endobj");
  }, Kr = function() {
    for (var s in He)
      He.hasOwnProperty(s) && Xr(He[s]);
  }, ca = function(s, v) {
    var C, T = [], J = 1 / (v - 1);
    for (C = 0; C < 1; C += J)
      T.push(C);
    if (T.push(1), s[0].offset != 0) {
      var st = { offset: 0, color: s[0].color };
      s.unshift(st);
    }
    if (s[s.length - 1].offset != 1) {
      var wt = { offset: 1, color: s[s.length - 1].color };
      s.push(wt);
    }
    for (var jt = "", Dt = 0, Kt = 0; Kt < T.length; Kt++) {
      for (C = T[Kt]; C > s[Dt + 1].offset; )
        Dt++;
      var Qt = s[Dt].offset, re = (C - Qt) / (s[Dt + 1].offset - Qt), Le = s[Dt].color, Se = s[Dt + 1].color;
      jt += W(Math.round((1 - re) * Le[0] + re * Se[0]).toString(16)) + W(Math.round((1 - re) * Le[1] + re * Se[1]).toString(16)) + W(Math.round((1 - re) * Le[2] + re * Se[2]).toString(16));
    }
    return jt.trim();
  }, lo = function(s, v) {
    v || (v = 21);
    var C = qe(), T = ca(s.colors, v), J = [];
    J.push({ key: "FunctionType", value: "0" }), J.push({ key: "Domain", value: "[0.0 1.0]" }), J.push({ key: "Size", value: "[" + v + "]" }), J.push({ key: "BitsPerSample", value: "8" }), J.push({ key: "Range", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), J.push({ key: "Decode", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), dn({ data: T, additionalKeyValues: J, alreadyAppliedFilters: ["/ASCIIHexDecode"], objectId: C }), E("endobj"), s.objectNumber = qe(), E("<< /ShadingType " + s.type), E("/ColorSpace /DeviceRGB");
    var st = "/Coords [" + tt(parseFloat(s.coords[0])) + " " + tt(parseFloat(s.coords[1])) + " ";
    s.type === 2 ? st += tt(parseFloat(s.coords[2])) + " " + tt(parseFloat(s.coords[3])) : st += tt(parseFloat(s.coords[2])) + " " + tt(parseFloat(s.coords[3])) + " " + tt(parseFloat(s.coords[4])) + " " + tt(parseFloat(s.coords[5])), E(st += "]"), s.matrix && E("/Matrix [" + s.matrix.toString() + "]"), E("/Function " + C + " 0 R"), E("/Extend [true true]"), E(">>"), E("endobj");
  }, ho = function(s, v) {
    var C = Oe(), T = qe();
    v.push({ resourcesOid: C, objectOid: T }), s.objectNumber = T;
    var J = [];
    J.push({ key: "Type", value: "/Pattern" }), J.push({ key: "PatternType", value: "1" }), J.push({ key: "PaintType", value: "1" }), J.push({ key: "TilingType", value: "1" }), J.push({ key: "BBox", value: "[" + s.boundingBox.map(tt).join(" ") + "]" }), J.push({ key: "XStep", value: tt(s.xStep) }), J.push({ key: "YStep", value: tt(s.yStep) }), J.push({ key: "Resources", value: C + " 0 R" }), s.matrix && J.push({ key: "Matrix", value: "[" + s.matrix.toString() + "]" }), dn({ data: s.stream, additionalKeyValues: J, objectId: s.objectNumber }), E("endobj");
  }, Zr = function(s) {
    var v;
    for (v in ue)
      ue.hasOwnProperty(v) && (ue[v] instanceof Hr ? lo(ue[v]) : ue[v] instanceof xi && ho(ue[v], s));
  }, la = function(s) {
    for (var v in s.objectNumber = qe(), E("<<"), s)
      switch (v) {
        case "opacity":
          E("/ca " + pt(s[v]));
          break;
        case "stroke-opacity":
          E("/CA " + pt(s[v]));
      }
    E(">>"), E("endobj");
  }, fo = function() {
    var s;
    for (s in Ne)
      Ne.hasOwnProperty(s) && la(Ne[s]);
  }, Fi = function() {
    for (var s in E("/XObject <<"), He)
      He.hasOwnProperty(s) && He[s].objectNumber >= 0 && E("/" + s + " " + He[s].objectNumber + " 0 R");
    ce.publish("putXobjectDict"), E(">>");
  }, po = function() {
    Ge.oid = qe(), E("<<"), E("/Filter /Standard"), E("/V " + Ge.v), E("/R " + Ge.r), E("/U <" + Ge.toHexString(Ge.U) + ">"), E("/O <" + Ge.toHexString(Ge.O) + ">"), E("/P " + Ge.P), E(">>"), E("endobj");
  }, ha = function() {
    for (var s in E("/Font <<"), ge)
      ge.hasOwnProperty(s) && (N === !1 || N === !0 && S.hasOwnProperty(s)) && E("/" + s + " " + ge[s].objectNumber + " 0 R");
    E(">>");
  }, go = function() {
    if (Object.keys(ue).length > 0) {
      for (var s in E("/Shading <<"), ue)
        ue.hasOwnProperty(s) && ue[s] instanceof Hr && ue[s].objectNumber >= 0 && E("/" + s + " " + ue[s].objectNumber + " 0 R");
      ce.publish("putShadingPatternDict"), E(">>");
    }
  }, $r = function(s) {
    if (Object.keys(ue).length > 0) {
      for (var v in E("/Pattern <<"), ue)
        ue.hasOwnProperty(v) && ue[v] instanceof d.TilingPattern && ue[v].objectNumber >= 0 && ue[v].objectNumber < s && E("/" + v + " " + ue[v].objectNumber + " 0 R");
      ce.publish("putTilingPatternDict"), E(">>");
    }
  }, mo = function() {
    if (Object.keys(Ne).length > 0) {
      var s;
      for (s in E("/ExtGState <<"), Ne)
        Ne.hasOwnProperty(s) && Ne[s].objectNumber >= 0 && E("/" + s + " " + Ne[s].objectNumber + " 0 R");
      ce.publish("putGStateDict"), E(">>");
    }
  }, ke = function(s) {
    cn(s.resourcesOid, !0), E("<<"), E("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), ha(), go(), $r(s.objectOid), mo(), Fi(), E(">>"), E("endobj");
  }, fa = function() {
    var s = [];
    Jr(), fo(), Kr(), Zr(s), ce.publish("putResources"), s.forEach(ke), ke({ resourcesOid: Nn, objectOid: Number.MAX_SAFE_INTEGER }), ce.publish("postPutResources");
  }, pa = function() {
    ce.publish("putAdditionalObjects");
    for (var s = 0; s < Nt.length; s++) {
      var v = Nt[s];
      cn(v.objId, !0), E(v.content), E("endobj");
    }
    ce.publish("postPutAdditionalObjects");
  }, da = function(s) {
    Ae[s.fontName] = Ae[s.fontName] || {}, Ae[s.fontName][s.fontStyle] = s.id;
  }, Ii = function(s, v, C, T, J) {
    var st = { id: "F" + (Object.keys(ge).length + 1).toString(10), postScriptName: s, fontName: v, fontStyle: C, encoding: T, isStandardFont: J || !1, metadata: {} };
    return ce.publish("addFont", { font: st, instance: this }), ge[st.id] = st, da(st), st.id;
  }, vo = function(s) {
    for (var v = 0, C = At.length; v < C; v++) {
      var T = Ii.call(this, s[v][0], s[v][1], s[v][2], At[v][3], !0);
      N === !1 && (S[T] = !0);
      var J = s[v][0].split("-");
      da({ id: T, fontName: J[0], fontStyle: J[1] || "" });
    }
    ce.publish("addFonts", { fonts: ge, dictionary: Ae });
  }, _n = function(s) {
    return s.foo = function() {
      try {
        return s.apply(this, arguments);
      } catch (T) {
        var v = T.stack || "";
        ~v.indexOf(" at ") && (v = v.split(" at ")[1]);
        var C = "Error in function " + v.split(`
`)[0].split("<")[0] + ": " + T.message;
        if (!Ht.console)
          throw new Error(C);
        Ht.console.error(C, T), Ht.alert && alert(C);
      }
    }, s.foo.bar = s, s.foo;
  }, Qr = function(s, v) {
    var C, T, J, st, wt, jt, Dt, Kt, Qt;
    if (J = (v = v || {}).sourceEncoding || "Unicode", wt = v.outputEncoding, (v.autoencode || wt) && ge[ee].metadata && ge[ee].metadata[J] && ge[ee].metadata[J].encoding && (st = ge[ee].metadata[J].encoding, !wt && ge[ee].encoding && (wt = ge[ee].encoding), !wt && st.codePages && (wt = st.codePages[0]), typeof wt == "string" && (wt = st[wt]), wt)) {
      for (Dt = !1, jt = [], C = 0, T = s.length; C < T; C++)
        (Kt = wt[s.charCodeAt(C)]) ? jt.push(String.fromCharCode(Kt)) : jt.push(s[C]), jt[C].charCodeAt(0) >> 8 && (Dt = !0);
      s = jt.join("");
    }
    for (C = s.length; Dt === void 0 && C !== 0; )
      s.charCodeAt(C - 1) >> 8 && (Dt = !0), C--;
    if (!Dt)
      return s;
    for (jt = v.noBOM ? [] : [254, 255], C = 0, T = s.length; C < T; C++) {
      if ((Qt = (Kt = s.charCodeAt(C)) >> 8) >> 8)
        throw new Error("Character at position " + C + " of string '" + s + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
      jt.push(Qt), jt.push(Kt - (Qt << 8));
    }
    return String.fromCharCode.apply(void 0, jt);
  }, nn = d.__private__.pdfEscape = d.pdfEscape = function(s, v) {
    return Qr(s, v).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
  }, Ci = d.__private__.beginPage = function(s) {
    Lt[++xe] = [], Yt[xe] = { objId: 0, contentsObjId: 0, userUnit: Number(h), artBox: null, bleedBox: null, cropBox: null, trimBox: null, mediaBox: { bottomLeftX: 0, bottomLeftY: 0, topRightX: Number(s[0]), topRightY: Number(s[1]) } }, ma(xe), ut(Lt[j]);
  }, ga = function(s, v) {
    var C, T, J;
    switch (n = v || n, typeof s == "string" && (C = _(s.toLowerCase()), Array.isArray(C) && (T = C[0], J = C[1])), Array.isArray(s) && (T = s[0] * It, J = s[1] * It), isNaN(T) && (T = u[0], J = u[1]), (T > 14400 || J > 14400) && (ve.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), T = Math.min(14400, T), J = Math.min(14400, J)), u = [T, J], n.substr(0, 1)) {
      case "l":
        J > T && (u = [J, T]);
        break;
      case "p":
        T > J && (u = [J, T]);
    }
    Ci(u), La(Bi), E(Pn), qi !== 0 && E(qi + " J"), Di !== 0 && E(Di + " j"), ce.publish("addPage", { pageNumber: xe });
  }, bo = function(s) {
    s > 0 && s <= xe && (Lt.splice(s, 1), Yt.splice(s, 1), xe--, j > xe && (j = xe), this.setPage(j));
  }, ma = function(s) {
    s > 0 && s <= xe && (j = s);
  }, yo = d.__private__.getNumberOfPages = d.getNumberOfPages = function() {
    return Lt.length - 1;
  }, va = function(s, v, C) {
    var T, J = void 0;
    return C = C || {}, s = s !== void 0 ? s : ge[ee].fontName, v = v !== void 0 ? v : ge[ee].fontStyle, T = s.toLowerCase(), Ae[T] !== void 0 && Ae[T][v] !== void 0 ? J = Ae[T][v] : Ae[s] !== void 0 && Ae[s][v] !== void 0 ? J = Ae[s][v] : C.disableWarning === !1 && ve.warn("Unable to look up font label for font '" + s + "', '" + v + "'. Refer to getFontList() for available fonts."), J || C.noFallback || (J = Ae.times[v]) == null && (J = Ae.times.normal), J;
  }, wo = d.__private__.putInfo = function() {
    var s = qe(), v = function(T) {
      return T;
    };
    for (var C in b !== null && (v = Ge.encryptor(s, 0)), E("<<"), E("/Producer (" + nn(v("jsPDF " + zt.version)) + ")"), Wt)
      Wt.hasOwnProperty(C) && Wt[C] && E("/" + C.substr(0, 1).toUpperCase() + C.substr(1) + " (" + nn(v(Wt[C])) + ")");
    E("/CreationDate (" + nn(v(at)) + ")"), E(">>"), E("endobj");
  }, ji = d.__private__.putCatalog = function(s) {
    var v = (s = s || {}).rootDictionaryObjId || Qn;
    switch (qe(), E("<<"), E("/Type /Catalog"), E("/Pages " + v + " 0 R"), Ft || (Ft = "fullwidth"), Ft) {
      case "fullwidth":
        E("/OpenAction [3 0 R /FitH null]");
        break;
      case "fullheight":
        E("/OpenAction [3 0 R /FitV null]");
        break;
      case "fullpage":
        E("/OpenAction [3 0 R /Fit]");
        break;
      case "original":
        E("/OpenAction [3 0 R /XYZ null null 1]");
        break;
      default:
        var C = "" + Ft;
        C.substr(C.length - 1) === "%" && (Ft = parseInt(Ft) / 100), typeof Ft == "number" && E("/OpenAction [3 0 R /XYZ null null " + pt(Ft) + "]");
    }
    switch (te || (te = "continuous"), te) {
      case "continuous":
        E("/PageLayout /OneColumn");
        break;
      case "single":
        E("/PageLayout /SinglePage");
        break;
      case "two":
      case "twoleft":
        E("/PageLayout /TwoColumnLeft");
        break;
      case "tworight":
        E("/PageLayout /TwoColumnRight");
    }
    Gt && E("/PageMode /" + Gt), ce.publish("putCatalog"), E(">>"), E("endobj");
  }, Ao = d.__private__.putTrailer = function() {
    E("trailer"), E("<<"), E("/Size " + (Y + 1)), E("/Root " + Y + " 0 R"), E("/Info " + (Y - 1) + " 0 R"), b !== null && E("/Encrypt " + Ge.oid + " 0 R"), E("/ID [ <" + nt + "> <" + nt + "> ]"), E(">>");
  }, Lo = d.__private__.putHeader = function() {
    E("%PDF-" + O), E("%ºß¬à");
  }, No = d.__private__.putXRef = function() {
    var s = "0000000000";
    E("xref"), E("0 " + (Y + 1)), E("0000000000 65535 f ");
    for (var v = 1; v <= Y; v++)
      typeof Q[v] == "function" ? E((s + Q[v]()).slice(-10) + " 00000 n ") : Q[v] !== void 0 ? E((s + Q[v]).slice(-10) + " 00000 n ") : E("0000000000 00000 n ");
  }, tr = d.__private__.buildDocument = function() {
    Ut(), ut(et), ce.publish("buildDocument"), Lo(), Mr(), pa(), fa(), b !== null && po(), wo(), ji();
    var s = rt;
    return No(), Ao(), E("startxref"), E("" + s), E("%%EOF"), ut(Lt[j]), et.join(`
`);
  }, ti = d.__private__.getBlob = function(s) {
    return new Blob([Et(s)], { type: "application/pdf" });
  }, ei = d.output = d.__private__.output = _n(function(s, v) {
    switch (typeof (v = v || {}) == "string" ? v = { filename: v } : v.filename = v.filename || "generated.pdf", s) {
      case void 0:
        return tr();
      case "save":
        d.save(v.filename);
        break;
      case "arraybuffer":
        return Et(tr());
      case "blob":
        return ti(tr());
      case "bloburi":
      case "bloburl":
        if (Ht.URL !== void 0 && typeof Ht.URL.createObjectURL == "function")
          return Ht.URL && Ht.URL.createObjectURL(ti(tr())) || void 0;
        ve.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
        break;
      case "datauristring":
      case "dataurlstring":
        var C = "", T = tr();
        try {
          C = gs(T);
        } catch {
          C = gs(unescape(encodeURIComponent(T)));
        }
        return "data:application/pdf;filename=" + v.filename + ";base64," + C;
      case "pdfobjectnewwindow":
        if (Object.prototype.toString.call(Ht) === "[object Window]") {
          var J = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", st = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
          v.pdfObjectUrl && (J = v.pdfObjectUrl, st = "");
          var wt = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + J + '"' + st + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(v) + ");<\/script></body></html>", jt = Ht.open();
          return jt !== null && jt.document.write(wt), jt;
        }
        throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
      case "pdfjsnewwindow":
        if (Object.prototype.toString.call(Ht) === "[object Window]") {
          var Dt = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (v.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + v.filename + '" width="500px" height="400px" /></body></html>', Kt = Ht.open();
          if (Kt !== null) {
            Kt.document.write(Dt);
            var Qt = this;
            Kt.document.documentElement.querySelector("#pdfViewer").onload = function() {
              Kt.document.title = v.filename, Kt.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(Qt.output("bloburl"));
            };
          }
          return Kt;
        }
        throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
      case "dataurlnewwindow":
        if (Object.prototype.toString.call(Ht) !== "[object Window]")
          throw new Error("The option dataurlnewwindow just works in a browser-environment.");
        var re = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", v) + '"></iframe></body></html>', Le = Ht.open();
        if (Le !== null && (Le.document.write(re), Le.document.title = v.filename), Le || typeof safari > "u")
          return Le;
        break;
      case "datauri":
      case "dataurl":
        return Ht.document.location.href = this.output("datauristring", v);
      default:
        return null;
    }
  }), ba = function(s) {
    return Array.isArray(Or) === !0 && Or.indexOf(s) > -1;
  };
  switch (a) {
    case "pt":
      It = 1;
      break;
    case "mm":
      It = 72 / 25.4;
      break;
    case "cm":
      It = 72 / 2.54;
      break;
    case "in":
      It = 72;
      break;
    case "px":
      It = ba("px_scaling") == 1 ? 0.75 : 96 / 72;
      break;
    case "pc":
    case "em":
      It = 12;
      break;
    case "ex":
      It = 6;
      break;
    default:
      if (typeof a != "number")
        throw new Error("Invalid unit: " + a);
      It = a;
  }
  var Ge = null;
  kt(), $();
  var xo = function(s) {
    return b !== null ? Ge.encryptor(s, 0) : function(v) {
      return v;
    };
  }, ya = d.__private__.getPageInfo = d.getPageInfo = function(s) {
    if (isNaN(s) || s % 1 != 0)
      throw new Error("Invalid argument passed to jsPDF.getPageInfo");
    return { objId: Yt[s].objId, pageNumber: s, pageContext: Yt[s] };
  }, Vt = d.__private__.getPageInfoByObjId = function(s) {
    if (isNaN(s) || s % 1 != 0)
      throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
    for (var v in Yt)
      if (Yt[v].objId === s)
        break;
    return ya(v);
  }, So = d.__private__.getCurrentPageInfo = d.getCurrentPageInfo = function() {
    return { objId: Yt[j].objId, pageNumber: j, pageContext: Yt[j] };
  };
  d.addPage = function() {
    return ga.apply(this, arguments), this;
  }, d.setPage = function() {
    return ma.apply(this, arguments), ut.call(this, Lt[j]), this;
  }, d.insertPage = function(s) {
    return this.addPage(), this.movePage(j, s), this;
  }, d.movePage = function(s, v) {
    var C, T;
    if (s > v) {
      C = Lt[s], T = Yt[s];
      for (var J = s; J > v; J--)
        Lt[J] = Lt[J - 1], Yt[J] = Yt[J - 1];
      Lt[v] = C, Yt[v] = T, this.setPage(v);
    } else if (s < v) {
      C = Lt[s], T = Yt[s];
      for (var st = s; st < v; st++)
        Lt[st] = Lt[st + 1], Yt[st] = Yt[st + 1];
      Lt[v] = C, Yt[v] = T, this.setPage(v);
    }
    return this;
  }, d.deletePage = function() {
    return bo.apply(this, arguments), this;
  }, d.__private__.text = d.text = function(s, v, C, T, J) {
    var st, wt, jt, Dt, Kt, Qt, re, Le, Se, Me = (T = T || {}).scope || this;
    if (typeof s == "number" && typeof v == "number" && (typeof C == "string" || Array.isArray(C))) {
      var Ye = C;
      C = v, v = s, s = Ye;
    }
    if (arguments[3] instanceof Tt ? (R("The transform parameter of text() with a Matrix value"), Se = J) : (jt = arguments[4], Dt = arguments[5], fe(re = arguments[3]) === "object" && re !== null || (typeof jt == "string" && (Dt = jt, jt = null), typeof re == "string" && (Dt = re, re = null), typeof re == "number" && (jt = re, re = null), T = { flags: re, angle: jt, align: Dt })), isNaN(v) || isNaN(C) || s == null)
      throw new Error("Invalid arguments passed to jsPDF.text");
    if (s.length === 0)
      return Me;
    var Re = "", kn = !1, ln = typeof T.lineHeightFactor == "number" ? T.lineHeightFactor : Er, nr = Me.internal.scaleFactor;
    function ka(be) {
      return be = be.split("	").join(Array(T.TabLen || 9).join(" ")), nn(be, re);
    }
    function Hi(be) {
      for (var ye, Fe = be.concat(), De = [], or = Fe.length; or--; )
        typeof (ye = Fe.shift()) == "string" ? De.push(ye) : Array.isArray(be) && (ye.length === 1 || ye[1] === void 0 && ye[2] === void 0) ? De.push(ye[0]) : De.push([ye[0], ye[1], ye[2]]);
      return De;
    }
    function Wi(be, ye) {
      var Fe;
      if (typeof be == "string")
        Fe = ye(be)[0];
      else if (Array.isArray(be)) {
        for (var De, or, yr = be.concat(), gi = [], Ia = yr.length; Ia--; )
          typeof (De = yr.shift()) == "string" ? gi.push(ye(De)[0]) : Array.isArray(De) && typeof De[0] == "string" && (or = ye(De[0], De[1], De[2]), gi.push([or[0], or[1], or[2]]));
        Fe = gi;
      }
      return Fe;
    }
    var si = !1, Vi = !0;
    if (typeof s == "string")
      si = !0;
    else if (Array.isArray(s)) {
      var Gi = s.concat();
      wt = [];
      for (var ui, rn = Gi.length; rn--; )
        (typeof (ui = Gi.shift()) != "string" || Array.isArray(ui) && typeof ui[0] != "string") && (Vi = !1);
      si = Vi;
    }
    if (si === !1)
      throw new Error('Type of text must be string or Array. "' + s + '" is not recognized.');
    typeof s == "string" && (s = s.match(/[\r?\n]/) ? s.split(/\r\n|\r|\n/g) : [s]);
    var ci = xt / Me.internal.scaleFactor, li = ci * (ln - 1);
    switch (T.baseline) {
      case "bottom":
        C -= li;
        break;
      case "top":
        C += ci - li;
        break;
      case "hanging":
        C += ci - 2 * li;
        break;
      case "middle":
        C += ci / 2 - li;
    }
    if ((Qt = T.maxWidth || 0) > 0 && (typeof s == "string" ? s = Me.splitTextToSize(s, Qt) : Object.prototype.toString.call(s) === "[object Array]" && (s = s.reduce(function(be, ye) {
      return be.concat(Me.splitTextToSize(ye, Qt));
    }, []))), st = { text: s, x: v, y: C, options: T, mutex: { pdfEscape: nn, activeFontKey: ee, fonts: ge, activeFontSize: xt } }, ce.publish("preProcessText", st), s = st.text, jt = (T = st.options).angle, !(Se instanceof Tt) && jt && typeof jt == "number") {
      jt *= Math.PI / 180, T.rotationDirection === 0 && (jt = -jt), X === M.ADVANCED && (jt = -jt);
      var hi = Math.cos(jt), Yi = Math.sin(jt);
      Se = new Tt(hi, Yi, -Yi, hi, 0, 0);
    } else
      jt && jt instanceof Tt && (Se = jt);
    X !== M.ADVANCED || Se || (Se = Un), (Kt = T.charSpace || ii) !== void 0 && (Re += tt(P(Kt)) + ` Tc
`, this.setCharSpace(this.getCharSpace() || 0)), (Le = T.horizontalScale) !== void 0 && (Re += tt(100 * Le) + ` Tz
`), T.lang;
    var an = -1, Bo = T.renderingMode !== void 0 ? T.renderingMode : T.stroke, Ji = Me.internal.getCurrentPageInfo().pageContext;
    switch (Bo) {
      case 0:
      case !1:
      case "fill":
        an = 0;
        break;
      case 1:
      case !0:
      case "stroke":
        an = 1;
        break;
      case 2:
      case "fillThenStroke":
        an = 2;
        break;
      case 3:
      case "invisible":
        an = 3;
        break;
      case 4:
      case "fillAndAddForClipping":
        an = 4;
        break;
      case 5:
      case "strokeAndAddPathForClipping":
        an = 5;
        break;
      case 6:
      case "fillThenStrokeAndAddToPathForClipping":
        an = 6;
        break;
      case 7:
      case "addToPathForClipping":
        an = 7;
    }
    var Fa = Ji.usedRenderingMode !== void 0 ? Ji.usedRenderingMode : -1;
    an !== -1 ? Re += an + ` Tr
` : Fa !== -1 && (Re += `0 Tr
`), an !== -1 && (Ji.usedRenderingMode = an), Dt = T.align || "left";
    var Fn, Xi = xt * ln, Eo = Me.internal.pageSize.getWidth(), qo = ge[ee];
    Kt = T.charSpace || ii, Qt = T.maxWidth || 0, re = Object.assign({ autoencode: !0, noBOM: !0 }, T.flags);
    var gr = [];
    if (Object.prototype.toString.call(s) === "[object Array]") {
      var gn;
      wt = Hi(s), Dt !== "left" && (Fn = wt.map(function(be) {
        return Me.getStringUnitWidth(be, { font: qo, charSpace: Kt, fontSize: xt, doKerning: !1 }) * xt / nr;
      }));
      var In, mr = 0;
      if (Dt === "right") {
        v -= Fn[0], s = [], rn = wt.length;
        for (var Gn = 0; Gn < rn; Gn++)
          Gn === 0 ? (In = er(v), gn = fr(C)) : (In = P(mr - Fn[Gn]), gn = -Xi), s.push([wt[Gn], In, gn]), mr = Fn[Gn];
      } else if (Dt === "center") {
        v -= Fn[0] / 2, s = [], rn = wt.length;
        for (var rr = 0; rr < rn; rr++)
          rr === 0 ? (In = er(v), gn = fr(C)) : (In = P((mr - Fn[rr]) / 2), gn = -Xi), s.push([wt[rr], In, gn]), mr = Fn[rr];
      } else if (Dt === "left") {
        s = [], rn = wt.length;
        for (var fi = 0; fi < rn; fi++)
          s.push(wt[fi]);
      } else {
        if (Dt !== "justify")
          throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
        s = [], rn = wt.length, Qt = Qt !== 0 ? Qt : Eo;
        for (var Cn = 0; Cn < rn; Cn++)
          gn = Cn === 0 ? fr(C) : -Xi, In = Cn === 0 ? er(v) : 0, Cn < rn - 1 ? gr.push(tt(P((Qt - Fn[Cn]) / (wt[Cn].split(" ").length - 1)))) : gr.push(0), s.push([wt[Cn], In, gn]);
      }
    }
    var pi = typeof T.R2L == "boolean" ? T.R2L : qt;
    pi === !0 && (s = Wi(s, function(be, ye, Fe) {
      return [be.split("").reverse().join(""), ye, Fe];
    })), st = { text: s, x: v, y: C, options: T, mutex: { pdfEscape: nn, activeFontKey: ee, fonts: ge, activeFontSize: xt } }, ce.publish("postProcessText", st), s = st.text, kn = st.mutex.isHex || !1;
    var Ki = ge[ee].encoding;
    Ki !== "WinAnsiEncoding" && Ki !== "StandardEncoding" || (s = Wi(s, function(be, ye, Fe) {
      return [ka(be), ye, Fe];
    })), wt = Hi(s), s = [];
    for (var vr, jn, ir, Rr = 0, di = 1, Tr = Array.isArray(wt[0]) ? di : Rr, br = "", Zi = function(be, ye, Fe) {
      var De = "";
      return Fe instanceof Tt ? (Fe = typeof T.angle == "number" ? Ln(Fe, new Tt(1, 0, 0, 1, be, ye)) : Ln(new Tt(1, 0, 0, 1, be, ye), Fe), X === M.ADVANCED && (Fe = Ln(new Tt(1, 0, 0, -1, 0, 0), Fe)), De = Fe.join(" ") + ` Tm
`) : De = tt(be) + " " + tt(ye) + ` Td
`, De;
    }, mn = 0; mn < wt.length; mn++) {
      switch (br = "", Tr) {
        case di:
          ir = (kn ? "<" : "(") + wt[mn][0] + (kn ? ">" : ")"), vr = parseFloat(wt[mn][1]), jn = parseFloat(wt[mn][2]);
          break;
        case Rr:
          ir = (kn ? "<" : "(") + wt[mn] + (kn ? ">" : ")"), vr = er(v), jn = fr(C);
      }
      gr !== void 0 && gr[mn] !== void 0 && (br = gr[mn] + ` Tw
`), mn === 0 ? s.push(br + Zi(vr, jn, Se) + ir) : Tr === Rr ? s.push(br + ir) : Tr === di && s.push(br + Zi(vr, jn, Se) + ir);
    }
    s = Tr === Rr ? s.join(` Tj
T* `) : s.join(` Tj
`), s += ` Tj
`;
    var ar = `BT
/`;
    return ar += ee + " " + xt + ` Tf
`, ar += tt(xt * ln) + ` TL
`, ar += qr + `
`, ar += Re, ar += s, E(ar += "ET"), S[ee] = !0, Me;
  };
  var _o = d.__private__.clip = d.clip = function(s) {
    return E(s === "evenodd" ? "W*" : "W"), this;
  };
  d.clipEvenOdd = function() {
    return _o("evenodd");
  }, d.__private__.discardPath = d.discardPath = function() {
    return E("n"), this;
  };
  var Vn = d.__private__.isValidStyle = function(s) {
    var v = !1;
    return [void 0, null, "S", "D", "F", "DF", "FD", "f", "f*", "B", "B*", "n"].indexOf(s) !== -1 && (v = !0), v;
  };
  d.__private__.setDefaultPathOperation = d.setDefaultPathOperation = function(s) {
    return Vn(s) && (g = s), this;
  };
  var wa = d.__private__.getStyle = d.getStyle = function(s) {
    var v = g;
    switch (s) {
      case "D":
      case "S":
        v = "S";
        break;
      case "F":
        v = "f";
        break;
      case "FD":
      case "DF":
        v = "B";
        break;
      case "f":
      case "f*":
      case "B":
      case "B*":
        v = s;
    }
    return v;
  }, Aa = d.close = function() {
    return E("h"), this;
  };
  d.stroke = function() {
    return E("S"), this;
  }, d.fill = function(s) {
    return ni("f", s), this;
  }, d.fillEvenOdd = function(s) {
    return ni("f*", s), this;
  }, d.fillStroke = function(s) {
    return ni("B", s), this;
  }, d.fillStrokeEvenOdd = function(s) {
    return ni("B*", s), this;
  };
  var ni = function(s, v) {
    fe(v) === "object" ? ko(v, s) : E(s);
  }, Oi = function(s) {
    s === null || X === M.ADVANCED && s === void 0 || (s = wa(s), E(s));
  };
  function Po(s, v, C, T, J) {
    var st = new xi(v || this.boundingBox, C || this.xStep, T || this.yStep, this.gState, J || this.matrix);
    st.stream = this.stream;
    var wt = s + "$$" + this.cloneIndex++ + "$$";
    return en(wt, st), st;
  }
  var ko = function(s, v) {
    var C = jr[s.key], T = ue[C];
    if (T instanceof Hr)
      E("q"), E(Fo(v)), T.gState && d.setGState(T.gState), E(s.matrix.toString() + " cm"), E("/" + C + " sh"), E("Q");
    else if (T instanceof xi) {
      var J = new Tt(1, 0, 0, -1, 0, dr());
      s.matrix && (J = J.multiply(s.matrix || Un), C = Po.call(T, s.key, s.boundingBox, s.xStep, s.yStep, J).id), E("q"), E("/Pattern cs"), E("/" + C + " scn"), T.gState && d.setGState(T.gState), E(v), E("Q");
    }
  }, Fo = function(s) {
    switch (s) {
      case "f":
      case "F":
        return "W n";
      case "f*":
        return "W* n";
      case "B":
        return "W S";
      case "B*":
        return "W* S";
      case "S":
        return "W S";
      case "n":
        return "W n";
    }
  }, Mi = d.moveTo = function(s, v) {
    return E(tt(P(s)) + " " + tt(D(v)) + " m"), this;
  }, Br = d.lineTo = function(s, v) {
    return E(tt(P(s)) + " " + tt(D(v)) + " l"), this;
  }, hr = d.curveTo = function(s, v, C, T, J, st) {
    return E([tt(P(s)), tt(D(v)), tt(P(C)), tt(D(T)), tt(P(J)), tt(D(st)), "c"].join(" ")), this;
  };
  d.__private__.line = d.line = function(s, v, C, T, J) {
    if (isNaN(s) || isNaN(v) || isNaN(C) || isNaN(T) || !Vn(J))
      throw new Error("Invalid arguments passed to jsPDF.line");
    return X === M.COMPAT ? this.lines([[C - s, T - v]], s, v, [1, 1], J || "S") : this.lines([[C - s, T - v]], s, v, [1, 1]).stroke();
  }, d.__private__.lines = d.lines = function(s, v, C, T, J, st) {
    var wt, jt, Dt, Kt, Qt, re, Le, Se, Me, Ye, Re, kn;
    if (typeof s == "number" && (kn = C, C = v, v = s, s = kn), T = T || [1, 1], st = st || !1, isNaN(v) || isNaN(C) || !Array.isArray(s) || !Array.isArray(T) || !Vn(J) || typeof st != "boolean")
      throw new Error("Invalid arguments passed to jsPDF.lines");
    for (Mi(v, C), wt = T[0], jt = T[1], Kt = s.length, Ye = v, Re = C, Dt = 0; Dt < Kt; Dt++)
      (Qt = s[Dt]).length === 2 ? (Ye = Qt[0] * wt + Ye, Re = Qt[1] * jt + Re, Br(Ye, Re)) : (re = Qt[0] * wt + Ye, Le = Qt[1] * jt + Re, Se = Qt[2] * wt + Ye, Me = Qt[3] * jt + Re, Ye = Qt[4] * wt + Ye, Re = Qt[5] * jt + Re, hr(re, Le, Se, Me, Ye, Re));
    return st && Aa(), Oi(J), this;
  }, d.path = function(s) {
    for (var v = 0; v < s.length; v++) {
      var C = s[v], T = C.c;
      switch (C.op) {
        case "m":
          Mi(T[0], T[1]);
          break;
        case "l":
          Br(T[0], T[1]);
          break;
        case "c":
          hr.apply(this, T);
          break;
        case "h":
          Aa();
      }
    }
    return this;
  }, d.__private__.rect = d.rect = function(s, v, C, T, J) {
    if (isNaN(s) || isNaN(v) || isNaN(C) || isNaN(T) || !Vn(J))
      throw new Error("Invalid arguments passed to jsPDF.rect");
    return X === M.COMPAT && (T = -T), E([tt(P(s)), tt(D(v)), tt(P(C)), tt(P(T)), "re"].join(" ")), Oi(J), this;
  }, d.__private__.triangle = d.triangle = function(s, v, C, T, J, st, wt) {
    if (isNaN(s) || isNaN(v) || isNaN(C) || isNaN(T) || isNaN(J) || isNaN(st) || !Vn(wt))
      throw new Error("Invalid arguments passed to jsPDF.triangle");
    return this.lines([[C - s, T - v], [J - C, st - T], [s - J, v - st]], s, v, [1, 1], wt, !0), this;
  }, d.__private__.roundedRect = d.roundedRect = function(s, v, C, T, J, st, wt) {
    if (isNaN(s) || isNaN(v) || isNaN(C) || isNaN(T) || isNaN(J) || isNaN(st) || !Vn(wt))
      throw new Error("Invalid arguments passed to jsPDF.roundedRect");
    var jt = 4 / 3 * (Math.SQRT2 - 1);
    return J = Math.min(J, 0.5 * C), st = Math.min(st, 0.5 * T), this.lines([[C - 2 * J, 0], [J * jt, 0, J, st - st * jt, J, st], [0, T - 2 * st], [0, st * jt, -J * jt, st, -J, st], [2 * J - C, 0], [-J * jt, 0, -J, -st * jt, -J, -st], [0, 2 * st - T], [0, -st * jt, J * jt, -st, J, -st]], s + J, v, [1, 1], wt, !0), this;
  }, d.__private__.ellipse = d.ellipse = function(s, v, C, T, J) {
    if (isNaN(s) || isNaN(v) || isNaN(C) || isNaN(T) || !Vn(J))
      throw new Error("Invalid arguments passed to jsPDF.ellipse");
    var st = 4 / 3 * (Math.SQRT2 - 1) * C, wt = 4 / 3 * (Math.SQRT2 - 1) * T;
    return Mi(s + C, v), hr(s + C, v - wt, s + st, v - T, s, v - T), hr(s - st, v - T, s - C, v - wt, s - C, v), hr(s - C, v + wt, s - st, v + T, s, v + T), hr(s + st, v + T, s + C, v + wt, s + C, v), Oi(J), this;
  }, d.__private__.circle = d.circle = function(s, v, C, T) {
    if (isNaN(s) || isNaN(v) || isNaN(C) || !Vn(T))
      throw new Error("Invalid arguments passed to jsPDF.circle");
    return this.ellipse(s, v, C, C, T);
  }, d.setFont = function(s, v, C) {
    return C && (v = yt(v, C)), ee = va(s, v, { disableWarning: !1 }), this;
  };
  var Io = d.__private__.getFont = d.getFont = function() {
    return ge[va.apply(d, arguments)];
  };
  d.__private__.getFontList = d.getFontList = function() {
    var s, v, C = {};
    for (s in Ae)
      if (Ae.hasOwnProperty(s))
        for (v in C[s] = [], Ae[s])
          Ae[s].hasOwnProperty(v) && C[s].push(v);
    return C;
  }, d.addFont = function(s, v, C, T, J) {
    var st = ["StandardEncoding", "MacRomanEncoding", "Identity-H", "WinAnsiEncoding"];
    return arguments[3] && st.indexOf(arguments[3]) !== -1 ? J = arguments[3] : arguments[3] && st.indexOf(arguments[3]) == -1 && (C = yt(C, T)), J = J || "Identity-H", Ii.call(this, s, v, C, J);
  };
  var Er, Bi = i.lineWidth || 0.200025, ri = d.__private__.getLineWidth = d.getLineWidth = function() {
    return Bi;
  }, La = d.__private__.setLineWidth = d.setLineWidth = function(s) {
    return Bi = s, E(tt(P(s)) + " w"), this;
  };
  d.__private__.setLineDash = zt.API.setLineDash = zt.API.setLineDashPattern = function(s, v) {
    if (s = s || [], v = v || 0, isNaN(v) || !Array.isArray(s))
      throw new Error("Invalid arguments passed to jsPDF.setLineDash");
    return s = s.map(function(C) {
      return tt(P(C));
    }).join(" "), v = tt(P(v)), E("[" + s + "] " + v + " d"), this;
  };
  var Na = d.__private__.getLineHeight = d.getLineHeight = function() {
    return xt * Er;
  };
  d.__private__.getLineHeight = d.getLineHeight = function() {
    return xt * Er;
  };
  var xa = d.__private__.setLineHeightFactor = d.setLineHeightFactor = function(s) {
    return typeof (s = s || 1.15) == "number" && (Er = s), this;
  }, Sa = d.__private__.getLineHeightFactor = d.getLineHeightFactor = function() {
    return Er;
  };
  xa(i.lineHeight);
  var er = d.__private__.getHorizontalCoordinate = function(s) {
    return P(s);
  }, fr = d.__private__.getVerticalCoordinate = function(s) {
    return X === M.ADVANCED ? s : Yt[j].mediaBox.topRightY - Yt[j].mediaBox.bottomLeftY - P(s);
  }, Co = d.__private__.getHorizontalCoordinateString = d.getHorizontalCoordinateString = function(s) {
    return tt(er(s));
  }, pr = d.__private__.getVerticalCoordinateString = d.getVerticalCoordinateString = function(s) {
    return tt(fr(s));
  }, Pn = i.strokeColor || "0 G";
  d.__private__.getStrokeColor = d.getDrawColor = function() {
    return xn(Pn);
  }, d.__private__.setStrokeColor = d.setDrawColor = function(s, v, C, T) {
    return Pn = Sn({ ch1: s, ch2: v, ch3: C, ch4: T, pdfColorType: "draw", precision: 2 }), E(Pn), this;
  };
  var Ei = i.fillColor || "0 g";
  d.__private__.getFillColor = d.getFillColor = function() {
    return xn(Ei);
  }, d.__private__.setFillColor = d.setFillColor = function(s, v, C, T) {
    return Ei = Sn({ ch1: s, ch2: v, ch3: C, ch4: T, pdfColorType: "fill", precision: 2 }), E(Ei), this;
  };
  var qr = i.textColor || "0 g", jo = d.__private__.getTextColor = d.getTextColor = function() {
    return xn(qr);
  };
  d.__private__.setTextColor = d.setTextColor = function(s, v, C, T) {
    return qr = Sn({ ch1: s, ch2: v, ch3: C, ch4: T, pdfColorType: "text", precision: 3 }), this;
  };
  var ii = i.charSpace, Oo = d.__private__.getCharSpace = d.getCharSpace = function() {
    return parseFloat(ii || 0);
  };
  d.__private__.setCharSpace = d.setCharSpace = function(s) {
    if (isNaN(s))
      throw new Error("Invalid argument passed to jsPDF.setCharSpace");
    return ii = s, this;
  };
  var qi = 0;
  d.CapJoinStyles = { 0: 0, butt: 0, but: 0, miter: 0, 1: 1, round: 1, rounded: 1, circle: 1, 2: 2, projecting: 2, project: 2, square: 2, bevel: 2 }, d.__private__.setLineCap = d.setLineCap = function(s) {
    var v = d.CapJoinStyles[s];
    if (v === void 0)
      throw new Error("Line cap style of '" + s + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return qi = v, E(v + " J"), this;
  };
  var Di = 0;
  d.__private__.setLineJoin = d.setLineJoin = function(s) {
    var v = d.CapJoinStyles[s];
    if (v === void 0)
      throw new Error("Line join style of '" + s + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return Di = v, E(v + " j"), this;
  }, d.__private__.setLineMiterLimit = d.__private__.setMiterLimit = d.setLineMiterLimit = d.setMiterLimit = function(s) {
    if (s = s || 0, isNaN(s))
      throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
    return E(tt(P(s)) + " M"), this;
  }, d.GState = ao, d.setGState = function(s) {
    (s = typeof s == "string" ? Ne[An[s]] : _a(null, s)).equals($n) || (E("/" + s.id + " gs"), $n = s);
  };
  var _a = function(s, v) {
    if (!s || !An[s]) {
      var C = !1;
      for (var T in Ne)
        if (Ne.hasOwnProperty(T) && Ne[T].equals(v)) {
          C = !0;
          break;
        }
      if (C)
        v = Ne[T];
      else {
        var J = "GS" + (Object.keys(Ne).length + 1).toString(10);
        Ne[J] = v, v.id = J;
      }
      return s && (An[s] = v.id), ce.publish("addGState", v), v;
    }
  };
  d.addGState = function(s, v) {
    return _a(s, v), this;
  }, d.saveGraphicsState = function() {
    return E("q"), Rn.push({ key: ee, size: xt, color: qr }), this;
  }, d.restoreGraphicsState = function() {
    E("Q");
    var s = Rn.pop();
    return ee = s.key, xt = s.size, qr = s.color, $n = null, this;
  }, d.setCurrentTransformationMatrix = function(s) {
    return E(s.toString() + " cm"), this;
  }, d.comment = function(s) {
    return E("#" + s), this;
  };
  var ai = function(s, v) {
    var C = s || 0;
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return C;
    }, set: function(st) {
      isNaN(st) || (C = parseFloat(st));
    } });
    var T = v || 0;
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return T;
    }, set: function(st) {
      isNaN(st) || (T = parseFloat(st));
    } });
    var J = "pt";
    return Object.defineProperty(this, "type", { enumerable: !0, get: function() {
      return J;
    }, set: function(st) {
      J = st.toString();
    } }), this;
  }, Ri = function(s, v, C, T) {
    ai.call(this, s, v), this.type = "rect";
    var J = C || 0;
    Object.defineProperty(this, "w", { enumerable: !0, get: function() {
      return J;
    }, set: function(wt) {
      isNaN(wt) || (J = parseFloat(wt));
    } });
    var st = T || 0;
    return Object.defineProperty(this, "h", { enumerable: !0, get: function() {
      return st;
    }, set: function(wt) {
      isNaN(wt) || (st = parseFloat(wt));
    } }), this;
  }, Ti = function() {
    this.page = xe, this.currentPage = j, this.pages = Lt.slice(0), this.pagesContext = Yt.slice(0), this.x = Ve, this.y = oe, this.matrix = wn, this.width = Dr(j), this.height = dr(j), this.outputDestination = Mt, this.id = "", this.objectNumber = -1;
  };
  Ti.prototype.restore = function() {
    xe = this.page, j = this.currentPage, Yt = this.pagesContext, Lt = this.pages, Ve = this.x, oe = this.y, wn = this.matrix, zi(j, this.width), Ui(j, this.height), Mt = this.outputDestination;
  };
  var Pa = function(s, v, C, T, J) {
    zn.push(new Ti()), xe = j = 0, Lt = [], Ve = s, oe = v, wn = J, Ci([C, T]);
  }, Mo = function(s) {
    if (Tn[s])
      zn.pop().restore();
    else {
      var v = new Ti(), C = "Xo" + (Object.keys(He).length + 1).toString(10);
      v.id = C, Tn[s] = C, He[C] = v, ce.publish("addFormObject", v), zn.pop().restore();
    }
  };
  for (var oi in d.beginFormObject = function(s, v, C, T, J) {
    return Pa(s, v, C, T, J), this;
  }, d.endFormObject = function(s) {
    return Mo(s), this;
  }, d.doFormObject = function(s, v) {
    var C = He[Tn[s]];
    return E("q"), E(v.toString() + " cm"), E("/" + C.id + " Do"), E("Q"), this;
  }, d.getFormObject = function(s) {
    var v = He[Tn[s]];
    return { x: v.x, y: v.y, width: v.width, height: v.height, matrix: v.matrix };
  }, d.save = function(s, v) {
    return s = s || "generated.pdf", (v = v || {}).returnPromise = v.returnPromise || !1, v.returnPromise === !1 ? (Ur(ti(tr()), s), typeof Ur.unload == "function" && Ht.setTimeout && setTimeout(Ur.unload, 911), this) : new Promise(function(C, T) {
      try {
        var J = Ur(ti(tr()), s);
        typeof Ur.unload == "function" && Ht.setTimeout && setTimeout(Ur.unload, 911), C(J);
      } catch (st) {
        T(st.message);
      }
    });
  }, zt.API)
    zt.API.hasOwnProperty(oi) && (oi === "events" && zt.API.events.length ? function(s, v) {
      var C, T, J;
      for (J = v.length - 1; J !== -1; J--)
        C = v[J][0], T = v[J][1], s.subscribe.apply(s, [C].concat(typeof T == "function" ? [T] : T));
    }(ce, zt.API.events) : d[oi] = zt.API[oi]);
  var Dr = d.getPageWidth = function(s) {
    return (Yt[s = s || j].mediaBox.topRightX - Yt[s].mediaBox.bottomLeftX) / It;
  }, zi = d.setPageWidth = function(s, v) {
    Yt[s].mediaBox.topRightX = v * It + Yt[s].mediaBox.bottomLeftX;
  }, dr = d.getPageHeight = function(s) {
    return (Yt[s = s || j].mediaBox.topRightY - Yt[s].mediaBox.bottomLeftY) / It;
  }, Ui = d.setPageHeight = function(s, v) {
    Yt[s].mediaBox.topRightY = v * It + Yt[s].mediaBox.bottomLeftY;
  };
  return d.internal = { pdfEscape: nn, getStyle: wa, getFont: Io, getFontSize: Pt, getCharSpace: Oo, getTextColor: jo, getLineHeight: Na, getLineHeightFactor: Sa, getLineWidth: ri, write: Xt, getHorizontalCoordinate: er, getVerticalCoordinate: fr, getCoordinateString: Co, getVerticalCoordinateString: pr, collections: {}, newObject: qe, newAdditionalObject: Gr, newObjectDeferred: Oe, newObjectDeferredBegin: cn, getFilters: Hn, putStream: dn, events: ce, scaleFactor: It, pageSize: { getWidth: function() {
    return Dr(j);
  }, setWidth: function(s) {
    zi(j, s);
  }, getHeight: function() {
    return dr(j);
  }, setHeight: function(s) {
    Ui(j, s);
  } }, encryptionOptions: b, encryption: Ge, getEncryptor: xo, output: ei, getNumberOfPages: yo, pages: Lt, out: E, f2: pt, f3: F, getPageInfo: ya, getPageInfoByObjId: Vt, getCurrentPageInfo: So, getPDFVersion: I, Point: ai, Rectangle: Ri, Matrix: Tt, hasHotfix: ba }, Object.defineProperty(d.internal.pageSize, "width", { get: function() {
    return Dr(j);
  }, set: function(s) {
    zi(j, s);
  }, enumerable: !0, configurable: !0 }), Object.defineProperty(d.internal.pageSize, "height", { get: function() {
    return dr(j);
  }, set: function(s) {
    Ui(j, s);
  }, enumerable: !0, configurable: !0 }), vo.call(d, At), ee = "F1", ga(u, n), ce.publish("initialized"), d;
}
Li.prototype.lsbFirstWord = function(i) {
  return String.fromCharCode(i >> 0 & 255, i >> 8 & 255, i >> 16 & 255, i >> 24 & 255);
}, Li.prototype.toHexString = function(i) {
  return i.split("").map(function(e) {
    return ("0" + (255 & e.charCodeAt(0)).toString(16)).slice(-2);
  }).join("");
}, Li.prototype.hexToBytes = function(i) {
  for (var e = [], n = 0; n < i.length; n += 2)
    e.push(String.fromCharCode(parseInt(i.substr(n, 2), 16)));
  return e.join("");
}, Li.prototype.processOwnerPassword = function(i, e) {
  return vs(ms(e).substr(0, 5), i);
}, Li.prototype.encryptor = function(i, e) {
  var n = ms(this.encryptionKey + String.fromCharCode(255 & i, i >> 8 & 255, i >> 16 & 255, 255 & e, e >> 8 & 255)).substr(0, 10);
  return function(a) {
    return vs(n, a);
  };
}, ao.prototype.equals = function(i) {
  var e, n = "id,objectNumber,equals";
  if (!i || fe(i) !== fe(this))
    return !1;
  var a = 0;
  for (e in this)
    if (!(n.indexOf(e) >= 0)) {
      if (this.hasOwnProperty(e) && !i.hasOwnProperty(e) || this[e] !== i[e])
        return !1;
      a++;
    }
  for (e in i)
    i.hasOwnProperty(e) && n.indexOf(e) < 0 && a--;
  return a === 0;
}, zt.API = { events: [] }, zt.version = "2.5.1";
var Pe = zt.API, Ls = 1, Vr = function(i) {
  return i.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, wi = function(i) {
  return i.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, Jt = function(i) {
  return i.toFixed(2);
}, kr = function(i) {
  return i.toFixed(5);
};
Pe.__acroform__ = {};
var un = function(i, e) {
  i.prototype = Object.create(e.prototype), i.prototype.constructor = i;
}, lu = function(i) {
  return i * Ls;
}, Jn = function(i) {
  var e = new ju(), n = Bt.internal.getHeight(i) || 0, a = Bt.internal.getWidth(i) || 0;
  return e.BBox = [0, 0, Number(Jt(a)), Number(Jt(n))], e;
}, Uc = Pe.__acroform__.setBit = function(i, e) {
  if (i = i || 0, e = e || 0, isNaN(i) || isNaN(e))
    throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
  return i |= 1 << e;
}, Hc = Pe.__acroform__.clearBit = function(i, e) {
  if (i = i || 0, e = e || 0, isNaN(i) || isNaN(e))
    throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
  return i &= ~(1 << e);
}, Wc = Pe.__acroform__.getBit = function(i, e) {
  if (isNaN(i) || isNaN(e))
    throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
  return i & 1 << e ? 1 : 0;
}, Ie = Pe.__acroform__.getBitForPdf = function(i, e) {
  if (isNaN(i) || isNaN(e))
    throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
  return Wc(i, e - 1);
}, Ce = Pe.__acroform__.setBitForPdf = function(i, e) {
  if (isNaN(i) || isNaN(e))
    throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
  return Uc(i, e - 1);
}, je = Pe.__acroform__.clearBitForPdf = function(i, e) {
  if (isNaN(i) || isNaN(e))
    throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
  return Hc(i, e - 1);
}, Vc = Pe.__acroform__.calculateCoordinates = function(i, e) {
  var n = e.internal.getHorizontalCoordinate, a = e.internal.getVerticalCoordinate, u = i[0], o = i[1], l = i[2], h = i[3], f = {};
  return f.lowerLeft_X = n(u) || 0, f.lowerLeft_Y = a(o + h) || 0, f.upperRight_X = n(u + l) || 0, f.upperRight_Y = a(o) || 0, [Number(Jt(f.lowerLeft_X)), Number(Jt(f.lowerLeft_Y)), Number(Jt(f.upperRight_X)), Number(Jt(f.upperRight_Y))];
}, Gc = function(i) {
  if (i.appearanceStreamContent)
    return i.appearanceStreamContent;
  if (i.V || i.DV) {
    var e = [], n = i._V || i.DV, a = bs(i, n), u = i.scope.internal.getFont(i.fontName, i.fontStyle).id;
    e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(i.scope.__private__.encodeColorString(i.color)), e.push("/" + u + " " + Jt(a.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(a.text), e.push("ET"), e.push("Q"), e.push("EMC");
    var o = Jn(i);
    return o.scope = i.scope, o.stream = e.join(`
`), o;
  }
}, bs = function(i, e) {
  var n = i.fontSize === 0 ? i.maxFontSize : i.fontSize, a = { text: "", fontSize: "" }, u = (e = (e = e.substr(0, 1) == "(" ? e.substr(1) : e).substr(e.length - 1) == ")" ? e.substr(0, e.length - 1) : e).split(" ");
  u = i.multiline ? u.map(function(F) {
    return F.split(`
`);
  }) : u.map(function(F) {
    return [F];
  });
  var o = n, l = Bt.internal.getHeight(i) || 0;
  l = l < 0 ? -l : l;
  var h = Bt.internal.getWidth(i) || 0;
  h = h < 0 ? -h : h;
  var f = function(F, P, z) {
    if (F + 1 < u.length) {
      var D = P + " " + u[F + 1][0];
      return Za(D, i, z).width <= h - 4;
    }
    return !1;
  };
  o++;
  t:
    for (; o > 0; ) {
      e = "", o--;
      var g, b, N = Za("3", i, o).height, S = i.multiline ? l - o : (l - N) / 2, d = S += 2, O = 0, I = 0, q = 0;
      if (o <= 0) {
        e = `(...) Tj
`, e += "% Width of Text: " + Za(e, i, o = 12).width + ", FieldWidth:" + h + `
`;
        break;
      }
      for (var _ = "", M = 0, X = 0; X < u.length; X++)
        if (u.hasOwnProperty(X)) {
          var ot = !1;
          if (u[X].length !== 1 && q !== u[X].length - 1) {
            if ((N + 2) * (M + 2) + 2 > l)
              continue t;
            _ += u[X][q], ot = !0, I = X, X--;
          } else {
            _ = (_ += u[X][q] + " ").substr(_.length - 1) == " " ? _.substr(0, _.length - 1) : _;
            var ct = parseInt(X), yt = f(ct, _, o), tt = X >= u.length - 1;
            if (yt && !tt) {
              _ += " ", q = 0;
              continue;
            }
            if (yt || tt) {
              if (tt)
                I = ct;
              else if (i.multiline && (N + 2) * (M + 2) + 2 > l)
                continue t;
            } else {
              if (!i.multiline || (N + 2) * (M + 2) + 2 > l)
                continue t;
              I = ct;
            }
          }
          for (var R = "", gt = O; gt <= I; gt++) {
            var pt = u[gt];
            if (i.multiline) {
              if (gt === I) {
                R += pt[q] + " ", q = (q + 1) % pt.length;
                continue;
              }
              if (gt === O) {
                R += pt[pt.length - 1] + " ";
                continue;
              }
            }
            R += pt[0] + " ";
          }
          switch (R = R.substr(R.length - 1) == " " ? R.substr(0, R.length - 1) : R, b = Za(R, i, o).width, i.textAlign) {
            case "right":
              g = h - b - 2;
              break;
            case "center":
              g = (h - b) / 2;
              break;
            case "left":
            default:
              g = 2;
          }
          e += Jt(g) + " " + Jt(d) + ` Td
`, e += "(" + Vr(R) + `) Tj
`, e += -Jt(g) + ` 0 Td
`, d = -(o + 2), b = 0, O = ot ? I : I + 1, M++, _ = "";
        }
      break;
    }
  return a.text = e, a.fontSize = o, a;
}, Za = function(i, e, n) {
  var a = e.scope.internal.getFont(e.fontName, e.fontStyle), u = e.scope.getStringUnitWidth(i, { font: a, fontSize: parseFloat(n), charSpace: 0 }) * parseFloat(n);
  return { height: e.scope.getStringUnitWidth("3", { font: a, fontSize: parseFloat(n), charSpace: 0 }) * parseFloat(n) * 1.5, width: u };
}, Yc = { fields: [], xForms: [], acroFormDictionaryRoot: null, printedOut: !1, internal: null, isInitialized: !1 }, Jc = function(i, e) {
  var n = { type: "reference", object: i };
  e.internal.getPageInfo(i.page).pageContext.annotations.find(function(a) {
    return a.type === n.type && a.object === n.object;
  }) === void 0 && e.internal.getPageInfo(i.page).pageContext.annotations.push(n);
}, Xc = function(i, e) {
  for (var n in i)
    if (i.hasOwnProperty(n)) {
      var a = n, u = i[n];
      e.internal.newObjectDeferredBegin(u.objId, !0), fe(u) === "object" && typeof u.putStream == "function" && u.putStream(), delete i[a];
    }
}, Kc = function(i, e) {
  if (e.scope = i, i.internal !== void 0 && (i.internal.acroformPlugin === void 0 || i.internal.acroformPlugin.isInitialized === !1)) {
    if (qn.FieldNum = 0, i.internal.acroformPlugin = JSON.parse(JSON.stringify(Yc)), i.internal.acroformPlugin.acroFormDictionaryRoot)
      throw new Error("Exception while creating AcroformDictionary");
    Ls = i.internal.scaleFactor, i.internal.acroformPlugin.acroFormDictionaryRoot = new Ou(), i.internal.acroformPlugin.acroFormDictionaryRoot.scope = i, i.internal.acroformPlugin.acroFormDictionaryRoot._eventID = i.internal.events.subscribe("postPutResources", function() {
      (function(n) {
        n.internal.events.unsubscribe(n.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete n.internal.acroformPlugin.acroFormDictionaryRoot._eventID, n.internal.acroformPlugin.printedOut = !0;
      })(i);
    }), i.internal.events.subscribe("buildDocument", function() {
      (function(n) {
        n.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
        var a = n.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
        for (var u in a)
          if (a.hasOwnProperty(u)) {
            var o = a[u];
            o.objId = void 0, o.hasAnnotation && Jc(o, n);
          }
      })(i);
    }), i.internal.events.subscribe("putCatalog", function() {
      (function(n) {
        if (n.internal.acroformPlugin.acroFormDictionaryRoot === void 0)
          throw new Error("putCatalogCallback: Root missing.");
        n.internal.write("/AcroForm " + n.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
      })(i);
    }), i.internal.events.subscribe("postPutPages", function(n) {
      (function(a, u) {
        var o = !a;
        for (var l in a || (u.internal.newObjectDeferredBegin(u.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), u.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), a = a || u.internal.acroformPlugin.acroFormDictionaryRoot.Kids)
          if (a.hasOwnProperty(l)) {
            var h = a[l], f = [], g = h.Rect;
            if (h.Rect && (h.Rect = Vc(h.Rect, u)), u.internal.newObjectDeferredBegin(h.objId, !0), h.DA = Bt.createDefaultAppearanceStream(h), fe(h) === "object" && typeof h.getKeyValueListForStream == "function" && (f = h.getKeyValueListForStream()), h.Rect = g, h.hasAppearanceStream && !h.appearanceStreamContent) {
              var b = Gc(h);
              f.push({ key: "AP", value: "<</N " + b + ">>" }), u.internal.acroformPlugin.xForms.push(b);
            }
            if (h.appearanceStreamContent) {
              var N = "";
              for (var S in h.appearanceStreamContent)
                if (h.appearanceStreamContent.hasOwnProperty(S)) {
                  var d = h.appearanceStreamContent[S];
                  if (N += "/" + S + " ", N += "<<", Object.keys(d).length >= 1 || Array.isArray(d)) {
                    for (var l in d)
                      if (d.hasOwnProperty(l)) {
                        var O = d[l];
                        typeof O == "function" && (O = O.call(u, h)), N += "/" + l + " " + O + " ", u.internal.acroformPlugin.xForms.indexOf(O) >= 0 || u.internal.acroformPlugin.xForms.push(O);
                      }
                  } else
                    typeof (O = d) == "function" && (O = O.call(u, h)), N += "/" + l + " " + O, u.internal.acroformPlugin.xForms.indexOf(O) >= 0 || u.internal.acroformPlugin.xForms.push(O);
                  N += ">>";
                }
              f.push({ key: "AP", value: `<<
` + N + ">>" });
            }
            u.internal.putStream({ additionalKeyValues: f, objectId: h.objId }), u.internal.out("endobj");
          }
        o && Xc(u.internal.acroformPlugin.xForms, u);
      })(n, i);
    }), i.internal.acroformPlugin.isInitialized = !0;
  }
}, Cu = Pe.__acroform__.arrayToPdfArray = function(i, e, n) {
  var a = function(l) {
    return l;
  };
  if (Array.isArray(i)) {
    for (var u = "[", o = 0; o < i.length; o++)
      switch (o !== 0 && (u += " "), fe(i[o])) {
        case "boolean":
        case "number":
        case "object":
          u += i[o].toString();
          break;
        case "string":
          i[o].substr(0, 1) !== "/" ? (e !== void 0 && n && (a = n.internal.getEncryptor(e)), u += "(" + Vr(a(i[o].toString())) + ")") : u += i[o].toString();
      }
    return u += "]";
  }
  throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
}, ss = function(i, e, n) {
  var a = function(u) {
    return u;
  };
  return e !== void 0 && n && (a = n.internal.getEncryptor(e)), (i = i || "").toString(), i = "(" + Vr(a(i)) + ")";
}, Xn = function() {
  this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", { get: function() {
    if (this._objId === void 0) {
      if (this.scope === void 0)
        return;
      this._objId = this.scope.internal.newObjectDeferred();
    }
    return this._objId;
  }, set: function(i) {
    this._objId = i;
  } }), Object.defineProperty(this, "scope", { value: this._scope, writable: !0 });
};
Xn.prototype.toString = function() {
  return this.objId + " 0 R";
}, Xn.prototype.putStream = function() {
  var i = this.getKeyValueListForStream();
  this.scope.internal.putStream({ data: this.stream, additionalKeyValues: i, objectId: this.objId }), this.scope.internal.out("endobj");
}, Xn.prototype.getKeyValueListForStream = function() {
  var i = [], e = Object.getOwnPropertyNames(this).filter(function(o) {
    return o != "content" && o != "appearanceStreamContent" && o != "scope" && o != "objId" && o.substring(0, 1) != "_";
  });
  for (var n in e)
    if (Object.getOwnPropertyDescriptor(this, e[n]).configurable === !1) {
      var a = e[n], u = this[a];
      u && (Array.isArray(u) ? i.push({ key: a, value: Cu(u, this.objId, this.scope) }) : u instanceof Xn ? (u.scope = this.scope, i.push({ key: a, value: u.objId + " 0 R" })) : typeof u != "function" && i.push({ key: a, value: u }));
    }
  return i;
};
var ju = function() {
  Xn.call(this), Object.defineProperty(this, "Type", { value: "/XObject", configurable: !1, writable: !0 }), Object.defineProperty(this, "Subtype", { value: "/Form", configurable: !1, writable: !0 }), Object.defineProperty(this, "FormType", { value: 1, configurable: !1, writable: !0 });
  var i, e = [];
  Object.defineProperty(this, "BBox", { configurable: !1, get: function() {
    return e;
  }, set: function(n) {
    e = n;
  } }), Object.defineProperty(this, "Resources", { value: "2 0 R", configurable: !1, writable: !0 }), Object.defineProperty(this, "stream", { enumerable: !1, configurable: !0, set: function(n) {
    i = n.trim();
  }, get: function() {
    return i || null;
  } });
};
un(ju, Xn);
var Ou = function() {
  Xn.call(this);
  var i, e = [];
  Object.defineProperty(this, "Kids", { enumerable: !1, configurable: !0, get: function() {
    return e.length > 0 ? e : void 0;
  } }), Object.defineProperty(this, "Fields", { enumerable: !1, configurable: !1, get: function() {
    return e;
  } }), Object.defineProperty(this, "DA", { enumerable: !1, configurable: !1, get: function() {
    if (i) {
      var n = function(a) {
        return a;
      };
      return this.scope && (n = this.scope.internal.getEncryptor(this.objId)), "(" + Vr(n(i)) + ")";
    }
  }, set: function(n) {
    i = n;
  } });
};
un(Ou, Xn);
var qn = function i() {
  Xn.call(this);
  var e = 4;
  Object.defineProperty(this, "F", { enumerable: !1, configurable: !1, get: function() {
    return e;
  }, set: function(_) {
    if (isNaN(_))
      throw new Error('Invalid value "' + _ + '" for attribute F supplied.');
    e = _;
  } }), Object.defineProperty(this, "showWhenPrinted", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(e, 3);
  }, set: function(_) {
    _ ? this.F = Ce(e, 3) : this.F = je(e, 3);
  } });
  var n = 0;
  Object.defineProperty(this, "Ff", { enumerable: !1, configurable: !1, get: function() {
    return n;
  }, set: function(_) {
    if (isNaN(_))
      throw new Error('Invalid value "' + _ + '" for attribute Ff supplied.');
    n = _;
  } });
  var a = [];
  Object.defineProperty(this, "Rect", { enumerable: !1, configurable: !1, get: function() {
    if (a.length !== 0)
      return a;
  }, set: function(_) {
    a = _ !== void 0 ? _ : [];
  } }), Object.defineProperty(this, "x", { enumerable: !0, configurable: !0, get: function() {
    return !a || isNaN(a[0]) ? 0 : a[0];
  }, set: function(_) {
    a[0] = _;
  } }), Object.defineProperty(this, "y", { enumerable: !0, configurable: !0, get: function() {
    return !a || isNaN(a[1]) ? 0 : a[1];
  }, set: function(_) {
    a[1] = _;
  } }), Object.defineProperty(this, "width", { enumerable: !0, configurable: !0, get: function() {
    return !a || isNaN(a[2]) ? 0 : a[2];
  }, set: function(_) {
    a[2] = _;
  } }), Object.defineProperty(this, "height", { enumerable: !0, configurable: !0, get: function() {
    return !a || isNaN(a[3]) ? 0 : a[3];
  }, set: function(_) {
    a[3] = _;
  } });
  var u = "";
  Object.defineProperty(this, "FT", { enumerable: !0, configurable: !1, get: function() {
    return u;
  }, set: function(_) {
    switch (_) {
      case "/Btn":
      case "/Tx":
      case "/Ch":
      case "/Sig":
        u = _;
        break;
      default:
        throw new Error('Invalid value "' + _ + '" for attribute FT supplied.');
    }
  } });
  var o = null;
  Object.defineProperty(this, "T", { enumerable: !0, configurable: !1, get: function() {
    if (!o || o.length < 1) {
      if (this instanceof oo)
        return;
      o = "FieldObject" + i.FieldNum++;
    }
    var _ = function(M) {
      return M;
    };
    return this.scope && (_ = this.scope.internal.getEncryptor(this.objId)), "(" + Vr(_(o)) + ")";
  }, set: function(_) {
    o = _.toString();
  } }), Object.defineProperty(this, "fieldName", { configurable: !0, enumerable: !0, get: function() {
    return o;
  }, set: function(_) {
    o = _;
  } });
  var l = "helvetica";
  Object.defineProperty(this, "fontName", { enumerable: !0, configurable: !0, get: function() {
    return l;
  }, set: function(_) {
    l = _;
  } });
  var h = "normal";
  Object.defineProperty(this, "fontStyle", { enumerable: !0, configurable: !0, get: function() {
    return h;
  }, set: function(_) {
    h = _;
  } });
  var f = 0;
  Object.defineProperty(this, "fontSize", { enumerable: !0, configurable: !0, get: function() {
    return f;
  }, set: function(_) {
    f = _;
  } });
  var g = void 0;
  Object.defineProperty(this, "maxFontSize", { enumerable: !0, configurable: !0, get: function() {
    return g === void 0 ? 50 / Ls : g;
  }, set: function(_) {
    g = _;
  } });
  var b = "black";
  Object.defineProperty(this, "color", { enumerable: !0, configurable: !0, get: function() {
    return b;
  }, set: function(_) {
    b = _;
  } });
  var N = "/F1 0 Tf 0 g";
  Object.defineProperty(this, "DA", { enumerable: !0, configurable: !1, get: function() {
    if (!(!N || this instanceof oo || this instanceof Wr))
      return ss(N, this.objId, this.scope);
  }, set: function(_) {
    _ = _.toString(), N = _;
  } });
  var S = null;
  Object.defineProperty(this, "DV", { enumerable: !1, configurable: !1, get: function() {
    if (S)
      return this instanceof Ue ? S : ss(S, this.objId, this.scope);
  }, set: function(_) {
    _ = _.toString(), S = this instanceof Ue ? _ : _.substr(0, 1) === "(" ? wi(_.substr(1, _.length - 2)) : wi(_);
  } }), Object.defineProperty(this, "defaultValue", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof Ue ? wi(S.substr(1, S.length - 1)) : S;
  }, set: function(_) {
    _ = _.toString(), S = this instanceof Ue ? "/" + _ : _;
  } });
  var d = null;
  Object.defineProperty(this, "_V", { enumerable: !1, configurable: !1, get: function() {
    if (d)
      return d;
  }, set: function(_) {
    this.V = _;
  } }), Object.defineProperty(this, "V", { enumerable: !1, configurable: !1, get: function() {
    if (d)
      return this instanceof Ue ? d : ss(d, this.objId, this.scope);
  }, set: function(_) {
    _ = _.toString(), d = this instanceof Ue ? _ : _.substr(0, 1) === "(" ? wi(_.substr(1, _.length - 2)) : wi(_);
  } }), Object.defineProperty(this, "value", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof Ue ? wi(d.substr(1, d.length - 1)) : d;
  }, set: function(_) {
    _ = _.toString(), d = this instanceof Ue ? "/" + _ : _;
  } }), Object.defineProperty(this, "hasAnnotation", { enumerable: !0, configurable: !0, get: function() {
    return this.Rect;
  } }), Object.defineProperty(this, "Type", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Annot" : null;
  } }), Object.defineProperty(this, "Subtype", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Widget" : null;
  } });
  var O, I = !1;
  Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return I;
  }, set: function(_) {
    _ = !!_, I = _;
  } }), Object.defineProperty(this, "page", { enumerable: !0, configurable: !0, get: function() {
    if (O)
      return O;
  }, set: function(_) {
    O = _;
  } }), Object.defineProperty(this, "readOnly", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 1);
  }, set: function(_) {
    _ ? this.Ff = Ce(this.Ff, 1) : this.Ff = je(this.Ff, 1);
  } }), Object.defineProperty(this, "required", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 2);
  }, set: function(_) {
    _ ? this.Ff = Ce(this.Ff, 2) : this.Ff = je(this.Ff, 2);
  } }), Object.defineProperty(this, "noExport", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 3);
  }, set: function(_) {
    _ ? this.Ff = Ce(this.Ff, 3) : this.Ff = je(this.Ff, 3);
  } });
  var q = null;
  Object.defineProperty(this, "Q", { enumerable: !0, configurable: !1, get: function() {
    if (q !== null)
      return q;
  }, set: function(_) {
    if ([0, 1, 2].indexOf(_) === -1)
      throw new Error('Invalid value "' + _ + '" for attribute Q supplied.');
    q = _;
  } }), Object.defineProperty(this, "textAlign", { get: function() {
    var _;
    switch (q) {
      case 0:
      default:
        _ = "left";
        break;
      case 1:
        _ = "center";
        break;
      case 2:
        _ = "right";
    }
    return _;
  }, configurable: !0, enumerable: !0, set: function(_) {
    switch (_) {
      case "right":
      case 2:
        q = 2;
        break;
      case "center":
      case 1:
        q = 1;
        break;
      case "left":
      case 0:
      default:
        q = 0;
    }
  } });
};
un(qn, Xn);
var Si = function() {
  qn.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
  var i = 0;
  Object.defineProperty(this, "TI", { enumerable: !0, configurable: !1, get: function() {
    return i;
  }, set: function(n) {
    i = n;
  } }), Object.defineProperty(this, "topIndex", { enumerable: !0, configurable: !0, get: function() {
    return i;
  }, set: function(n) {
    i = n;
  } });
  var e = [];
  Object.defineProperty(this, "Opt", { enumerable: !0, configurable: !1, get: function() {
    return Cu(e, this.objId, this.scope);
  }, set: function(n) {
    var a, u;
    u = [], typeof (a = n) == "string" && (u = function(o, l, h) {
      h || (h = 1);
      for (var f, g = []; f = l.exec(o); )
        g.push(f[h]);
      return g;
    }(a, /\((.*?)\)/g)), e = u;
  } }), this.getOptions = function() {
    return e;
  }, this.setOptions = function(n) {
    e = n, this.sort && e.sort();
  }, this.addOption = function(n) {
    n = (n = n || "").toString(), e.push(n), this.sort && e.sort();
  }, this.removeOption = function(n, a) {
    for (a = a || !1, n = (n = n || "").toString(); e.indexOf(n) !== -1 && (e.splice(e.indexOf(n), 1), a !== !1); )
      ;
  }, Object.defineProperty(this, "combo", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 18);
  }, set: function(n) {
    n ? this.Ff = Ce(this.Ff, 18) : this.Ff = je(this.Ff, 18);
  } }), Object.defineProperty(this, "edit", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 19);
  }, set: function(n) {
    this.combo === !0 && (n ? this.Ff = Ce(this.Ff, 19) : this.Ff = je(this.Ff, 19));
  } }), Object.defineProperty(this, "sort", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 20);
  }, set: function(n) {
    n ? (this.Ff = Ce(this.Ff, 20), e.sort()) : this.Ff = je(this.Ff, 20);
  } }), Object.defineProperty(this, "multiSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 22);
  }, set: function(n) {
    n ? this.Ff = Ce(this.Ff, 22) : this.Ff = je(this.Ff, 22);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 23);
  }, set: function(n) {
    n ? this.Ff = Ce(this.Ff, 23) : this.Ff = je(this.Ff, 23);
  } }), Object.defineProperty(this, "commitOnSelChange", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 27);
  }, set: function(n) {
    n ? this.Ff = Ce(this.Ff, 27) : this.Ff = je(this.Ff, 27);
  } }), this.hasAppearanceStream = !1;
};
un(Si, qn);
var _i = function() {
  Si.call(this), this.fontName = "helvetica", this.combo = !1;
};
un(_i, Si);
var Pi = function() {
  _i.call(this), this.combo = !0;
};
un(Pi, _i);
var eo = function() {
  Pi.call(this), this.edit = !0;
};
un(eo, Pi);
var Ue = function() {
  qn.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 15);
  }, set: function(n) {
    n ? this.Ff = Ce(this.Ff, 15) : this.Ff = je(this.Ff, 15);
  } }), Object.defineProperty(this, "radio", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 16);
  }, set: function(n) {
    n ? this.Ff = Ce(this.Ff, 16) : this.Ff = je(this.Ff, 16);
  } }), Object.defineProperty(this, "pushButton", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 17);
  }, set: function(n) {
    n ? this.Ff = Ce(this.Ff, 17) : this.Ff = je(this.Ff, 17);
  } }), Object.defineProperty(this, "radioIsUnison", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 26);
  }, set: function(n) {
    n ? this.Ff = Ce(this.Ff, 26) : this.Ff = je(this.Ff, 26);
  } });
  var i, e = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var n = function(o) {
      return o;
    };
    if (this.scope && (n = this.scope.internal.getEncryptor(this.objId)), Object.keys(e).length !== 0) {
      var a, u = [];
      for (a in u.push("<<"), e)
        u.push("/" + a + " (" + Vr(n(e[a])) + ")");
      return u.push(">>"), u.join(`
`);
    }
  }, set: function(n) {
    fe(n) === "object" && (e = n);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return e.CA || "";
  }, set: function(n) {
    typeof n == "string" && (e.CA = n);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return i;
  }, set: function(n) {
    i = n;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return i.substr(1, i.length - 1);
  }, set: function(n) {
    i = "/" + n;
  } });
};
un(Ue, qn);
var no = function() {
  Ue.call(this), this.pushButton = !0;
};
un(no, Ue);
var ki = function() {
  Ue.call(this), this.radio = !0, this.pushButton = !1;
  var i = [];
  Object.defineProperty(this, "Kids", { enumerable: !0, configurable: !1, get: function() {
    return i;
  }, set: function(e) {
    i = e !== void 0 ? e : [];
  } });
};
un(ki, Ue);
var oo = function() {
  var i, e;
  qn.call(this), Object.defineProperty(this, "Parent", { enumerable: !1, configurable: !1, get: function() {
    return i;
  }, set: function(u) {
    i = u;
  } }), Object.defineProperty(this, "optionName", { enumerable: !1, configurable: !0, get: function() {
    return e;
  }, set: function(u) {
    e = u;
  } });
  var n, a = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var u = function(h) {
      return h;
    };
    this.scope && (u = this.scope.internal.getEncryptor(this.objId));
    var o, l = [];
    for (o in l.push("<<"), a)
      l.push("/" + o + " (" + Vr(u(a[o])) + ")");
    return l.push(">>"), l.join(`
`);
  }, set: function(u) {
    fe(u) === "object" && (a = u);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return a.CA || "";
  }, set: function(u) {
    typeof u == "string" && (a.CA = u);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return n;
  }, set: function(u) {
    n = u;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return n.substr(1, n.length - 1);
  }, set: function(u) {
    n = "/" + u;
  } }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = Bt.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
un(oo, qn), ki.prototype.setAppearance = function(i) {
  if (!("createAppearanceStream" in i) || !("getCA" in i))
    throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
  for (var e in this.Kids)
    if (this.Kids.hasOwnProperty(e)) {
      var n = this.Kids[e];
      n.appearanceStreamContent = i.createAppearanceStream(n.optionName), n.caption = i.getCA();
    }
}, ki.prototype.createOption = function(i) {
  var e = new oo();
  return e.Parent = this, e.optionName = i, this.Kids.push(e), Zc.call(this.scope, e), e;
};
var ro = function() {
  Ue.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = Bt.CheckBox.createAppearanceStream();
};
un(ro, Ue);
var Wr = function() {
  qn.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 13);
  }, set: function(e) {
    e ? this.Ff = Ce(this.Ff, 13) : this.Ff = je(this.Ff, 13);
  } }), Object.defineProperty(this, "fileSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 21);
  }, set: function(e) {
    e ? this.Ff = Ce(this.Ff, 21) : this.Ff = je(this.Ff, 21);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 23);
  }, set: function(e) {
    e ? this.Ff = Ce(this.Ff, 23) : this.Ff = je(this.Ff, 23);
  } }), Object.defineProperty(this, "doNotScroll", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 24);
  }, set: function(e) {
    e ? this.Ff = Ce(this.Ff, 24) : this.Ff = je(this.Ff, 24);
  } }), Object.defineProperty(this, "comb", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 25);
  }, set: function(e) {
    e ? this.Ff = Ce(this.Ff, 25) : this.Ff = je(this.Ff, 25);
  } }), Object.defineProperty(this, "richText", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 26);
  }, set: function(e) {
    e ? this.Ff = Ce(this.Ff, 26) : this.Ff = je(this.Ff, 26);
  } });
  var i = null;
  Object.defineProperty(this, "MaxLen", { enumerable: !0, configurable: !1, get: function() {
    return i;
  }, set: function(e) {
    i = e;
  } }), Object.defineProperty(this, "maxLength", { enumerable: !0, configurable: !0, get: function() {
    return i;
  }, set: function(e) {
    Number.isInteger(e) && (i = e);
  } }), Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return this.V || this.DV;
  } });
};
un(Wr, qn);
var io = function() {
  Wr.call(this), Object.defineProperty(this, "password", { enumerable: !0, configurable: !0, get: function() {
    return !!Ie(this.Ff, 14);
  }, set: function(i) {
    i ? this.Ff = Ce(this.Ff, 14) : this.Ff = je(this.Ff, 14);
  } }), this.password = !0;
};
un(io, Wr);
var Bt = { CheckBox: { createAppearanceStream: function() {
  return { N: { On: Bt.CheckBox.YesNormal }, D: { On: Bt.CheckBox.YesPushDown, Off: Bt.CheckBox.OffPushDown } };
}, YesPushDown: function(i) {
  var e = Jn(i);
  e.scope = i.scope;
  var n = [], a = i.scope.internal.getFont(i.fontName, i.fontStyle).id, u = i.scope.__private__.encodeColorString(i.color), o = bs(i, i.caption);
  return n.push("0.749023 g"), n.push("0 0 " + Jt(Bt.internal.getWidth(i)) + " " + Jt(Bt.internal.getHeight(i)) + " re"), n.push("f"), n.push("BMC"), n.push("q"), n.push("0 0 1 rg"), n.push("/" + a + " " + Jt(o.fontSize) + " Tf " + u), n.push("BT"), n.push(o.text), n.push("ET"), n.push("Q"), n.push("EMC"), e.stream = n.join(`
`), e;
}, YesNormal: function(i) {
  var e = Jn(i);
  e.scope = i.scope;
  var n = i.scope.internal.getFont(i.fontName, i.fontStyle).id, a = i.scope.__private__.encodeColorString(i.color), u = [], o = Bt.internal.getHeight(i), l = Bt.internal.getWidth(i), h = bs(i, i.caption);
  return u.push("1 g"), u.push("0 0 " + Jt(l) + " " + Jt(o) + " re"), u.push("f"), u.push("q"), u.push("0 0 1 rg"), u.push("0 0 " + Jt(l - 1) + " " + Jt(o - 1) + " re"), u.push("W"), u.push("n"), u.push("0 g"), u.push("BT"), u.push("/" + n + " " + Jt(h.fontSize) + " Tf " + a), u.push(h.text), u.push("ET"), u.push("Q"), e.stream = u.join(`
`), e;
}, OffPushDown: function(i) {
  var e = Jn(i);
  e.scope = i.scope;
  var n = [];
  return n.push("0.749023 g"), n.push("0 0 " + Jt(Bt.internal.getWidth(i)) + " " + Jt(Bt.internal.getHeight(i)) + " re"), n.push("f"), e.stream = n.join(`
`), e;
} }, RadioButton: { Circle: { createAppearanceStream: function(i) {
  var e = { D: { Off: Bt.RadioButton.Circle.OffPushDown }, N: {} };
  return e.N[i] = Bt.RadioButton.Circle.YesNormal, e.D[i] = Bt.RadioButton.Circle.YesPushDown, e;
}, getCA: function() {
  return "l";
}, YesNormal: function(i) {
  var e = Jn(i);
  e.scope = i.scope;
  var n = [], a = Bt.internal.getWidth(i) <= Bt.internal.getHeight(i) ? Bt.internal.getWidth(i) / 4 : Bt.internal.getHeight(i) / 4;
  a = Number((0.9 * a).toFixed(5));
  var u = Bt.internal.Bezier_C, o = Number((a * u).toFixed(5));
  return n.push("q"), n.push("1 0 0 1 " + kr(Bt.internal.getWidth(i) / 2) + " " + kr(Bt.internal.getHeight(i) / 2) + " cm"), n.push(a + " 0 m"), n.push(a + " " + o + " " + o + " " + a + " 0 " + a + " c"), n.push("-" + o + " " + a + " -" + a + " " + o + " -" + a + " 0 c"), n.push("-" + a + " -" + o + " -" + o + " -" + a + " 0 -" + a + " c"), n.push(o + " -" + a + " " + a + " -" + o + " " + a + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join(`
`), e;
}, YesPushDown: function(i) {
  var e = Jn(i);
  e.scope = i.scope;
  var n = [], a = Bt.internal.getWidth(i) <= Bt.internal.getHeight(i) ? Bt.internal.getWidth(i) / 4 : Bt.internal.getHeight(i) / 4;
  a = Number((0.9 * a).toFixed(5));
  var u = Number((2 * a).toFixed(5)), o = Number((u * Bt.internal.Bezier_C).toFixed(5)), l = Number((a * Bt.internal.Bezier_C).toFixed(5));
  return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + kr(Bt.internal.getWidth(i) / 2) + " " + kr(Bt.internal.getHeight(i) / 2) + " cm"), n.push(u + " 0 m"), n.push(u + " " + o + " " + o + " " + u + " 0 " + u + " c"), n.push("-" + o + " " + u + " -" + u + " " + o + " -" + u + " 0 c"), n.push("-" + u + " -" + o + " -" + o + " -" + u + " 0 -" + u + " c"), n.push(o + " -" + u + " " + u + " -" + o + " " + u + " 0 c"), n.push("f"), n.push("Q"), n.push("0 g"), n.push("q"), n.push("1 0 0 1 " + kr(Bt.internal.getWidth(i) / 2) + " " + kr(Bt.internal.getHeight(i) / 2) + " cm"), n.push(a + " 0 m"), n.push(a + " " + l + " " + l + " " + a + " 0 " + a + " c"), n.push("-" + l + " " + a + " -" + a + " " + l + " -" + a + " 0 c"), n.push("-" + a + " -" + l + " -" + l + " -" + a + " 0 -" + a + " c"), n.push(l + " -" + a + " " + a + " -" + l + " " + a + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join(`
`), e;
}, OffPushDown: function(i) {
  var e = Jn(i);
  e.scope = i.scope;
  var n = [], a = Bt.internal.getWidth(i) <= Bt.internal.getHeight(i) ? Bt.internal.getWidth(i) / 4 : Bt.internal.getHeight(i) / 4;
  a = Number((0.9 * a).toFixed(5));
  var u = Number((2 * a).toFixed(5)), o = Number((u * Bt.internal.Bezier_C).toFixed(5));
  return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + kr(Bt.internal.getWidth(i) / 2) + " " + kr(Bt.internal.getHeight(i) / 2) + " cm"), n.push(u + " 0 m"), n.push(u + " " + o + " " + o + " " + u + " 0 " + u + " c"), n.push("-" + o + " " + u + " -" + u + " " + o + " -" + u + " 0 c"), n.push("-" + u + " -" + o + " -" + o + " -" + u + " 0 -" + u + " c"), n.push(o + " -" + u + " " + u + " -" + o + " " + u + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join(`
`), e;
} }, Cross: { createAppearanceStream: function(i) {
  var e = { D: { Off: Bt.RadioButton.Cross.OffPushDown }, N: {} };
  return e.N[i] = Bt.RadioButton.Cross.YesNormal, e.D[i] = Bt.RadioButton.Cross.YesPushDown, e;
}, getCA: function() {
  return "8";
}, YesNormal: function(i) {
  var e = Jn(i);
  e.scope = i.scope;
  var n = [], a = Bt.internal.calculateCross(i);
  return n.push("q"), n.push("1 1 " + Jt(Bt.internal.getWidth(i) - 2) + " " + Jt(Bt.internal.getHeight(i) - 2) + " re"), n.push("W"), n.push("n"), n.push(Jt(a.x1.x) + " " + Jt(a.x1.y) + " m"), n.push(Jt(a.x2.x) + " " + Jt(a.x2.y) + " l"), n.push(Jt(a.x4.x) + " " + Jt(a.x4.y) + " m"), n.push(Jt(a.x3.x) + " " + Jt(a.x3.y) + " l"), n.push("s"), n.push("Q"), e.stream = n.join(`
`), e;
}, YesPushDown: function(i) {
  var e = Jn(i);
  e.scope = i.scope;
  var n = Bt.internal.calculateCross(i), a = [];
  return a.push("0.749023 g"), a.push("0 0 " + Jt(Bt.internal.getWidth(i)) + " " + Jt(Bt.internal.getHeight(i)) + " re"), a.push("f"), a.push("q"), a.push("1 1 " + Jt(Bt.internal.getWidth(i) - 2) + " " + Jt(Bt.internal.getHeight(i) - 2) + " re"), a.push("W"), a.push("n"), a.push(Jt(n.x1.x) + " " + Jt(n.x1.y) + " m"), a.push(Jt(n.x2.x) + " " + Jt(n.x2.y) + " l"), a.push(Jt(n.x4.x) + " " + Jt(n.x4.y) + " m"), a.push(Jt(n.x3.x) + " " + Jt(n.x3.y) + " l"), a.push("s"), a.push("Q"), e.stream = a.join(`
`), e;
}, OffPushDown: function(i) {
  var e = Jn(i);
  e.scope = i.scope;
  var n = [];
  return n.push("0.749023 g"), n.push("0 0 " + Jt(Bt.internal.getWidth(i)) + " " + Jt(Bt.internal.getHeight(i)) + " re"), n.push("f"), e.stream = n.join(`
`), e;
} } }, createDefaultAppearanceStream: function(i) {
  var e = i.scope.internal.getFont(i.fontName, i.fontStyle).id, n = i.scope.__private__.encodeColorString(i.color);
  return "/" + e + " " + i.fontSize + " Tf " + n;
} };
Bt.internal = { Bezier_C: 0.551915024494, calculateCross: function(i) {
  var e = Bt.internal.getWidth(i), n = Bt.internal.getHeight(i), a = Math.min(e, n);
  return { x1: { x: (e - a) / 2, y: (n - a) / 2 + a }, x2: { x: (e - a) / 2 + a, y: (n - a) / 2 }, x3: { x: (e - a) / 2, y: (n - a) / 2 }, x4: { x: (e - a) / 2 + a, y: (n - a) / 2 + a } };
} }, Bt.internal.getWidth = function(i) {
  var e = 0;
  return fe(i) === "object" && (e = lu(i.Rect[2])), e;
}, Bt.internal.getHeight = function(i) {
  var e = 0;
  return fe(i) === "object" && (e = lu(i.Rect[3])), e;
};
var Zc = Pe.addField = function(i) {
  if (Kc(this, i), !(i instanceof qn))
    throw new Error("Invalid argument passed to jsPDF.addField.");
  var e;
  return (e = i).scope.internal.acroformPlugin.printedOut && (e.scope.internal.acroformPlugin.printedOut = !1, e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e), i.page = i.scope.internal.getCurrentPageInfo().pageNumber, this;
};
Pe.AcroFormChoiceField = Si, Pe.AcroFormListBox = _i, Pe.AcroFormComboBox = Pi, Pe.AcroFormEditBox = eo, Pe.AcroFormButton = Ue, Pe.AcroFormPushButton = no, Pe.AcroFormRadioButton = ki, Pe.AcroFormCheckBox = ro, Pe.AcroFormTextField = Wr, Pe.AcroFormPasswordField = io, Pe.AcroFormAppearance = Bt, Pe.AcroForm = { ChoiceField: Si, ListBox: _i, ComboBox: Pi, EditBox: eo, Button: Ue, PushButton: no, RadioButton: ki, CheckBox: ro, TextField: Wr, PasswordField: io, Appearance: Bt }, zt.AcroForm = { ChoiceField: Si, ListBox: _i, ComboBox: Pi, EditBox: eo, Button: Ue, PushButton: no, RadioButton: ki, CheckBox: ro, TextField: Wr, PasswordField: io, Appearance: Bt };
var wl = zt.AcroForm;
function Mu(i) {
  return i.reduce(function(e, n, a) {
    return e[n] = a, e;
  }, {});
}
(function(i) {
  i.__addimage__ = {};
  var e = "UNKNOWN", n = { PNG: [[137, 80, 78, 71]], TIFF: [[77, 77, 0, 42], [73, 73, 42, 0]], JPEG: [[255, 216, 255, 224, void 0, void 0, 74, 70, 73, 70, 0], [255, 216, 255, 225, void 0, void 0, 69, 120, 105, 102, 0, 0], [255, 216, 255, 219], [255, 216, 255, 238]], JPEG2000: [[0, 0, 0, 12, 106, 80, 32, 32]], GIF87a: [[71, 73, 70, 56, 55, 97]], GIF89a: [[71, 73, 70, 56, 57, 97]], WEBP: [[82, 73, 70, 70, void 0, void 0, void 0, void 0, 87, 69, 66, 80]], BMP: [[66, 77], [66, 65], [67, 73], [67, 80], [73, 67], [80, 84]] }, a = i.__addimage__.getImageFileTypeByImageData = function(F, P) {
    var z, D, at, nt, lt, $ = e;
    if ((P = P || e) === "RGBA" || F.data !== void 0 && F.data instanceof Uint8ClampedArray && "height" in F && "width" in F)
      return "RGBA";
    if (yt(F))
      for (lt in n)
        for (at = n[lt], z = 0; z < at.length; z += 1) {
          for (nt = !0, D = 0; D < at[z].length; D += 1)
            if (at[z][D] !== void 0 && at[z][D] !== F[D]) {
              nt = !1;
              break;
            }
          if (nt === !0) {
            $ = lt;
            break;
          }
        }
    else
      for (lt in n)
        for (at = n[lt], z = 0; z < at.length; z += 1) {
          for (nt = !0, D = 0; D < at[z].length; D += 1)
            if (at[z][D] !== void 0 && at[z][D] !== F.charCodeAt(D)) {
              nt = !1;
              break;
            }
          if (nt === !0) {
            $ = lt;
            break;
          }
        }
    return $ === e && P !== e && ($ = P), $;
  }, u = function F(P) {
    for (var z = this.internal.write, D = this.internal.putStream, at = (0, this.internal.getFilters)(); at.indexOf("FlateEncode") !== -1; )
      at.splice(at.indexOf("FlateEncode"), 1);
    P.objectId = this.internal.newObject();
    var nt = [];
    if (nt.push({ key: "Type", value: "/XObject" }), nt.push({ key: "Subtype", value: "/Image" }), nt.push({ key: "Width", value: P.width }), nt.push({ key: "Height", value: P.height }), P.colorSpace === q.INDEXED ? nt.push({ key: "ColorSpace", value: "[/Indexed /DeviceRGB " + (P.palette.length / 3 - 1) + " " + ("sMask" in P && P.sMask !== void 0 ? P.objectId + 2 : P.objectId + 1) + " 0 R]" }) : (nt.push({ key: "ColorSpace", value: "/" + P.colorSpace }), P.colorSpace === q.DEVICE_CMYK && nt.push({ key: "Decode", value: "[1 0 1 0 1 0 1 0]" })), nt.push({ key: "BitsPerComponent", value: P.bitsPerComponent }), "decodeParameters" in P && P.decodeParameters !== void 0 && nt.push({ key: "DecodeParms", value: "<<" + P.decodeParameters + ">>" }), "transparency" in P && Array.isArray(P.transparency)) {
      for (var lt = "", $ = 0, ft = P.transparency.length; $ < ft; $++)
        lt += P.transparency[$] + " " + P.transparency[$] + " ";
      nt.push({ key: "Mask", value: "[" + lt + "]" });
    }
    P.sMask !== void 0 && nt.push({ key: "SMask", value: P.objectId + 1 + " 0 R" });
    var ht = P.filter !== void 0 ? ["/" + P.filter] : void 0;
    if (D({ data: P.data, additionalKeyValues: nt, alreadyAppliedFilters: ht, objectId: P.objectId }), z("endobj"), "sMask" in P && P.sMask !== void 0) {
      var kt = "/Predictor " + P.predictor + " /Colors 1 /BitsPerComponent " + P.bitsPerComponent + " /Columns " + P.width, A = { width: P.width, height: P.height, colorSpace: "DeviceGray", bitsPerComponent: P.bitsPerComponent, decodeParameters: kt, data: P.sMask };
      "filter" in P && (A.filter = P.filter), F.call(this, A);
    }
    if (P.colorSpace === q.INDEXED) {
      var j = this.internal.newObject();
      D({ data: R(new Uint8Array(P.palette)), objectId: j }), z("endobj");
    }
  }, o = function() {
    var F = this.internal.collections.addImage_images;
    for (var P in F)
      u.call(this, F[P]);
  }, l = function() {
    var F, P = this.internal.collections.addImage_images, z = this.internal.write;
    for (var D in P)
      z("/I" + (F = P[D]).index, F.objectId, "0", "R");
  }, h = function() {
    this.internal.collections.addImage_images || (this.internal.collections.addImage_images = {}, this.internal.events.subscribe("putResources", o), this.internal.events.subscribe("putXobjectDict", l));
  }, f = function() {
    var F = this.internal.collections.addImage_images;
    return h.call(this), F;
  }, g = function() {
    return Object.keys(this.internal.collections.addImage_images).length;
  }, b = function(F) {
    return typeof i["process" + F.toUpperCase()] == "function";
  }, N = function(F) {
    return fe(F) === "object" && F.nodeType === 1;
  }, S = function(F, P) {
    if (F.nodeName === "IMG" && F.hasAttribute("src")) {
      var z = "" + F.getAttribute("src");
      if (z.indexOf("data:image/") === 0)
        return oa(unescape(z).split("base64,").pop());
      var D = i.loadFile(z, !0);
      if (D !== void 0)
        return D;
    }
    if (F.nodeName === "CANVAS") {
      if (F.width === 0 || F.height === 0)
        throw new Error("Given canvas must have data. Canvas width: " + F.width + ", height: " + F.height);
      var at;
      switch (P) {
        case "PNG":
          at = "image/png";
          break;
        case "WEBP":
          at = "image/webp";
          break;
        case "JPEG":
        case "JPG":
        default:
          at = "image/jpeg";
      }
      return oa(F.toDataURL(at, 1).split("base64,").pop());
    }
  }, d = function(F) {
    var P = this.internal.collections.addImage_images;
    if (P) {
      for (var z in P)
        if (F === P[z].alias)
          return P[z];
    }
  }, O = function(F, P, z) {
    return F || P || (F = -96, P = -96), F < 0 && (F = -1 * z.width * 72 / F / this.internal.scaleFactor), P < 0 && (P = -1 * z.height * 72 / P / this.internal.scaleFactor), F === 0 && (F = P * z.width / z.height), P === 0 && (P = F * z.height / z.width), [F, P];
  }, I = function(F, P, z, D, at, nt) {
    var lt = O.call(this, z, D, at), $ = this.internal.getCoordinateString, ft = this.internal.getVerticalCoordinateString, ht = f.call(this);
    if (z = lt[0], D = lt[1], ht[at.index] = at, nt) {
      nt *= Math.PI / 180;
      var kt = Math.cos(nt), A = Math.sin(nt), j = function(W) {
        return W.toFixed(4);
      }, B = [j(kt), j(A), j(-1 * A), j(kt), 0, 0, "cm"];
    }
    this.internal.write("q"), nt ? (this.internal.write([1, "0", "0", 1, $(F), ft(P + D), "cm"].join(" ")), this.internal.write(B.join(" ")), this.internal.write([$(z), "0", "0", $(D), "0", "0", "cm"].join(" "))) : this.internal.write([$(z), "0", "0", $(D), $(F), ft(P + D), "cm"].join(" ")), this.isAdvancedAPI() && this.internal.write([1, 0, 0, -1, 0, 0, "cm"].join(" ")), this.internal.write("/I" + at.index + " Do"), this.internal.write("Q");
  }, q = i.color_spaces = { DEVICE_RGB: "DeviceRGB", DEVICE_GRAY: "DeviceGray", DEVICE_CMYK: "DeviceCMYK", CAL_GREY: "CalGray", CAL_RGB: "CalRGB", LAB: "Lab", ICC_BASED: "ICCBased", INDEXED: "Indexed", PATTERN: "Pattern", SEPARATION: "Separation", DEVICE_N: "DeviceN" };
  i.decode = { DCT_DECODE: "DCTDecode", FLATE_DECODE: "FlateDecode", LZW_DECODE: "LZWDecode", JPX_DECODE: "JPXDecode", JBIG2_DECODE: "JBIG2Decode", ASCII85_DECODE: "ASCII85Decode", ASCII_HEX_DECODE: "ASCIIHexDecode", RUN_LENGTH_DECODE: "RunLengthDecode", CCITT_FAX_DECODE: "CCITTFaxDecode" };
  var _ = i.image_compression = { NONE: "NONE", FAST: "FAST", MEDIUM: "MEDIUM", SLOW: "SLOW" }, M = i.__addimage__.sHashCode = function(F) {
    var P, z, D = 0;
    if (typeof F == "string")
      for (z = F.length, P = 0; P < z; P++)
        D = (D << 5) - D + F.charCodeAt(P), D |= 0;
    else if (yt(F))
      for (z = F.byteLength / 2, P = 0; P < z; P++)
        D = (D << 5) - D + F[P], D |= 0;
    return D;
  }, X = i.__addimage__.validateStringAsBase64 = function(F) {
    (F = F || "").toString().trim();
    var P = !0;
    return F.length === 0 && (P = !1), F.length % 4 != 0 && (P = !1), /^[A-Za-z0-9+/]+$/.test(F.substr(0, F.length - 2)) === !1 && (P = !1), /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(F.substr(-2)) === !1 && (P = !1), P;
  }, ot = i.__addimage__.extractImageFromDataUrl = function(F) {
    var P = (F = F || "").split("base64,"), z = null;
    if (P.length === 2) {
      var D = /^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(P[0]);
      Array.isArray(D) && (z = { mimeType: D[1], charset: D[2], data: P[1] });
    }
    return z;
  }, ct = i.__addimage__.supportsArrayBuffer = function() {
    return typeof ArrayBuffer < "u" && typeof Uint8Array < "u";
  };
  i.__addimage__.isArrayBuffer = function(F) {
    return ct() && F instanceof ArrayBuffer;
  };
  var yt = i.__addimage__.isArrayBufferView = function(F) {
    return ct() && typeof Uint32Array < "u" && (F instanceof Int8Array || F instanceof Uint8Array || typeof Uint8ClampedArray < "u" && F instanceof Uint8ClampedArray || F instanceof Int16Array || F instanceof Uint16Array || F instanceof Int32Array || F instanceof Uint32Array || F instanceof Float32Array || F instanceof Float64Array);
  }, tt = i.__addimage__.binaryStringToUint8Array = function(F) {
    for (var P = F.length, z = new Uint8Array(P), D = 0; D < P; D++)
      z[D] = F.charCodeAt(D);
    return z;
  }, R = i.__addimage__.arrayBufferToBinaryString = function(F) {
    for (var P = "", z = yt(F) ? F : new Uint8Array(F), D = 0; D < z.length; D += 8192)
      P += String.fromCharCode.apply(null, z.subarray(D, D + 8192));
    return P;
  };
  i.addImage = function() {
    var F, P, z, D, at, nt, lt, $, ft;
    if (typeof arguments[1] == "number" ? (P = e, z = arguments[1], D = arguments[2], at = arguments[3], nt = arguments[4], lt = arguments[5], $ = arguments[6], ft = arguments[7]) : (P = arguments[1], z = arguments[2], D = arguments[3], at = arguments[4], nt = arguments[5], lt = arguments[6], $ = arguments[7], ft = arguments[8]), fe(F = arguments[0]) === "object" && !N(F) && "imageData" in F) {
      var ht = F;
      F = ht.imageData, P = ht.format || P || e, z = ht.x || z || 0, D = ht.y || D || 0, at = ht.w || ht.width || at, nt = ht.h || ht.height || nt, lt = ht.alias || lt, $ = ht.compression || $, ft = ht.rotation || ht.angle || ft;
    }
    var kt = this.internal.getFilters();
    if ($ === void 0 && kt.indexOf("FlateEncode") !== -1 && ($ = "SLOW"), isNaN(z) || isNaN(D))
      throw new Error("Invalid coordinates passed to jsPDF.addImage");
    h.call(this);
    var A = gt.call(this, F, P, lt, $);
    return I.call(this, z, D, at, nt, A, ft), this;
  };
  var gt = function(F, P, z, D) {
    var at, nt, lt;
    if (typeof F == "string" && a(F) === e) {
      F = unescape(F);
      var $ = pt(F, !1);
      ($ !== "" || ($ = i.loadFile(F, !0)) !== void 0) && (F = $);
    }
    if (N(F) && (F = S(F, P)), P = a(F, P), !b(P))
      throw new Error("addImage does not support files of type '" + P + "', please ensure that a plugin for '" + P + "' support is added.");
    if (((lt = z) == null || lt.length === 0) && (z = function(ft) {
      return typeof ft == "string" || yt(ft) ? M(ft) : yt(ft.data) ? M(ft.data) : null;
    }(F)), (at = d.call(this, z)) || (ct() && (F instanceof Uint8Array || P === "RGBA" || (nt = F, F = tt(F))), at = this["process" + P.toUpperCase()](F, g.call(this), z, function(ft) {
      return ft && typeof ft == "string" && (ft = ft.toUpperCase()), ft in i.image_compression ? ft : _.NONE;
    }(D), nt)), !at)
      throw new Error("An unknown error occurred whilst processing the image.");
    return at;
  }, pt = i.__addimage__.convertBase64ToBinaryString = function(F, P) {
    var z;
    P = typeof P != "boolean" || P;
    var D, at = "";
    if (typeof F == "string") {
      D = (z = ot(F)) !== null ? z.data : F;
      try {
        at = oa(D);
      } catch (nt) {
        if (P)
          throw X(D) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + nt.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
      }
    }
    return at;
  };
  i.getImageProperties = function(F) {
    var P, z, D = "";
    if (N(F) && (F = S(F)), typeof F == "string" && a(F) === e && ((D = pt(F, !1)) === "" && (D = i.loadFile(F) || ""), F = D), z = a(F), !b(z))
      throw new Error("addImage does not support files of type '" + z + "', please ensure that a plugin for '" + z + "' support is added.");
    if (!ct() || F instanceof Uint8Array || (F = tt(F)), !(P = this["process" + z.toUpperCase()](F)))
      throw new Error("An unknown error occurred whilst processing the image");
    return P.fileType = z, P;
  };
})(zt.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(i) {
  var e = function(n) {
    if (n !== void 0 && n != "")
      return !0;
  };
  zt.API.events.push(["addPage", function(n) {
    this.internal.getPageInfo(n.pageNumber).pageContext.annotations = [];
  }]), i.events.push(["putPage", function(n) {
    for (var a, u, o, l = this.internal.getCoordinateString, h = this.internal.getVerticalCoordinateString, f = this.internal.getPageInfoByObjId(n.objId), g = n.pageContext.annotations, b = !1, N = 0; N < g.length && !b; N++)
      switch ((a = g[N]).type) {
        case "link":
          (e(a.options.url) || e(a.options.pageNumber)) && (b = !0);
          break;
        case "reference":
        case "text":
        case "freetext":
          b = !0;
      }
    if (b != 0) {
      this.internal.write("/Annots [");
      for (var S = 0; S < g.length; S++) {
        a = g[S];
        var d = this.internal.pdfEscape, O = this.internal.getEncryptor(n.objId);
        switch (a.type) {
          case "reference":
            this.internal.write(" " + a.object.objId + " 0 R ");
            break;
          case "text":
            var I = this.internal.newAdditionalObject(), q = this.internal.newAdditionalObject(), _ = this.internal.getEncryptor(I.objId), M = a.title || "Note";
            o = "<</Type /Annot /Subtype /Text " + (u = "/Rect [" + l(a.bounds.x) + " " + h(a.bounds.y + a.bounds.h) + " " + l(a.bounds.x + a.bounds.w) + " " + h(a.bounds.y) + "] ") + "/Contents (" + d(_(a.contents)) + ")", o += " /Popup " + q.objId + " 0 R", o += " /P " + f.objId + " 0 R", o += " /T (" + d(_(M)) + ") >>", I.content = o;
            var X = I.objId + " 0 R";
            o = "<</Type /Annot /Subtype /Popup " + (u = "/Rect [" + l(a.bounds.x + 30) + " " + h(a.bounds.y + a.bounds.h) + " " + l(a.bounds.x + a.bounds.w + 30) + " " + h(a.bounds.y) + "] ") + " /Parent " + X, a.open && (o += " /Open true"), o += " >>", q.content = o, this.internal.write(I.objId, "0 R", q.objId, "0 R");
            break;
          case "freetext":
            u = "/Rect [" + l(a.bounds.x) + " " + h(a.bounds.y) + " " + l(a.bounds.x + a.bounds.w) + " " + h(a.bounds.y + a.bounds.h) + "] ";
            var ot = a.color || "#000000";
            o = "<</Type /Annot /Subtype /FreeText " + u + "/Contents (" + d(O(a.contents)) + ")", o += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + ot + ")", o += " /Border [0 0 0]", o += " >>", this.internal.write(o);
            break;
          case "link":
            if (a.options.name) {
              var ct = this.annotations._nameMap[a.options.name];
              a.options.pageNumber = ct.page, a.options.top = ct.y;
            } else
              a.options.top || (a.options.top = 0);
            if (u = "/Rect [" + a.finalBounds.x + " " + a.finalBounds.y + " " + a.finalBounds.w + " " + a.finalBounds.h + "] ", o = "", a.options.url)
              o = "<</Type /Annot /Subtype /Link " + u + "/Border [0 0 0] /A <</S /URI /URI (" + d(O(a.options.url)) + ") >>";
            else if (a.options.pageNumber)
              switch (o = "<</Type /Annot /Subtype /Link " + u + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(a.options.pageNumber).objId + " 0 R", a.options.magFactor = a.options.magFactor || "XYZ", a.options.magFactor) {
                case "Fit":
                  o += " /Fit]";
                  break;
                case "FitH":
                  o += " /FitH " + a.options.top + "]";
                  break;
                case "FitV":
                  a.options.left = a.options.left || 0, o += " /FitV " + a.options.left + "]";
                  break;
                case "XYZ":
                default:
                  var yt = h(a.options.top);
                  a.options.left = a.options.left || 0, a.options.zoom === void 0 && (a.options.zoom = 0), o += " /XYZ " + a.options.left + " " + yt + " " + a.options.zoom + "]";
              }
            o != "" && (o += " >>", this.internal.write(o));
        }
      }
      this.internal.write("]");
    }
  }]), i.createAnnotation = function(n) {
    var a = this.internal.getCurrentPageInfo();
    switch (n.type) {
      case "link":
        this.link(n.bounds.x, n.bounds.y, n.bounds.w, n.bounds.h, n);
        break;
      case "text":
      case "freetext":
        a.pageContext.annotations.push(n);
    }
  }, i.link = function(n, a, u, o, l) {
    var h = this.internal.getCurrentPageInfo(), f = this.internal.getCoordinateString, g = this.internal.getVerticalCoordinateString;
    h.pageContext.annotations.push({ finalBounds: { x: f(n), y: g(a), w: f(n + u), h: g(a + o) }, options: l, type: "link" });
  }, i.textWithLink = function(n, a, u, o) {
    var l, h, f = this.getTextWidth(n), g = this.internal.getLineHeight() / this.internal.scaleFactor;
    if (o.maxWidth !== void 0) {
      h = o.maxWidth;
      var b = this.splitTextToSize(n, h).length;
      l = Math.ceil(g * b);
    } else
      h = f, l = g;
    return this.text(n, a, u, o), u += 0.2 * g, o.align === "center" && (a -= f / 2), o.align === "right" && (a -= f), this.link(a, u - g, h, l, o), f;
  }, i.getTextWidth = function(n) {
    var a = this.internal.getFontSize();
    return this.getStringUnitWidth(n) * a / this.internal.scaleFactor;
  };
}(zt.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(i) {
  var e = { 1569: [65152], 1570: [65153, 65154], 1571: [65155, 65156], 1572: [65157, 65158], 1573: [65159, 65160], 1574: [65161, 65162, 65163, 65164], 1575: [65165, 65166], 1576: [65167, 65168, 65169, 65170], 1577: [65171, 65172], 1578: [65173, 65174, 65175, 65176], 1579: [65177, 65178, 65179, 65180], 1580: [65181, 65182, 65183, 65184], 1581: [65185, 65186, 65187, 65188], 1582: [65189, 65190, 65191, 65192], 1583: [65193, 65194], 1584: [65195, 65196], 1585: [65197, 65198], 1586: [65199, 65200], 1587: [65201, 65202, 65203, 65204], 1588: [65205, 65206, 65207, 65208], 1589: [65209, 65210, 65211, 65212], 1590: [65213, 65214, 65215, 65216], 1591: [65217, 65218, 65219, 65220], 1592: [65221, 65222, 65223, 65224], 1593: [65225, 65226, 65227, 65228], 1594: [65229, 65230, 65231, 65232], 1601: [65233, 65234, 65235, 65236], 1602: [65237, 65238, 65239, 65240], 1603: [65241, 65242, 65243, 65244], 1604: [65245, 65246, 65247, 65248], 1605: [65249, 65250, 65251, 65252], 1606: [65253, 65254, 65255, 65256], 1607: [65257, 65258, 65259, 65260], 1608: [65261, 65262], 1609: [65263, 65264, 64488, 64489], 1610: [65265, 65266, 65267, 65268], 1649: [64336, 64337], 1655: [64477], 1657: [64358, 64359, 64360, 64361], 1658: [64350, 64351, 64352, 64353], 1659: [64338, 64339, 64340, 64341], 1662: [64342, 64343, 64344, 64345], 1663: [64354, 64355, 64356, 64357], 1664: [64346, 64347, 64348, 64349], 1667: [64374, 64375, 64376, 64377], 1668: [64370, 64371, 64372, 64373], 1670: [64378, 64379, 64380, 64381], 1671: [64382, 64383, 64384, 64385], 1672: [64392, 64393], 1676: [64388, 64389], 1677: [64386, 64387], 1678: [64390, 64391], 1681: [64396, 64397], 1688: [64394, 64395], 1700: [64362, 64363, 64364, 64365], 1702: [64366, 64367, 64368, 64369], 1705: [64398, 64399, 64400, 64401], 1709: [64467, 64468, 64469, 64470], 1711: [64402, 64403, 64404, 64405], 1713: [64410, 64411, 64412, 64413], 1715: [64406, 64407, 64408, 64409], 1722: [64414, 64415], 1723: [64416, 64417, 64418, 64419], 1726: [64426, 64427, 64428, 64429], 1728: [64420, 64421], 1729: [64422, 64423, 64424, 64425], 1733: [64480, 64481], 1734: [64473, 64474], 1735: [64471, 64472], 1736: [64475, 64476], 1737: [64482, 64483], 1739: [64478, 64479], 1740: [64508, 64509, 64510, 64511], 1744: [64484, 64485, 64486, 64487], 1746: [64430, 64431], 1747: [64432, 64433] }, n = { 65247: { 65154: 65269, 65156: 65271, 65160: 65273, 65166: 65275 }, 65248: { 65154: 65270, 65156: 65272, 65160: 65274, 65166: 65276 }, 65165: { 65247: { 65248: { 65258: 65010 } } }, 1617: { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 } }, a = { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 }, u = [1570, 1571, 1573, 1575];
  i.__arabicParser__ = {};
  var o = i.__arabicParser__.isInArabicSubstitutionA = function(I) {
    return e[I.charCodeAt(0)] !== void 0;
  }, l = i.__arabicParser__.isArabicLetter = function(I) {
    return typeof I == "string" && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(I);
  }, h = i.__arabicParser__.isArabicEndLetter = function(I) {
    return l(I) && o(I) && e[I.charCodeAt(0)].length <= 2;
  }, f = i.__arabicParser__.isArabicAlfLetter = function(I) {
    return l(I) && u.indexOf(I.charCodeAt(0)) >= 0;
  };
  i.__arabicParser__.arabicLetterHasIsolatedForm = function(I) {
    return l(I) && o(I) && e[I.charCodeAt(0)].length >= 1;
  };
  var g = i.__arabicParser__.arabicLetterHasFinalForm = function(I) {
    return l(I) && o(I) && e[I.charCodeAt(0)].length >= 2;
  };
  i.__arabicParser__.arabicLetterHasInitialForm = function(I) {
    return l(I) && o(I) && e[I.charCodeAt(0)].length >= 3;
  };
  var b = i.__arabicParser__.arabicLetterHasMedialForm = function(I) {
    return l(I) && o(I) && e[I.charCodeAt(0)].length == 4;
  }, N = i.__arabicParser__.resolveLigatures = function(I) {
    var q = 0, _ = n, M = "", X = 0;
    for (q = 0; q < I.length; q += 1)
      _[I.charCodeAt(q)] !== void 0 ? (X++, typeof (_ = _[I.charCodeAt(q)]) == "number" && (M += String.fromCharCode(_), _ = n, X = 0), q === I.length - 1 && (_ = n, M += I.charAt(q - (X - 1)), q -= X - 1, X = 0)) : (_ = n, M += I.charAt(q - X), q -= X, X = 0);
    return M;
  };
  i.__arabicParser__.isArabicDiacritic = function(I) {
    return I !== void 0 && a[I.charCodeAt(0)] !== void 0;
  };
  var S = i.__arabicParser__.getCorrectForm = function(I, q, _) {
    return l(I) ? o(I) === !1 ? -1 : !g(I) || !l(q) && !l(_) || !l(_) && h(q) || h(I) && !l(q) || h(I) && f(q) || h(I) && h(q) ? 0 : b(I) && l(q) && !h(q) && l(_) && g(_) ? 3 : h(I) || !l(_) ? 1 : 2 : -1;
  }, d = function(I) {
    var q = 0, _ = 0, M = 0, X = "", ot = "", ct = "", yt = (I = I || "").split("\\s+"), tt = [];
    for (q = 0; q < yt.length; q += 1) {
      for (tt.push(""), _ = 0; _ < yt[q].length; _ += 1)
        X = yt[q][_], ot = yt[q][_ - 1], ct = yt[q][_ + 1], l(X) ? (M = S(X, ot, ct), tt[q] += M !== -1 ? String.fromCharCode(e[X.charCodeAt(0)][M]) : X) : tt[q] += X;
      tt[q] = N(tt[q]);
    }
    return tt.join(" ");
  }, O = i.__arabicParser__.processArabic = i.processArabic = function() {
    var I, q = typeof arguments[0] == "string" ? arguments[0] : arguments[0].text, _ = [];
    if (Array.isArray(q)) {
      var M = 0;
      for (_ = [], M = 0; M < q.length; M += 1)
        Array.isArray(q[M]) ? _.push([d(q[M][0]), q[M][1], q[M][2]]) : _.push([d(q[M])]);
      I = _;
    } else
      I = d(q);
    return typeof arguments[0] == "string" ? I : (arguments[0].text = I, arguments[0]);
  };
  i.events.push(["preProcessText", O]);
}(zt.API), zt.API.autoPrint = function(i) {
  var e;
  switch ((i = i || {}).variant = i.variant || "non-conform", i.variant) {
    case "javascript":
      this.addJS("print({});");
      break;
    case "non-conform":
    default:
      this.internal.events.subscribe("postPutResources", function() {
        e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
      }), this.internal.events.subscribe("putCatalog", function() {
        this.internal.out("/OpenAction " + e + " 0 R");
      });
  }
  return this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(i) {
  var e = function() {
    var n = void 0;
    Object.defineProperty(this, "pdf", { get: function() {
      return n;
    }, set: function(h) {
      n = h;
    } });
    var a = 150;
    Object.defineProperty(this, "width", { get: function() {
      return a;
    }, set: function(h) {
      a = isNaN(h) || Number.isInteger(h) === !1 || h < 0 ? 150 : h, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = a + 1);
    } });
    var u = 300;
    Object.defineProperty(this, "height", { get: function() {
      return u;
    }, set: function(h) {
      u = isNaN(h) || Number.isInteger(h) === !1 || h < 0 ? 300 : h, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = u + 1);
    } });
    var o = [];
    Object.defineProperty(this, "childNodes", { get: function() {
      return o;
    }, set: function(h) {
      o = h;
    } });
    var l = {};
    Object.defineProperty(this, "style", { get: function() {
      return l;
    }, set: function(h) {
      l = h;
    } }), Object.defineProperty(this, "parentNode", {});
  };
  e.prototype.getContext = function(n, a) {
    var u;
    if ((n = n || "2d") !== "2d")
      return null;
    for (u in a)
      this.pdf.context2d.hasOwnProperty(u) && (this.pdf.context2d[u] = a[u]);
    return this.pdf.context2d._canvas = this, this.pdf.context2d;
  }, e.prototype.toDataURL = function() {
    throw new Error("toDataURL is not implemented.");
  }, i.events.push(["initialized", function() {
    this.canvas = new e(), this.canvas.pdf = this;
  }]);
}(zt.API), function(i) {
  var e = { left: 0, top: 0, bottom: 0, right: 0 }, n = !1, a = function() {
    this.internal.__cell__ === void 0 && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, e), this.internal.__cell__.margins.width = this.getPageWidth(), u.call(this));
  }, u = function() {
    this.internal.__cell__.lastCell = new o(), this.internal.__cell__.pages = 1;
  }, o = function() {
    var f = arguments[0];
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return f;
    }, set: function(I) {
      f = I;
    } });
    var g = arguments[1];
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return g;
    }, set: function(I) {
      g = I;
    } });
    var b = arguments[2];
    Object.defineProperty(this, "width", { enumerable: !0, get: function() {
      return b;
    }, set: function(I) {
      b = I;
    } });
    var N = arguments[3];
    Object.defineProperty(this, "height", { enumerable: !0, get: function() {
      return N;
    }, set: function(I) {
      N = I;
    } });
    var S = arguments[4];
    Object.defineProperty(this, "text", { enumerable: !0, get: function() {
      return S;
    }, set: function(I) {
      S = I;
    } });
    var d = arguments[5];
    Object.defineProperty(this, "lineNumber", { enumerable: !0, get: function() {
      return d;
    }, set: function(I) {
      d = I;
    } });
    var O = arguments[6];
    return Object.defineProperty(this, "align", { enumerable: !0, get: function() {
      return O;
    }, set: function(I) {
      O = I;
    } }), this;
  };
  o.prototype.clone = function() {
    return new o(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
  }, o.prototype.toArray = function() {
    return [this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align];
  }, i.setHeaderFunction = function(f) {
    return a.call(this), this.internal.__cell__.headerFunction = typeof f == "function" ? f : void 0, this;
  }, i.getTextDimensions = function(f, g) {
    a.call(this);
    var b = (g = g || {}).fontSize || this.getFontSize(), N = g.font || this.getFont(), S = g.scaleFactor || this.internal.scaleFactor, d = 0, O = 0, I = 0, q = this;
    if (!Array.isArray(f) && typeof f != "string") {
      if (typeof f != "number")
        throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
      f = String(f);
    }
    var _ = g.maxWidth;
    _ > 0 ? typeof f == "string" ? f = this.splitTextToSize(f, _) : Object.prototype.toString.call(f) === "[object Array]" && (f = f.reduce(function(X, ot) {
      return X.concat(q.splitTextToSize(ot, _));
    }, [])) : f = Array.isArray(f) ? f : [f];
    for (var M = 0; M < f.length; M++)
      d < (I = this.getStringUnitWidth(f[M], { font: N }) * b) && (d = I);
    return d !== 0 && (O = f.length), { w: d /= S, h: Math.max((O * b * this.getLineHeightFactor() - b * (this.getLineHeightFactor() - 1)) / S, 0) };
  }, i.cellAddPage = function() {
    a.call(this), this.addPage();
    var f = this.internal.__cell__.margins || e;
    return this.internal.__cell__.lastCell = new o(f.left, f.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
  };
  var l = i.cell = function() {
    var f;
    f = arguments[0] instanceof o ? arguments[0] : new o(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]), a.call(this);
    var g = this.internal.__cell__.lastCell, b = this.internal.__cell__.padding, N = this.internal.__cell__.margins || e, S = this.internal.__cell__.tableHeaderRow, d = this.internal.__cell__.printHeaders;
    return g.lineNumber !== void 0 && (g.lineNumber === f.lineNumber ? (f.x = (g.x || 0) + (g.width || 0), f.y = g.y || 0) : g.y + g.height + f.height + N.bottom > this.getPageHeight() ? (this.cellAddPage(), f.y = N.top, d && S && (this.printHeaderRow(f.lineNumber, !0), f.y += S[0].height)) : f.y = g.y + g.height || f.y), f.text[0] !== void 0 && (this.rect(f.x, f.y, f.width, f.height, n === !0 ? "FD" : void 0), f.align === "right" ? this.text(f.text, f.x + f.width - b, f.y + b, { align: "right", baseline: "top" }) : f.align === "center" ? this.text(f.text, f.x + f.width / 2, f.y + b, { align: "center", baseline: "top", maxWidth: f.width - b - b }) : this.text(f.text, f.x + b, f.y + b, { align: "left", baseline: "top", maxWidth: f.width - b - b })), this.internal.__cell__.lastCell = f, this;
  };
  i.table = function(f, g, b, N, S) {
    if (a.call(this), !b)
      throw new Error("No data for PDF table.");
    var d, O, I, q, _ = [], M = [], X = [], ot = {}, ct = {}, yt = [], tt = [], R = (S = S || {}).autoSize || !1, gt = S.printHeaders !== !1, pt = S.css && S.css["font-size"] !== void 0 ? 16 * S.css["font-size"] : S.fontSize || 12, F = S.margins || Object.assign({ width: this.getPageWidth() }, e), P = typeof S.padding == "number" ? S.padding : 3, z = S.headerBackgroundColor || "#c8c8c8", D = S.headerTextColor || "#000";
    if (u.call(this), this.internal.__cell__.printHeaders = gt, this.internal.__cell__.margins = F, this.internal.__cell__.table_font_size = pt, this.internal.__cell__.padding = P, this.internal.__cell__.headerBackgroundColor = z, this.internal.__cell__.headerTextColor = D, this.setFontSize(pt), N == null)
      M = _ = Object.keys(b[0]), X = _.map(function() {
        return "left";
      });
    else if (Array.isArray(N) && fe(N[0]) === "object")
      for (_ = N.map(function(ht) {
        return ht.name;
      }), M = N.map(function(ht) {
        return ht.prompt || ht.name || "";
      }), X = N.map(function(ht) {
        return ht.align || "left";
      }), d = 0; d < N.length; d += 1)
        ct[N[d].name] = N[d].width * (19.049976 / 25.4);
    else
      Array.isArray(N) && typeof N[0] == "string" && (M = _ = N, X = _.map(function() {
        return "left";
      }));
    if (R || Array.isArray(N) && typeof N[0] == "string")
      for (d = 0; d < _.length; d += 1) {
        for (ot[q = _[d]] = b.map(function(ht) {
          return ht[q];
        }), this.setFont(void 0, "bold"), yt.push(this.getTextDimensions(M[d], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w), O = ot[q], this.setFont(void 0, "normal"), I = 0; I < O.length; I += 1)
          yt.push(this.getTextDimensions(O[I], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w);
        ct[q] = Math.max.apply(null, yt) + P + P, yt = [];
      }
    if (gt) {
      var at = {};
      for (d = 0; d < _.length; d += 1)
        at[_[d]] = {}, at[_[d]].text = M[d], at[_[d]].align = X[d];
      var nt = h.call(this, at, ct);
      tt = _.map(function(ht) {
        return new o(f, g, ct[ht], nt, at[ht].text, void 0, at[ht].align);
      }), this.setTableHeaderRow(tt), this.printHeaderRow(1, !1);
    }
    var lt = N.reduce(function(ht, kt) {
      return ht[kt.name] = kt.align, ht;
    }, {});
    for (d = 0; d < b.length; d += 1) {
      "rowStart" in S && S.rowStart instanceof Function && S.rowStart({ row: d, data: b[d] }, this);
      var $ = h.call(this, b[d], ct);
      for (I = 0; I < _.length; I += 1) {
        var ft = b[d][_[I]];
        "cellStart" in S && S.cellStart instanceof Function && S.cellStart({ row: d, col: I, data: ft }, this), l.call(this, new o(f, g, ct[_[I]], $, ft, d + 2, lt[_[I]]));
      }
    }
    return this.internal.__cell__.table_x = f, this.internal.__cell__.table_y = g, this;
  };
  var h = function(f, g) {
    var b = this.internal.__cell__.padding, N = this.internal.__cell__.table_font_size, S = this.internal.scaleFactor;
    return Object.keys(f).map(function(d) {
      var O = f[d];
      return this.splitTextToSize(O.hasOwnProperty("text") ? O.text : O, g[d] - b - b);
    }, this).map(function(d) {
      return this.getLineHeightFactor() * d.length * N / S + b + b;
    }, this).reduce(function(d, O) {
      return Math.max(d, O);
    }, 0);
  };
  i.setTableHeaderRow = function(f) {
    a.call(this), this.internal.__cell__.tableHeaderRow = f;
  }, i.printHeaderRow = function(f, g) {
    if (a.call(this), !this.internal.__cell__.tableHeaderRow)
      throw new Error("Property tableHeaderRow does not exist.");
    var b;
    if (n = !0, typeof this.internal.__cell__.headerFunction == "function") {
      var N = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
      this.internal.__cell__.lastCell = new o(N[0], N[1], N[2], N[3], void 0, -1);
    }
    this.setFont(void 0, "bold");
    for (var S = [], d = 0; d < this.internal.__cell__.tableHeaderRow.length; d += 1) {
      b = this.internal.__cell__.tableHeaderRow[d].clone(), g && (b.y = this.internal.__cell__.margins.top || 0, S.push(b)), b.lineNumber = f;
      var O = this.getTextColor();
      this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), l.call(this, b), this.setTextColor(O);
    }
    S.length > 0 && this.setTableHeaderRow(S), this.setFont(void 0, "normal"), n = !1;
  };
}(zt.API);
var Bu = { italic: ["italic", "oblique", "normal"], oblique: ["oblique", "italic", "normal"], normal: ["normal", "oblique", "italic"] }, Eu = ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded"], ys = Mu(Eu), qu = [100, 200, 300, 400, 500, 600, 700, 800, 900], $c = Mu(qu);
function ws(i) {
  var e = i.family.replace(/"|'/g, "").toLowerCase(), n = function(o) {
    return Bu[o = o || "normal"] ? o : "normal";
  }(i.style), a = function(o) {
    if (!o)
      return 400;
    if (typeof o == "number")
      return o >= 100 && o <= 900 && o % 100 == 0 ? o : 400;
    if (/^\d00$/.test(o))
      return parseInt(o);
    switch (o) {
      case "bold":
        return 700;
      case "normal":
      default:
        return 400;
    }
  }(i.weight), u = function(o) {
    return typeof ys[o = o || "normal"] == "number" ? o : "normal";
  }(i.stretch);
  return { family: e, style: n, weight: a, stretch: u, src: i.src || [], ref: i.ref || { name: e, style: [u, n, a].join(" ") } };
}
function hu(i, e, n, a) {
  var u;
  for (u = n; u >= 0 && u < e.length; u += a)
    if (i[e[u]])
      return i[e[u]];
  for (u = n; u >= 0 && u < e.length; u -= a)
    if (i[e[u]])
      return i[e[u]];
}
var Qc = { "sans-serif": "helvetica", fixed: "courier", monospace: "courier", terminal: "courier", cursive: "times", fantasy: "times", serif: "times" }, fu = { caption: "times", icon: "times", menu: "times", "message-box": "times", "small-caption": "times", "status-bar": "times" };
function pu(i) {
  return [i.stretch, i.style, i.weight, i.family].join(" ");
}
function tl(i, e, n) {
  for (var a = (n = n || {}).defaultFontFamily || "times", u = Object.assign({}, Qc, n.genericFontFamilies || {}), o = null, l = null, h = 0; h < e.length; ++h)
    if (u[(o = ws(e[h])).family] && (o.family = u[o.family]), i.hasOwnProperty(o.family)) {
      l = i[o.family];
      break;
    }
  if (!(l = l || i[a]))
    throw new Error("Could not find a font-family for the rule '" + pu(o) + "' and default family '" + a + "'.");
  if (l = function(f, g) {
    if (g[f])
      return g[f];
    var b = ys[f], N = b <= ys.normal ? -1 : 1, S = hu(g, Eu, b, N);
    if (!S)
      throw new Error("Could not find a matching font-stretch value for " + f);
    return S;
  }(o.stretch, l), l = function(f, g) {
    if (g[f])
      return g[f];
    for (var b = Bu[f], N = 0; N < b.length; ++N)
      if (g[b[N]])
        return g[b[N]];
    throw new Error("Could not find a matching font-style for " + f);
  }(o.style, l), !(l = function(f, g) {
    if (g[f])
      return g[f];
    if (f === 400 && g[500])
      return g[500];
    if (f === 500 && g[400])
      return g[400];
    var b = $c[f], N = hu(g, qu, b, f < 400 ? -1 : 1);
    if (!N)
      throw new Error("Could not find a matching font-weight for value " + f);
    return N;
  }(o.weight, l)))
    throw new Error("Failed to resolve a font for the rule '" + pu(o) + "'.");
  return l;
}
function du(i) {
  return i.trimLeft();
}
function el(i, e) {
  for (var n = 0; n < i.length; ) {
    if (i.charAt(n) === e)
      return [i.substring(0, n), i.substring(n + 1)];
    n += 1;
  }
  return null;
}
function nl(i) {
  var e = i.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
  return e === null ? null : [e[0], i.substring(e[0].length)];
}
var $a, gu, mu, us = ["times"];
(function(i) {
  var e, n, a, u, o, l, h, f, g, b = function(A) {
    return A = A || {}, this.isStrokeTransparent = A.isStrokeTransparent || !1, this.strokeOpacity = A.strokeOpacity || 1, this.strokeStyle = A.strokeStyle || "#000000", this.fillStyle = A.fillStyle || "#000000", this.isFillTransparent = A.isFillTransparent || !1, this.fillOpacity = A.fillOpacity || 1, this.font = A.font || "10px sans-serif", this.textBaseline = A.textBaseline || "alphabetic", this.textAlign = A.textAlign || "left", this.lineWidth = A.lineWidth || 1, this.lineJoin = A.lineJoin || "miter", this.lineCap = A.lineCap || "butt", this.path = A.path || [], this.transform = A.transform !== void 0 ? A.transform.clone() : new f(), this.globalCompositeOperation = A.globalCompositeOperation || "normal", this.globalAlpha = A.globalAlpha || 1, this.clip_path = A.clip_path || [], this.currentPoint = A.currentPoint || new l(), this.miterLimit = A.miterLimit || 10, this.lastPoint = A.lastPoint || new l(), this.lineDashOffset = A.lineDashOffset || 0, this.lineDash = A.lineDash || [], this.margin = A.margin || [0, 0, 0, 0], this.prevPageLastElemOffset = A.prevPageLastElemOffset || 0, this.ignoreClearRect = typeof A.ignoreClearRect != "boolean" || A.ignoreClearRect, this;
  };
  i.events.push(["initialized", function() {
    this.context2d = new N(this), e = this.internal.f2, n = this.internal.getCoordinateString, a = this.internal.getVerticalCoordinateString, u = this.internal.getHorizontalCoordinate, o = this.internal.getVerticalCoordinate, l = this.internal.Point, h = this.internal.Rectangle, f = this.internal.Matrix, g = new b();
  }]);
  var N = function(A) {
    Object.defineProperty(this, "canvas", { get: function() {
      return { parentNode: !1, style: !1 };
    } });
    var j = A;
    Object.defineProperty(this, "pdf", { get: function() {
      return j;
    } });
    var B = !1;
    Object.defineProperty(this, "pageWrapXEnabled", { get: function() {
      return B;
    }, set: function(ut) {
      B = !!ut;
    } });
    var W = !1;
    Object.defineProperty(this, "pageWrapYEnabled", { get: function() {
      return W;
    }, set: function(ut) {
      W = !!ut;
    } });
    var Y = 0;
    Object.defineProperty(this, "posX", { get: function() {
      return Y;
    }, set: function(ut) {
      isNaN(ut) || (Y = ut);
    } });
    var Q = 0;
    Object.defineProperty(this, "posY", { get: function() {
      return Q;
    }, set: function(ut) {
      isNaN(ut) || (Q = ut);
    } }), Object.defineProperty(this, "margin", { get: function() {
      return g.margin;
    }, set: function(ut) {
      var E;
      typeof ut == "number" ? E = [ut, ut, ut, ut] : ((E = new Array(4))[0] = ut[0], E[1] = ut.length >= 2 ? ut[1] : E[0], E[2] = ut.length >= 3 ? ut[2] : E[0], E[3] = ut.length >= 4 ? ut[3] : E[1]), g.margin = E;
    } });
    var et = !1;
    Object.defineProperty(this, "autoPaging", { get: function() {
      return et;
    }, set: function(ut) {
      et = ut;
    } });
    var rt = 0;
    Object.defineProperty(this, "lastBreak", { get: function() {
      return rt;
    }, set: function(ut) {
      rt = ut;
    } });
    var Nt = [];
    Object.defineProperty(this, "pageBreaks", { get: function() {
      return Nt;
    }, set: function(ut) {
      Nt = ut;
    } }), Object.defineProperty(this, "ctx", { get: function() {
      return g;
    }, set: function(ut) {
      ut instanceof b && (g = ut);
    } }), Object.defineProperty(this, "path", { get: function() {
      return g.path;
    }, set: function(ut) {
      g.path = ut;
    } });
    var Lt = [];
    Object.defineProperty(this, "ctxStack", { get: function() {
      return Lt;
    }, set: function(ut) {
      Lt = ut;
    } }), Object.defineProperty(this, "fillStyle", { get: function() {
      return this.ctx.fillStyle;
    }, set: function(ut) {
      var E;
      E = S(ut), this.ctx.fillStyle = E.style, this.ctx.isFillTransparent = E.a === 0, this.ctx.fillOpacity = E.a, this.pdf.setFillColor(E.r, E.g, E.b, { a: E.a }), this.pdf.setTextColor(E.r, E.g, E.b, { a: E.a });
    } }), Object.defineProperty(this, "strokeStyle", { get: function() {
      return this.ctx.strokeStyle;
    }, set: function(ut) {
      var E = S(ut);
      this.ctx.strokeStyle = E.style, this.ctx.isStrokeTransparent = E.a === 0, this.ctx.strokeOpacity = E.a, E.a === 0 ? this.pdf.setDrawColor(255, 255, 255) : (E.a, this.pdf.setDrawColor(E.r, E.g, E.b));
    } }), Object.defineProperty(this, "lineCap", { get: function() {
      return this.ctx.lineCap;
    }, set: function(ut) {
      ["butt", "round", "square"].indexOf(ut) !== -1 && (this.ctx.lineCap = ut, this.pdf.setLineCap(ut));
    } }), Object.defineProperty(this, "lineWidth", { get: function() {
      return this.ctx.lineWidth;
    }, set: function(ut) {
      isNaN(ut) || (this.ctx.lineWidth = ut, this.pdf.setLineWidth(ut));
    } }), Object.defineProperty(this, "lineJoin", { get: function() {
      return this.ctx.lineJoin;
    }, set: function(ut) {
      ["bevel", "round", "miter"].indexOf(ut) !== -1 && (this.ctx.lineJoin = ut, this.pdf.setLineJoin(ut));
    } }), Object.defineProperty(this, "miterLimit", { get: function() {
      return this.ctx.miterLimit;
    }, set: function(ut) {
      isNaN(ut) || (this.ctx.miterLimit = ut, this.pdf.setMiterLimit(ut));
    } }), Object.defineProperty(this, "textBaseline", { get: function() {
      return this.ctx.textBaseline;
    }, set: function(ut) {
      this.ctx.textBaseline = ut;
    } }), Object.defineProperty(this, "textAlign", { get: function() {
      return this.ctx.textAlign;
    }, set: function(ut) {
      ["right", "end", "center", "left", "start"].indexOf(ut) !== -1 && (this.ctx.textAlign = ut);
    } });
    var Ct = null;
    function Mt(ut, E) {
      if (Ct === null) {
        var Xt = function(Et) {
          var At = [];
          return Object.keys(Et).forEach(function(xt) {
            Et[xt].forEach(function(Ft) {
              var Pt = null;
              switch (Ft) {
                case "bold":
                  Pt = { family: xt, weight: "bold" };
                  break;
                case "italic":
                  Pt = { family: xt, style: "italic" };
                  break;
                case "bolditalic":
                  Pt = { family: xt, weight: "bold", style: "italic" };
                  break;
                case "":
                case "normal":
                  Pt = { family: xt };
              }
              Pt !== null && (Pt.ref = { name: xt, style: Ft }, At.push(Pt));
            });
          }), At;
        }(ut.getFontList());
        Ct = function(Et) {
          for (var At = {}, xt = 0; xt < Et.length; ++xt) {
            var Ft = ws(Et[xt]), Pt = Ft.family, qt = Ft.stretch, Gt = Ft.style, $t = Ft.weight;
            At[Pt] = At[Pt] || {}, At[Pt][qt] = At[Pt][qt] || {}, At[Pt][qt][Gt] = At[Pt][qt][Gt] || {}, At[Pt][qt][Gt][$t] = Ft;
          }
          return At;
        }(Xt.concat(E));
      }
      return Ct;
    }
    var Ut = null;
    Object.defineProperty(this, "fontFaces", { get: function() {
      return Ut;
    }, set: function(ut) {
      Ct = null, Ut = ut;
    } }), Object.defineProperty(this, "font", { get: function() {
      return this.ctx.font;
    }, set: function(ut) {
      var E;
      if (this.ctx.font = ut, (E = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(ut)) !== null) {
        var Xt = E[1], Et = (E[2], E[3]), At = E[4], xt = (E[5], E[6]), Ft = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(At)[2];
        At = Math.floor(Ft === "px" ? parseFloat(At) * this.pdf.internal.scaleFactor : Ft === "em" ? parseFloat(At) * this.pdf.getFontSize() : parseFloat(At) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(At);
        var Pt = function(Wt) {
          var ee, It, Ve = [], oe = Wt.trim();
          if (oe === "")
            return us;
          if (oe in fu)
            return [fu[oe]];
          for (; oe !== ""; ) {
            switch (It = null, ee = (oe = du(oe)).charAt(0)) {
              case '"':
              case "'":
                It = el(oe.substring(1), ee);
                break;
              default:
                It = nl(oe);
            }
            if (It === null || (Ve.push(It[0]), (oe = du(It[1])) !== "" && oe.charAt(0) !== ","))
              return us;
            oe = oe.replace(/^,/, "");
          }
          return Ve;
        }(xt);
        if (this.fontFaces) {
          var qt = tl(Mt(this.pdf, this.fontFaces), Pt.map(function(Wt) {
            return { family: Wt, stretch: "normal", weight: Et, style: Xt };
          }));
          this.pdf.setFont(qt.ref.name, qt.ref.style);
        } else {
          var Gt = "";
          (Et === "bold" || parseInt(Et, 10) >= 700 || Xt === "bold") && (Gt = "bold"), Xt === "italic" && (Gt += "italic"), Gt.length === 0 && (Gt = "normal");
          for (var $t = "", te = { arial: "Helvetica", Arial: "Helvetica", verdana: "Helvetica", Verdana: "Helvetica", helvetica: "Helvetica", Helvetica: "Helvetica", "sans-serif": "Helvetica", fixed: "Courier", monospace: "Courier", terminal: "Courier", cursive: "Times", fantasy: "Times", serif: "Times" }, ie = 0; ie < Pt.length; ie++) {
            if (this.pdf.internal.getFont(Pt[ie], Gt, { noFallback: !0, disableWarning: !0 }) !== void 0) {
              $t = Pt[ie];
              break;
            }
            if (Gt === "bolditalic" && this.pdf.internal.getFont(Pt[ie], "bold", { noFallback: !0, disableWarning: !0 }) !== void 0)
              $t = Pt[ie], Gt = "bold";
            else if (this.pdf.internal.getFont(Pt[ie], "normal", { noFallback: !0, disableWarning: !0 }) !== void 0) {
              $t = Pt[ie], Gt = "normal";
              break;
            }
          }
          if ($t === "") {
            for (var pe = 0; pe < Pt.length; pe++)
              if (te[Pt[pe]]) {
                $t = te[Pt[pe]];
                break;
              }
          }
          $t = $t === "" ? "Times" : $t, this.pdf.setFont($t, Gt);
        }
      }
    } }), Object.defineProperty(this, "globalCompositeOperation", { get: function() {
      return this.ctx.globalCompositeOperation;
    }, set: function(ut) {
      this.ctx.globalCompositeOperation = ut;
    } }), Object.defineProperty(this, "globalAlpha", { get: function() {
      return this.ctx.globalAlpha;
    }, set: function(ut) {
      this.ctx.globalAlpha = ut;
    } }), Object.defineProperty(this, "lineDashOffset", { get: function() {
      return this.ctx.lineDashOffset;
    }, set: function(ut) {
      this.ctx.lineDashOffset = ut, kt.call(this);
    } }), Object.defineProperty(this, "lineDash", { get: function() {
      return this.ctx.lineDash;
    }, set: function(ut) {
      this.ctx.lineDash = ut, kt.call(this);
    } }), Object.defineProperty(this, "ignoreClearRect", { get: function() {
      return this.ctx.ignoreClearRect;
    }, set: function(ut) {
      this.ctx.ignoreClearRect = !!ut;
    } });
  };
  N.prototype.setLineDash = function(A) {
    this.lineDash = A;
  }, N.prototype.getLineDash = function() {
    return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
  }, N.prototype.fill = function() {
    ot.call(this, "fill", !1);
  }, N.prototype.stroke = function() {
    ot.call(this, "stroke", !1);
  }, N.prototype.beginPath = function() {
    this.path = [{ type: "begin" }];
  }, N.prototype.moveTo = function(A, j) {
    if (isNaN(A) || isNaN(j))
      throw ve.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
    var B = this.ctx.transform.applyToPoint(new l(A, j));
    this.path.push({ type: "mt", x: B.x, y: B.y }), this.ctx.lastPoint = new l(A, j);
  }, N.prototype.closePath = function() {
    var A = new l(0, 0), j = 0;
    for (j = this.path.length - 1; j !== -1; j--)
      if (this.path[j].type === "begin" && fe(this.path[j + 1]) === "object" && typeof this.path[j + 1].x == "number") {
        A = new l(this.path[j + 1].x, this.path[j + 1].y);
        break;
      }
    this.path.push({ type: "close" }), this.ctx.lastPoint = new l(A.x, A.y);
  }, N.prototype.lineTo = function(A, j) {
    if (isNaN(A) || isNaN(j))
      throw ve.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
    var B = this.ctx.transform.applyToPoint(new l(A, j));
    this.path.push({ type: "lt", x: B.x, y: B.y }), this.ctx.lastPoint = new l(B.x, B.y);
  }, N.prototype.clip = function() {
    this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), ot.call(this, null, !0);
  }, N.prototype.quadraticCurveTo = function(A, j, B, W) {
    if (isNaN(B) || isNaN(W) || isNaN(A) || isNaN(j))
      throw ve.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
    var Y = this.ctx.transform.applyToPoint(new l(B, W)), Q = this.ctx.transform.applyToPoint(new l(A, j));
    this.path.push({ type: "qct", x1: Q.x, y1: Q.y, x: Y.x, y: Y.y }), this.ctx.lastPoint = new l(Y.x, Y.y);
  }, N.prototype.bezierCurveTo = function(A, j, B, W, Y, Q) {
    if (isNaN(Y) || isNaN(Q) || isNaN(A) || isNaN(j) || isNaN(B) || isNaN(W))
      throw ve.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
    var et = this.ctx.transform.applyToPoint(new l(Y, Q)), rt = this.ctx.transform.applyToPoint(new l(A, j)), Nt = this.ctx.transform.applyToPoint(new l(B, W));
    this.path.push({ type: "bct", x1: rt.x, y1: rt.y, x2: Nt.x, y2: Nt.y, x: et.x, y: et.y }), this.ctx.lastPoint = new l(et.x, et.y);
  }, N.prototype.arc = function(A, j, B, W, Y, Q) {
    if (isNaN(A) || isNaN(j) || isNaN(B) || isNaN(W) || isNaN(Y))
      throw ve.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
    if (Q = !!Q, !this.ctx.transform.isIdentity) {
      var et = this.ctx.transform.applyToPoint(new l(A, j));
      A = et.x, j = et.y;
      var rt = this.ctx.transform.applyToPoint(new l(0, B)), Nt = this.ctx.transform.applyToPoint(new l(0, 0));
      B = Math.sqrt(Math.pow(rt.x - Nt.x, 2) + Math.pow(rt.y - Nt.y, 2));
    }
    Math.abs(Y - W) >= 2 * Math.PI && (W = 0, Y = 2 * Math.PI), this.path.push({ type: "arc", x: A, y: j, radius: B, startAngle: W, endAngle: Y, counterclockwise: Q });
  }, N.prototype.arcTo = function(A, j, B, W, Y) {
    throw new Error("arcTo not implemented.");
  }, N.prototype.rect = function(A, j, B, W) {
    if (isNaN(A) || isNaN(j) || isNaN(B) || isNaN(W))
      throw ve.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
    this.moveTo(A, j), this.lineTo(A + B, j), this.lineTo(A + B, j + W), this.lineTo(A, j + W), this.lineTo(A, j), this.lineTo(A + B, j), this.lineTo(A, j);
  }, N.prototype.fillRect = function(A, j, B, W) {
    if (isNaN(A) || isNaN(j) || isNaN(B) || isNaN(W))
      throw ve.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
    if (!d.call(this)) {
      var Y = {};
      this.lineCap !== "butt" && (Y.lineCap = this.lineCap, this.lineCap = "butt"), this.lineJoin !== "miter" && (Y.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(A, j, B, W), this.fill(), Y.hasOwnProperty("lineCap") && (this.lineCap = Y.lineCap), Y.hasOwnProperty("lineJoin") && (this.lineJoin = Y.lineJoin);
    }
  }, N.prototype.strokeRect = function(A, j, B, W) {
    if (isNaN(A) || isNaN(j) || isNaN(B) || isNaN(W))
      throw ve.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
    O.call(this) || (this.beginPath(), this.rect(A, j, B, W), this.stroke());
  }, N.prototype.clearRect = function(A, j, B, W) {
    if (isNaN(A) || isNaN(j) || isNaN(B) || isNaN(W))
      throw ve.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
    this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(A, j, B, W));
  }, N.prototype.save = function(A) {
    A = typeof A != "boolean" || A;
    for (var j = this.pdf.internal.getCurrentPageInfo().pageNumber, B = 0; B < this.pdf.internal.getNumberOfPages(); B++)
      this.pdf.setPage(B + 1), this.pdf.internal.out("q");
    if (this.pdf.setPage(j), A) {
      this.ctx.fontSize = this.pdf.internal.getFontSize();
      var W = new b(this.ctx);
      this.ctxStack.push(this.ctx), this.ctx = W;
    }
  }, N.prototype.restore = function(A) {
    A = typeof A != "boolean" || A;
    for (var j = this.pdf.internal.getCurrentPageInfo().pageNumber, B = 0; B < this.pdf.internal.getNumberOfPages(); B++)
      this.pdf.setPage(B + 1), this.pdf.internal.out("Q");
    this.pdf.setPage(j), A && this.ctxStack.length !== 0 && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
  }, N.prototype.toDataURL = function() {
    throw new Error("toDataUrl not implemented.");
  };
  var S = function(A) {
    var j, B, W, Y;
    if (A.isCanvasGradient === !0 && (A = A.getColor()), !A)
      return { r: 0, g: 0, b: 0, a: 0, style: A };
    if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(A))
      j = 0, B = 0, W = 0, Y = 0;
    else {
      var Q = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(A);
      if (Q !== null)
        j = parseInt(Q[1]), B = parseInt(Q[2]), W = parseInt(Q[3]), Y = 1;
      else if ((Q = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(A)) !== null)
        j = parseInt(Q[1]), B = parseInt(Q[2]), W = parseInt(Q[3]), Y = parseFloat(Q[4]);
      else {
        if (Y = 1, typeof A == "string" && A.charAt(0) !== "#") {
          var et = new ku(A);
          A = et.ok ? et.toHex() : "#000000";
        }
        A.length === 4 ? (j = A.substring(1, 2), j += j, B = A.substring(2, 3), B += B, W = A.substring(3, 4), W += W) : (j = A.substring(1, 3), B = A.substring(3, 5), W = A.substring(5, 7)), j = parseInt(j, 16), B = parseInt(B, 16), W = parseInt(W, 16);
      }
    }
    return { r: j, g: B, b: W, a: Y, style: A };
  }, d = function() {
    return this.ctx.isFillTransparent || this.globalAlpha == 0;
  }, O = function() {
    return !!(this.ctx.isStrokeTransparent || this.globalAlpha == 0);
  };
  N.prototype.fillText = function(A, j, B, W) {
    if (isNaN(j) || isNaN(B) || typeof A != "string")
      throw ve.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
    if (W = isNaN(W) ? void 0 : W, !d.call(this)) {
      var Y = $(this.ctx.transform.rotation), Q = this.ctx.transform.scaleX;
      P.call(this, { text: A, x: j, y: B, scale: Q, angle: Y, align: this.textAlign, maxWidth: W });
    }
  }, N.prototype.strokeText = function(A, j, B, W) {
    if (isNaN(j) || isNaN(B) || typeof A != "string")
      throw ve.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
    if (!O.call(this)) {
      W = isNaN(W) ? void 0 : W;
      var Y = $(this.ctx.transform.rotation), Q = this.ctx.transform.scaleX;
      P.call(this, { text: A, x: j, y: B, scale: Q, renderingMode: "stroke", angle: Y, align: this.textAlign, maxWidth: W });
    }
  }, N.prototype.measureText = function(A) {
    if (typeof A != "string")
      throw ve.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
    var j = this.pdf, B = this.pdf.internal.scaleFactor, W = j.internal.getFontSize(), Y = j.getStringUnitWidth(A) * W / j.internal.scaleFactor, Q = function(et) {
      var rt = (et = et || {}).width || 0;
      return Object.defineProperty(this, "width", { get: function() {
        return rt;
      } }), this;
    };
    return new Q({ width: Y *= Math.round(96 * B / 72 * 1e4) / 1e4 });
  }, N.prototype.scale = function(A, j) {
    if (isNaN(A) || isNaN(j))
      throw ve.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
    var B = new f(A, 0, 0, j, 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(B);
  }, N.prototype.rotate = function(A) {
    if (isNaN(A))
      throw ve.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
    var j = new f(Math.cos(A), Math.sin(A), -Math.sin(A), Math.cos(A), 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(j);
  }, N.prototype.translate = function(A, j) {
    if (isNaN(A) || isNaN(j))
      throw ve.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
    var B = new f(1, 0, 0, 1, A, j);
    this.ctx.transform = this.ctx.transform.multiply(B);
  }, N.prototype.transform = function(A, j, B, W, Y, Q) {
    if (isNaN(A) || isNaN(j) || isNaN(B) || isNaN(W) || isNaN(Y) || isNaN(Q))
      throw ve.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
    var et = new f(A, j, B, W, Y, Q);
    this.ctx.transform = this.ctx.transform.multiply(et);
  }, N.prototype.setTransform = function(A, j, B, W, Y, Q) {
    A = isNaN(A) ? 1 : A, j = isNaN(j) ? 0 : j, B = isNaN(B) ? 0 : B, W = isNaN(W) ? 1 : W, Y = isNaN(Y) ? 0 : Y, Q = isNaN(Q) ? 0 : Q, this.ctx.transform = new f(A, j, B, W, Y, Q);
  };
  var I = function() {
    return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
  };
  N.prototype.drawImage = function(A, j, B, W, Y, Q, et, rt, Nt) {
    var Lt = this.pdf.getImageProperties(A), Ct = 1, Mt = 1, Ut = 1, ut = 1;
    W !== void 0 && rt !== void 0 && (Ut = rt / W, ut = Nt / Y, Ct = Lt.width / W * rt / W, Mt = Lt.height / Y * Nt / Y), Q === void 0 && (Q = j, et = B, j = 0, B = 0), W !== void 0 && rt === void 0 && (rt = W, Nt = Y), W === void 0 && rt === void 0 && (rt = Lt.width, Nt = Lt.height);
    for (var E, Xt = this.ctx.transform.decompose(), Et = $(Xt.rotate.shx), At = new f(), xt = (At = (At = (At = At.multiply(Xt.translate)).multiply(Xt.skew)).multiply(Xt.scale)).applyToRectangle(new h(Q - j * Ut, et - B * ut, W * Ct, Y * Mt)), Ft = q.call(this, xt), Pt = [], qt = 0; qt < Ft.length; qt += 1)
      Pt.indexOf(Ft[qt]) === -1 && Pt.push(Ft[qt]);
    if (X(Pt), this.autoPaging)
      for (var Gt = Pt[0], $t = Pt[Pt.length - 1], te = Gt; te < $t + 1; te++) {
        this.pdf.setPage(te);
        var ie = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], pe = te === 1 ? this.posY + this.margin[0] : this.margin[0], Wt = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], ee = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], It = te === 1 ? 0 : Wt + (te - 2) * ee;
        if (this.ctx.clip_path.length !== 0) {
          var Ve = this.path;
          E = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = M(E, this.posX + this.margin[3], -It + pe + this.ctx.prevPageLastElemOffset), ct.call(this, "fill", !0), this.path = Ve;
        }
        var oe = JSON.parse(JSON.stringify(xt));
        oe = M([oe], this.posX + this.margin[3], -It + pe + this.ctx.prevPageLastElemOffset)[0];
        var wn = (te > Gt || te < $t) && I.call(this);
        wn && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], ie, ee, null).clip().discardPath()), this.pdf.addImage(A, "JPEG", oe.x, oe.y, oe.w, oe.h, null, null, Et), wn && this.pdf.restoreGraphicsState();
      }
    else
      this.pdf.addImage(A, "JPEG", xt.x, xt.y, xt.w, xt.h, null, null, Et);
  };
  var q = function(A, j, B) {
    var W = [];
    j = j || this.pdf.internal.pageSize.width, B = B || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
    var Y = this.posY + this.ctx.prevPageLastElemOffset;
    switch (A.type) {
      default:
      case "mt":
      case "lt":
        W.push(Math.floor((A.y + Y) / B) + 1);
        break;
      case "arc":
        W.push(Math.floor((A.y + Y - A.radius) / B) + 1), W.push(Math.floor((A.y + Y + A.radius) / B) + 1);
        break;
      case "qct":
        var Q = ft(this.ctx.lastPoint.x, this.ctx.lastPoint.y, A.x1, A.y1, A.x, A.y);
        W.push(Math.floor((Q.y + Y) / B) + 1), W.push(Math.floor((Q.y + Q.h + Y) / B) + 1);
        break;
      case "bct":
        var et = ht(this.ctx.lastPoint.x, this.ctx.lastPoint.y, A.x1, A.y1, A.x2, A.y2, A.x, A.y);
        W.push(Math.floor((et.y + Y) / B) + 1), W.push(Math.floor((et.y + et.h + Y) / B) + 1);
        break;
      case "rect":
        W.push(Math.floor((A.y + Y) / B) + 1), W.push(Math.floor((A.y + A.h + Y) / B) + 1);
    }
    for (var rt = 0; rt < W.length; rt += 1)
      for (; this.pdf.internal.getNumberOfPages() < W[rt]; )
        _.call(this);
    return W;
  }, _ = function() {
    var A = this.fillStyle, j = this.strokeStyle, B = this.font, W = this.lineCap, Y = this.lineWidth, Q = this.lineJoin;
    this.pdf.addPage(), this.fillStyle = A, this.strokeStyle = j, this.font = B, this.lineCap = W, this.lineWidth = Y, this.lineJoin = Q;
  }, M = function(A, j, B) {
    for (var W = 0; W < A.length; W++)
      switch (A[W].type) {
        case "bct":
          A[W].x2 += j, A[W].y2 += B;
        case "qct":
          A[W].x1 += j, A[W].y1 += B;
        case "mt":
        case "lt":
        case "arc":
        default:
          A[W].x += j, A[W].y += B;
      }
    return A;
  }, X = function(A) {
    return A.sort(function(j, B) {
      return j - B;
    });
  }, ot = function(A, j) {
    for (var B, W, Y = this.fillStyle, Q = this.strokeStyle, et = this.lineCap, rt = this.lineWidth, Nt = Math.abs(rt * this.ctx.transform.scaleX), Lt = this.lineJoin, Ct = JSON.parse(JSON.stringify(this.path)), Mt = JSON.parse(JSON.stringify(this.path)), Ut = [], ut = 0; ut < Mt.length; ut++)
      if (Mt[ut].x !== void 0)
        for (var E = q.call(this, Mt[ut]), Xt = 0; Xt < E.length; Xt += 1)
          Ut.indexOf(E[Xt]) === -1 && Ut.push(E[Xt]);
    for (var Et = 0; Et < Ut.length; Et++)
      for (; this.pdf.internal.getNumberOfPages() < Ut[Et]; )
        _.call(this);
    if (X(Ut), this.autoPaging)
      for (var At = Ut[0], xt = Ut[Ut.length - 1], Ft = At; Ft < xt + 1; Ft++) {
        this.pdf.setPage(Ft), this.fillStyle = Y, this.strokeStyle = Q, this.lineCap = et, this.lineWidth = Nt, this.lineJoin = Lt;
        var Pt = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], qt = Ft === 1 ? this.posY + this.margin[0] : this.margin[0], Gt = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], $t = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], te = Ft === 1 ? 0 : Gt + (Ft - 2) * $t;
        if (this.ctx.clip_path.length !== 0) {
          var ie = this.path;
          B = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = M(B, this.posX + this.margin[3], -te + qt + this.ctx.prevPageLastElemOffset), ct.call(this, A, !0), this.path = ie;
        }
        if (W = JSON.parse(JSON.stringify(Ct)), this.path = M(W, this.posX + this.margin[3], -te + qt + this.ctx.prevPageLastElemOffset), j === !1 || Ft === 0) {
          var pe = (Ft > At || Ft < xt) && I.call(this);
          pe && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], Pt, $t, null).clip().discardPath()), ct.call(this, A, j), pe && this.pdf.restoreGraphicsState();
        }
        this.lineWidth = rt;
      }
    else
      this.lineWidth = Nt, ct.call(this, A, j), this.lineWidth = rt;
    this.path = Ct;
  }, ct = function(A, j) {
    if ((A !== "stroke" || j || !O.call(this)) && (A === "stroke" || j || !d.call(this))) {
      for (var B, W, Y = [], Q = this.path, et = 0; et < Q.length; et++) {
        var rt = Q[et];
        switch (rt.type) {
          case "begin":
            Y.push({ begin: !0 });
            break;
          case "close":
            Y.push({ close: !0 });
            break;
          case "mt":
            Y.push({ start: rt, deltas: [], abs: [] });
            break;
          case "lt":
            var Nt = Y.length;
            if (Q[et - 1] && !isNaN(Q[et - 1].x) && (B = [rt.x - Q[et - 1].x, rt.y - Q[et - 1].y], Nt > 0)) {
              for (; Nt >= 0; Nt--)
                if (Y[Nt - 1].close !== !0 && Y[Nt - 1].begin !== !0) {
                  Y[Nt - 1].deltas.push(B), Y[Nt - 1].abs.push(rt);
                  break;
                }
            }
            break;
          case "bct":
            B = [rt.x1 - Q[et - 1].x, rt.y1 - Q[et - 1].y, rt.x2 - Q[et - 1].x, rt.y2 - Q[et - 1].y, rt.x - Q[et - 1].x, rt.y - Q[et - 1].y], Y[Y.length - 1].deltas.push(B);
            break;
          case "qct":
            var Lt = Q[et - 1].x + 2 / 3 * (rt.x1 - Q[et - 1].x), Ct = Q[et - 1].y + 2 / 3 * (rt.y1 - Q[et - 1].y), Mt = rt.x + 2 / 3 * (rt.x1 - rt.x), Ut = rt.y + 2 / 3 * (rt.y1 - rt.y), ut = rt.x, E = rt.y;
            B = [Lt - Q[et - 1].x, Ct - Q[et - 1].y, Mt - Q[et - 1].x, Ut - Q[et - 1].y, ut - Q[et - 1].x, E - Q[et - 1].y], Y[Y.length - 1].deltas.push(B);
            break;
          case "arc":
            Y.push({ deltas: [], abs: [], arc: !0 }), Array.isArray(Y[Y.length - 1].abs) && Y[Y.length - 1].abs.push(rt);
        }
      }
      W = j ? null : A === "stroke" ? "stroke" : "fill";
      for (var Xt = !1, Et = 0; Et < Y.length; Et++)
        if (Y[Et].arc)
          for (var At = Y[Et].abs, xt = 0; xt < At.length; xt++) {
            var Ft = At[xt];
            Ft.type === "arc" ? R.call(this, Ft.x, Ft.y, Ft.radius, Ft.startAngle, Ft.endAngle, Ft.counterclockwise, void 0, j, !Xt) : z.call(this, Ft.x, Ft.y), Xt = !0;
          }
        else if (Y[Et].close === !0)
          this.pdf.internal.out("h"), Xt = !1;
        else if (Y[Et].begin !== !0) {
          var Pt = Y[Et].start.x, qt = Y[Et].start.y;
          D.call(this, Y[Et].deltas, Pt, qt), Xt = !0;
        }
      W && gt.call(this, W), j && pt.call(this);
    }
  }, yt = function(A) {
    var j = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, B = j * (this.pdf.internal.getLineHeightFactor() - 1);
    switch (this.ctx.textBaseline) {
      case "bottom":
        return A - B;
      case "top":
        return A + j - B;
      case "hanging":
        return A + j - 2 * B;
      case "middle":
        return A + j / 2 - B;
      case "ideographic":
        return A;
      case "alphabetic":
      default:
        return A;
    }
  }, tt = function(A) {
    return A + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
  };
  N.prototype.createLinearGradient = function() {
    var A = function() {
    };
    return A.colorStops = [], A.addColorStop = function(j, B) {
      this.colorStops.push([j, B]);
    }, A.getColor = function() {
      return this.colorStops.length === 0 ? "#000000" : this.colorStops[0][1];
    }, A.isCanvasGradient = !0, A;
  }, N.prototype.createPattern = function() {
    return this.createLinearGradient();
  }, N.prototype.createRadialGradient = function() {
    return this.createLinearGradient();
  };
  var R = function(A, j, B, W, Y, Q, et, rt, Nt) {
    for (var Lt = nt.call(this, B, W, Y, Q), Ct = 0; Ct < Lt.length; Ct++) {
      var Mt = Lt[Ct];
      Ct === 0 && (Nt ? F.call(this, Mt.x1 + A, Mt.y1 + j) : z.call(this, Mt.x1 + A, Mt.y1 + j)), at.call(this, A, j, Mt.x2, Mt.y2, Mt.x3, Mt.y3, Mt.x4, Mt.y4);
    }
    rt ? pt.call(this) : gt.call(this, et);
  }, gt = function(A) {
    switch (A) {
      case "stroke":
        this.pdf.internal.out("S");
        break;
      case "fill":
        this.pdf.internal.out("f");
    }
  }, pt = function() {
    this.pdf.clip(), this.pdf.discardPath();
  }, F = function(A, j) {
    this.pdf.internal.out(n(A) + " " + a(j) + " m");
  }, P = function(A) {
    var j;
    switch (A.align) {
      case "right":
      case "end":
        j = "right";
        break;
      case "center":
        j = "center";
        break;
      case "left":
      case "start":
      default:
        j = "left";
    }
    var B = this.pdf.getTextDimensions(A.text), W = yt.call(this, A.y), Y = tt.call(this, W) - B.h, Q = this.ctx.transform.applyToPoint(new l(A.x, W)), et = this.ctx.transform.decompose(), rt = new f();
    rt = (rt = (rt = rt.multiply(et.translate)).multiply(et.skew)).multiply(et.scale);
    for (var Nt, Lt, Ct, Mt = this.ctx.transform.applyToRectangle(new h(A.x, W, B.w, B.h)), Ut = rt.applyToRectangle(new h(A.x, Y, B.w, B.h)), ut = q.call(this, Ut), E = [], Xt = 0; Xt < ut.length; Xt += 1)
      E.indexOf(ut[Xt]) === -1 && E.push(ut[Xt]);
    if (X(E), this.autoPaging)
      for (var Et = E[0], At = E[E.length - 1], xt = Et; xt < At + 1; xt++) {
        this.pdf.setPage(xt);
        var Ft = xt === 1 ? this.posY + this.margin[0] : this.margin[0], Pt = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], qt = this.pdf.internal.pageSize.height - this.margin[2], Gt = qt - this.margin[0], $t = this.pdf.internal.pageSize.width - this.margin[1], te = $t - this.margin[3], ie = xt === 1 ? 0 : Pt + (xt - 2) * Gt;
        if (this.ctx.clip_path.length !== 0) {
          var pe = this.path;
          Nt = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = M(Nt, this.posX + this.margin[3], -1 * ie + Ft), ct.call(this, "fill", !0), this.path = pe;
        }
        var Wt = M([JSON.parse(JSON.stringify(Ut))], this.posX + this.margin[3], -ie + Ft + this.ctx.prevPageLastElemOffset)[0];
        A.scale >= 0.01 && (Lt = this.pdf.internal.getFontSize(), this.pdf.setFontSize(Lt * A.scale), Ct = this.lineWidth, this.lineWidth = Ct * A.scale);
        var ee = this.autoPaging !== "text";
        if (ee || Wt.y + Wt.h <= qt) {
          if (ee || Wt.y >= Ft && Wt.x <= $t) {
            var It = ee ? A.text : this.pdf.splitTextToSize(A.text, A.maxWidth || $t - Wt.x)[0], Ve = M([JSON.parse(JSON.stringify(Mt))], this.posX + this.margin[3], -ie + Ft + this.ctx.prevPageLastElemOffset)[0], oe = ee && (xt > Et || xt < At) && I.call(this);
            oe && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], te, Gt, null).clip().discardPath()), this.pdf.text(It, Ve.x, Ve.y, { angle: A.angle, align: j, renderingMode: A.renderingMode }), oe && this.pdf.restoreGraphicsState();
          }
        } else
          Wt.y < qt && (this.ctx.prevPageLastElemOffset += qt - Wt.y);
        A.scale >= 0.01 && (this.pdf.setFontSize(Lt), this.lineWidth = Ct);
      }
    else
      A.scale >= 0.01 && (Lt = this.pdf.internal.getFontSize(), this.pdf.setFontSize(Lt * A.scale), Ct = this.lineWidth, this.lineWidth = Ct * A.scale), this.pdf.text(A.text, Q.x + this.posX, Q.y + this.posY, { angle: A.angle, align: j, renderingMode: A.renderingMode, maxWidth: A.maxWidth }), A.scale >= 0.01 && (this.pdf.setFontSize(Lt), this.lineWidth = Ct);
  }, z = function(A, j, B, W) {
    B = B || 0, W = W || 0, this.pdf.internal.out(n(A + B) + " " + a(j + W) + " l");
  }, D = function(A, j, B) {
    return this.pdf.lines(A, j, B, null, null);
  }, at = function(A, j, B, W, Y, Q, et, rt) {
    this.pdf.internal.out([e(u(B + A)), e(o(W + j)), e(u(Y + A)), e(o(Q + j)), e(u(et + A)), e(o(rt + j)), "c"].join(" "));
  }, nt = function(A, j, B, W) {
    for (var Y = 2 * Math.PI, Q = Math.PI / 2; j > B; )
      j -= Y;
    var et = Math.abs(B - j);
    et < Y && W && (et = Y - et);
    for (var rt = [], Nt = W ? -1 : 1, Lt = j; et > 1e-5; ) {
      var Ct = Lt + Nt * Math.min(et, Q);
      rt.push(lt.call(this, A, Lt, Ct)), et -= Math.abs(Ct - Lt), Lt = Ct;
    }
    return rt;
  }, lt = function(A, j, B) {
    var W = (B - j) / 2, Y = A * Math.cos(W), Q = A * Math.sin(W), et = Y, rt = -Q, Nt = et * et + rt * rt, Lt = Nt + et * Y + rt * Q, Ct = 4 / 3 * (Math.sqrt(2 * Nt * Lt) - Lt) / (et * Q - rt * Y), Mt = et - Ct * rt, Ut = rt + Ct * et, ut = Mt, E = -Ut, Xt = W + j, Et = Math.cos(Xt), At = Math.sin(Xt);
    return { x1: A * Math.cos(j), y1: A * Math.sin(j), x2: Mt * Et - Ut * At, y2: Mt * At + Ut * Et, x3: ut * Et - E * At, y3: ut * At + E * Et, x4: A * Math.cos(B), y4: A * Math.sin(B) };
  }, $ = function(A) {
    return 180 * A / Math.PI;
  }, ft = function(A, j, B, W, Y, Q) {
    var et = A + 0.5 * (B - A), rt = j + 0.5 * (W - j), Nt = Y + 0.5 * (B - Y), Lt = Q + 0.5 * (W - Q), Ct = Math.min(A, Y, et, Nt), Mt = Math.max(A, Y, et, Nt), Ut = Math.min(j, Q, rt, Lt), ut = Math.max(j, Q, rt, Lt);
    return new h(Ct, Ut, Mt - Ct, ut - Ut);
  }, ht = function(A, j, B, W, Y, Q, et, rt) {
    var Nt, Lt, Ct, Mt, Ut, ut, E, Xt, Et, At, xt, Ft, Pt, qt, Gt = B - A, $t = W - j, te = Y - B, ie = Q - W, pe = et - Y, Wt = rt - Q;
    for (Lt = 0; Lt < 41; Lt++)
      Et = (E = (Ct = A + (Nt = Lt / 40) * Gt) + Nt * ((Ut = B + Nt * te) - Ct)) + Nt * (Ut + Nt * (Y + Nt * pe - Ut) - E), At = (Xt = (Mt = j + Nt * $t) + Nt * ((ut = W + Nt * ie) - Mt)) + Nt * (ut + Nt * (Q + Nt * Wt - ut) - Xt), Lt == 0 ? (xt = Et, Ft = At, Pt = Et, qt = At) : (xt = Math.min(xt, Et), Ft = Math.min(Ft, At), Pt = Math.max(Pt, Et), qt = Math.max(qt, At));
    return new h(Math.round(xt), Math.round(Ft), Math.round(Pt - xt), Math.round(qt - Ft));
  }, kt = function() {
    if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
      var A, j, B = (A = this.ctx.lineDash, j = this.ctx.lineDashOffset, JSON.stringify({ lineDash: A, lineDashOffset: j }));
      this.prevLineDash !== B && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = B);
    }
  };
})(zt.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(i) {
  var e = function(o) {
    var l, h, f, g, b, N, S, d, O, I;
    for (/[^\x00-\xFF]/.test(o), h = [], f = 0, g = (o += l = "\0\0\0\0".slice(o.length % 4 || 4)).length; g > f; f += 4)
      (b = (o.charCodeAt(f) << 24) + (o.charCodeAt(f + 1) << 16) + (o.charCodeAt(f + 2) << 8) + o.charCodeAt(f + 3)) !== 0 ? (N = (b = ((b = ((b = ((b = (b - (I = b % 85)) / 85) - (O = b % 85)) / 85) - (d = b % 85)) / 85) - (S = b % 85)) / 85) % 85, h.push(N + 33, S + 33, d + 33, O + 33, I + 33)) : h.push(122);
    return function(q, _) {
      for (var M = _; M > 0; M--)
        q.pop();
    }(h, l.length), String.fromCharCode.apply(String, h) + "~>";
  }, n = function(o) {
    var l, h, f, g, b, N = String, S = "length", d = 255, O = "charCodeAt", I = "slice", q = "replace";
    for (o[I](-2), o = o[I](0, -2)[q](/\s/g, "")[q]("z", "!!!!!"), f = [], g = 0, b = (o += l = "uuuuu"[I](o[S] % 5 || 5))[S]; b > g; g += 5)
      h = 52200625 * (o[O](g) - 33) + 614125 * (o[O](g + 1) - 33) + 7225 * (o[O](g + 2) - 33) + 85 * (o[O](g + 3) - 33) + (o[O](g + 4) - 33), f.push(d & h >> 24, d & h >> 16, d & h >> 8, d & h);
    return function(_, M) {
      for (var X = M; X > 0; X--)
        _.pop();
    }(f, l[S]), N.fromCharCode.apply(N, f);
  }, a = function(o) {
    var l = new RegExp(/^([0-9A-Fa-f]{2})+$/);
    if ((o = o.replace(/\s/g, "")).indexOf(">") !== -1 && (o = o.substr(0, o.indexOf(">"))), o.length % 2 && (o += "0"), l.test(o) === !1)
      return "";
    for (var h = "", f = 0; f < o.length; f += 2)
      h += String.fromCharCode("0x" + (o[f] + o[f + 1]));
    return h;
  }, u = function(o) {
    for (var l = new Uint8Array(o.length), h = o.length; h--; )
      l[h] = o.charCodeAt(h);
    return o = (l = ds(l)).reduce(function(f, g) {
      return f + String.fromCharCode(g);
    }, "");
  };
  i.processDataByFilters = function(o, l) {
    var h = 0, f = o || "", g = [];
    for (typeof (l = l || []) == "string" && (l = [l]), h = 0; h < l.length; h += 1)
      switch (l[h]) {
        case "ASCII85Decode":
        case "/ASCII85Decode":
          f = n(f), g.push("/ASCII85Encode");
          break;
        case "ASCII85Encode":
        case "/ASCII85Encode":
          f = e(f), g.push("/ASCII85Decode");
          break;
        case "ASCIIHexDecode":
        case "/ASCIIHexDecode":
          f = a(f), g.push("/ASCIIHexEncode");
          break;
        case "ASCIIHexEncode":
        case "/ASCIIHexEncode":
          f = f.split("").map(function(b) {
            return ("0" + b.charCodeAt().toString(16)).slice(-2);
          }).join("") + ">", g.push("/ASCIIHexDecode");
          break;
        case "FlateEncode":
        case "/FlateEncode":
          f = u(f), g.push("/FlateDecode");
          break;
        default:
          throw new Error('The filter: "' + l[h] + '" is not implemented');
      }
    return { data: f, reverseChain: g.reverse().join(" ") };
  };
}(zt.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(i) {
  i.loadFile = function(e, n, a) {
    return function(u, o, l) {
      o = o !== !1, l = typeof l == "function" ? l : function() {
      };
      var h = void 0;
      try {
        h = function(f, g, b) {
          var N = new XMLHttpRequest(), S = 0, d = function(O) {
            var I = O.length, q = [], _ = String.fromCharCode;
            for (S = 0; S < I; S += 1)
              q.push(_(255 & O.charCodeAt(S)));
            return q.join("");
          };
          if (N.open("GET", f, !g), N.overrideMimeType("text/plain; charset=x-user-defined"), g === !1 && (N.onload = function() {
            N.status === 200 ? b(d(this.responseText)) : b(void 0);
          }), N.send(null), g && N.status === 200)
            return d(N.responseText);
        }(u, o, l);
      } catch {
      }
      return h;
    }(e, n, a);
  }, i.loadImageFile = i.loadFile;
}(zt.API), function(i) {
  function e() {
    return (Ht.html2canvas ? Promise.resolve(Ht.html2canvas) : import("./html2canvas.esm-DbilGY6A.mjs")).catch(function(l) {
      return Promise.reject(new Error("Could not load html2canvas: " + l));
    }).then(function(l) {
      return l.default ? l.default : l;
    });
  }
  function n() {
    return (Ht.DOMPurify ? Promise.resolve(Ht.DOMPurify) : import("./purify.es-eVVQmvBg.mjs")).catch(function(l) {
      return Promise.reject(new Error("Could not load dompurify: " + l));
    }).then(function(l) {
      return l.default ? l.default : l;
    });
  }
  var a = function(l) {
    var h = fe(l);
    return h === "undefined" ? "undefined" : h === "string" || l instanceof String ? "string" : h === "number" || l instanceof Number ? "number" : h === "function" || l instanceof Function ? "function" : l && l.constructor === Array ? "array" : l && l.nodeType === 1 ? "element" : h === "object" ? "object" : "unknown";
  }, u = function(l, h) {
    var f = document.createElement(l);
    for (var g in h.className && (f.className = h.className), h.innerHTML && h.dompurify && (f.innerHTML = h.dompurify.sanitize(h.innerHTML)), h.style)
      f.style[g] = h.style[g];
    return f;
  }, o = function l(h) {
    var f = Object.assign(l.convert(Promise.resolve()), JSON.parse(JSON.stringify(l.template))), g = l.convert(Promise.resolve(), f);
    return g = (g = g.setProgress(1, l, 1, [l])).set(h);
  };
  (o.prototype = Object.create(Promise.prototype)).constructor = o, o.convert = function(l, h) {
    return l.__proto__ = h || o.prototype, l;
  }, o.template = { prop: { src: null, container: null, overlay: null, canvas: null, img: null, pdf: null, pageSize: null, callback: function() {
  } }, progress: { val: 0, state: null, n: 0, stack: [] }, opt: { filename: "file.pdf", margin: [0, 0, 0, 0], enableLinks: !0, x: 0, y: 0, html2canvas: {}, jsPDF: {}, backgroundColor: "transparent" } }, o.prototype.from = function(l, h) {
    return this.then(function() {
      switch (h = h || function(f) {
        switch (a(f)) {
          case "string":
            return "string";
          case "element":
            return f.nodeName.toLowerCase() === "canvas" ? "canvas" : "element";
          default:
            return "unknown";
        }
      }(l)) {
        case "string":
          return this.then(n).then(function(f) {
            return this.set({ src: u("div", { innerHTML: l, dompurify: f }) });
          });
        case "element":
          return this.set({ src: l });
        case "canvas":
          return this.set({ canvas: l });
        case "img":
          return this.set({ img: l });
        default:
          return this.error("Unknown source type.");
      }
    });
  }, o.prototype.to = function(l) {
    switch (l) {
      case "container":
        return this.toContainer();
      case "canvas":
        return this.toCanvas();
      case "img":
        return this.toImg();
      case "pdf":
        return this.toPdf();
      default:
        return this.error("Invalid target.");
    }
  }, o.prototype.toContainer = function() {
    return this.thenList([function() {
      return this.prop.src || this.error("Cannot duplicate - no source HTML.");
    }, function() {
      return this.prop.pageSize || this.setPageSize();
    }]).then(function() {
      var l = { position: "relative", display: "inline-block", width: (typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px", left: 0, right: 0, top: 0, margin: "auto", backgroundColor: this.opt.backgroundColor }, h = function f(g, b) {
        for (var N = g.nodeType === 3 ? document.createTextNode(g.nodeValue) : g.cloneNode(!1), S = g.firstChild; S; S = S.nextSibling)
          b !== !0 && S.nodeType === 1 && S.nodeName === "SCRIPT" || N.appendChild(f(S, b));
        return g.nodeType === 1 && (g.nodeName === "CANVAS" ? (N.width = g.width, N.height = g.height, N.getContext("2d").drawImage(g, 0, 0)) : g.nodeName !== "TEXTAREA" && g.nodeName !== "SELECT" || (N.value = g.value), N.addEventListener("load", function() {
          N.scrollTop = g.scrollTop, N.scrollLeft = g.scrollLeft;
        }, !0)), N;
      }(this.prop.src, this.opt.html2canvas.javascriptEnabled);
      h.tagName === "BODY" && (l.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = u("div", { className: "html2pdf__overlay", style: { position: "fixed", overflow: "hidden", zIndex: 1e3, left: "-100000px", right: 0, bottom: 0, top: 0 } }), this.prop.container = u("div", { className: "html2pdf__container", style: l }), this.prop.container.appendChild(h), this.prop.container.firstChild.appendChild(u("div", { style: { clear: "both", border: "0 none transparent", margin: 0, padding: 0, height: 0 } })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
    });
  }, o.prototype.toCanvas = function() {
    var l = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(l).then(e).then(function(h) {
      var f = Object.assign({}, this.opt.html2canvas);
      return delete f.onrendered, h(this.prop.container, f);
    }).then(function(h) {
      (this.opt.html2canvas.onrendered || function() {
      })(h), this.prop.canvas = h, document.body.removeChild(this.prop.overlay);
    });
  }, o.prototype.toContext2d = function() {
    var l = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(l).then(e).then(function(h) {
      var f = this.opt.jsPDF, g = this.opt.fontFaces, b = typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, N = Object.assign({ async: !0, allowTaint: !0, scale: b, scrollX: this.opt.scrollX || 0, scrollY: this.opt.scrollY || 0, backgroundColor: "#ffffff", imageTimeout: 15e3, logging: !0, proxy: null, removeContainer: !0, foreignObjectRendering: !1, useCORS: !1 }, this.opt.html2canvas);
      if (delete N.onrendered, f.context2d.autoPaging = this.opt.autoPaging === void 0 || this.opt.autoPaging, f.context2d.posX = this.opt.x, f.context2d.posY = this.opt.y, f.context2d.margin = this.opt.margin, f.context2d.fontFaces = g, g)
        for (var S = 0; S < g.length; ++S) {
          var d = g[S], O = d.src.find(function(I) {
            return I.format === "truetype";
          });
          O && f.addFont(O.url, d.ref.name, d.ref.style);
        }
      return N.windowHeight = N.windowHeight || 0, N.windowHeight = N.windowHeight == 0 ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : N.windowHeight, f.context2d.save(!0), h(this.prop.container, N);
    }).then(function(h) {
      this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {
      })(h), this.prop.canvas = h, document.body.removeChild(this.prop.overlay);
    });
  }, o.prototype.toImg = function() {
    return this.thenList([function() {
      return this.prop.canvas || this.toCanvas();
    }]).then(function() {
      var l = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
      this.prop.img = document.createElement("img"), this.prop.img.src = l;
    });
  }, o.prototype.toPdf = function() {
    return this.thenList([function() {
      return this.toContext2d();
    }]).then(function() {
      this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
    });
  }, o.prototype.output = function(l, h, f) {
    return (f = f || "pdf").toLowerCase() === "img" || f.toLowerCase() === "image" ? this.outputImg(l, h) : this.outputPdf(l, h);
  }, o.prototype.outputPdf = function(l, h) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      return this.prop.pdf.output(l, h);
    });
  }, o.prototype.outputImg = function(l) {
    return this.thenList([function() {
      return this.prop.img || this.toImg();
    }]).then(function() {
      switch (l) {
        case void 0:
        case "img":
          return this.prop.img;
        case "datauristring":
        case "dataurlstring":
          return this.prop.img.src;
        case "datauri":
        case "dataurl":
          return document.location.href = this.prop.img.src;
        default:
          throw 'Image output type "' + l + '" is not supported.';
      }
    });
  }, o.prototype.save = function(l) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).set(l ? { filename: l } : null).then(function() {
      this.prop.pdf.save(this.opt.filename);
    });
  }, o.prototype.doCallback = function() {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      this.prop.callback(this.prop.pdf);
    });
  }, o.prototype.set = function(l) {
    if (a(l) !== "object")
      return this;
    var h = Object.keys(l || {}).map(function(f) {
      if (f in o.template.prop)
        return function() {
          this.prop[f] = l[f];
        };
      switch (f) {
        case "margin":
          return this.setMargin.bind(this, l.margin);
        case "jsPDF":
          return function() {
            return this.opt.jsPDF = l.jsPDF, this.setPageSize();
          };
        case "pageSize":
          return this.setPageSize.bind(this, l.pageSize);
        default:
          return function() {
            this.opt[f] = l[f];
          };
      }
    }, this);
    return this.then(function() {
      return this.thenList(h);
    });
  }, o.prototype.get = function(l, h) {
    return this.then(function() {
      var f = l in o.template.prop ? this.prop[l] : this.opt[l];
      return h ? h(f) : f;
    });
  }, o.prototype.setMargin = function(l) {
    return this.then(function() {
      switch (a(l)) {
        case "number":
          l = [l, l, l, l];
        case "array":
          if (l.length === 2 && (l = [l[0], l[1], l[0], l[1]]), l.length === 4)
            break;
        default:
          return this.error("Invalid margin array.");
      }
      this.opt.margin = l;
    }).then(this.setPageSize);
  }, o.prototype.setPageSize = function(l) {
    function h(f, g) {
      return Math.floor(f * g / 72 * 96);
    }
    return this.then(function() {
      (l = l || zt.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (l.inner = { width: l.width - this.opt.margin[1] - this.opt.margin[3], height: l.height - this.opt.margin[0] - this.opt.margin[2] }, l.inner.px = { width: h(l.inner.width, l.k), height: h(l.inner.height, l.k) }, l.inner.ratio = l.inner.height / l.inner.width), this.prop.pageSize = l;
    });
  }, o.prototype.setProgress = function(l, h, f, g) {
    return l != null && (this.progress.val = l), h != null && (this.progress.state = h), f != null && (this.progress.n = f), g != null && (this.progress.stack = g), this.progress.ratio = this.progress.val / this.progress.state, this;
  }, o.prototype.updateProgress = function(l, h, f, g) {
    return this.setProgress(l ? this.progress.val + l : null, h || null, f ? this.progress.n + f : null, g ? this.progress.stack.concat(g) : null);
  }, o.prototype.then = function(l, h) {
    var f = this;
    return this.thenCore(l, h, function(g, b) {
      return f.updateProgress(null, null, 1, [g]), Promise.prototype.then.call(this, function(N) {
        return f.updateProgress(null, g), N;
      }).then(g, b).then(function(N) {
        return f.updateProgress(1), N;
      });
    });
  }, o.prototype.thenCore = function(l, h, f) {
    f = f || Promise.prototype.then, l && (l = l.bind(this)), h && (h = h.bind(this));
    var g = Promise.toString().indexOf("[native code]") !== -1 && Promise.name === "Promise" ? this : o.convert(Object.assign({}, this), Promise.prototype), b = f.call(g, l, h);
    return o.convert(b, this.__proto__);
  }, o.prototype.thenExternal = function(l, h) {
    return Promise.prototype.then.call(this, l, h);
  }, o.prototype.thenList = function(l) {
    var h = this;
    return l.forEach(function(f) {
      h = h.thenCore(f);
    }), h;
  }, o.prototype.catch = function(l) {
    l && (l = l.bind(this));
    var h = Promise.prototype.catch.call(this, l);
    return o.convert(h, this);
  }, o.prototype.catchExternal = function(l) {
    return Promise.prototype.catch.call(this, l);
  }, o.prototype.error = function(l) {
    return this.then(function() {
      throw new Error(l);
    });
  }, o.prototype.using = o.prototype.set, o.prototype.saveAs = o.prototype.save, o.prototype.export = o.prototype.output, o.prototype.run = o.prototype.then, zt.getPageSize = function(l, h, f) {
    if (fe(l) === "object") {
      var g = l;
      l = g.orientation, h = g.unit || h, f = g.format || f;
    }
    h = h || "mm", f = f || "a4", l = ("" + (l || "P")).toLowerCase();
    var b, N = ("" + f).toLowerCase(), S = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
    switch (h) {
      case "pt":
        b = 1;
        break;
      case "mm":
        b = 72 / 25.4;
        break;
      case "cm":
        b = 72 / 2.54;
        break;
      case "in":
        b = 72;
        break;
      case "px":
        b = 0.75;
        break;
      case "pc":
      case "em":
        b = 12;
        break;
      case "ex":
        b = 6;
        break;
      default:
        throw "Invalid unit: " + h;
    }
    var d, O = 0, I = 0;
    if (S.hasOwnProperty(N))
      O = S[N][1] / b, I = S[N][0] / b;
    else
      try {
        O = f[1], I = f[0];
      } catch {
        throw new Error("Invalid format: " + f);
      }
    if (l === "p" || l === "portrait")
      l = "p", I > O && (d = I, I = O, O = d);
    else {
      if (l !== "l" && l !== "landscape")
        throw "Invalid orientation: " + l;
      l = "l", O > I && (d = I, I = O, O = d);
    }
    return { width: I, height: O, unit: h, k: b, orientation: l };
  }, i.html = function(l, h) {
    (h = h || {}).callback = h.callback || function() {
    }, h.html2canvas = h.html2canvas || {}, h.html2canvas.canvas = h.html2canvas.canvas || this.canvas, h.jsPDF = h.jsPDF || this, h.fontFaces = h.fontFaces ? h.fontFaces.map(ws) : null;
    var f = new o(h);
    return h.worker ? f : f.from(l).doCallback();
  };
}(zt.API), zt.API.addJS = function(i) {
  return mu = i, this.internal.events.subscribe("postPutResources", function() {
    $a = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + ($a + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), gu = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + mu + ")"), this.internal.out(">>"), this.internal.out("endobj");
  }), this.internal.events.subscribe("putCatalog", function() {
    $a !== void 0 && gu !== void 0 && this.internal.out("/Names <</JavaScript " + $a + " 0 R>>");
  }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(i) {
  var e;
  i.events.push(["postPutResources", function() {
    var n = this, a = /^(\d+) 0 obj$/;
    if (this.outline.root.children.length > 0)
      for (var u = n.outline.render().split(/\r\n/), o = 0; o < u.length; o++) {
        var l = u[o], h = a.exec(l);
        if (h != null) {
          var f = h[1];
          n.internal.newObjectDeferredBegin(f, !1);
        }
        n.internal.write(l);
      }
    if (this.outline.createNamedDestinations) {
      var g = this.internal.pages.length, b = [];
      for (o = 0; o < g; o++) {
        var N = n.internal.newObject();
        b.push(N);
        var S = n.internal.getPageInfo(o + 1);
        n.internal.write("<< /D[" + S.objId + " 0 R /XYZ null null null]>> endobj");
      }
      var d = n.internal.newObject();
      for (n.internal.write("<< /Names [ "), o = 0; o < b.length; o++)
        n.internal.write("(page_" + (o + 1) + ")" + b[o] + " 0 R");
      n.internal.write(" ] >>", "endobj"), e = n.internal.newObject(), n.internal.write("<< /Dests " + d + " 0 R"), n.internal.write(">>", "endobj");
    }
  }]), i.events.push(["putCatalog", function() {
    this.outline.root.children.length > 0 && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + e + " 0 R"));
  }]), i.events.push(["initialized", function() {
    var n = this;
    n.outline = { createNamedDestinations: !1, root: { children: [] } }, n.outline.add = function(a, u, o) {
      var l = { title: u, options: o, children: [] };
      return a == null && (a = this.root), a.children.push(l), l;
    }, n.outline.render = function() {
      return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = n, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
    }, n.outline.genIds_r = function(a) {
      a.id = n.internal.newObjectDeferred();
      for (var u = 0; u < a.children.length; u++)
        this.genIds_r(a.children[u]);
    }, n.outline.renderRoot = function(a) {
      this.objStart(a), this.line("/Type /Outlines"), a.children.length > 0 && (this.line("/First " + this.makeRef(a.children[0])), this.line("/Last " + this.makeRef(a.children[a.children.length - 1]))), this.line("/Count " + this.count_r({ count: 0 }, a)), this.objEnd();
    }, n.outline.renderItems = function(a) {
      for (var u = this.ctx.pdf.internal.getVerticalCoordinateString, o = 0; o < a.children.length; o++) {
        var l = a.children[o];
        this.objStart(l), this.line("/Title " + this.makeString(l.title)), this.line("/Parent " + this.makeRef(a)), o > 0 && this.line("/Prev " + this.makeRef(a.children[o - 1])), o < a.children.length - 1 && this.line("/Next " + this.makeRef(a.children[o + 1])), l.children.length > 0 && (this.line("/First " + this.makeRef(l.children[0])), this.line("/Last " + this.makeRef(l.children[l.children.length - 1])));
        var h = this.count = this.count_r({ count: 0 }, l);
        if (h > 0 && this.line("/Count " + h), l.options && l.options.pageNumber) {
          var f = n.internal.getPageInfo(l.options.pageNumber);
          this.line("/Dest [" + f.objId + " 0 R /XYZ 0 " + u(0) + " 0]");
        }
        this.objEnd();
      }
      for (var g = 0; g < a.children.length; g++)
        this.renderItems(a.children[g]);
    }, n.outline.line = function(a) {
      this.ctx.val += a + `\r
`;
    }, n.outline.makeRef = function(a) {
      return a.id + " 0 R";
    }, n.outline.makeString = function(a) {
      return "(" + n.internal.pdfEscape(a) + ")";
    }, n.outline.objStart = function(a) {
      this.ctx.val += `\r
` + a.id + ` 0 obj\r
<<\r
`;
    }, n.outline.objEnd = function() {
      this.ctx.val += `>> \r
endobj\r
`;
    }, n.outline.count_r = function(a, u) {
      for (var o = 0; o < u.children.length; o++)
        a.count++, this.count_r(a, u.children[o]);
      return a.count;
    };
  }]);
}(zt.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(i) {
  var e = [192, 193, 194, 195, 196, 197, 198, 199];
  i.processJPEG = function(n, a, u, o, l, h) {
    var f, g = this.decode.DCT_DECODE, b = null;
    if (typeof n == "string" || this.__addimage__.isArrayBuffer(n) || this.__addimage__.isArrayBufferView(n)) {
      switch (n = l || n, n = this.__addimage__.isArrayBuffer(n) ? new Uint8Array(n) : n, (f = function(N) {
        for (var S, d = 256 * N.charCodeAt(4) + N.charCodeAt(5), O = N.length, I = { width: 0, height: 0, numcomponents: 1 }, q = 4; q < O; q += 2) {
          if (q += d, e.indexOf(N.charCodeAt(q + 1)) !== -1) {
            S = 256 * N.charCodeAt(q + 5) + N.charCodeAt(q + 6), I = { width: 256 * N.charCodeAt(q + 7) + N.charCodeAt(q + 8), height: S, numcomponents: N.charCodeAt(q + 9) };
            break;
          }
          d = 256 * N.charCodeAt(q + 2) + N.charCodeAt(q + 3);
        }
        return I;
      }(n = this.__addimage__.isArrayBufferView(n) ? this.__addimage__.arrayBufferToBinaryString(n) : n)).numcomponents) {
        case 1:
          h = this.color_spaces.DEVICE_GRAY;
          break;
        case 4:
          h = this.color_spaces.DEVICE_CMYK;
          break;
        case 3:
          h = this.color_spaces.DEVICE_RGB;
      }
      b = { data: n, width: f.width, height: f.height, colorSpace: h, bitsPerComponent: 8, filter: g, index: a, alias: u };
    }
    return b;
  };
}(zt.API);
var Ai, Qa, vu, bu, yu, rl = function() {
  var i, e, n;
  function a(o) {
    var l, h, f, g, b, N, S, d, O, I, q, _, M, X;
    for (this.data = o, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, N = null; ; ) {
      switch (l = this.readUInt32(), O = (function() {
        var ot, ct;
        for (ct = [], ot = 0; ot < 4; ++ot)
          ct.push(String.fromCharCode(this.data[this.pos++]));
        return ct;
      }).call(this).join("")) {
        case "IHDR":
          this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
          break;
        case "acTL":
          this.animation = { numFrames: this.readUInt32(), numPlays: this.readUInt32() || 1 / 0, frames: [] };
          break;
        case "PLTE":
          this.palette = this.read(l);
          break;
        case "fcTL":
          N && this.animation.frames.push(N), this.pos += 4, N = { width: this.readUInt32(), height: this.readUInt32(), xOffset: this.readUInt32(), yOffset: this.readUInt32() }, b = this.readUInt16(), g = this.readUInt16() || 100, N.delay = 1e3 * b / g, N.disposeOp = this.data[this.pos++], N.blendOp = this.data[this.pos++], N.data = [];
          break;
        case "IDAT":
        case "fdAT":
          for (O === "fdAT" && (this.pos += 4, l -= 4), o = (N != null ? N.data : void 0) || this.imgData, _ = 0; 0 <= l ? _ < l : _ > l; 0 <= l ? ++_ : --_)
            o.push(this.data[this.pos++]);
          break;
        case "tRNS":
          switch (this.transparency = {}, this.colorType) {
            case 3:
              if (f = this.palette.length / 3, this.transparency.indexed = this.read(l), this.transparency.indexed.length > f)
                throw new Error("More transparent colors than palette size");
              if ((I = f - this.transparency.indexed.length) > 0)
                for (M = 0; 0 <= I ? M < I : M > I; 0 <= I ? ++M : --M)
                  this.transparency.indexed.push(255);
              break;
            case 0:
              this.transparency.grayscale = this.read(l)[0];
              break;
            case 2:
              this.transparency.rgb = this.read(l);
          }
          break;
        case "tEXt":
          S = (q = this.read(l)).indexOf(0), d = String.fromCharCode.apply(String, q.slice(0, S)), this.text[d] = String.fromCharCode.apply(String, q.slice(S + 1));
          break;
        case "IEND":
          return N && this.animation.frames.push(N), this.colors = (function() {
            switch (this.colorType) {
              case 0:
              case 3:
              case 4:
                return 1;
              case 2:
              case 6:
                return 3;
            }
          }).call(this), this.hasAlphaChannel = (X = this.colorType) === 4 || X === 6, h = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * h, this.colorSpace = (function() {
            switch (this.colors) {
              case 1:
                return "DeviceGray";
              case 3:
                return "DeviceRGB";
            }
          }).call(this), void (this.imgData = new Uint8Array(this.imgData));
        default:
          this.pos += l;
      }
      if (this.pos += 4, this.pos > this.data.length)
        throw new Error("Incomplete or corrupt PNG file");
    }
  }
  a.prototype.read = function(o) {
    var l, h;
    for (h = [], l = 0; 0 <= o ? l < o : l > o; 0 <= o ? ++l : --l)
      h.push(this.data[this.pos++]);
    return h;
  }, a.prototype.readUInt32 = function() {
    return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
  }, a.prototype.readUInt16 = function() {
    return this.data[this.pos++] << 8 | this.data[this.pos++];
  }, a.prototype.decodePixels = function(o) {
    var l = this.pixelBitlength / 8, h = new Uint8Array(this.width * this.height * l), f = 0, g = this;
    if (o == null && (o = this.imgData), o.length === 0)
      return new Uint8Array(0);
    function b(N, S, d, O) {
      var I, q, _, M, X, ot, ct, yt, tt, R, gt, pt, F, P, z, D, at, nt, lt, $, ft, ht = Math.ceil((g.width - N) / d), kt = Math.ceil((g.height - S) / O), A = g.width == ht && g.height == kt;
      for (P = l * ht, pt = A ? h : new Uint8Array(P * kt), ot = o.length, F = 0, q = 0; F < kt && f < ot; ) {
        switch (o[f++]) {
          case 0:
            for (M = at = 0; at < P; M = at += 1)
              pt[q++] = o[f++];
            break;
          case 1:
            for (M = nt = 0; nt < P; M = nt += 1)
              I = o[f++], X = M < l ? 0 : pt[q - l], pt[q++] = (I + X) % 256;
            break;
          case 2:
            for (M = lt = 0; lt < P; M = lt += 1)
              I = o[f++], _ = (M - M % l) / l, z = F && pt[(F - 1) * P + _ * l + M % l], pt[q++] = (z + I) % 256;
            break;
          case 3:
            for (M = $ = 0; $ < P; M = $ += 1)
              I = o[f++], _ = (M - M % l) / l, X = M < l ? 0 : pt[q - l], z = F && pt[(F - 1) * P + _ * l + M % l], pt[q++] = (I + Math.floor((X + z) / 2)) % 256;
            break;
          case 4:
            for (M = ft = 0; ft < P; M = ft += 1)
              I = o[f++], _ = (M - M % l) / l, X = M < l ? 0 : pt[q - l], F === 0 ? z = D = 0 : (z = pt[(F - 1) * P + _ * l + M % l], D = _ && pt[(F - 1) * P + (_ - 1) * l + M % l]), ct = X + z - D, yt = Math.abs(ct - X), R = Math.abs(ct - z), gt = Math.abs(ct - D), tt = yt <= R && yt <= gt ? X : R <= gt ? z : D, pt[q++] = (I + tt) % 256;
            break;
          default:
            throw new Error("Invalid filter algorithm: " + o[f - 1]);
        }
        if (!A) {
          var j = ((S + F * O) * g.width + N) * l, B = F * P;
          for (M = 0; M < ht; M += 1) {
            for (var W = 0; W < l; W += 1)
              h[j++] = pt[B++];
            j += (d - 1) * l;
          }
        }
        F++;
      }
    }
    return o = qc(o), g.interlaceMethod == 1 ? (b(0, 0, 8, 8), b(4, 0, 8, 8), b(0, 4, 4, 8), b(2, 0, 4, 4), b(0, 2, 2, 4), b(1, 0, 2, 2), b(0, 1, 1, 2)) : b(0, 0, 1, 1), h;
  }, a.prototype.decodePalette = function() {
    var o, l, h, f, g, b, N, S, d;
    for (h = this.palette, b = this.transparency.indexed || [], g = new Uint8Array((b.length || 0) + h.length), f = 0, o = 0, l = N = 0, S = h.length; N < S; l = N += 3)
      g[f++] = h[l], g[f++] = h[l + 1], g[f++] = h[l + 2], g[f++] = (d = b[o++]) != null ? d : 255;
    return g;
  }, a.prototype.copyToImageData = function(o, l) {
    var h, f, g, b, N, S, d, O, I, q, _;
    if (f = this.colors, I = null, h = this.hasAlphaChannel, this.palette.length && (I = (_ = this._decodedPalette) != null ? _ : this._decodedPalette = this.decodePalette(), f = 4, h = !0), O = (g = o.data || o).length, N = I || l, b = S = 0, f === 1)
      for (; b < O; )
        d = I ? 4 * l[b / 4] : S, q = N[d++], g[b++] = q, g[b++] = q, g[b++] = q, g[b++] = h ? N[d++] : 255, S = d;
    else
      for (; b < O; )
        d = I ? 4 * l[b / 4] : S, g[b++] = N[d++], g[b++] = N[d++], g[b++] = N[d++], g[b++] = h ? N[d++] : 255, S = d;
  }, a.prototype.decode = function() {
    var o;
    return o = new Uint8Array(this.width * this.height * 4), this.copyToImageData(o, this.decodePixels()), o;
  };
  var u = function() {
    if (Object.prototype.toString.call(Ht) === "[object Window]") {
      try {
        e = Ht.document.createElement("canvas"), n = e.getContext("2d");
      } catch {
        return !1;
      }
      return !0;
    }
    return !1;
  };
  return u(), i = function(o) {
    var l;
    if (u() === !0)
      return n.width = o.width, n.height = o.height, n.clearRect(0, 0, o.width, o.height), n.putImageData(o, 0, 0), (l = new Image()).src = e.toDataURL(), l;
    throw new Error("This method requires a Browser with Canvas-capability.");
  }, a.prototype.decodeFrames = function(o) {
    var l, h, f, g, b, N, S, d;
    if (this.animation) {
      for (d = [], h = b = 0, N = (S = this.animation.frames).length; b < N; h = ++b)
        l = S[h], f = o.createImageData(l.width, l.height), g = this.decodePixels(new Uint8Array(l.data)), this.copyToImageData(f, g), l.imageData = f, d.push(l.image = i(f));
      return d;
    }
  }, a.prototype.renderFrame = function(o, l) {
    var h, f, g;
    return h = (f = this.animation.frames)[l], g = f[l - 1], l === 0 && o.clearRect(0, 0, this.width, this.height), (g != null ? g.disposeOp : void 0) === 1 ? o.clearRect(g.xOffset, g.yOffset, g.width, g.height) : (g != null ? g.disposeOp : void 0) === 2 && o.putImageData(g.imageData, g.xOffset, g.yOffset), h.blendOp === 0 && o.clearRect(h.xOffset, h.yOffset, h.width, h.height), o.drawImage(h.image, h.xOffset, h.yOffset);
  }, a.prototype.animate = function(o) {
    var l, h, f, g, b, N, S = this;
    return h = 0, N = this.animation, g = N.numFrames, f = N.frames, b = N.numPlays, (l = function() {
      var d, O;
      if (d = h++ % g, O = f[d], S.renderFrame(o, d), g > 1 && h / g < b)
        return S.animation._timeout = setTimeout(l, O.delay);
    })();
  }, a.prototype.stopAnimation = function() {
    var o;
    return clearTimeout((o = this.animation) != null ? o._timeout : void 0);
  }, a.prototype.render = function(o) {
    var l, h;
    return o._png && o._png.stopAnimation(), o._png = this, o.width = this.width, o.height = this.height, l = o.getContext("2d"), this.animation ? (this.decodeFrames(l), this.animate(l)) : (h = l.createImageData(this.width, this.height), this.copyToImageData(h, this.decodePixels()), l.putImageData(h, 0, 0));
  }, a;
}();
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
/**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */
function il(i) {
  var e = 0;
  if (i[e++] !== 71 || i[e++] !== 73 || i[e++] !== 70 || i[e++] !== 56 || (i[e++] + 1 & 253) != 56 || i[e++] !== 97)
    throw new Error("Invalid GIF 87a/89a header.");
  var n = i[e++] | i[e++] << 8, a = i[e++] | i[e++] << 8, u = i[e++], o = u >> 7, l = 1 << (7 & u) + 1;
  i[e++], i[e++];
  var h = null, f = null;
  o && (h = e, f = l, e += 3 * l);
  var g = !0, b = [], N = 0, S = null, d = 0, O = null;
  for (this.width = n, this.height = a; g && e < i.length; )
    switch (i[e++]) {
      case 33:
        switch (i[e++]) {
          case 255:
            if (i[e] !== 11 || i[e + 1] == 78 && i[e + 2] == 69 && i[e + 3] == 84 && i[e + 4] == 83 && i[e + 5] == 67 && i[e + 6] == 65 && i[e + 7] == 80 && i[e + 8] == 69 && i[e + 9] == 50 && i[e + 10] == 46 && i[e + 11] == 48 && i[e + 12] == 3 && i[e + 13] == 1 && i[e + 16] == 0)
              e += 14, O = i[e++] | i[e++] << 8, e++;
            else
              for (e += 12; ; ) {
                if (!((F = i[e++]) >= 0))
                  throw Error("Invalid block size");
                if (F === 0)
                  break;
                e += F;
              }
            break;
          case 249:
            if (i[e++] !== 4 || i[e + 4] !== 0)
              throw new Error("Invalid graphics extension block.");
            var I = i[e++];
            N = i[e++] | i[e++] << 8, S = i[e++], !(1 & I) && (S = null), d = I >> 2 & 7, e++;
            break;
          case 254:
            for (; ; ) {
              if (!((F = i[e++]) >= 0))
                throw Error("Invalid block size");
              if (F === 0)
                break;
              e += F;
            }
            break;
          default:
            throw new Error("Unknown graphic control label: 0x" + i[e - 1].toString(16));
        }
        break;
      case 44:
        var q = i[e++] | i[e++] << 8, _ = i[e++] | i[e++] << 8, M = i[e++] | i[e++] << 8, X = i[e++] | i[e++] << 8, ot = i[e++], ct = ot >> 6 & 1, yt = 1 << (7 & ot) + 1, tt = h, R = f, gt = !1;
        ot >> 7 && (gt = !0, tt = e, R = yt, e += 3 * yt);
        var pt = e;
        for (e++; ; ) {
          var F;
          if (!((F = i[e++]) >= 0))
            throw Error("Invalid block size");
          if (F === 0)
            break;
          e += F;
        }
        b.push({ x: q, y: _, width: M, height: X, has_local_palette: gt, palette_offset: tt, palette_size: R, data_offset: pt, data_length: e - pt, transparent_index: S, interlaced: !!ct, delay: N, disposal: d });
        break;
      case 59:
        g = !1;
        break;
      default:
        throw new Error("Unknown gif block: 0x" + i[e - 1].toString(16));
    }
  this.numFrames = function() {
    return b.length;
  }, this.loopCount = function() {
    return O;
  }, this.frameInfo = function(P) {
    if (P < 0 || P >= b.length)
      throw new Error("Frame index out of range.");
    return b[P];
  }, this.decodeAndBlitFrameBGRA = function(P, z) {
    var D = this.frameInfo(P), at = D.width * D.height, nt = new Uint8Array(at);
    wu(i, D.data_offset, nt, at);
    var lt = D.palette_offset, $ = D.transparent_index;
    $ === null && ($ = 256);
    var ft = D.width, ht = n - ft, kt = ft, A = 4 * (D.y * n + D.x), j = 4 * ((D.y + D.height) * n + D.x), B = A, W = 4 * ht;
    D.interlaced === !0 && (W += 4 * n * 7);
    for (var Y = 8, Q = 0, et = nt.length; Q < et; ++Q) {
      var rt = nt[Q];
      if (kt === 0 && (kt = ft, (B += W) >= j && (W = 4 * ht + 4 * n * (Y - 1), B = A + (ft + ht) * (Y << 1), Y >>= 1)), rt === $)
        B += 4;
      else {
        var Nt = i[lt + 3 * rt], Lt = i[lt + 3 * rt + 1], Ct = i[lt + 3 * rt + 2];
        z[B++] = Ct, z[B++] = Lt, z[B++] = Nt, z[B++] = 255;
      }
      --kt;
    }
  }, this.decodeAndBlitFrameRGBA = function(P, z) {
    var D = this.frameInfo(P), at = D.width * D.height, nt = new Uint8Array(at);
    wu(i, D.data_offset, nt, at);
    var lt = D.palette_offset, $ = D.transparent_index;
    $ === null && ($ = 256);
    var ft = D.width, ht = n - ft, kt = ft, A = 4 * (D.y * n + D.x), j = 4 * ((D.y + D.height) * n + D.x), B = A, W = 4 * ht;
    D.interlaced === !0 && (W += 4 * n * 7);
    for (var Y = 8, Q = 0, et = nt.length; Q < et; ++Q) {
      var rt = nt[Q];
      if (kt === 0 && (kt = ft, (B += W) >= j && (W = 4 * ht + 4 * n * (Y - 1), B = A + (ft + ht) * (Y << 1), Y >>= 1)), rt === $)
        B += 4;
      else {
        var Nt = i[lt + 3 * rt], Lt = i[lt + 3 * rt + 1], Ct = i[lt + 3 * rt + 2];
        z[B++] = Nt, z[B++] = Lt, z[B++] = Ct, z[B++] = 255;
      }
      --kt;
    }
  };
}
function wu(i, e, n, a) {
  for (var u = i[e++], o = 1 << u, l = o + 1, h = l + 1, f = u + 1, g = (1 << f) - 1, b = 0, N = 0, S = 0, d = i[e++], O = new Int32Array(4096), I = null; ; ) {
    for (; b < 16 && d !== 0; )
      N |= i[e++] << b, b += 8, d === 1 ? d = i[e++] : --d;
    if (b < f)
      break;
    var q = N & g;
    if (N >>= f, b -= f, q !== o) {
      if (q === l)
        break;
      for (var _ = q < h ? q : I, M = 0, X = _; X > o; )
        X = O[X] >> 8, ++M;
      var ot = X;
      if (S + M + (_ !== q ? 1 : 0) > a)
        return void ve.log("Warning, gif stream longer than expected.");
      n[S++] = ot;
      var ct = S += M;
      for (_ !== q && (n[S++] = ot), X = _; M--; )
        X = O[X], n[--ct] = 255 & X, X >>= 8;
      I !== null && h < 4096 && (O[h++] = I << 8 | ot, h >= g + 1 && f < 12 && (++f, g = g << 1 | 1)), I = q;
    } else
      h = l + 1, g = (1 << (f = u + 1)) - 1, I = null;
  }
  return S !== a && ve.log("Warning, gif stream shorter than expected."), n;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
function cs(i) {
  var e, n, a, u, o, l = Math.floor, h = new Array(64), f = new Array(64), g = new Array(64), b = new Array(64), N = new Array(65535), S = new Array(65535), d = new Array(64), O = new Array(64), I = [], q = 0, _ = 7, M = new Array(64), X = new Array(64), ot = new Array(64), ct = new Array(256), yt = new Array(2048), tt = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63], R = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0], gt = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], pt = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125], F = [1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20, 50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51, 98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250], P = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0], z = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], D = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119], at = [0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50, 129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114, 209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41, 42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229, 230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249, 250];
  function nt(A, j) {
    for (var B = 0, W = 0, Y = new Array(), Q = 1; Q <= 16; Q++) {
      for (var et = 1; et <= A[Q]; et++)
        Y[j[W]] = [], Y[j[W]][0] = B, Y[j[W]][1] = Q, W++, B++;
      B *= 2;
    }
    return Y;
  }
  function lt(A) {
    for (var j = A[0], B = A[1] - 1; B >= 0; )
      j & 1 << B && (q |= 1 << _), B--, --_ < 0 && (q == 255 ? ($(255), $(0)) : $(q), _ = 7, q = 0);
  }
  function $(A) {
    I.push(A);
  }
  function ft(A) {
    $(A >> 8 & 255), $(255 & A);
  }
  function ht(A, j, B, W, Y) {
    for (var Q, et = Y[0], rt = Y[240], Nt = function(At, xt) {
      var Ft, Pt, qt, Gt, $t, te, ie, pe, Wt, ee, It = 0;
      for (Wt = 0; Wt < 8; ++Wt) {
        Ft = At[It], Pt = At[It + 1], qt = At[It + 2], Gt = At[It + 3], $t = At[It + 4], te = At[It + 5], ie = At[It + 6];
        var Ve = Ft + (pe = At[It + 7]), oe = Ft - pe, wn = Pt + ie, ge = Pt - ie, Ae = qt + te, Rn = qt - te, ue = Gt + $t, jr = Gt - $t, Ne = Ve + ue, An = Ve - ue, $n = wn + Ae, xe = wn - Ae;
        At[It] = Ne + $n, At[It + 4] = Ne - $n;
        var Yt = 0.707106781 * (xe + An);
        At[It + 2] = An + Yt, At[It + 6] = An - Yt;
        var ce = 0.382683433 * ((Ne = jr + Rn) - (xe = ge + oe)), Or = 0.5411961 * Ne + ce, He = 1.306562965 * xe + ce, Tn = 0.707106781 * ($n = Rn + ge), zn = oe + Tn, Tt = oe - Tn;
        At[It + 5] = Tt + Or, At[It + 3] = Tt - Or, At[It + 1] = zn + He, At[It + 7] = zn - He, It += 8;
      }
      for (It = 0, Wt = 0; Wt < 8; ++Wt) {
        Ft = At[It], Pt = At[It + 8], qt = At[It + 16], Gt = At[It + 24], $t = At[It + 32], te = At[It + 40], ie = At[It + 48];
        var Ln = Ft + (pe = At[It + 56]), Un = Ft - pe, en = Pt + ie, qe = Pt - ie, Oe = qt + te, cn = qt - te, Gr = Gt + $t, Qn = Gt - $t, Nn = Ln + Gr, xn = Ln - Gr, Sn = en + Oe, Hn = en - Oe;
        At[It] = Nn + Sn, At[It + 32] = Nn - Sn;
        var dn = 0.707106781 * (Hn + xn);
        At[It + 16] = xn + dn, At[It + 48] = xn - dn;
        var Wn = 0.382683433 * ((Nn = Qn + cn) - (Hn = qe + Un)), Mr = 0.5411961 * Nn + Wn, Yr = 1.306562965 * Hn + Wn, Jr = 0.707106781 * (Sn = cn + qe), Xr = Un + Jr, Kr = Un - Jr;
        At[It + 40] = Kr + Mr, At[It + 24] = Kr - Mr, At[It + 8] = Xr + Yr, At[It + 56] = Xr - Yr, It++;
      }
      for (Wt = 0; Wt < 64; ++Wt)
        ee = At[Wt] * xt[Wt], d[Wt] = ee > 0 ? ee + 0.5 | 0 : ee - 0.5 | 0;
      return d;
    }(A, j), Lt = 0; Lt < 64; ++Lt)
      O[tt[Lt]] = Nt[Lt];
    var Ct = O[0] - B;
    B = O[0], Ct == 0 ? lt(W[0]) : (lt(W[S[Q = 32767 + Ct]]), lt(N[Q]));
    for (var Mt = 63; Mt > 0 && O[Mt] == 0; )
      Mt--;
    if (Mt == 0)
      return lt(et), B;
    for (var Ut, ut = 1; ut <= Mt; ) {
      for (var E = ut; O[ut] == 0 && ut <= Mt; )
        ++ut;
      var Xt = ut - E;
      if (Xt >= 16) {
        Ut = Xt >> 4;
        for (var Et = 1; Et <= Ut; ++Et)
          lt(rt);
        Xt &= 15;
      }
      Q = 32767 + O[ut], lt(Y[(Xt << 4) + S[Q]]), lt(N[Q]), ut++;
    }
    return Mt != 63 && lt(et), B;
  }
  function kt(A) {
    A = Math.min(Math.max(A, 1), 100), o != A && (function(j) {
      for (var B = [16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26, 58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17, 22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109, 103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64, 78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112, 100, 103, 99], W = 0; W < 64; W++) {
        var Y = l((B[W] * j + 50) / 100);
        Y = Math.min(Math.max(Y, 1), 255), h[tt[W]] = Y;
      }
      for (var Q = [17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99, 99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99], et = 0; et < 64; et++) {
        var rt = l((Q[et] * j + 50) / 100);
        rt = Math.min(Math.max(rt, 1), 255), f[tt[et]] = rt;
      }
      for (var Nt = [1, 1.387039845, 1.306562965, 1.175875602, 1, 0.785694958, 0.5411961, 0.275899379], Lt = 0, Ct = 0; Ct < 8; Ct++)
        for (var Mt = 0; Mt < 8; Mt++)
          g[Lt] = 1 / (h[tt[Lt]] * Nt[Ct] * Nt[Mt] * 8), b[Lt] = 1 / (f[tt[Lt]] * Nt[Ct] * Nt[Mt] * 8), Lt++;
    }(A < 50 ? Math.floor(5e3 / A) : Math.floor(200 - 2 * A)), o = A);
  }
  this.encode = function(A, j) {
    j && kt(j), I = new Array(), q = 0, _ = 7, ft(65496), ft(65504), ft(16), $(74), $(70), $(73), $(70), $(0), $(1), $(1), $(0), ft(1), ft(1), $(0), $(0), function() {
      ft(65499), ft(132), $(0);
      for (var Pt = 0; Pt < 64; Pt++)
        $(h[Pt]);
      $(1);
      for (var qt = 0; qt < 64; qt++)
        $(f[qt]);
    }(), function(Pt, qt) {
      ft(65472), ft(17), $(8), ft(qt), ft(Pt), $(3), $(1), $(17), $(0), $(2), $(17), $(1), $(3), $(17), $(1);
    }(A.width, A.height), function() {
      ft(65476), ft(418), $(0);
      for (var Pt = 0; Pt < 16; Pt++)
        $(R[Pt + 1]);
      for (var qt = 0; qt <= 11; qt++)
        $(gt[qt]);
      $(16);
      for (var Gt = 0; Gt < 16; Gt++)
        $(pt[Gt + 1]);
      for (var $t = 0; $t <= 161; $t++)
        $(F[$t]);
      $(1);
      for (var te = 0; te < 16; te++)
        $(P[te + 1]);
      for (var ie = 0; ie <= 11; ie++)
        $(z[ie]);
      $(17);
      for (var pe = 0; pe < 16; pe++)
        $(D[pe + 1]);
      for (var Wt = 0; Wt <= 161; Wt++)
        $(at[Wt]);
    }(), ft(65498), ft(12), $(3), $(1), $(0), $(2), $(17), $(3), $(17), $(0), $(63), $(0);
    var B = 0, W = 0, Y = 0;
    q = 0, _ = 7, this.encode.displayName = "_encode_";
    for (var Q, et, rt, Nt, Lt, Ct, Mt, Ut, ut, E = A.data, Xt = A.width, Et = A.height, At = 4 * Xt, xt = 0; xt < Et; ) {
      for (Q = 0; Q < At; ) {
        for (Lt = At * xt + Q, Mt = -1, Ut = 0, ut = 0; ut < 64; ut++)
          Ct = Lt + (Ut = ut >> 3) * At + (Mt = 4 * (7 & ut)), xt + Ut >= Et && (Ct -= At * (xt + 1 + Ut - Et)), Q + Mt >= At && (Ct -= Q + Mt - At + 4), et = E[Ct++], rt = E[Ct++], Nt = E[Ct++], M[ut] = (yt[et] + yt[rt + 256 >> 0] + yt[Nt + 512 >> 0] >> 16) - 128, X[ut] = (yt[et + 768 >> 0] + yt[rt + 1024 >> 0] + yt[Nt + 1280 >> 0] >> 16) - 128, ot[ut] = (yt[et + 1280 >> 0] + yt[rt + 1536 >> 0] + yt[Nt + 1792 >> 0] >> 16) - 128;
        B = ht(M, g, B, e, a), W = ht(X, b, W, n, u), Y = ht(ot, b, Y, n, u), Q += 32;
      }
      xt += 8;
    }
    if (_ >= 0) {
      var Ft = [];
      Ft[1] = _ + 1, Ft[0] = (1 << _ + 1) - 1, lt(Ft);
    }
    return ft(65497), new Uint8Array(I);
  }, i = i || 50, function() {
    for (var A = String.fromCharCode, j = 0; j < 256; j++)
      ct[j] = A(j);
  }(), e = nt(R, gt), n = nt(P, z), a = nt(pt, F), u = nt(D, at), function() {
    for (var A = 1, j = 2, B = 1; B <= 15; B++) {
      for (var W = A; W < j; W++)
        S[32767 + W] = B, N[32767 + W] = [], N[32767 + W][1] = B, N[32767 + W][0] = W;
      for (var Y = -(j - 1); Y <= -A; Y++)
        S[32767 + Y] = B, N[32767 + Y] = [], N[32767 + Y][1] = B, N[32767 + Y][0] = j - 1 + Y;
      A <<= 1, j <<= 1;
    }
  }(), function() {
    for (var A = 0; A < 256; A++)
      yt[A] = 19595 * A, yt[A + 256 >> 0] = 38470 * A, yt[A + 512 >> 0] = 7471 * A + 32768, yt[A + 768 >> 0] = -11059 * A, yt[A + 1024 >> 0] = -21709 * A, yt[A + 1280 >> 0] = 32768 * A + 8421375, yt[A + 1536 >> 0] = -27439 * A, yt[A + 1792 >> 0] = -5329 * A;
  }(), kt(i);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function En(i, e) {
  if (this.pos = 0, this.buffer = i, this.datav = new DataView(i.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, ["BM", "BA", "CI", "CP", "IC", "PT"].indexOf(this.flag) === -1)
    throw new Error("Invalid BMP File");
  this.parseHeader(), this.parseBGR();
}
function Au(i) {
  function e(R) {
    if (!R)
      throw Error("assert :P");
  }
  function n(R, gt, pt) {
    for (var F = 0; 4 > F; F++)
      if (R[gt + F] != pt.charCodeAt(F))
        return !0;
    return !1;
  }
  function a(R, gt, pt, F, P) {
    for (var z = 0; z < P; z++)
      R[gt + z] = pt[F + z];
  }
  function u(R, gt, pt, F) {
    for (var P = 0; P < F; P++)
      R[gt + P] = pt;
  }
  function o(R) {
    return new Int32Array(R);
  }
  function l(R, gt) {
    for (var pt = [], F = 0; F < R; F++)
      pt.push(new gt());
    return pt;
  }
  function h(R, gt) {
    var pt = [];
    return function F(P, z, D) {
      for (var at = D[z], nt = 0; nt < at && (P.push(D.length > z + 1 ? [] : new gt()), !(D.length < z + 1)); nt++)
        F(P[nt], z + 1, D);
    }(pt, 0, R), pt;
  }
  var f = function() {
    var R = this;
    function gt(t, r) {
      for (var c = 1 << r - 1 >>> 0; t & c; )
        c >>>= 1;
      return c ? (t & c - 1) + c : t;
    }
    function pt(t, r, c, p, m) {
      e(!(p % c));
      do
        t[r + (p -= c)] = m;
      while (0 < p);
    }
    function F(t, r, c, p, m) {
      if (e(2328 >= m), 512 >= m)
        var y = o(512);
      else if ((y = o(m)) == null)
        return 0;
      return function(w, L, x, k, U, K) {
        var Z, G, vt = L, it = 1 << x, H = o(16), V = o(16);
        for (e(U != 0), e(k != null), e(w != null), e(0 < x), G = 0; G < U; ++G) {
          if (15 < k[G])
            return 0;
          ++H[k[G]];
        }
        if (H[0] == U)
          return 0;
        for (V[1] = 0, Z = 1; 15 > Z; ++Z) {
          if (H[Z] > 1 << Z)
            return 0;
          V[Z + 1] = V[Z] + H[Z];
        }
        for (G = 0; G < U; ++G)
          Z = k[G], 0 < k[G] && (K[V[Z]++] = G);
        if (V[15] == 1)
          return (k = new P()).g = 0, k.value = K[0], pt(w, vt, 1, it, k), it;
        var dt, bt = -1, mt = it - 1, Ot = 0, St = 1, Rt = 1, _t = 1 << x;
        for (G = 0, Z = 1, U = 2; Z <= x; ++Z, U <<= 1) {
          if (St += Rt <<= 1, 0 > (Rt -= H[Z]))
            return 0;
          for (; 0 < H[Z]; --H[Z])
            (k = new P()).g = Z, k.value = K[G++], pt(w, vt + Ot, U, _t, k), Ot = gt(Ot, Z);
        }
        for (Z = x + 1, U = 2; 15 >= Z; ++Z, U <<= 1) {
          if (St += Rt <<= 1, 0 > (Rt -= H[Z]))
            return 0;
          for (; 0 < H[Z]; --H[Z]) {
            if (k = new P(), (Ot & mt) != bt) {
              for (vt += _t, dt = 1 << (bt = Z) - x; 15 > bt && !(0 >= (dt -= H[bt])); )
                ++bt, dt <<= 1;
              it += _t = 1 << (dt = bt - x), w[L + (bt = Ot & mt)].g = dt + x, w[L + bt].value = vt - L - bt;
            }
            k.g = Z - x, k.value = K[G++], pt(w, vt + (Ot >> x), U, _t, k), Ot = gt(Ot, Z);
          }
        }
        return St != 2 * V[15] - 1 ? 0 : it;
      }(t, r, c, p, m, y);
    }
    function P() {
      this.value = this.g = 0;
    }
    function z() {
      this.value = this.g = 0;
    }
    function D() {
      this.G = l(5, P), this.H = o(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = l(rn, z);
    }
    function at(t, r, c, p) {
      e(t != null), e(r != null), e(2147483648 > p), t.Ca = 254, t.I = 0, t.b = -8, t.Ka = 0, t.oa = r, t.pa = c, t.Jd = r, t.Yc = c + p, t.Zc = 4 <= p ? c + p - 4 + 1 : c, Q(t);
    }
    function nt(t, r) {
      for (var c = 0; 0 < r--; )
        c |= rt(t, 128) << r;
      return c;
    }
    function lt(t, r) {
      var c = nt(t, r);
      return et(t) ? -c : c;
    }
    function $(t, r, c, p) {
      var m, y = 0;
      for (e(t != null), e(r != null), e(4294967288 > p), t.Sb = p, t.Ra = 0, t.u = 0, t.h = 0, 4 < p && (p = 4), m = 0; m < p; ++m)
        y += r[c + m] << 8 * m;
      t.Ra = y, t.bb = p, t.oa = r, t.pa = c;
    }
    function ft(t) {
      for (; 8 <= t.u && t.bb < t.Sb; )
        t.Ra >>>= 8, t.Ra += t.oa[t.pa + t.bb] << hi - 8 >>> 0, ++t.bb, t.u -= 8;
      B(t) && (t.h = 1, t.u = 0);
    }
    function ht(t, r) {
      if (e(0 <= r), !t.h && r <= li) {
        var c = j(t) & ci[r];
        return t.u += r, ft(t), c;
      }
      return t.h = 1, t.u = 0;
    }
    function kt() {
      this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
    }
    function A() {
      this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
    }
    function j(t) {
      return t.Ra >>> (t.u & hi - 1) >>> 0;
    }
    function B(t) {
      return e(t.bb <= t.Sb), t.h || t.bb == t.Sb && t.u > hi;
    }
    function W(t, r) {
      t.u = r, t.h = B(t);
    }
    function Y(t) {
      t.u >= Yi && (e(t.u >= Yi), ft(t));
    }
    function Q(t) {
      e(t != null && t.oa != null), t.pa < t.Zc ? (t.I = (t.oa[t.pa++] | t.I << 8) >>> 0, t.b += 8) : (e(t != null && t.oa != null), t.pa < t.Yc ? (t.b += 8, t.I = t.oa[t.pa++] | t.I << 8) : t.Ka ? t.b = 0 : (t.I <<= 8, t.b += 8, t.Ka = 1));
    }
    function et(t) {
      return nt(t, 1);
    }
    function rt(t, r) {
      var c = t.Ca;
      0 > t.b && Q(t);
      var p = t.b, m = c * r >>> 8, y = (t.I >>> p > m) + 0;
      for (y ? (c -= m, t.I -= m + 1 << p >>> 0) : c = m + 1, p = c, m = 0; 256 <= p; )
        m += 8, p >>= 8;
      return p = 7 ^ m + an[p], t.b -= p, t.Ca = (c << p) - 1, y;
    }
    function Nt(t, r, c) {
      t[r + 0] = c >> 24 & 255, t[r + 1] = c >> 16 & 255, t[r + 2] = c >> 8 & 255, t[r + 3] = c >> 0 & 255;
    }
    function Lt(t, r) {
      return t[r + 0] << 0 | t[r + 1] << 8;
    }
    function Ct(t, r) {
      return Lt(t, r) | t[r + 2] << 16;
    }
    function Mt(t, r) {
      return Lt(t, r) | Lt(t, r + 2) << 16;
    }
    function Ut(t, r) {
      var c = 1 << r;
      return e(t != null), e(0 < r), t.X = o(c), t.X == null ? 0 : (t.Mb = 32 - r, t.Xa = r, 1);
    }
    function ut(t, r) {
      e(t != null), e(r != null), e(t.Xa == r.Xa), a(r.X, 0, t.X, 0, 1 << r.Xa);
    }
    function E() {
      this.X = [], this.Xa = this.Mb = 0;
    }
    function Xt(t, r, c, p) {
      e(c != null), e(p != null);
      var m = c[0], y = p[0];
      return m == 0 && (m = (t * y + r / 2) / r), y == 0 && (y = (r * m + t / 2) / t), 0 >= m || 0 >= y ? 0 : (c[0] = m, p[0] = y, 1);
    }
    function Et(t, r) {
      return t + (1 << r) - 1 >>> r;
    }
    function At(t, r) {
      return ((4278255360 & t) + (4278255360 & r) >>> 0 & 4278255360) + ((16711935 & t) + (16711935 & r) >>> 0 & 16711935) >>> 0;
    }
    function xt(t, r) {
      R[r] = function(c, p, m, y, w, L, x) {
        var k;
        for (k = 0; k < w; ++k) {
          var U = R[t](L[x + k - 1], m, y + k);
          L[x + k] = At(c[p + k], U);
        }
      };
    }
    function Ft() {
      this.ud = this.hd = this.jd = 0;
    }
    function Pt(t, r) {
      return ((4278124286 & (t ^ r)) >>> 1) + (t & r) >>> 0;
    }
    function qt(t) {
      return 0 <= t && 256 > t ? t : 0 > t ? 0 : 255 < t ? 255 : void 0;
    }
    function Gt(t, r) {
      return qt(t + (t - r + 0.5 >> 1));
    }
    function $t(t, r, c) {
      return Math.abs(r - c) - Math.abs(t - c);
    }
    function te(t, r, c, p, m, y, w) {
      for (p = y[w - 1], c = 0; c < m; ++c)
        y[w + c] = p = At(t[r + c], p);
    }
    function ie(t, r, c, p, m) {
      var y;
      for (y = 0; y < c; ++y) {
        var w = t[r + y], L = w >> 8 & 255, x = 16711935 & (x = (x = 16711935 & w) + ((L << 16) + L));
        p[m + y] = (4278255360 & w) + x >>> 0;
      }
    }
    function pe(t, r) {
      r.jd = t >> 0 & 255, r.hd = t >> 8 & 255, r.ud = t >> 16 & 255;
    }
    function Wt(t, r, c, p, m, y) {
      var w;
      for (w = 0; w < p; ++w) {
        var L = r[c + w], x = L >>> 8, k = L, U = 255 & (U = (U = L >>> 16) + ((t.jd << 24 >> 24) * (x << 24 >> 24) >>> 5));
        k = 255 & (k = (k = k + ((t.hd << 24 >> 24) * (x << 24 >> 24) >>> 5)) + ((t.ud << 24 >> 24) * (U << 24 >> 24) >>> 5)), m[y + w] = (4278255360 & L) + (U << 16) + k;
      }
    }
    function ee(t, r, c, p, m) {
      R[r] = function(y, w, L, x, k, U, K, Z, G) {
        for (x = K; x < Z; ++x)
          for (K = 0; K < G; ++K)
            k[U++] = m(L[p(y[w++])]);
      }, R[t] = function(y, w, L, x, k, U, K) {
        var Z = 8 >> y.b, G = y.Ea, vt = y.K[0], it = y.w;
        if (8 > Z)
          for (y = (1 << y.b) - 1, it = (1 << Z) - 1; w < L; ++w) {
            var H, V = 0;
            for (H = 0; H < G; ++H)
              H & y || (V = p(x[k++])), U[K++] = m(vt[V & it]), V >>= Z;
          }
        else
          R["VP8LMapColor" + c](x, k, vt, it, U, K, w, L, G);
      };
    }
    function It(t, r, c, p, m) {
      for (c = r + c; r < c; ) {
        var y = t[r++];
        p[m++] = y >> 16 & 255, p[m++] = y >> 8 & 255, p[m++] = y >> 0 & 255;
      }
    }
    function Ve(t, r, c, p, m) {
      for (c = r + c; r < c; ) {
        var y = t[r++];
        p[m++] = y >> 16 & 255, p[m++] = y >> 8 & 255, p[m++] = y >> 0 & 255, p[m++] = y >> 24 & 255;
      }
    }
    function oe(t, r, c, p, m) {
      for (c = r + c; r < c; ) {
        var y = (w = t[r++]) >> 16 & 240 | w >> 12 & 15, w = w >> 0 & 240 | w >> 28 & 15;
        p[m++] = y, p[m++] = w;
      }
    }
    function wn(t, r, c, p, m) {
      for (c = r + c; r < c; ) {
        var y = (w = t[r++]) >> 16 & 248 | w >> 13 & 7, w = w >> 5 & 224 | w >> 3 & 31;
        p[m++] = y, p[m++] = w;
      }
    }
    function ge(t, r, c, p, m) {
      for (c = r + c; r < c; ) {
        var y = t[r++];
        p[m++] = y >> 0 & 255, p[m++] = y >> 8 & 255, p[m++] = y >> 16 & 255;
      }
    }
    function Ae(t, r, c, p, m, y) {
      if (y == 0)
        for (c = r + c; r < c; )
          Nt(p, ((y = t[r++])[0] >> 24 | y[1] >> 8 & 65280 | y[2] << 8 & 16711680 | y[3] << 24) >>> 0), m += 32;
      else
        a(p, m, t, r, c);
    }
    function Rn(t, r) {
      R[r][0] = R[t + "0"], R[r][1] = R[t + "1"], R[r][2] = R[t + "2"], R[r][3] = R[t + "3"], R[r][4] = R[t + "4"], R[r][5] = R[t + "5"], R[r][6] = R[t + "6"], R[r][7] = R[t + "7"], R[r][8] = R[t + "8"], R[r][9] = R[t + "9"], R[r][10] = R[t + "10"], R[r][11] = R[t + "11"], R[r][12] = R[t + "12"], R[r][13] = R[t + "13"], R[r][14] = R[t + "0"], R[r][15] = R[t + "0"];
    }
    function ue(t) {
      return t == To || t == zo || t == Ea || t == Uo;
    }
    function jr() {
      this.eb = [], this.size = this.A = this.fb = 0;
    }
    function Ne() {
      this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
    }
    function An() {
      this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new jr(), this.f.kb = new Ne(), this.sd = null;
    }
    function $n() {
      this.width = [0], this.height = [0], this.Pd = [0], this.Qd = [0], this.format = [0];
    }
    function xe() {
      this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
    }
    function Yt(t) {
      return alert("todo:WebPSamplerProcessPlane"), t.T;
    }
    function ce(t, r) {
      var c = t.T, p = r.ba.f.RGBA, m = p.eb, y = p.fb + t.ka * p.A, w = bn[r.ba.S], L = t.y, x = t.O, k = t.f, U = t.N, K = t.ea, Z = t.W, G = r.cc, vt = r.dc, it = r.Mc, H = r.Nc, V = t.ka, dt = t.ka + t.T, bt = t.U, mt = bt + 1 >> 1;
      for (V == 0 ? w(L, x, null, null, k, U, K, Z, k, U, K, Z, m, y, null, null, bt) : (w(r.ec, r.fc, L, x, G, vt, it, H, k, U, K, Z, m, y - p.A, m, y, bt), ++c); V + 2 < dt; V += 2)
        G = k, vt = U, it = K, H = Z, U += t.Rc, Z += t.Rc, y += 2 * p.A, w(L, (x += 2 * t.fa) - t.fa, L, x, G, vt, it, H, k, U, K, Z, m, y - p.A, m, y, bt);
      return x += t.fa, t.j + dt < t.o ? (a(r.ec, r.fc, L, x, bt), a(r.cc, r.dc, k, U, mt), a(r.Mc, r.Nc, K, Z, mt), c--) : 1 & dt || w(L, x, null, null, k, U, K, Z, k, U, K, Z, m, y + p.A, null, null, bt), c;
    }
    function Or(t, r, c) {
      var p = t.F, m = [t.J];
      if (p != null) {
        var y = t.U, w = r.ba.S, L = w == Ba || w == Ea;
        r = r.ba.f.RGBA;
        var x = [0], k = t.ka;
        x[0] = t.T, t.Kb && (k == 0 ? --x[0] : (--k, m[0] -= t.width), t.j + t.ka + t.T == t.o && (x[0] = t.o - t.j - k));
        var U = r.eb;
        k = r.fb + k * r.A, t = Ia(p, m[0], t.width, y, x, U, k + (L ? 0 : 3), r.A), e(c == x), t && ue(w) && yr(U, k, L, y, x, r.A);
      }
      return 0;
    }
    function He(t) {
      var r = t.ma, c = r.ba.S, p = 11 > c, m = c == Oa || c == Ma || c == Ba || c == Ro || c == 12 || ue(c);
      if (r.memory = null, r.Ib = null, r.Jb = null, r.Nd = null, !Vi(r.Oa, t, m ? 11 : 12))
        return 0;
      if (m && ue(c) && wt(), t.da)
        alert("todo:use_scaling");
      else {
        if (p) {
          if (r.Ib = Yt, t.Kb) {
            if (c = t.U + 1 >> 1, r.memory = o(t.U + 2 * c), r.memory == null)
              return 0;
            r.ec = r.memory, r.fc = 0, r.cc = r.ec, r.dc = r.fc + t.U, r.Mc = r.cc, r.Nc = r.dc + c, r.Ib = ce, wt();
          }
        } else
          alert("todo:EmitYUV");
        m && (r.Jb = Or, p && J());
      }
      if (p && !Rs) {
        for (t = 0; 256 > t; ++t)
          ic[t] = 89858 * (t - 128) + Da >> qa, sc[t] = -22014 * (t - 128) + Da, oc[t] = -45773 * (t - 128), ac[t] = 113618 * (t - 128) + Da >> qa;
        for (t = Qi; t < Vo; ++t)
          r = 76283 * (t - 16) + Da >> qa, uc[t - Qi] = ln(r, 255), cc[t - Qi] = ln(r + 8 >> 4, 15);
        Rs = 1;
      }
      return 1;
    }
    function Tn(t) {
      var r = t.ma, c = t.U, p = t.T;
      return e(!(1 & t.ka)), 0 >= c || 0 >= p ? 0 : (c = r.Ib(t, r), r.Jb != null && r.Jb(t, r, c), r.Dc += c, 1);
    }
    function zn(t) {
      t.ma.memory = null;
    }
    function Tt(t, r, c, p) {
      return ht(t, 8) != 47 ? 0 : (r[0] = ht(t, 14) + 1, c[0] = ht(t, 14) + 1, p[0] = ht(t, 1), ht(t, 3) != 0 ? 0 : !t.h);
    }
    function Ln(t, r) {
      if (4 > t)
        return t + 1;
      var c = t - 2 >> 1;
      return (2 + (1 & t) << c) + ht(r, c) + 1;
    }
    function Un(t, r) {
      return 120 < r ? r - 120 : 1 <= (c = ((c = Wu[r - 1]) >> 4) * t + (8 - (15 & c))) ? c : 1;
      var c;
    }
    function en(t, r, c) {
      var p = j(c), m = t[r += 255 & p].g - 8;
      return 0 < m && (W(c, c.u + 8), p = j(c), r += t[r].value, r += p & (1 << m) - 1), W(c, c.u + t[r].g), t[r].value;
    }
    function qe(t, r, c) {
      return c.g += t.g, c.value += t.value << r >>> 0, e(8 >= c.g), t.g;
    }
    function Oe(t, r, c) {
      var p = t.xc;
      return e((r = p == 0 ? 0 : t.vc[t.md * (c >> p) + (r >> p)]) < t.Wb), t.Ya[r];
    }
    function cn(t, r, c, p) {
      var m = t.ab, y = t.c * r, w = t.C;
      r = w + r;
      var L = c, x = p;
      for (p = t.Ta, c = t.Ua; 0 < m--; ) {
        var k = t.gc[m], U = w, K = r, Z = L, G = x, vt = (x = p, L = c, k.Ea);
        switch (e(U < K), e(K <= k.nc), k.hc) {
          case 2:
            Fa(Z, G, (K - U) * vt, x, L);
            break;
          case 0:
            var it = U, H = K, V = x, dt = L, bt = (_t = k).Ea;
            it == 0 && (Bo(Z, G, null, null, 1, V, dt), te(Z, G + 1, 0, 0, bt - 1, V, dt + 1), G += bt, dt += bt, ++it);
            for (var mt = 1 << _t.b, Ot = mt - 1, St = Et(bt, _t.b), Rt = _t.K, _t = _t.w + (it >> _t.b) * St; it < H; ) {
              var se = Rt, le = _t, ae = 1;
              for (Ji(Z, G, V, dt - bt, 1, V, dt); ae < bt; ) {
                var ne = (ae & ~Ot) + mt;
                ne > bt && (ne = bt), (0, gr[se[le++] >> 8 & 15])(Z, G + +ae, V, dt + ae - bt, ne - ae, V, dt + ae), ae = ne;
              }
              G += bt, dt += bt, ++it & Ot || (_t += St);
            }
            K != k.nc && a(x, L - vt, x, L + (K - U - 1) * vt, vt);
            break;
          case 1:
            for (vt = Z, H = G, bt = (Z = k.Ea) - (dt = Z & ~(V = (G = 1 << k.b) - 1)), it = Et(Z, k.b), mt = k.K, k = k.w + (U >> k.b) * it; U < K; ) {
              for (Ot = mt, St = k, Rt = new Ft(), _t = H + dt, se = H + Z; H < _t; )
                pe(Ot[St++], Rt), gn(Rt, vt, H, G, x, L), H += G, L += G;
              H < se && (pe(Ot[St++], Rt), gn(Rt, vt, H, bt, x, L), H += bt, L += bt), ++U & V || (k += it);
            }
            break;
          case 3:
            if (Z == x && G == L && 0 < k.b) {
              for (H = x, Z = vt = L + (K - U) * vt - (dt = (K - U) * Et(k.Ea, k.b)), G = x, V = L, it = [], dt = (bt = dt) - 1; 0 <= dt; --dt)
                it[dt] = G[V + dt];
              for (dt = bt - 1; 0 <= dt; --dt)
                H[Z + dt] = it[dt];
              Fn(k, U, K, x, vt, x, L);
            } else
              Fn(k, U, K, Z, G, x, L);
        }
        L = p, x = c;
      }
      x != c && a(p, c, L, x, y);
    }
    function Gr(t, r) {
      var c = t.V, p = t.Ba + t.c * t.C, m = r - t.C;
      if (e(r <= t.l.o), e(16 >= m), 0 < m) {
        var y = t.l, w = t.Ta, L = t.Ua, x = y.width;
        if (cn(t, m, c, p), m = L = [L], e((c = t.C) < (p = r)), e(y.v < y.va), p > y.o && (p = y.o), c < y.j) {
          var k = y.j - c;
          c = y.j, m[0] += k * x;
        }
        if (c >= p ? c = 0 : (m[0] += 4 * y.v, y.ka = c - y.j, y.U = y.va - y.v, y.T = p - c, c = 1), c) {
          if (L = L[0], 11 > (c = t.ca).S) {
            var U = c.f.RGBA, K = (p = c.S, m = y.U, y = y.T, k = U.eb, U.A), Z = y;
            for (U = U.fb + t.Ma * U.A; 0 < Z--; ) {
              var G = w, vt = L, it = m, H = k, V = U;
              switch (p) {
                case ja:
                  In(G, vt, it, H, V);
                  break;
                case Oa:
                  mr(G, vt, it, H, V);
                  break;
                case To:
                  mr(G, vt, it, H, V), yr(H, V, 0, it, 1, 0);
                  break;
                case Fs:
                  fi(G, vt, it, H, V);
                  break;
                case Ma:
                  Ae(G, vt, it, H, V, 1);
                  break;
                case zo:
                  Ae(G, vt, it, H, V, 1), yr(H, V, 0, it, 1, 0);
                  break;
                case Ba:
                  Ae(G, vt, it, H, V, 0);
                  break;
                case Ea:
                  Ae(G, vt, it, H, V, 0), yr(H, V, 1, it, 1, 0);
                  break;
                case Ro:
                  Gn(G, vt, it, H, V);
                  break;
                case Uo:
                  Gn(G, vt, it, H, V), gi(H, V, it, 1, 0);
                  break;
                case Is:
                  rr(G, vt, it, H, V);
                  break;
                default:
                  e(0);
              }
              L += x, U += K;
            }
            t.Ma += y;
          } else
            alert("todo:EmitRescaledRowsYUVA");
          e(t.Ma <= c.height);
        }
      }
      t.C = r, e(t.C <= t.i);
    }
    function Qn(t) {
      var r;
      if (0 < t.ua)
        return 0;
      for (r = 0; r < t.Wb; ++r) {
        var c = t.Ya[r].G, p = t.Ya[r].H;
        if (0 < c[1][p[1] + 0].g || 0 < c[2][p[2] + 0].g || 0 < c[3][p[3] + 0].g)
          return 0;
      }
      return 1;
    }
    function Nn(t, r, c, p, m, y) {
      if (t.Z != 0) {
        var w = t.qd, L = t.rd;
        for (e(Ar[t.Z] != null); r < c; ++r)
          Ar[t.Z](w, L, p, m, p, m, y), w = p, L = m, m += y;
        t.qd = w, t.rd = L;
      }
    }
    function xn(t, r) {
      var c = t.l.ma, p = c.Z == 0 || c.Z == 1 ? t.l.j : t.C;
      if (p = t.C < p ? p : t.C, e(r <= t.l.o), r > p) {
        var m = t.l.width, y = c.ca, w = c.tb + m * p, L = t.V, x = t.Ba + t.c * p, k = t.gc;
        e(t.ab == 1), e(k[0].hc == 3), Eo(k[0], p, r, L, x, y, w), Nn(c, p, r, y, w, m);
      }
      t.C = t.Ma = r;
    }
    function Sn(t, r, c, p, m, y, w) {
      var L = t.$ / p, x = t.$ % p, k = t.m, U = t.s, K = c + t.$, Z = K;
      m = c + p * m;
      var G = c + p * y, vt = 280 + U.ua, it = t.Pb ? L : 16777216, H = 0 < U.ua ? U.Wa : null, V = U.wc, dt = K < G ? Oe(U, x, L) : null;
      e(t.C < y), e(G <= m);
      var bt = !1;
      t:
        for (; ; ) {
          for (; bt || K < G; ) {
            var mt = 0;
            if (L >= it) {
              var Ot = K - c;
              e((it = t).Pb), it.wd = it.m, it.xd = Ot, 0 < it.s.ua && ut(it.s.Wa, it.s.vb), it = L + Gu;
            }
            if (x & V || (dt = Oe(U, x, L)), e(dt != null), dt.Qb && (r[K] = dt.qb, bt = !0), !bt)
              if (Y(k), dt.jc) {
                mt = k, Ot = r;
                var St = K, Rt = dt.pd[j(mt) & rn - 1];
                e(dt.jc), 256 > Rt.g ? (W(mt, mt.u + Rt.g), Ot[St] = Rt.value, mt = 0) : (W(mt, mt.u + Rt.g - 256), e(256 <= Rt.value), mt = Rt.value), mt == 0 && (bt = !0);
              } else
                mt = en(dt.G[0], dt.H[0], k);
            if (k.h)
              break;
            if (bt || 256 > mt) {
              if (!bt)
                if (dt.nd)
                  r[K] = (dt.qb | mt << 8) >>> 0;
                else {
                  if (Y(k), bt = en(dt.G[1], dt.H[1], k), Y(k), Ot = en(dt.G[2], dt.H[2], k), St = en(dt.G[3], dt.H[3], k), k.h)
                    break;
                  r[K] = (St << 24 | bt << 16 | mt << 8 | Ot) >>> 0;
                }
              if (bt = !1, ++K, ++x >= p && (x = 0, ++L, w != null && L <= y && !(L % 16) && w(t, L), H != null))
                for (; Z < K; )
                  mt = r[Z++], H.X[(506832829 * mt & 4294967295) >>> H.Mb] = mt;
            } else if (280 > mt) {
              if (mt = Ln(mt - 256, k), Ot = en(dt.G[4], dt.H[4], k), Y(k), Ot = Un(p, Ot = Ln(Ot, k)), k.h)
                break;
              if (K - c < Ot || m - K < mt)
                break t;
              for (St = 0; St < mt; ++St)
                r[K + St] = r[K + St - Ot];
              for (K += mt, x += mt; x >= p; )
                x -= p, ++L, w != null && L <= y && !(L % 16) && w(t, L);
              if (e(K <= m), x & V && (dt = Oe(U, x, L)), H != null)
                for (; Z < K; )
                  mt = r[Z++], H.X[(506832829 * mt & 4294967295) >>> H.Mb] = mt;
            } else {
              if (!(mt < vt))
                break t;
              for (bt = mt - 280, e(H != null); Z < K; )
                mt = r[Z++], H.X[(506832829 * mt & 4294967295) >>> H.Mb] = mt;
              mt = K, e(!(bt >>> (Ot = H).Xa)), r[mt] = Ot.X[bt], bt = !0;
            }
            bt || e(k.h == B(k));
          }
          if (t.Pb && k.h && K < m)
            e(t.m.h), t.a = 5, t.m = t.wd, t.$ = t.xd, 0 < t.s.ua && ut(t.s.vb, t.s.Wa);
          else {
            if (k.h)
              break t;
            w != null && w(t, L > y ? y : L), t.a = 0, t.$ = K - c;
          }
          return 1;
        }
      return t.a = 3, 0;
    }
    function Hn(t) {
      e(t != null), t.vc = null, t.yc = null, t.Ya = null;
      var r = t.Wa;
      r != null && (r.X = null), t.vb = null, e(t != null);
    }
    function dn() {
      var t = new Mo();
      return t == null ? null : (t.a = 0, t.xb = Os, Rn("Predictor", "VP8LPredictors"), Rn("Predictor", "VP8LPredictors_C"), Rn("PredictorAdd", "VP8LPredictorsAdd"), Rn("PredictorAdd", "VP8LPredictorsAdd_C"), Fa = ie, gn = Wt, In = It, mr = Ve, Gn = oe, rr = wn, fi = ge, R.VP8LMapColor32b = Xi, R.VP8LMapColor8b = qo, t);
    }
    function Wn(t, r, c, p, m) {
      var y = 1, w = [t], L = [r], x = p.m, k = p.s, U = null, K = 0;
      t:
        for (; ; ) {
          if (c)
            for (; y && ht(x, 1); ) {
              var Z = w, G = L, vt = p, it = 1, H = vt.m, V = vt.gc[vt.ab], dt = ht(H, 2);
              if (vt.Oc & 1 << dt)
                y = 0;
              else {
                switch (vt.Oc |= 1 << dt, V.hc = dt, V.Ea = Z[0], V.nc = G[0], V.K = [null], ++vt.ab, e(4 >= vt.ab), dt) {
                  case 0:
                  case 1:
                    V.b = ht(H, 3) + 2, it = Wn(Et(V.Ea, V.b), Et(V.nc, V.b), 0, vt, V.K), V.K = V.K[0];
                    break;
                  case 3:
                    var bt, mt = ht(H, 8) + 1, Ot = 16 < mt ? 0 : 4 < mt ? 1 : 2 < mt ? 2 : 3;
                    if (Z[0] = Et(V.Ea, Ot), V.b = Ot, bt = it = Wn(mt, 1, 0, vt, V.K)) {
                      var St, Rt = mt, _t = V, se = 1 << (8 >> _t.b), le = o(se);
                      if (le == null)
                        bt = 0;
                      else {
                        var ae = _t.K[0], ne = _t.w;
                        for (le[0] = _t.K[0][0], St = 1; St < 1 * Rt; ++St)
                          le[St] = At(ae[ne + St], le[St - 1]);
                        for (; St < 4 * se; ++St)
                          le[St] = 0;
                        _t.K[0] = null, _t.K[0] = le, bt = 1;
                      }
                    }
                    it = bt;
                    break;
                  case 2:
                    break;
                  default:
                    e(0);
                }
                y = it;
              }
            }
          if (w = w[0], L = L[0], y && ht(x, 1) && !(y = 1 <= (K = ht(x, 4)) && 11 >= K)) {
            p.a = 3;
            break t;
          }
          var me;
          if (me = y)
            e: {
              var de, Zt, Be, on = p, Ee = w, sn = L, he = K, fn = c, pn = on.m, Te = on.s, We = [null], $e = 1, yn = 0, Yn = Vu[he];
              n:
                for (; ; ) {
                  if (fn && ht(pn, 1)) {
                    var ze = ht(pn, 3) + 2, ur = Et(Ee, ze), zr = Et(sn, ze), mi = ur * zr;
                    if (!Wn(ur, zr, 0, on, We))
                      break n;
                    for (We = We[0], Te.xc = ze, de = 0; de < mi; ++de) {
                      var Lr = We[de] >> 8 & 65535;
                      We[de] = Lr, Lr >= $e && ($e = Lr + 1);
                    }
                  }
                  if (pn.h)
                    break n;
                  for (Zt = 0; 5 > Zt; ++Zt) {
                    var _e = Cs[Zt];
                    !Zt && 0 < he && (_e += 1 << he), yn < _e && (yn = _e);
                  }
                  var Go = l($e * Yn, P), Us = $e, Hs = l(Us, D);
                  if (Hs == null)
                    var Ta = null;
                  else
                    e(65536 >= Us), Ta = Hs;
                  var ta = o(yn);
                  if (Ta == null || ta == null || Go == null) {
                    on.a = 1;
                    break n;
                  }
                  var za = Go;
                  for (de = Be = 0; de < $e; ++de) {
                    var Mn = Ta[de], vi = Mn.G, bi = Mn.H, Ws = 0, Ua = 1, Vs = 0;
                    for (Zt = 0; 5 > Zt; ++Zt) {
                      _e = Cs[Zt], vi[Zt] = za, bi[Zt] = Be, !Zt && 0 < he && (_e += 1 << he);
                      i: {
                        var Ha, Yo = _e, Wa = on, ea = ta, fc = za, pc = Be, Jo = 0, Nr = Wa.m, dc = ht(Nr, 1);
                        if (u(ea, 0, 0, Yo), dc) {
                          var gc = ht(Nr, 1) + 1, mc = ht(Nr, 1), Gs = ht(Nr, mc == 0 ? 1 : 8);
                          ea[Gs] = 1, gc == 2 && (ea[Gs = ht(Nr, 8)] = 1);
                          var Va = 1;
                        } else {
                          var Ys = o(19), Js = ht(Nr, 4) + 4;
                          if (19 < Js) {
                            Wa.a = 3;
                            var Ga = 0;
                            break i;
                          }
                          for (Ha = 0; Ha < Js; ++Ha)
                            Ys[Hu[Ha]] = ht(Nr, 3);
                          var Xo = void 0, na = void 0, Xs = Wa, vc = Ys, Ya = Yo, Ks = ea, Ko = 0, xr = Xs.m, Zs = 8, $s = l(128, P);
                          r:
                            for (; F($s, 0, 7, vc, 19); ) {
                              if (ht(xr, 1)) {
                                var bc = 2 + 2 * ht(xr, 3);
                                if ((Xo = 2 + ht(xr, bc)) > Ya)
                                  break r;
                              } else
                                Xo = Ya;
                              for (na = 0; na < Ya && Xo--; ) {
                                Y(xr);
                                var Qs = $s[0 + (127 & j(xr))];
                                W(xr, xr.u + Qs.g);
                                var yi = Qs.value;
                                if (16 > yi)
                                  Ks[na++] = yi, yi != 0 && (Zs = yi);
                                else {
                                  var yc = yi == 16, tu = yi - 16, wc = zu[tu], eu = ht(xr, Tu[tu]) + wc;
                                  if (na + eu > Ya)
                                    break r;
                                  for (var Ac = yc ? Zs : 0; 0 < eu--; )
                                    Ks[na++] = Ac;
                                }
                              }
                              Ko = 1;
                              break r;
                            }
                          Ko || (Xs.a = 3), Va = Ko;
                        }
                        (Va = Va && !Nr.h) && (Jo = F(fc, pc, 8, ea, Yo)), Va && Jo != 0 ? Ga = Jo : (Wa.a = 3, Ga = 0);
                      }
                      if (Ga == 0)
                        break n;
                      if (Ua && Uu[Zt] == 1 && (Ua = za[Be].g == 0), Ws += za[Be].g, Be += Ga, 3 >= Zt) {
                        var ra, Zo = ta[0];
                        for (ra = 1; ra < _e; ++ra)
                          ta[ra] > Zo && (Zo = ta[ra]);
                        Vs += Zo;
                      }
                    }
                    if (Mn.nd = Ua, Mn.Qb = 0, Ua && (Mn.qb = (vi[3][bi[3] + 0].value << 24 | vi[1][bi[1] + 0].value << 16 | vi[2][bi[2] + 0].value) >>> 0, Ws == 0 && 256 > vi[0][bi[0] + 0].value && (Mn.Qb = 1, Mn.qb += vi[0][bi[0] + 0].value << 8)), Mn.jc = !Mn.Qb && 6 > Vs, Mn.jc) {
                      var Ja, cr = Mn;
                      for (Ja = 0; Ja < rn; ++Ja) {
                        var Sr = Ja, _r = cr.pd[Sr], Xa = cr.G[0][cr.H[0] + Sr];
                        256 <= Xa.value ? (_r.g = Xa.g + 256, _r.value = Xa.value) : (_r.g = 0, _r.value = 0, Sr >>= qe(Xa, 8, _r), Sr >>= qe(cr.G[1][cr.H[1] + Sr], 16, _r), Sr >>= qe(cr.G[2][cr.H[2] + Sr], 0, _r), qe(cr.G[3][cr.H[3] + Sr], 24, _r));
                      }
                    }
                  }
                  Te.vc = We, Te.Wb = $e, Te.Ya = Ta, Te.yc = Go, me = 1;
                  break e;
                }
              me = 0;
            }
          if (!(y = me)) {
            p.a = 3;
            break t;
          }
          if (0 < K) {
            if (k.ua = 1 << K, !Ut(k.Wa, K)) {
              p.a = 1, y = 0;
              break t;
            }
          } else
            k.ua = 0;
          var $o = p, nu = w, Lc = L, Qo = $o.s, ts = Qo.xc;
          if ($o.c = nu, $o.i = Lc, Qo.md = Et(nu, ts), Qo.wc = ts == 0 ? -1 : (1 << ts) - 1, c) {
            p.xb = Qu;
            break t;
          }
          if ((U = o(w * L)) == null) {
            p.a = 1, y = 0;
            break t;
          }
          y = (y = Sn(p, U, 0, w, L, L, null)) && !x.h;
          break t;
        }
      return y ? (m != null ? m[0] = U : (e(U == null), e(c)), p.$ = 0, c || Hn(k)) : Hn(k), y;
    }
    function Mr(t, r) {
      var c = t.c * t.i, p = c + r + 16 * r;
      return e(t.c <= r), t.V = o(p), t.V == null ? (t.Ta = null, t.Ua = 0, t.a = 1, 0) : (t.Ta = t.V, t.Ua = t.Ba + c + r, 1);
    }
    function Yr(t, r) {
      var c = t.C, p = r - c, m = t.V, y = t.Ba + t.c * c;
      for (e(r <= t.l.o); 0 < p; ) {
        var w = 16 < p ? 16 : p, L = t.l.ma, x = t.l.width, k = x * w, U = L.ca, K = L.tb + x * c, Z = t.Ta, G = t.Ua;
        cn(t, w, m, y), Ns(Z, G, U, K, k), Nn(L, c, c + w, U, K, x), p -= w, m += w * t.c, c += w;
      }
      e(c == r), t.C = t.Ma = r;
    }
    function Jr() {
      this.ub = this.yd = this.td = this.Rb = 0;
    }
    function Xr() {
      this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
    }
    function Kr() {
      this.Fb = this.Bb = this.Cb = 0, this.Zb = o(4), this.Lb = o(4);
    }
    function ca() {
      this.Yb = function() {
        var t = [];
        return function r(c, p, m) {
          for (var y = m[p], w = 0; w < y && (c.push(m.length > p + 1 ? [] : 0), !(m.length < p + 1)); w++)
            r(c[w], p + 1, m);
        }(t, 0, [3, 11]), t;
      }();
    }
    function lo() {
      this.jb = o(3), this.Wc = h([4, 8], ca), this.Xc = h([4, 17], ca);
    }
    function ho() {
      this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new o(4), this.od = new o(4);
    }
    function Zr() {
      this.ld = this.La = this.dd = this.tc = 0;
    }
    function la() {
      this.Na = this.la = 0;
    }
    function fo() {
      this.Sc = [0, 0], this.Eb = [0, 0], this.Qc = [0, 0], this.ia = this.lc = 0;
    }
    function Fi() {
      this.ad = o(384), this.Za = 0, this.Ob = o(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
    }
    function po() {
      this.uc = this.M = this.Nb = 0, this.wa = Array(new Zr()), this.Y = 0, this.ya = Array(new Fi()), this.aa = 0, this.l = new $r();
    }
    function ha() {
      this.y = o(16), this.f = o(8), this.ea = o(8);
    }
    function go() {
      this.cb = this.a = 0, this.sc = "", this.m = new kt(), this.Od = new Jr(), this.Kc = new Xr(), this.ed = new ho(), this.Qa = new Kr(), this.Ic = this.$c = this.Aa = 0, this.D = new po(), this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = l(8, kt), this.ia = 0, this.pb = l(4, fo), this.Pa = new lo(), this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [0, 0, 0, 0], this.Gd = Array(new ha()), this.Hd = 0, this.rb = Array(new la()), this.sb = 0, this.wa = Array(new Zr()), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new Fi()), this.L = this.aa = 0, this.gd = h([4, 2], Zr), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
    }
    function $r() {
      this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
    }
    function mo() {
      var t = new go();
      return t != null && (t.a = 0, t.sc = "OK", t.cb = 0, t.Xb = 0, $i || ($i = da)), t;
    }
    function ke(t, r, c) {
      return t.a == 0 && (t.a = r, t.sc = c, t.cb = 0), 0;
    }
    function fa(t, r, c) {
      return 3 <= c && t[r + 0] == 157 && t[r + 1] == 1 && t[r + 2] == 42;
    }
    function pa(t, r) {
      if (t == null)
        return 0;
      if (t.a = 0, t.sc = "OK", r == null)
        return ke(t, 2, "null VP8Io passed to VP8GetHeaders()");
      var c = r.data, p = r.w, m = r.ha;
      if (4 > m)
        return ke(t, 7, "Truncated header.");
      var y = c[p + 0] | c[p + 1] << 8 | c[p + 2] << 16, w = t.Od;
      if (w.Rb = !(1 & y), w.td = y >> 1 & 7, w.yd = y >> 4 & 1, w.ub = y >> 5, 3 < w.td)
        return ke(t, 3, "Incorrect keyframe parameters.");
      if (!w.yd)
        return ke(t, 4, "Frame not displayable.");
      p += 3, m -= 3;
      var L = t.Kc;
      if (w.Rb) {
        if (7 > m)
          return ke(t, 7, "cannot parse picture header");
        if (!fa(c, p, m))
          return ke(t, 3, "Bad code word");
        L.c = 16383 & (c[p + 4] << 8 | c[p + 3]), L.Td = c[p + 4] >> 6, L.i = 16383 & (c[p + 6] << 8 | c[p + 5]), L.Ud = c[p + 6] >> 6, p += 7, m -= 7, t.za = L.c + 15 >> 4, t.Ub = L.i + 15 >> 4, r.width = L.c, r.height = L.i, r.Da = 0, r.j = 0, r.v = 0, r.va = r.width, r.o = r.height, r.da = 0, r.ib = r.width, r.hb = r.height, r.U = r.width, r.T = r.height, u((y = t.Pa).jb, 0, 255, y.jb.length), e((y = t.Qa) != null), y.Cb = 0, y.Bb = 0, y.Fb = 1, u(y.Zb, 0, 0, y.Zb.length), u(y.Lb, 0, 0, y.Lb);
      }
      if (w.ub > m)
        return ke(t, 7, "bad partition length");
      at(y = t.m, c, p, w.ub), p += w.ub, m -= w.ub, w.Rb && (L.Ld = et(y), L.Kd = et(y)), L = t.Qa;
      var x, k = t.Pa;
      if (e(y != null), e(L != null), L.Cb = et(y), L.Cb) {
        if (L.Bb = et(y), et(y)) {
          for (L.Fb = et(y), x = 0; 4 > x; ++x)
            L.Zb[x] = et(y) ? lt(y, 7) : 0;
          for (x = 0; 4 > x; ++x)
            L.Lb[x] = et(y) ? lt(y, 6) : 0;
        }
        if (L.Bb)
          for (x = 0; 3 > x; ++x)
            k.jb[x] = et(y) ? nt(y, 8) : 255;
      } else
        L.Bb = 0;
      if (y.Ka)
        return ke(t, 3, "cannot parse segment header");
      if ((L = t.ed).zd = et(y), L.Tb = nt(y, 6), L.wb = nt(y, 3), L.Pc = et(y), L.Pc && et(y)) {
        for (k = 0; 4 > k; ++k)
          et(y) && (L.vd[k] = lt(y, 6));
        for (k = 0; 4 > k; ++k)
          et(y) && (L.od[k] = lt(y, 6));
      }
      if (t.L = L.Tb == 0 ? 0 : L.zd ? 1 : 2, y.Ka)
        return ke(t, 3, "cannot parse filter header");
      var U = m;
      if (m = x = p, p = x + U, L = U, t.Xb = (1 << nt(t.m, 2)) - 1, U < 3 * (k = t.Xb))
        c = 7;
      else {
        for (x += 3 * k, L -= 3 * k, U = 0; U < k; ++U) {
          var K = c[m + 0] | c[m + 1] << 8 | c[m + 2] << 16;
          K > L && (K = L), at(t.Jc[+U], c, x, K), x += K, L -= K, m += 3;
        }
        at(t.Jc[+k], c, x, L), c = x < p ? 0 : 5;
      }
      if (c != 0)
        return ke(t, c, "cannot parse partitions");
      for (c = nt(x = t.m, 7), m = et(x) ? lt(x, 4) : 0, p = et(x) ? lt(x, 4) : 0, L = et(x) ? lt(x, 4) : 0, k = et(x) ? lt(x, 4) : 0, x = et(x) ? lt(x, 4) : 0, U = t.Qa, K = 0; 4 > K; ++K) {
        if (U.Cb) {
          var Z = U.Zb[K];
          U.Fb || (Z += c);
        } else {
          if (0 < K) {
            t.pb[K] = t.pb[0];
            continue;
          }
          Z = c;
        }
        var G = t.pb[K];
        G.Sc[0] = Ho[ln(Z + m, 127)], G.Sc[1] = Wo[ln(Z + 0, 127)], G.Eb[0] = 2 * Ho[ln(Z + p, 127)], G.Eb[1] = 101581 * Wo[ln(Z + L, 127)] >> 16, 8 > G.Eb[1] && (G.Eb[1] = 8), G.Qc[0] = Ho[ln(Z + k, 117)], G.Qc[1] = Wo[ln(Z + x, 127)], G.lc = Z + x;
      }
      if (!w.Rb)
        return ke(t, 4, "Not a key frame.");
      for (et(y), w = t.Pa, c = 0; 4 > c; ++c) {
        for (m = 0; 8 > m; ++m)
          for (p = 0; 3 > p; ++p)
            for (L = 0; 11 > L; ++L)
              k = rt(y, Zu[c][m][p][L]) ? nt(y, 8) : Xu[c][m][p][L], w.Wc[c][m].Yb[p][L] = k;
        for (m = 0; 17 > m; ++m)
          w.Xc[c][m] = w.Wc[c][$u[m]];
      }
      return t.kc = et(y), t.kc && (t.Bd = nt(y, 8)), t.cb = 1;
    }
    function da(t, r, c, p, m, y, w) {
      var L = r[m].Yb[c];
      for (c = 0; 16 > m; ++m) {
        if (!rt(t, L[c + 0]))
          return m;
        for (; !rt(t, L[c + 1]); )
          if (L = r[++m].Yb[0], c = 0, m == 16)
            return 16;
        var x = r[m + 1].Yb;
        if (rt(t, L[c + 2])) {
          var k = t, U = 0;
          if (rt(k, (Z = L)[(K = c) + 3]))
            if (rt(k, Z[K + 6])) {
              for (L = 0, K = 2 * (U = rt(k, Z[K + 8])) + (Z = rt(k, Z[K + 9 + U])), U = 0, Z = Yu[K]; Z[L]; ++L)
                U += U + rt(k, Z[L]);
              U += 3 + (8 << K);
            } else
              rt(k, Z[K + 7]) ? (U = 7 + 2 * rt(k, 165), U += rt(k, 145)) : U = 5 + rt(k, 159);
          else
            U = rt(k, Z[K + 4]) ? 3 + rt(k, Z[K + 5]) : 2;
          L = x[2];
        } else
          U = 1, L = x[1];
        x = w + Ju[m], 0 > (k = t).b && Q(k);
        var K, Z = k.b, G = (K = k.Ca >> 1) - (k.I >> Z) >> 31;
        --k.b, k.Ca += G, k.Ca |= 1, k.I -= (K + 1 & G) << Z, y[x] = ((U ^ G) - G) * p[(0 < m) + 0];
      }
      return 16;
    }
    function Ii(t) {
      var r = t.rb[t.sb - 1];
      r.la = 0, r.Na = 0, u(t.zc, 0, 0, t.zc.length), t.ja = 0;
    }
    function vo(t, r) {
      if (t == null)
        return 0;
      if (r == null)
        return ke(t, 2, "NULL VP8Io parameter in VP8Decode().");
      if (!t.cb && !pa(t, r))
        return 0;
      if (e(t.cb), r.ac == null || r.ac(r)) {
        r.ob && (t.L = 0);
        var c = Ra[t.L];
        if (t.L == 2 ? (t.yb = 0, t.zb = 0) : (t.yb = r.v - c >> 4, t.zb = r.j - c >> 4, 0 > t.yb && (t.yb = 0), 0 > t.zb && (t.zb = 0)), t.Va = r.o + 15 + c >> 4, t.Hb = r.va + 15 + c >> 4, t.Hb > t.za && (t.Hb = t.za), t.Va > t.Ub && (t.Va = t.Ub), 0 < t.L) {
          var p = t.ed;
          for (c = 0; 4 > c; ++c) {
            var m;
            if (t.Qa.Cb) {
              var y = t.Qa.Lb[c];
              t.Qa.Fb || (y += p.Tb);
            } else
              y = p.Tb;
            for (m = 0; 1 >= m; ++m) {
              var w = t.gd[c][m], L = y;
              if (p.Pc && (L += p.vd[0], m && (L += p.od[0])), 0 < (L = 0 > L ? 0 : 63 < L ? 63 : L)) {
                var x = L;
                0 < p.wb && (x = 4 < p.wb ? x >> 2 : x >> 1) > 9 - p.wb && (x = 9 - p.wb), 1 > x && (x = 1), w.dd = x, w.tc = 2 * L + x, w.ld = 40 <= L ? 2 : 15 <= L ? 1 : 0;
              } else
                w.tc = 0;
              w.La = m;
            }
          }
        }
        c = 0;
      } else
        ke(t, 6, "Frame setup failed"), c = t.a;
      if (c = c == 0) {
        if (c) {
          t.$c = 0, 0 < t.Aa || (t.Ic = hc);
          t: {
            c = t.Ic, p = 4 * (x = t.za);
            var k = 32 * x, U = x + 1, K = 0 < t.L ? x * (0 < t.Aa ? 2 : 1) : 0, Z = (t.Aa == 2 ? 2 : 1) * x;
            if ((w = p + 832 + (m = 3 * (16 * c + Ra[t.L]) / 2 * k) + (y = t.Fa != null && 0 < t.Fa.length ? t.Kc.c * t.Kc.i : 0)) != w)
              c = 0;
            else {
              if (w > t.Vb) {
                if (t.Vb = 0, t.Ec = o(w), t.Fc = 0, t.Ec == null) {
                  c = ke(t, 1, "no memory during frame initialization.");
                  break t;
                }
                t.Vb = w;
              }
              w = t.Ec, L = t.Fc, t.Ac = w, t.Bc = L, L += p, t.Gd = l(k, ha), t.Hd = 0, t.rb = l(U + 1, la), t.sb = 1, t.wa = K ? l(K, Zr) : null, t.Y = 0, t.D.Nb = 0, t.D.wa = t.wa, t.D.Y = t.Y, 0 < t.Aa && (t.D.Y += x), e(!0), t.oc = w, t.pc = L, L += 832, t.ya = l(Z, Fi), t.aa = 0, t.D.ya = t.ya, t.D.aa = t.aa, t.Aa == 2 && (t.D.aa += x), t.R = 16 * x, t.B = 8 * x, x = (k = Ra[t.L]) * t.R, k = k / 2 * t.B, t.sa = w, t.ta = L + x, t.qa = t.sa, t.ra = t.ta + 16 * c * t.R + k, t.Ha = t.qa, t.Ia = t.ra + 8 * c * t.B + k, t.$c = 0, L += m, t.mb = y ? w : null, t.nb = y ? L : null, e(L + y <= t.Fc + t.Vb), Ii(t), u(t.Ac, t.Bc, 0, p), c = 1;
            }
          }
          if (c) {
            if (r.ka = 0, r.y = t.sa, r.O = t.ta, r.f = t.qa, r.N = t.ra, r.ea = t.Ha, r.Vd = t.Ia, r.fa = t.R, r.Rc = t.B, r.F = null, r.J = 0, !ks) {
              for (c = -255; 255 >= c; ++c)
                xs[255 + c] = 0 > c ? -c : c;
              for (c = -1020; 1020 >= c; ++c)
                Ss[1020 + c] = -128 > c ? -128 : 127 < c ? 127 : c;
              for (c = -112; 112 >= c; ++c)
                _s[112 + c] = -16 > c ? -16 : 15 < c ? 15 : c;
              for (c = -255; 510 >= c; ++c)
                Ps[255 + c] = 0 > c ? 0 : 255 < c ? 255 : c;
              ks = 1;
            }
            Cn = wo, pi = bo, vr = ma, jn = yo, ir = va, Ki = ga, Rr = Ei, di = qr, Tr = Oo, br = qi, Zi = jo, mn = ii, ar = Di, be = _a, ye = Sa, Fe = er, De = fr, or = Co, On[0] = Vn, On[1] = Ao, On[2] = So, On[3] = _o, On[4] = wa, On[5] = ni, On[6] = Aa, On[7] = Oi, On[8] = ko, On[9] = Po, wr[0] = ba, wr[1] = No, wr[2] = tr, wr[3] = ti, wr[4] = Ge, wr[5] = xo, wr[6] = ya, sr[0] = hr, sr[1] = Lo, sr[2] = Fo, sr[3] = Mi, sr[4] = Er, sr[5] = Io, sr[6] = Bi, c = 1;
          } else
            c = 0;
        }
        c && (c = function(G, vt) {
          for (G.M = 0; G.M < G.Va; ++G.M) {
            var it, H = G.Jc[G.M & G.Xb], V = G.m, dt = G;
            for (it = 0; it < dt.za; ++it) {
              var bt = V, mt = dt, Ot = mt.Ac, St = mt.Bc + 4 * it, Rt = mt.zc, _t = mt.ya[mt.aa + it];
              if (mt.Qa.Bb ? _t.$b = rt(bt, mt.Pa.jb[0]) ? 2 + rt(bt, mt.Pa.jb[2]) : rt(bt, mt.Pa.jb[1]) : _t.$b = 0, mt.kc && (_t.Ad = rt(bt, mt.Bd)), _t.Za = !rt(bt, 145) + 0, _t.Za) {
                var se = _t.Ob, le = 0;
                for (mt = 0; 4 > mt; ++mt) {
                  var ae, ne = Rt[0 + mt];
                  for (ae = 0; 4 > ae; ++ae) {
                    ne = Ku[Ot[St + ae]][ne];
                    for (var me = js[rt(bt, ne[0])]; 0 < me; )
                      me = js[2 * me + rt(bt, ne[me])];
                    ne = -me, Ot[St + ae] = ne;
                  }
                  a(se, le, Ot, St, 4), le += 4, Rt[0 + mt] = ne;
                }
              } else
                ne = rt(bt, 156) ? rt(bt, 128) ? 1 : 3 : rt(bt, 163) ? 2 : 0, _t.Ob[0] = ne, u(Ot, St, ne, 4), u(Rt, 0, ne, 4);
              _t.Dd = rt(bt, 142) ? rt(bt, 114) ? rt(bt, 183) ? 1 : 3 : 2 : 0;
            }
            if (dt.m.Ka)
              return ke(G, 7, "Premature end-of-partition0 encountered.");
            for (; G.ja < G.za; ++G.ja) {
              if (dt = H, bt = (V = G).rb[V.sb - 1], Ot = V.rb[V.sb + V.ja], it = V.ya[V.aa + V.ja], St = V.kc ? it.Ad : 0)
                bt.la = Ot.la = 0, it.Za || (bt.Na = Ot.Na = 0), it.Hc = 0, it.Gc = 0, it.ia = 0;
              else {
                var de, Zt;
                if (bt = Ot, Ot = dt, St = V.Pa.Xc, Rt = V.ya[V.aa + V.ja], _t = V.pb[Rt.$b], mt = Rt.ad, se = 0, le = V.rb[V.sb - 1], ne = ae = 0, u(mt, se, 0, 384), Rt.Za)
                  var Be = 0, on = St[3];
                else {
                  me = o(16);
                  var Ee = bt.Na + le.Na;
                  if (Ee = $i(Ot, St[1], Ee, _t.Eb, 0, me, 0), bt.Na = le.Na = (0 < Ee) + 0, 1 < Ee)
                    Cn(me, 0, mt, se);
                  else {
                    var sn = me[0] + 3 >> 3;
                    for (me = 0; 256 > me; me += 16)
                      mt[se + me] = sn;
                  }
                  Be = 1, on = St[0];
                }
                var he = 15 & bt.la, fn = 15 & le.la;
                for (me = 0; 4 > me; ++me) {
                  var pn = 1 & fn;
                  for (sn = Zt = 0; 4 > sn; ++sn)
                    he = he >> 1 | (pn = (Ee = $i(Ot, on, Ee = pn + (1 & he), _t.Sc, Be, mt, se)) > Be) << 7, Zt = Zt << 2 | (3 < Ee ? 3 : 1 < Ee ? 2 : mt[se + 0] != 0), se += 16;
                  he >>= 4, fn = fn >> 1 | pn << 7, ae = (ae << 8 | Zt) >>> 0;
                }
                for (on = he, Be = fn >> 4, de = 0; 4 > de; de += 2) {
                  for (Zt = 0, he = bt.la >> 4 + de, fn = le.la >> 4 + de, me = 0; 2 > me; ++me) {
                    for (pn = 1 & fn, sn = 0; 2 > sn; ++sn)
                      Ee = pn + (1 & he), he = he >> 1 | (pn = 0 < (Ee = $i(Ot, St[2], Ee, _t.Qc, 0, mt, se))) << 3, Zt = Zt << 2 | (3 < Ee ? 3 : 1 < Ee ? 2 : mt[se + 0] != 0), se += 16;
                    he >>= 2, fn = fn >> 1 | pn << 5;
                  }
                  ne |= Zt << 4 * de, on |= he << 4 << de, Be |= (240 & fn) << de;
                }
                bt.la = on, le.la = Be, Rt.Hc = ae, Rt.Gc = ne, Rt.ia = 43690 & ne ? 0 : _t.ia, St = !(ae | ne);
              }
              if (0 < V.L && (V.wa[V.Y + V.ja] = V.gd[it.$b][it.Za], V.wa[V.Y + V.ja].La |= !St), dt.Ka)
                return ke(G, 7, "Premature end-of-file encountered.");
            }
            if (Ii(G), V = vt, dt = 1, it = (H = G).D, bt = 0 < H.L && H.M >= H.zb && H.M <= H.Va, H.Aa == 0)
              t: {
                if (it.M = H.M, it.uc = bt, Wi(H, it), dt = 1, it = (Zt = H.D).Nb, bt = (ne = Ra[H.L]) * H.R, Ot = ne / 2 * H.B, me = 16 * it * H.R, sn = 8 * it * H.B, St = H.sa, Rt = H.ta - bt + me, _t = H.qa, mt = H.ra - Ot + sn, se = H.Ha, le = H.Ia - Ot + sn, fn = (he = Zt.M) == 0, ae = he >= H.Va - 1, H.Aa == 2 && Wi(H, Zt), Zt.uc)
                  for (pn = (Ee = H).D.M, e(Ee.D.uc), Zt = Ee.yb; Zt < Ee.Hb; ++Zt) {
                    Be = Zt, on = pn;
                    var Te = (We = (_e = Ee).D).Nb;
                    de = _e.R;
                    var We = We.wa[We.Y + Be], $e = _e.sa, yn = _e.ta + 16 * Te * de + 16 * Be, Yn = We.dd, ze = We.tc;
                    if (ze != 0)
                      if (e(3 <= ze), _e.L == 1)
                        0 < Be && Fe($e, yn, de, ze + 4), We.La && or($e, yn, de, ze), 0 < on && ye($e, yn, de, ze + 4), We.La && De($e, yn, de, ze);
                      else {
                        var ur = _e.B, zr = _e.qa, mi = _e.ra + 8 * Te * ur + 8 * Be, Lr = _e.Ha, _e = _e.Ia + 8 * Te * ur + 8 * Be;
                        Te = We.ld, 0 < Be && (di($e, yn, de, ze + 4, Yn, Te), br(zr, mi, Lr, _e, ur, ze + 4, Yn, Te)), We.La && (mn($e, yn, de, ze, Yn, Te), be(zr, mi, Lr, _e, ur, ze, Yn, Te)), 0 < on && (Rr($e, yn, de, ze + 4, Yn, Te), Tr(zr, mi, Lr, _e, ur, ze + 4, Yn, Te)), We.La && (Zi($e, yn, de, ze, Yn, Te), ar(zr, mi, Lr, _e, ur, ze, Yn, Te));
                      }
                  }
                if (H.ia && alert("todo:DitherRow"), V.put != null) {
                  if (Zt = 16 * he, he = 16 * (he + 1), fn ? (V.y = H.sa, V.O = H.ta + me, V.f = H.qa, V.N = H.ra + sn, V.ea = H.Ha, V.W = H.Ia + sn) : (Zt -= ne, V.y = St, V.O = Rt, V.f = _t, V.N = mt, V.ea = se, V.W = le), ae || (he -= ne), he > V.o && (he = V.o), V.F = null, V.J = null, H.Fa != null && 0 < H.Fa.length && Zt < he && (V.J = Ui(H, V, Zt, he - Zt), V.F = H.mb, V.F == null && V.F.length == 0)) {
                    dt = ke(H, 3, "Could not decode alpha data.");
                    break t;
                  }
                  Zt < V.j && (ne = V.j - Zt, Zt = V.j, e(!(1 & ne)), V.O += H.R * ne, V.N += H.B * (ne >> 1), V.W += H.B * (ne >> 1), V.F != null && (V.J += V.width * ne)), Zt < he && (V.O += V.v, V.N += V.v >> 1, V.W += V.v >> 1, V.F != null && (V.J += V.v), V.ka = Zt - V.j, V.U = V.va - V.v, V.T = he - Zt, dt = V.put(V));
                }
                it + 1 != H.Ic || ae || (a(H.sa, H.ta - bt, St, Rt + 16 * H.R, bt), a(H.qa, H.ra - Ot, _t, mt + 8 * H.B, Ot), a(H.Ha, H.Ia - Ot, se, le + 8 * H.B, Ot));
              }
            if (!dt)
              return ke(G, 6, "Output aborted.");
          }
          return 1;
        }(t, r)), r.bc != null && r.bc(r), c &= 1;
      }
      return c ? (t.cb = 0, c) : 0;
    }
    function _n(t, r, c, p, m) {
      m = t[r + c + 32 * p] + (m >> 3), t[r + c + 32 * p] = -256 & m ? 0 > m ? 0 : 255 : m;
    }
    function Qr(t, r, c, p, m, y) {
      _n(t, r, 0, c, p + m), _n(t, r, 1, c, p + y), _n(t, r, 2, c, p - y), _n(t, r, 3, c, p - m);
    }
    function nn(t) {
      return (20091 * t >> 16) + t;
    }
    function Ci(t, r, c, p) {
      var m, y = 0, w = o(16);
      for (m = 0; 4 > m; ++m) {
        var L = t[r + 0] + t[r + 8], x = t[r + 0] - t[r + 8], k = (35468 * t[r + 4] >> 16) - nn(t[r + 12]), U = nn(t[r + 4]) + (35468 * t[r + 12] >> 16);
        w[y + 0] = L + U, w[y + 1] = x + k, w[y + 2] = x - k, w[y + 3] = L - U, y += 4, r++;
      }
      for (m = y = 0; 4 > m; ++m)
        L = (t = w[y + 0] + 4) + w[y + 8], x = t - w[y + 8], k = (35468 * w[y + 4] >> 16) - nn(w[y + 12]), _n(c, p, 0, 0, L + (U = nn(w[y + 4]) + (35468 * w[y + 12] >> 16))), _n(c, p, 1, 0, x + k), _n(c, p, 2, 0, x - k), _n(c, p, 3, 0, L - U), y++, p += 32;
    }
    function ga(t, r, c, p) {
      var m = t[r + 0] + 4, y = 35468 * t[r + 4] >> 16, w = nn(t[r + 4]), L = 35468 * t[r + 1] >> 16;
      Qr(c, p, 0, m + w, t = nn(t[r + 1]), L), Qr(c, p, 1, m + y, t, L), Qr(c, p, 2, m - y, t, L), Qr(c, p, 3, m - w, t, L);
    }
    function bo(t, r, c, p, m) {
      Ci(t, r, c, p), m && Ci(t, r + 16, c, p + 4);
    }
    function ma(t, r, c, p) {
      pi(t, r + 0, c, p, 1), pi(t, r + 32, c, p + 128, 1);
    }
    function yo(t, r, c, p) {
      var m;
      for (t = t[r + 0] + 4, m = 0; 4 > m; ++m)
        for (r = 0; 4 > r; ++r)
          _n(c, p, r, m, t);
    }
    function va(t, r, c, p) {
      t[r + 0] && jn(t, r + 0, c, p), t[r + 16] && jn(t, r + 16, c, p + 4), t[r + 32] && jn(t, r + 32, c, p + 128), t[r + 48] && jn(t, r + 48, c, p + 128 + 4);
    }
    function wo(t, r, c, p) {
      var m, y = o(16);
      for (m = 0; 4 > m; ++m) {
        var w = t[r + 0 + m] + t[r + 12 + m], L = t[r + 4 + m] + t[r + 8 + m], x = t[r + 4 + m] - t[r + 8 + m], k = t[r + 0 + m] - t[r + 12 + m];
        y[0 + m] = w + L, y[8 + m] = w - L, y[4 + m] = k + x, y[12 + m] = k - x;
      }
      for (m = 0; 4 > m; ++m)
        w = (t = y[0 + 4 * m] + 3) + y[3 + 4 * m], L = y[1 + 4 * m] + y[2 + 4 * m], x = y[1 + 4 * m] - y[2 + 4 * m], k = t - y[3 + 4 * m], c[p + 0] = w + L >> 3, c[p + 16] = k + x >> 3, c[p + 32] = w - L >> 3, c[p + 48] = k - x >> 3, p += 64;
    }
    function ji(t, r, c) {
      var p, m = r - 32, y = hn, w = 255 - t[m - 1];
      for (p = 0; p < c; ++p) {
        var L, x = y, k = w + t[r - 1];
        for (L = 0; L < c; ++L)
          t[r + L] = x[k + t[m + L]];
        r += 32;
      }
    }
    function Ao(t, r) {
      ji(t, r, 4);
    }
    function Lo(t, r) {
      ji(t, r, 8);
    }
    function No(t, r) {
      ji(t, r, 16);
    }
    function tr(t, r) {
      var c;
      for (c = 0; 16 > c; ++c)
        a(t, r + 32 * c, t, r - 32, 16);
    }
    function ti(t, r) {
      var c;
      for (c = 16; 0 < c; --c)
        u(t, r, t[r - 1], 16), r += 32;
    }
    function ei(t, r, c) {
      var p;
      for (p = 0; 16 > p; ++p)
        u(r, c + 32 * p, t, 16);
    }
    function ba(t, r) {
      var c, p = 16;
      for (c = 0; 16 > c; ++c)
        p += t[r - 1 + 32 * c] + t[r + c - 32];
      ei(p >> 5, t, r);
    }
    function Ge(t, r) {
      var c, p = 8;
      for (c = 0; 16 > c; ++c)
        p += t[r - 1 + 32 * c];
      ei(p >> 4, t, r);
    }
    function xo(t, r) {
      var c, p = 8;
      for (c = 0; 16 > c; ++c)
        p += t[r + c - 32];
      ei(p >> 4, t, r);
    }
    function ya(t, r) {
      ei(128, t, r);
    }
    function Vt(t, r, c) {
      return t + 2 * r + c + 2 >> 2;
    }
    function So(t, r) {
      var c, p = r - 32;
      for (p = new Uint8Array([Vt(t[p - 1], t[p + 0], t[p + 1]), Vt(t[p + 0], t[p + 1], t[p + 2]), Vt(t[p + 1], t[p + 2], t[p + 3]), Vt(t[p + 2], t[p + 3], t[p + 4])]), c = 0; 4 > c; ++c)
        a(t, r + 32 * c, p, 0, p.length);
    }
    function _o(t, r) {
      var c = t[r - 1], p = t[r - 1 + 32], m = t[r - 1 + 64], y = t[r - 1 + 96];
      Nt(t, r + 0, 16843009 * Vt(t[r - 1 - 32], c, p)), Nt(t, r + 32, 16843009 * Vt(c, p, m)), Nt(t, r + 64, 16843009 * Vt(p, m, y)), Nt(t, r + 96, 16843009 * Vt(m, y, y));
    }
    function Vn(t, r) {
      var c, p = 4;
      for (c = 0; 4 > c; ++c)
        p += t[r + c - 32] + t[r - 1 + 32 * c];
      for (p >>= 3, c = 0; 4 > c; ++c)
        u(t, r + 32 * c, p, 4);
    }
    function wa(t, r) {
      var c = t[r - 1 + 0], p = t[r - 1 + 32], m = t[r - 1 + 64], y = t[r - 1 - 32], w = t[r + 0 - 32], L = t[r + 1 - 32], x = t[r + 2 - 32], k = t[r + 3 - 32];
      t[r + 0 + 96] = Vt(p, m, t[r - 1 + 96]), t[r + 1 + 96] = t[r + 0 + 64] = Vt(c, p, m), t[r + 2 + 96] = t[r + 1 + 64] = t[r + 0 + 32] = Vt(y, c, p), t[r + 3 + 96] = t[r + 2 + 64] = t[r + 1 + 32] = t[r + 0 + 0] = Vt(w, y, c), t[r + 3 + 64] = t[r + 2 + 32] = t[r + 1 + 0] = Vt(L, w, y), t[r + 3 + 32] = t[r + 2 + 0] = Vt(x, L, w), t[r + 3 + 0] = Vt(k, x, L);
    }
    function Aa(t, r) {
      var c = t[r + 1 - 32], p = t[r + 2 - 32], m = t[r + 3 - 32], y = t[r + 4 - 32], w = t[r + 5 - 32], L = t[r + 6 - 32], x = t[r + 7 - 32];
      t[r + 0 + 0] = Vt(t[r + 0 - 32], c, p), t[r + 1 + 0] = t[r + 0 + 32] = Vt(c, p, m), t[r + 2 + 0] = t[r + 1 + 32] = t[r + 0 + 64] = Vt(p, m, y), t[r + 3 + 0] = t[r + 2 + 32] = t[r + 1 + 64] = t[r + 0 + 96] = Vt(m, y, w), t[r + 3 + 32] = t[r + 2 + 64] = t[r + 1 + 96] = Vt(y, w, L), t[r + 3 + 64] = t[r + 2 + 96] = Vt(w, L, x), t[r + 3 + 96] = Vt(L, x, x);
    }
    function ni(t, r) {
      var c = t[r - 1 + 0], p = t[r - 1 + 32], m = t[r - 1 + 64], y = t[r - 1 - 32], w = t[r + 0 - 32], L = t[r + 1 - 32], x = t[r + 2 - 32], k = t[r + 3 - 32];
      t[r + 0 + 0] = t[r + 1 + 64] = y + w + 1 >> 1, t[r + 1 + 0] = t[r + 2 + 64] = w + L + 1 >> 1, t[r + 2 + 0] = t[r + 3 + 64] = L + x + 1 >> 1, t[r + 3 + 0] = x + k + 1 >> 1, t[r + 0 + 96] = Vt(m, p, c), t[r + 0 + 64] = Vt(p, c, y), t[r + 0 + 32] = t[r + 1 + 96] = Vt(c, y, w), t[r + 1 + 32] = t[r + 2 + 96] = Vt(y, w, L), t[r + 2 + 32] = t[r + 3 + 96] = Vt(w, L, x), t[r + 3 + 32] = Vt(L, x, k);
    }
    function Oi(t, r) {
      var c = t[r + 0 - 32], p = t[r + 1 - 32], m = t[r + 2 - 32], y = t[r + 3 - 32], w = t[r + 4 - 32], L = t[r + 5 - 32], x = t[r + 6 - 32], k = t[r + 7 - 32];
      t[r + 0 + 0] = c + p + 1 >> 1, t[r + 1 + 0] = t[r + 0 + 64] = p + m + 1 >> 1, t[r + 2 + 0] = t[r + 1 + 64] = m + y + 1 >> 1, t[r + 3 + 0] = t[r + 2 + 64] = y + w + 1 >> 1, t[r + 0 + 32] = Vt(c, p, m), t[r + 1 + 32] = t[r + 0 + 96] = Vt(p, m, y), t[r + 2 + 32] = t[r + 1 + 96] = Vt(m, y, w), t[r + 3 + 32] = t[r + 2 + 96] = Vt(y, w, L), t[r + 3 + 64] = Vt(w, L, x), t[r + 3 + 96] = Vt(L, x, k);
    }
    function Po(t, r) {
      var c = t[r - 1 + 0], p = t[r - 1 + 32], m = t[r - 1 + 64], y = t[r - 1 + 96];
      t[r + 0 + 0] = c + p + 1 >> 1, t[r + 2 + 0] = t[r + 0 + 32] = p + m + 1 >> 1, t[r + 2 + 32] = t[r + 0 + 64] = m + y + 1 >> 1, t[r + 1 + 0] = Vt(c, p, m), t[r + 3 + 0] = t[r + 1 + 32] = Vt(p, m, y), t[r + 3 + 32] = t[r + 1 + 64] = Vt(m, y, y), t[r + 3 + 64] = t[r + 2 + 64] = t[r + 0 + 96] = t[r + 1 + 96] = t[r + 2 + 96] = t[r + 3 + 96] = y;
    }
    function ko(t, r) {
      var c = t[r - 1 + 0], p = t[r - 1 + 32], m = t[r - 1 + 64], y = t[r - 1 + 96], w = t[r - 1 - 32], L = t[r + 0 - 32], x = t[r + 1 - 32], k = t[r + 2 - 32];
      t[r + 0 + 0] = t[r + 2 + 32] = c + w + 1 >> 1, t[r + 0 + 32] = t[r + 2 + 64] = p + c + 1 >> 1, t[r + 0 + 64] = t[r + 2 + 96] = m + p + 1 >> 1, t[r + 0 + 96] = y + m + 1 >> 1, t[r + 3 + 0] = Vt(L, x, k), t[r + 2 + 0] = Vt(w, L, x), t[r + 1 + 0] = t[r + 3 + 32] = Vt(c, w, L), t[r + 1 + 32] = t[r + 3 + 64] = Vt(p, c, w), t[r + 1 + 64] = t[r + 3 + 96] = Vt(m, p, c), t[r + 1 + 96] = Vt(y, m, p);
    }
    function Fo(t, r) {
      var c;
      for (c = 0; 8 > c; ++c)
        a(t, r + 32 * c, t, r - 32, 8);
    }
    function Mi(t, r) {
      var c;
      for (c = 0; 8 > c; ++c)
        u(t, r, t[r - 1], 8), r += 32;
    }
    function Br(t, r, c) {
      var p;
      for (p = 0; 8 > p; ++p)
        u(r, c + 32 * p, t, 8);
    }
    function hr(t, r) {
      var c, p = 8;
      for (c = 0; 8 > c; ++c)
        p += t[r + c - 32] + t[r - 1 + 32 * c];
      Br(p >> 4, t, r);
    }
    function Io(t, r) {
      var c, p = 4;
      for (c = 0; 8 > c; ++c)
        p += t[r + c - 32];
      Br(p >> 3, t, r);
    }
    function Er(t, r) {
      var c, p = 4;
      for (c = 0; 8 > c; ++c)
        p += t[r - 1 + 32 * c];
      Br(p >> 3, t, r);
    }
    function Bi(t, r) {
      Br(128, t, r);
    }
    function ri(t, r, c) {
      var p = t[r - c], m = t[r + 0], y = 3 * (m - p) + Do[1020 + t[r - 2 * c] - t[r + c]], w = Ca[112 + (y + 4 >> 3)];
      t[r - c] = hn[255 + p + Ca[112 + (y + 3 >> 3)]], t[r + 0] = hn[255 + m - w];
    }
    function La(t, r, c, p) {
      var m = t[r + 0], y = t[r + c];
      return vn[255 + t[r - 2 * c] - t[r - c]] > p || vn[255 + y - m] > p;
    }
    function Na(t, r, c, p) {
      return 4 * vn[255 + t[r - c] - t[r + 0]] + vn[255 + t[r - 2 * c] - t[r + c]] <= p;
    }
    function xa(t, r, c, p, m) {
      var y = t[r - 3 * c], w = t[r - 2 * c], L = t[r - c], x = t[r + 0], k = t[r + c], U = t[r + 2 * c], K = t[r + 3 * c];
      return 4 * vn[255 + L - x] + vn[255 + w - k] > p ? 0 : vn[255 + t[r - 4 * c] - y] <= m && vn[255 + y - w] <= m && vn[255 + w - L] <= m && vn[255 + K - U] <= m && vn[255 + U - k] <= m && vn[255 + k - x] <= m;
    }
    function Sa(t, r, c, p) {
      var m = 2 * p + 1;
      for (p = 0; 16 > p; ++p)
        Na(t, r + p, c, m) && ri(t, r + p, c);
    }
    function er(t, r, c, p) {
      var m = 2 * p + 1;
      for (p = 0; 16 > p; ++p)
        Na(t, r + p * c, 1, m) && ri(t, r + p * c, 1);
    }
    function fr(t, r, c, p) {
      var m;
      for (m = 3; 0 < m; --m)
        Sa(t, r += 4 * c, c, p);
    }
    function Co(t, r, c, p) {
      var m;
      for (m = 3; 0 < m; --m)
        er(t, r += 4, c, p);
    }
    function pr(t, r, c, p, m, y, w, L) {
      for (y = 2 * y + 1; 0 < m--; ) {
        if (xa(t, r, c, y, w))
          if (La(t, r, c, L))
            ri(t, r, c);
          else {
            var x = t, k = r, U = c, K = x[k - 2 * U], Z = x[k - U], G = x[k + 0], vt = x[k + U], it = x[k + 2 * U], H = 27 * (dt = Do[1020 + 3 * (G - Z) + Do[1020 + K - vt]]) + 63 >> 7, V = 18 * dt + 63 >> 7, dt = 9 * dt + 63 >> 7;
            x[k - 3 * U] = hn[255 + x[k - 3 * U] + dt], x[k - 2 * U] = hn[255 + K + V], x[k - U] = hn[255 + Z + H], x[k + 0] = hn[255 + G - H], x[k + U] = hn[255 + vt - V], x[k + 2 * U] = hn[255 + it - dt];
          }
        r += p;
      }
    }
    function Pn(t, r, c, p, m, y, w, L) {
      for (y = 2 * y + 1; 0 < m--; ) {
        if (xa(t, r, c, y, w))
          if (La(t, r, c, L))
            ri(t, r, c);
          else {
            var x = t, k = r, U = c, K = x[k - U], Z = x[k + 0], G = x[k + U], vt = Ca[112 + ((it = 3 * (Z - K)) + 4 >> 3)], it = Ca[112 + (it + 3 >> 3)], H = vt + 1 >> 1;
            x[k - 2 * U] = hn[255 + x[k - 2 * U] + H], x[k - U] = hn[255 + K + it], x[k + 0] = hn[255 + Z - vt], x[k + U] = hn[255 + G - H];
          }
        r += p;
      }
    }
    function Ei(t, r, c, p, m, y) {
      pr(t, r, c, 1, 16, p, m, y);
    }
    function qr(t, r, c, p, m, y) {
      pr(t, r, 1, c, 16, p, m, y);
    }
    function jo(t, r, c, p, m, y) {
      var w;
      for (w = 3; 0 < w; --w)
        Pn(t, r += 4 * c, c, 1, 16, p, m, y);
    }
    function ii(t, r, c, p, m, y) {
      var w;
      for (w = 3; 0 < w; --w)
        Pn(t, r += 4, 1, c, 16, p, m, y);
    }
    function Oo(t, r, c, p, m, y, w, L) {
      pr(t, r, m, 1, 8, y, w, L), pr(c, p, m, 1, 8, y, w, L);
    }
    function qi(t, r, c, p, m, y, w, L) {
      pr(t, r, 1, m, 8, y, w, L), pr(c, p, 1, m, 8, y, w, L);
    }
    function Di(t, r, c, p, m, y, w, L) {
      Pn(t, r + 4 * m, m, 1, 8, y, w, L), Pn(c, p + 4 * m, m, 1, 8, y, w, L);
    }
    function _a(t, r, c, p, m, y, w, L) {
      Pn(t, r + 4, 1, m, 8, y, w, L), Pn(c, p + 4, 1, m, 8, y, w, L);
    }
    function ai() {
      this.ba = new An(), this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new xe(), this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
    }
    function Ri() {
      this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
    }
    function Ti() {
      this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
    }
    function Pa() {
      this.ua = 0, this.Wa = new E(), this.vb = new E(), this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new D(), this.yc = new P();
    }
    function Mo() {
      this.xb = this.a = 0, this.l = new $r(), this.ca = new An(), this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new A(), this.Pb = 0, this.wd = new A(), this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new Pa(), this.ab = 0, this.gc = l(4, Ti), this.Oc = 0;
    }
    function oi() {
      this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new $r(), this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
    }
    function Dr(t, r, c, p, m, y, w) {
      for (t = t == null ? 0 : t[r + 0], r = 0; r < w; ++r)
        m[y + r] = t + c[p + r] & 255, t = m[y + r];
    }
    function zi(t, r, c, p, m, y, w) {
      var L;
      if (t == null)
        Dr(null, null, c, p, m, y, w);
      else
        for (L = 0; L < w; ++L)
          m[y + L] = t[r + L] + c[p + L] & 255;
    }
    function dr(t, r, c, p, m, y, w) {
      if (t == null)
        Dr(null, null, c, p, m, y, w);
      else {
        var L, x = t[r + 0], k = x, U = x;
        for (L = 0; L < w; ++L)
          k = U + (x = t[r + L]) - k, U = c[p + L] + (-256 & k ? 0 > k ? 0 : 255 : k) & 255, k = x, m[y + L] = U;
      }
    }
    function Ui(t, r, c, p) {
      var m = r.width, y = r.o;
      if (e(t != null && r != null), 0 > c || 0 >= p || c + p > y)
        return null;
      if (!t.Cc) {
        if (t.ga == null) {
          var w;
          if (t.ga = new oi(), (w = t.ga == null) || (w = r.width * r.o, e(t.Gb.length == 0), t.Gb = o(w), t.Uc = 0, t.Gb == null ? w = 0 : (t.mb = t.Gb, t.nb = t.Uc, t.rc = null, w = 1), w = !w), !w) {
            w = t.ga;
            var L = t.Fa, x = t.P, k = t.qc, U = t.mb, K = t.nb, Z = x + 1, G = k - 1, vt = w.l;
            if (e(L != null && U != null && r != null), Ar[0] = null, Ar[1] = Dr, Ar[2] = zi, Ar[3] = dr, w.ca = U, w.tb = K, w.c = r.width, w.i = r.height, e(0 < w.c && 0 < w.i), 1 >= k)
              r = 0;
            else if (w.$a = L[x + 0] >> 0 & 3, w.Z = L[x + 0] >> 2 & 3, w.Lc = L[x + 0] >> 4 & 3, x = L[x + 0] >> 6 & 3, 0 > w.$a || 1 < w.$a || 4 <= w.Z || 1 < w.Lc || x)
              r = 0;
            else if (vt.put = Tn, vt.ac = He, vt.bc = zn, vt.ma = w, vt.width = r.width, vt.height = r.height, vt.Da = r.Da, vt.v = r.v, vt.va = r.va, vt.j = r.j, vt.o = r.o, w.$a)
              t: {
                e(w.$a == 1), r = dn();
                e:
                  for (; ; ) {
                    if (r == null) {
                      r = 0;
                      break t;
                    }
                    if (e(w != null), w.mc = r, r.c = w.c, r.i = w.i, r.l = w.l, r.l.ma = w, r.l.width = w.c, r.l.height = w.i, r.a = 0, $(r.m, L, Z, G), !Wn(w.c, w.i, 1, r, null) || (r.ab == 1 && r.gc[0].hc == 3 && Qn(r.s) ? (w.ic = 1, L = r.c * r.i, r.Ta = null, r.Ua = 0, r.V = o(L), r.Ba = 0, r.V == null ? (r.a = 1, r = 0) : r = 1) : (w.ic = 0, r = Mr(r, w.c)), !r))
                      break e;
                    r = 1;
                    break t;
                  }
                w.mc = null, r = 0;
              }
            else
              r = G >= w.c * w.i;
            w = !r;
          }
          if (w)
            return null;
          t.ga.Lc != 1 ? t.Ga = 0 : p = y - c;
        }
        e(t.ga != null), e(c + p <= y);
        t: {
          if (r = (L = t.ga).c, y = L.l.o, L.$a == 0) {
            if (Z = t.rc, G = t.Vc, vt = t.Fa, x = t.P + 1 + c * r, k = t.mb, U = t.nb + c * r, e(x <= t.P + t.qc), L.Z != 0)
              for (e(Ar[L.Z] != null), w = 0; w < p; ++w)
                Ar[L.Z](Z, G, vt, x, k, U, r), Z = k, G = U, U += r, x += r;
            else
              for (w = 0; w < p; ++w)
                a(k, U, vt, x, r), Z = k, G = U, U += r, x += r;
            t.rc = Z, t.Vc = G;
          } else {
            if (e(L.mc != null), r = c + p, e((w = L.mc) != null), e(r <= w.i), w.C >= r)
              r = 1;
            else if (L.ic || J(), L.ic) {
              L = w.V, Z = w.Ba, G = w.c;
              var it = w.i, H = (vt = 1, x = w.$ / G, k = w.$ % G, U = w.m, K = w.s, w.$), V = G * it, dt = G * r, bt = K.wc, mt = H < dt ? Oe(K, k, x) : null;
              e(H <= V), e(r <= it), e(Qn(K));
              e:
                for (; ; ) {
                  for (; !U.h && H < dt; ) {
                    if (k & bt || (mt = Oe(K, k, x)), e(mt != null), Y(U), 256 > (it = en(mt.G[0], mt.H[0], U)))
                      L[Z + H] = it, ++H, ++k >= G && (k = 0, ++x <= r && !(x % 16) && xn(w, x));
                    else {
                      if (!(280 > it)) {
                        vt = 0;
                        break e;
                      }
                      it = Ln(it - 256, U);
                      var Ot, St = en(mt.G[4], mt.H[4], U);
                      if (Y(U), !(H >= (St = Un(G, St = Ln(St, U))) && V - H >= it)) {
                        vt = 0;
                        break e;
                      }
                      for (Ot = 0; Ot < it; ++Ot)
                        L[Z + H + Ot] = L[Z + H + Ot - St];
                      for (H += it, k += it; k >= G; )
                        k -= G, ++x <= r && !(x % 16) && xn(w, x);
                      H < dt && k & bt && (mt = Oe(K, k, x));
                    }
                    e(U.h == B(U));
                  }
                  xn(w, x > r ? r : x);
                  break e;
                }
              !vt || U.h && H < V ? (vt = 0, w.a = U.h ? 5 : 3) : w.$ = H, r = vt;
            } else
              r = Sn(w, w.V, w.Ba, w.c, w.i, r, Yr);
            if (!r) {
              p = 0;
              break t;
            }
          }
          c + p >= y && (t.Cc = 1), p = 1;
        }
        if (!p)
          return null;
        if (t.Cc && ((p = t.ga) != null && (p.mc = null), t.ga = null, 0 < t.Ga))
          return alert("todo:WebPDequantizeLevels"), null;
      }
      return t.nb + c * m;
    }
    function s(t, r, c, p, m, y) {
      for (; 0 < m--; ) {
        var w, L = t, x = r + (c ? 1 : 0), k = t, U = r + (c ? 0 : 3);
        for (w = 0; w < p; ++w) {
          var K = k[U + 4 * w];
          K != 255 && (K *= 32897, L[x + 4 * w + 0] = L[x + 4 * w + 0] * K >> 23, L[x + 4 * w + 1] = L[x + 4 * w + 1] * K >> 23, L[x + 4 * w + 2] = L[x + 4 * w + 2] * K >> 23);
        }
        r += y;
      }
    }
    function v(t, r, c, p, m) {
      for (; 0 < p--; ) {
        var y;
        for (y = 0; y < c; ++y) {
          var w = t[r + 2 * y + 0], L = 15 & (k = t[r + 2 * y + 1]), x = 4369 * L, k = (240 & k | k >> 4) * x >> 16;
          t[r + 2 * y + 0] = (240 & w | w >> 4) * x >> 16 & 240 | (15 & w | w << 4) * x >> 16 >> 4 & 15, t[r + 2 * y + 1] = 240 & k | L;
        }
        r += m;
      }
    }
    function C(t, r, c, p, m, y, w, L) {
      var x, k, U = 255;
      for (k = 0; k < m; ++k) {
        for (x = 0; x < p; ++x) {
          var K = t[r + x];
          y[w + 4 * x] = K, U &= K;
        }
        r += c, w += L;
      }
      return U != 255;
    }
    function T(t, r, c, p, m) {
      var y;
      for (y = 0; y < m; ++y)
        c[p + y] = t[r + y] >> 8;
    }
    function J() {
      yr = s, gi = v, Ia = C, Ns = T;
    }
    function st(t, r, c) {
      R[t] = function(p, m, y, w, L, x, k, U, K, Z, G, vt, it, H, V, dt, bt) {
        var mt, Ot = bt - 1 >> 1, St = L[x + 0] | k[U + 0] << 16, Rt = K[Z + 0] | G[vt + 0] << 16;
        e(p != null);
        var _t = 3 * St + Rt + 131074 >> 2;
        for (r(p[m + 0], 255 & _t, _t >> 16, it, H), y != null && (_t = 3 * Rt + St + 131074 >> 2, r(y[w + 0], 255 & _t, _t >> 16, V, dt)), mt = 1; mt <= Ot; ++mt) {
          var se = L[x + mt] | k[U + mt] << 16, le = K[Z + mt] | G[vt + mt] << 16, ae = St + se + Rt + le + 524296, ne = ae + 2 * (se + Rt) >> 3;
          _t = ne + St >> 1, St = (ae = ae + 2 * (St + le) >> 3) + se >> 1, r(p[m + 2 * mt - 1], 255 & _t, _t >> 16, it, H + (2 * mt - 1) * c), r(p[m + 2 * mt - 0], 255 & St, St >> 16, it, H + (2 * mt - 0) * c), y != null && (_t = ae + Rt >> 1, St = ne + le >> 1, r(y[w + 2 * mt - 1], 255 & _t, _t >> 16, V, dt + (2 * mt - 1) * c), r(y[w + 2 * mt + 0], 255 & St, St >> 16, V, dt + (2 * mt + 0) * c)), St = se, Rt = le;
        }
        1 & bt || (_t = 3 * St + Rt + 131074 >> 2, r(p[m + bt - 1], 255 & _t, _t >> 16, it, H + (bt - 1) * c), y != null && (_t = 3 * Rt + St + 131074 >> 2, r(y[w + bt - 1], 255 & _t, _t >> 16, V, dt + (bt - 1) * c)));
      };
    }
    function wt() {
      bn[ja] = tc, bn[Oa] = Ms, bn[Fs] = ec, bn[Ma] = Bs, bn[Ba] = Es, bn[Ro] = qs, bn[Is] = nc, bn[To] = Ms, bn[zo] = Bs, bn[Ea] = Es, bn[Uo] = qs;
    }
    function jt(t) {
      return t & ~rc ? 0 > t ? 0 : 255 : t >> Ds;
    }
    function Dt(t, r) {
      return jt((19077 * t >> 8) + (26149 * r >> 8) - 14234);
    }
    function Kt(t, r, c) {
      return jt((19077 * t >> 8) - (6419 * r >> 8) - (13320 * c >> 8) + 8708);
    }
    function Qt(t, r) {
      return jt((19077 * t >> 8) + (33050 * r >> 8) - 17685);
    }
    function re(t, r, c, p, m) {
      p[m + 0] = Dt(t, c), p[m + 1] = Kt(t, r, c), p[m + 2] = Qt(t, r);
    }
    function Le(t, r, c, p, m) {
      p[m + 0] = Qt(t, r), p[m + 1] = Kt(t, r, c), p[m + 2] = Dt(t, c);
    }
    function Se(t, r, c, p, m) {
      var y = Kt(t, r, c);
      r = y << 3 & 224 | Qt(t, r) >> 3, p[m + 0] = 248 & Dt(t, c) | y >> 5, p[m + 1] = r;
    }
    function Me(t, r, c, p, m) {
      var y = 240 & Qt(t, r) | 15;
      p[m + 0] = 240 & Dt(t, c) | Kt(t, r, c) >> 4, p[m + 1] = y;
    }
    function Ye(t, r, c, p, m) {
      p[m + 0] = 255, re(t, r, c, p, m + 1);
    }
    function Re(t, r, c, p, m) {
      Le(t, r, c, p, m), p[m + 3] = 255;
    }
    function kn(t, r, c, p, m) {
      re(t, r, c, p, m), p[m + 3] = 255;
    }
    function ln(t, r) {
      return 0 > t ? 0 : t > r ? r : t;
    }
    function nr(t, r, c) {
      R[t] = function(p, m, y, w, L, x, k, U, K) {
        for (var Z = U + (-2 & K) * c; U != Z; )
          r(p[m + 0], y[w + 0], L[x + 0], k, U), r(p[m + 1], y[w + 0], L[x + 0], k, U + c), m += 2, ++w, ++x, U += 2 * c;
        1 & K && r(p[m + 0], y[w + 0], L[x + 0], k, U);
      };
    }
    function ka(t, r, c) {
      return c == 0 ? t == 0 ? r == 0 ? 6 : 5 : r == 0 ? 4 : 0 : c;
    }
    function Hi(t, r, c, p, m) {
      switch (t >>> 30) {
        case 3:
          pi(r, c, p, m, 0);
          break;
        case 2:
          Ki(r, c, p, m);
          break;
        case 1:
          jn(r, c, p, m);
      }
    }
    function Wi(t, r) {
      var c, p, m = r.M, y = r.Nb, w = t.oc, L = t.pc + 40, x = t.oc, k = t.pc + 584, U = t.oc, K = t.pc + 600;
      for (c = 0; 16 > c; ++c)
        w[L + 32 * c - 1] = 129;
      for (c = 0; 8 > c; ++c)
        x[k + 32 * c - 1] = 129, U[K + 32 * c - 1] = 129;
      for (0 < m ? w[L - 1 - 32] = x[k - 1 - 32] = U[K - 1 - 32] = 129 : (u(w, L - 32 - 1, 127, 21), u(x, k - 32 - 1, 127, 9), u(U, K - 32 - 1, 127, 9)), p = 0; p < t.za; ++p) {
        var Z = r.ya[r.aa + p];
        if (0 < p) {
          for (c = -1; 16 > c; ++c)
            a(w, L + 32 * c - 4, w, L + 32 * c + 12, 4);
          for (c = -1; 8 > c; ++c)
            a(x, k + 32 * c - 4, x, k + 32 * c + 4, 4), a(U, K + 32 * c - 4, U, K + 32 * c + 4, 4);
        }
        var G = t.Gd, vt = t.Hd + p, it = Z.ad, H = Z.Hc;
        if (0 < m && (a(w, L - 32, G[vt].y, 0, 16), a(x, k - 32, G[vt].f, 0, 8), a(U, K - 32, G[vt].ea, 0, 8)), Z.Za) {
          var V = w, dt = L - 32 + 16;
          for (0 < m && (p >= t.za - 1 ? u(V, dt, G[vt].y[15], 4) : a(V, dt, G[vt + 1].y, 0, 4)), c = 0; 4 > c; c++)
            V[dt + 128 + c] = V[dt + 256 + c] = V[dt + 384 + c] = V[dt + 0 + c];
          for (c = 0; 16 > c; ++c, H <<= 2)
            V = w, dt = L + Ts[c], On[Z.Ob[c]](V, dt), Hi(H, it, 16 * +c, V, dt);
        } else if (V = ka(p, m, Z.Ob[0]), wr[V](w, L), H != 0)
          for (c = 0; 16 > c; ++c, H <<= 2)
            Hi(H, it, 16 * +c, w, L + Ts[c]);
        for (c = Z.Gc, V = ka(p, m, Z.Dd), sr[V](x, k), sr[V](U, K), H = it, V = x, dt = k, 255 & (Z = c >> 0) && (170 & Z ? vr(H, 256, V, dt) : ir(H, 256, V, dt)), Z = U, H = K, 255 & (c >>= 8) && (170 & c ? vr(it, 320, Z, H) : ir(it, 320, Z, H)), m < t.Ub - 1 && (a(G[vt].y, 0, w, L + 480, 16), a(G[vt].f, 0, x, k + 224, 8), a(G[vt].ea, 0, U, K + 224, 8)), c = 8 * y * t.B, G = t.sa, vt = t.ta + 16 * p + 16 * y * t.R, it = t.qa, Z = t.ra + 8 * p + c, H = t.Ha, V = t.Ia + 8 * p + c, c = 0; 16 > c; ++c)
          a(G, vt + c * t.R, w, L + 32 * c, 16);
        for (c = 0; 8 > c; ++c)
          a(it, Z + c * t.B, x, k + 32 * c, 8), a(H, V + c * t.B, U, K + 32 * c, 8);
      }
    }
    function si(t, r, c, p, m, y, w, L, x) {
      var k = [0], U = [0], K = 0, Z = x != null ? x.kd : 0, G = x ?? new Ri();
      if (t == null || 12 > c)
        return 7;
      G.data = t, G.w = r, G.ha = c, r = [r], c = [c], G.gb = [G.gb];
      t: {
        var vt = r, it = c, H = G.gb;
        if (e(t != null), e(it != null), e(H != null), H[0] = 0, 12 <= it[0] && !n(t, vt[0], "RIFF")) {
          if (n(t, vt[0] + 8, "WEBP")) {
            H = 3;
            break t;
          }
          var V = Mt(t, vt[0] + 4);
          if (12 > V || 4294967286 < V) {
            H = 3;
            break t;
          }
          if (Z && V > it[0] - 8) {
            H = 7;
            break t;
          }
          H[0] = V, vt[0] += 12, it[0] -= 12;
        }
        H = 0;
      }
      if (H != 0)
        return H;
      for (V = 0 < G.gb[0], c = c[0]; ; ) {
        t: {
          var dt = t;
          it = r, H = c;
          var bt = k, mt = U, Ot = vt = [0];
          if ((_t = K = [K])[0] = 0, 8 > H[0])
            H = 7;
          else {
            if (!n(dt, it[0], "VP8X")) {
              if (Mt(dt, it[0] + 4) != 10) {
                H = 3;
                break t;
              }
              if (18 > H[0]) {
                H = 7;
                break t;
              }
              var St = Mt(dt, it[0] + 8), Rt = 1 + Ct(dt, it[0] + 12);
              if (2147483648 <= Rt * (dt = 1 + Ct(dt, it[0] + 15))) {
                H = 3;
                break t;
              }
              Ot != null && (Ot[0] = St), bt != null && (bt[0] = Rt), mt != null && (mt[0] = dt), it[0] += 18, H[0] -= 18, _t[0] = 1;
            }
            H = 0;
          }
        }
        if (K = K[0], vt = vt[0], H != 0)
          return H;
        if (it = !!(2 & vt), !V && K)
          return 3;
        if (y != null && (y[0] = !!(16 & vt)), w != null && (w[0] = it), L != null && (L[0] = 0), w = k[0], vt = U[0], K && it && x == null) {
          H = 0;
          break;
        }
        if (4 > c) {
          H = 7;
          break;
        }
        if (V && K || !V && !K && !n(t, r[0], "ALPH")) {
          c = [c], G.na = [G.na], G.P = [G.P], G.Sa = [G.Sa];
          t: {
            St = t, H = r, V = c;
            var _t = G.gb;
            bt = G.na, mt = G.P, Ot = G.Sa, Rt = 22, e(St != null), e(V != null), dt = H[0];
            var se = V[0];
            for (e(bt != null), e(Ot != null), bt[0] = null, mt[0] = null, Ot[0] = 0; ; ) {
              if (H[0] = dt, V[0] = se, 8 > se) {
                H = 7;
                break t;
              }
              var le = Mt(St, dt + 4);
              if (4294967286 < le) {
                H = 3;
                break t;
              }
              var ae = 8 + le + 1 & -2;
              if (Rt += ae, 0 < _t && Rt > _t) {
                H = 3;
                break t;
              }
              if (!n(St, dt, "VP8 ") || !n(St, dt, "VP8L")) {
                H = 0;
                break t;
              }
              if (se[0] < ae) {
                H = 7;
                break t;
              }
              n(St, dt, "ALPH") || (bt[0] = St, mt[0] = dt + 8, Ot[0] = le), dt += ae, se -= ae;
            }
          }
          if (c = c[0], G.na = G.na[0], G.P = G.P[0], G.Sa = G.Sa[0], H != 0)
            break;
        }
        c = [c], G.Ja = [G.Ja], G.xa = [G.xa];
        t:
          if (_t = t, H = r, V = c, bt = G.gb[0], mt = G.Ja, Ot = G.xa, St = H[0], dt = !n(_t, St, "VP8 "), Rt = !n(_t, St, "VP8L"), e(_t != null), e(V != null), e(mt != null), e(Ot != null), 8 > V[0])
            H = 7;
          else {
            if (dt || Rt) {
              if (_t = Mt(_t, St + 4), 12 <= bt && _t > bt - 12) {
                H = 3;
                break t;
              }
              if (Z && _t > V[0] - 8) {
                H = 7;
                break t;
              }
              mt[0] = _t, H[0] += 8, V[0] -= 8, Ot[0] = Rt;
            } else
              Ot[0] = 5 <= V[0] && _t[St + 0] == 47 && !(_t[St + 4] >> 5), mt[0] = V[0];
            H = 0;
          }
        if (c = c[0], G.Ja = G.Ja[0], G.xa = G.xa[0], r = r[0], H != 0)
          break;
        if (4294967286 < G.Ja)
          return 3;
        if (L == null || it || (L[0] = G.xa ? 2 : 1), w = [w], vt = [vt], G.xa) {
          if (5 > c) {
            H = 7;
            break;
          }
          L = w, Z = vt, it = y, t == null || 5 > c ? t = 0 : 5 <= c && t[r + 0] == 47 && !(t[r + 4] >> 5) ? (V = [0], _t = [0], bt = [0], $(mt = new A(), t, r, c), Tt(mt, V, _t, bt) ? (L != null && (L[0] = V[0]), Z != null && (Z[0] = _t[0]), it != null && (it[0] = bt[0]), t = 1) : t = 0) : t = 0;
        } else {
          if (10 > c) {
            H = 7;
            break;
          }
          L = vt, t == null || 10 > c || !fa(t, r + 3, c - 3) ? t = 0 : (Z = t[r + 0] | t[r + 1] << 8 | t[r + 2] << 16, it = 16383 & (t[r + 7] << 8 | t[r + 6]), t = 16383 & (t[r + 9] << 8 | t[r + 8]), 1 & Z || 3 < (Z >> 1 & 7) || !(Z >> 4 & 1) || Z >> 5 >= G.Ja || !it || !t ? t = 0 : (w && (w[0] = it), L && (L[0] = t), t = 1));
        }
        if (!t || (w = w[0], vt = vt[0], K && (k[0] != w || U[0] != vt)))
          return 3;
        x != null && (x[0] = G, x.offset = r - x.w, e(4294967286 > r - x.w), e(x.offset == x.ha - c));
        break;
      }
      return H == 0 || H == 7 && K && x == null ? (y != null && (y[0] |= G.na != null && 0 < G.na.length), p != null && (p[0] = w), m != null && (m[0] = vt), 0) : H;
    }
    function Vi(t, r, c) {
      var p = r.width, m = r.height, y = 0, w = 0, L = p, x = m;
      if (r.Da = t != null && 0 < t.Da, r.Da && (L = t.cd, x = t.bd, y = t.v, w = t.j, 11 > c || (y &= -2, w &= -2), 0 > y || 0 > w || 0 >= L || 0 >= x || y + L > p || w + x > m))
        return 0;
      if (r.v = y, r.j = w, r.va = y + L, r.o = w + x, r.U = L, r.T = x, r.da = t != null && 0 < t.da, r.da) {
        if (!Xt(L, x, c = [t.ib], y = [t.hb]))
          return 0;
        r.ib = c[0], r.hb = y[0];
      }
      return r.ob = t != null && t.ob, r.Kb = t == null || !t.Sd, r.da && (r.ob = r.ib < 3 * p / 4 && r.hb < 3 * m / 4, r.Kb = 0), 1;
    }
    function Gi(t) {
      if (t == null)
        return 2;
      if (11 > t.S) {
        var r = t.f.RGBA;
        r.fb += (t.height - 1) * r.A, r.A = -r.A;
      } else
        r = t.f.kb, t = t.height, r.O += (t - 1) * r.fa, r.fa = -r.fa, r.N += (t - 1 >> 1) * r.Ab, r.Ab = -r.Ab, r.W += (t - 1 >> 1) * r.Db, r.Db = -r.Db, r.F != null && (r.J += (t - 1) * r.lb, r.lb = -r.lb);
      return 0;
    }
    function ui(t, r, c, p) {
      if (p == null || 0 >= t || 0 >= r)
        return 2;
      if (c != null) {
        if (c.Da) {
          var m = c.cd, y = c.bd, w = -2 & c.v, L = -2 & c.j;
          if (0 > w || 0 > L || 0 >= m || 0 >= y || w + m > t || L + y > r)
            return 2;
          t = m, r = y;
        }
        if (c.da) {
          if (!Xt(t, r, m = [c.ib], y = [c.hb]))
            return 2;
          t = m[0], r = y[0];
        }
      }
      p.width = t, p.height = r;
      t: {
        var x = p.width, k = p.height;
        if (t = p.S, 0 >= x || 0 >= k || !(t >= ja && 13 > t))
          t = 2;
        else {
          if (0 >= p.Rd && p.sd == null) {
            w = y = m = r = 0;
            var U = (L = x * zs[t]) * k;
            if (11 > t || (y = (k + 1) / 2 * (r = (x + 1) / 2), t == 12 && (w = (m = x) * k)), (k = o(U + 2 * y + w)) == null) {
              t = 1;
              break t;
            }
            p.sd = k, 11 > t ? ((x = p.f.RGBA).eb = k, x.fb = 0, x.A = L, x.size = U) : ((x = p.f.kb).y = k, x.O = 0, x.fa = L, x.Fd = U, x.f = k, x.N = 0 + U, x.Ab = r, x.Cd = y, x.ea = k, x.W = 0 + U + y, x.Db = r, x.Ed = y, t == 12 && (x.F = k, x.J = 0 + U + 2 * y), x.Tc = w, x.lb = m);
          }
          if (r = 1, m = p.S, y = p.width, w = p.height, m >= ja && 13 > m)
            if (11 > m)
              t = p.f.RGBA, r &= (L = Math.abs(t.A)) * (w - 1) + y <= t.size, r &= L >= y * zs[m], r &= t.eb != null;
            else {
              t = p.f.kb, L = (y + 1) / 2, U = (w + 1) / 2, x = Math.abs(t.fa), k = Math.abs(t.Ab);
              var K = Math.abs(t.Db), Z = Math.abs(t.lb), G = Z * (w - 1) + y;
              r &= x * (w - 1) + y <= t.Fd, r &= k * (U - 1) + L <= t.Cd, r = (r &= K * (U - 1) + L <= t.Ed) & x >= y & k >= L & K >= L, r &= t.y != null, r &= t.f != null, r &= t.ea != null, m == 12 && (r &= Z >= y, r &= G <= t.Tc, r &= t.F != null);
            }
          else
            r = 0;
          t = r ? 0 : 2;
        }
      }
      return t != 0 || c != null && c.fd && (t = Gi(p)), t;
    }
    var rn = 64, ci = [0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767, 65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215], li = 24, hi = 32, Yi = 8, an = [0, 0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7];
    xt("Predictor0", "PredictorAdd0"), R.Predictor0 = function() {
      return 4278190080;
    }, R.Predictor1 = function(t) {
      return t;
    }, R.Predictor2 = function(t, r, c) {
      return r[c + 0];
    }, R.Predictor3 = function(t, r, c) {
      return r[c + 1];
    }, R.Predictor4 = function(t, r, c) {
      return r[c - 1];
    }, R.Predictor5 = function(t, r, c) {
      return Pt(Pt(t, r[c + 1]), r[c + 0]);
    }, R.Predictor6 = function(t, r, c) {
      return Pt(t, r[c - 1]);
    }, R.Predictor7 = function(t, r, c) {
      return Pt(t, r[c + 0]);
    }, R.Predictor8 = function(t, r, c) {
      return Pt(r[c - 1], r[c + 0]);
    }, R.Predictor9 = function(t, r, c) {
      return Pt(r[c + 0], r[c + 1]);
    }, R.Predictor10 = function(t, r, c) {
      return Pt(Pt(t, r[c - 1]), Pt(r[c + 0], r[c + 1]));
    }, R.Predictor11 = function(t, r, c) {
      var p = r[c + 0];
      return 0 >= $t(p >> 24 & 255, t >> 24 & 255, (r = r[c - 1]) >> 24 & 255) + $t(p >> 16 & 255, t >> 16 & 255, r >> 16 & 255) + $t(p >> 8 & 255, t >> 8 & 255, r >> 8 & 255) + $t(255 & p, 255 & t, 255 & r) ? p : t;
    }, R.Predictor12 = function(t, r, c) {
      var p = r[c + 0];
      return (qt((t >> 24 & 255) + (p >> 24 & 255) - ((r = r[c - 1]) >> 24 & 255)) << 24 | qt((t >> 16 & 255) + (p >> 16 & 255) - (r >> 16 & 255)) << 16 | qt((t >> 8 & 255) + (p >> 8 & 255) - (r >> 8 & 255)) << 8 | qt((255 & t) + (255 & p) - (255 & r))) >>> 0;
    }, R.Predictor13 = function(t, r, c) {
      var p = r[c - 1];
      return (Gt((t = Pt(t, r[c + 0])) >> 24 & 255, p >> 24 & 255) << 24 | Gt(t >> 16 & 255, p >> 16 & 255) << 16 | Gt(t >> 8 & 255, p >> 8 & 255) << 8 | Gt(t >> 0 & 255, p >> 0 & 255)) >>> 0;
    };
    var Bo = R.PredictorAdd0;
    R.PredictorAdd1 = te, xt("Predictor2", "PredictorAdd2"), xt("Predictor3", "PredictorAdd3"), xt("Predictor4", "PredictorAdd4"), xt("Predictor5", "PredictorAdd5"), xt("Predictor6", "PredictorAdd6"), xt("Predictor7", "PredictorAdd7"), xt("Predictor8", "PredictorAdd8"), xt("Predictor9", "PredictorAdd9"), xt("Predictor10", "PredictorAdd10"), xt("Predictor11", "PredictorAdd11"), xt("Predictor12", "PredictorAdd12"), xt("Predictor13", "PredictorAdd13");
    var Ji = R.PredictorAdd2;
    ee("ColorIndexInverseTransform", "MapARGB", "32b", function(t) {
      return t >> 8 & 255;
    }, function(t) {
      return t;
    }), ee("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(t) {
      return t;
    }, function(t) {
      return t >> 8 & 255;
    });
    var Fa, Fn = R.ColorIndexInverseTransform, Xi = R.MapARGB, Eo = R.VP8LColorIndexInverseTransformAlpha, qo = R.MapAlpha, gr = R.VP8LPredictorsAdd = [];
    gr.length = 16, (R.VP8LPredictors = []).length = 16, (R.VP8LPredictorsAdd_C = []).length = 16, (R.VP8LPredictors_C = []).length = 16;
    var gn, In, mr, Gn, rr, fi, Cn, pi, Ki, vr, jn, ir, Rr, di, Tr, br, Zi, mn, ar, be, ye, Fe, De, or, yr, gi, Ia, Ns, xs = o(511), Ss = o(2041), _s = o(225), Ps = o(767), ks = 0, Do = Ss, Ca = _s, hn = Ps, vn = xs, ja = 0, Oa = 1, Fs = 2, Ma = 3, Ba = 4, Ro = 5, Is = 6, To = 7, zo = 8, Ea = 9, Uo = 10, Tu = [2, 3, 7], zu = [3, 3, 11], Cs = [280, 256, 256, 256, 40], Uu = [0, 1, 1, 1, 0], Hu = [17, 18, 0, 1, 2, 3, 4, 5, 16, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], Wu = [24, 7, 23, 25, 40, 6, 39, 41, 22, 26, 38, 42, 56, 5, 55, 57, 21, 27, 54, 58, 37, 43, 72, 4, 71, 73, 20, 28, 53, 59, 70, 74, 36, 44, 88, 69, 75, 52, 60, 3, 87, 89, 19, 29, 86, 90, 35, 45, 68, 76, 85, 91, 51, 61, 104, 2, 103, 105, 18, 30, 102, 106, 34, 46, 84, 92, 67, 77, 101, 107, 50, 62, 120, 1, 119, 121, 83, 93, 17, 31, 100, 108, 66, 78, 118, 122, 33, 47, 117, 123, 49, 63, 99, 109, 82, 94, 0, 116, 124, 65, 79, 16, 32, 98, 110, 48, 115, 125, 81, 95, 64, 114, 126, 97, 111, 80, 113, 127, 96, 112], Vu = [2954, 2956, 2958, 2962, 2970, 2986, 3018, 3082, 3212, 3468, 3980, 5004], Gu = 8, Ho = [4, 5, 6, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15, 16, 17, 17, 18, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 25, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 93, 95, 96, 98, 100, 101, 102, 104, 106, 108, 110, 112, 114, 116, 118, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140, 143, 145, 148, 151, 154, 157], Wo = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108, 110, 112, 114, 116, 119, 122, 125, 128, 131, 134, 137, 140, 143, 146, 149, 152, 155, 158, 161, 164, 167, 170, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 234, 239, 245, 249, 254, 259, 264, 269, 274, 279, 284], $i = null, Yu = [[173, 148, 140, 0], [176, 155, 140, 135, 0], [180, 157, 141, 134, 130, 0], [254, 254, 243, 230, 196, 177, 153, 140, 133, 130, 129, 0]], Ju = [0, 1, 4, 8, 5, 2, 3, 6, 9, 12, 13, 10, 7, 11, 14, 15], js = [-0, 1, -1, 2, -2, 3, 4, 6, -3, 5, -4, -5, -6, 7, -7, 8, -8, -9], Xu = [[[[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]], [[253, 136, 254, 255, 228, 219, 128, 128, 128, 128, 128], [189, 129, 242, 255, 227, 213, 255, 219, 128, 128, 128], [106, 126, 227, 252, 214, 209, 255, 255, 128, 128, 128]], [[1, 98, 248, 255, 236, 226, 255, 255, 128, 128, 128], [181, 133, 238, 254, 221, 234, 255, 154, 128, 128, 128], [78, 134, 202, 247, 198, 180, 255, 219, 128, 128, 128]], [[1, 185, 249, 255, 243, 255, 128, 128, 128, 128, 128], [184, 150, 247, 255, 236, 224, 128, 128, 128, 128, 128], [77, 110, 216, 255, 236, 230, 128, 128, 128, 128, 128]], [[1, 101, 251, 255, 241, 255, 128, 128, 128, 128, 128], [170, 139, 241, 252, 236, 209, 255, 255, 128, 128, 128], [37, 116, 196, 243, 228, 255, 255, 255, 128, 128, 128]], [[1, 204, 254, 255, 245, 255, 128, 128, 128, 128, 128], [207, 160, 250, 255, 238, 128, 128, 128, 128, 128, 128], [102, 103, 231, 255, 211, 171, 128, 128, 128, 128, 128]], [[1, 152, 252, 255, 240, 255, 128, 128, 128, 128, 128], [177, 135, 243, 255, 234, 225, 128, 128, 128, 128, 128], [80, 129, 211, 255, 194, 224, 128, 128, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [246, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [255, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[198, 35, 237, 223, 193, 187, 162, 160, 145, 155, 62], [131, 45, 198, 221, 172, 176, 220, 157, 252, 221, 1], [68, 47, 146, 208, 149, 167, 221, 162, 255, 223, 128]], [[1, 149, 241, 255, 221, 224, 255, 255, 128, 128, 128], [184, 141, 234, 253, 222, 220, 255, 199, 128, 128, 128], [81, 99, 181, 242, 176, 190, 249, 202, 255, 255, 128]], [[1, 129, 232, 253, 214, 197, 242, 196, 255, 255, 128], [99, 121, 210, 250, 201, 198, 255, 202, 128, 128, 128], [23, 91, 163, 242, 170, 187, 247, 210, 255, 255, 128]], [[1, 200, 246, 255, 234, 255, 128, 128, 128, 128, 128], [109, 178, 241, 255, 231, 245, 255, 255, 128, 128, 128], [44, 130, 201, 253, 205, 192, 255, 255, 128, 128, 128]], [[1, 132, 239, 251, 219, 209, 255, 165, 128, 128, 128], [94, 136, 225, 251, 218, 190, 255, 255, 128, 128, 128], [22, 100, 174, 245, 186, 161, 255, 199, 128, 128, 128]], [[1, 182, 249, 255, 232, 235, 128, 128, 128, 128, 128], [124, 143, 241, 255, 227, 234, 128, 128, 128, 128, 128], [35, 77, 181, 251, 193, 211, 255, 205, 128, 128, 128]], [[1, 157, 247, 255, 236, 231, 255, 255, 128, 128, 128], [121, 141, 235, 255, 225, 227, 255, 255, 128, 128, 128], [45, 99, 188, 251, 195, 217, 255, 224, 128, 128, 128]], [[1, 1, 251, 255, 213, 255, 128, 128, 128, 128, 128], [203, 1, 248, 255, 255, 128, 128, 128, 128, 128, 128], [137, 1, 177, 255, 224, 255, 128, 128, 128, 128, 128]]], [[[253, 9, 248, 251, 207, 208, 255, 192, 128, 128, 128], [175, 13, 224, 243, 193, 185, 249, 198, 255, 255, 128], [73, 17, 171, 221, 161, 179, 236, 167, 255, 234, 128]], [[1, 95, 247, 253, 212, 183, 255, 255, 128, 128, 128], [239, 90, 244, 250, 211, 209, 255, 255, 128, 128, 128], [155, 77, 195, 248, 188, 195, 255, 255, 128, 128, 128]], [[1, 24, 239, 251, 218, 219, 255, 205, 128, 128, 128], [201, 51, 219, 255, 196, 186, 128, 128, 128, 128, 128], [69, 46, 190, 239, 201, 218, 255, 228, 128, 128, 128]], [[1, 191, 251, 255, 255, 128, 128, 128, 128, 128, 128], [223, 165, 249, 255, 213, 255, 128, 128, 128, 128, 128], [141, 124, 248, 255, 255, 128, 128, 128, 128, 128, 128]], [[1, 16, 248, 255, 255, 128, 128, 128, 128, 128, 128], [190, 36, 230, 255, 236, 255, 128, 128, 128, 128, 128], [149, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 226, 255, 128, 128, 128, 128, 128, 128, 128, 128], [247, 192, 255, 128, 128, 128, 128, 128, 128, 128, 128], [240, 128, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 134, 252, 255, 255, 128, 128, 128, 128, 128, 128], [213, 62, 250, 255, 255, 128, 128, 128, 128, 128, 128], [55, 93, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[202, 24, 213, 235, 186, 191, 220, 160, 240, 175, 255], [126, 38, 182, 232, 169, 184, 228, 174, 255, 187, 128], [61, 46, 138, 219, 151, 178, 240, 170, 255, 216, 128]], [[1, 112, 230, 250, 199, 191, 247, 159, 255, 255, 128], [166, 109, 228, 252, 211, 215, 255, 174, 128, 128, 128], [39, 77, 162, 232, 172, 180, 245, 178, 255, 255, 128]], [[1, 52, 220, 246, 198, 199, 249, 220, 255, 255, 128], [124, 74, 191, 243, 183, 193, 250, 221, 255, 255, 128], [24, 71, 130, 219, 154, 170, 243, 182, 255, 255, 128]], [[1, 182, 225, 249, 219, 240, 255, 224, 128, 128, 128], [149, 150, 226, 252, 216, 205, 255, 171, 128, 128, 128], [28, 108, 170, 242, 183, 194, 254, 223, 255, 255, 128]], [[1, 81, 230, 252, 204, 203, 255, 192, 128, 128, 128], [123, 102, 209, 247, 188, 196, 255, 233, 128, 128, 128], [20, 95, 153, 243, 164, 173, 255, 203, 128, 128, 128]], [[1, 222, 248, 255, 216, 213, 128, 128, 128, 128, 128], [168, 175, 246, 252, 235, 205, 255, 255, 128, 128, 128], [47, 116, 215, 255, 211, 212, 255, 255, 128, 128, 128]], [[1, 121, 236, 253, 212, 214, 255, 255, 128, 128, 128], [141, 84, 213, 252, 201, 202, 255, 219, 128, 128, 128], [42, 80, 160, 240, 162, 185, 255, 205, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [244, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [238, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]]]], Ku = [[[231, 120, 48, 89, 115, 113, 120, 152, 112], [152, 179, 64, 126, 170, 118, 46, 70, 95], [175, 69, 143, 80, 85, 82, 72, 155, 103], [56, 58, 10, 171, 218, 189, 17, 13, 152], [114, 26, 17, 163, 44, 195, 21, 10, 173], [121, 24, 80, 195, 26, 62, 44, 64, 85], [144, 71, 10, 38, 171, 213, 144, 34, 26], [170, 46, 55, 19, 136, 160, 33, 206, 71], [63, 20, 8, 114, 114, 208, 12, 9, 226], [81, 40, 11, 96, 182, 84, 29, 16, 36]], [[134, 183, 89, 137, 98, 101, 106, 165, 148], [72, 187, 100, 130, 157, 111, 32, 75, 80], [66, 102, 167, 99, 74, 62, 40, 234, 128], [41, 53, 9, 178, 241, 141, 26, 8, 107], [74, 43, 26, 146, 73, 166, 49, 23, 157], [65, 38, 105, 160, 51, 52, 31, 115, 128], [104, 79, 12, 27, 217, 255, 87, 17, 7], [87, 68, 71, 44, 114, 51, 15, 186, 23], [47, 41, 14, 110, 182, 183, 21, 17, 194], [66, 45, 25, 102, 197, 189, 23, 18, 22]], [[88, 88, 147, 150, 42, 46, 45, 196, 205], [43, 97, 183, 117, 85, 38, 35, 179, 61], [39, 53, 200, 87, 26, 21, 43, 232, 171], [56, 34, 51, 104, 114, 102, 29, 93, 77], [39, 28, 85, 171, 58, 165, 90, 98, 64], [34, 22, 116, 206, 23, 34, 43, 166, 73], [107, 54, 32, 26, 51, 1, 81, 43, 31], [68, 25, 106, 22, 64, 171, 36, 225, 114], [34, 19, 21, 102, 132, 188, 16, 76, 124], [62, 18, 78, 95, 85, 57, 50, 48, 51]], [[193, 101, 35, 159, 215, 111, 89, 46, 111], [60, 148, 31, 172, 219, 228, 21, 18, 111], [112, 113, 77, 85, 179, 255, 38, 120, 114], [40, 42, 1, 196, 245, 209, 10, 25, 109], [88, 43, 29, 140, 166, 213, 37, 43, 154], [61, 63, 30, 155, 67, 45, 68, 1, 209], [100, 80, 8, 43, 154, 1, 51, 26, 71], [142, 78, 78, 16, 255, 128, 34, 197, 171], [41, 40, 5, 102, 211, 183, 4, 1, 221], [51, 50, 17, 168, 209, 192, 23, 25, 82]], [[138, 31, 36, 171, 27, 166, 38, 44, 229], [67, 87, 58, 169, 82, 115, 26, 59, 179], [63, 59, 90, 180, 59, 166, 93, 73, 154], [40, 40, 21, 116, 143, 209, 34, 39, 175], [47, 15, 16, 183, 34, 223, 49, 45, 183], [46, 17, 33, 183, 6, 98, 15, 32, 183], [57, 46, 22, 24, 128, 1, 54, 17, 37], [65, 32, 73, 115, 28, 128, 23, 128, 205], [40, 3, 9, 115, 51, 192, 18, 6, 223], [87, 37, 9, 115, 59, 77, 64, 21, 47]], [[104, 55, 44, 218, 9, 54, 53, 130, 226], [64, 90, 70, 205, 40, 41, 23, 26, 57], [54, 57, 112, 184, 5, 41, 38, 166, 213], [30, 34, 26, 133, 152, 116, 10, 32, 134], [39, 19, 53, 221, 26, 114, 32, 73, 255], [31, 9, 65, 234, 2, 15, 1, 118, 73], [75, 32, 12, 51, 192, 255, 160, 43, 51], [88, 31, 35, 67, 102, 85, 55, 186, 85], [56, 21, 23, 111, 59, 205, 45, 37, 192], [55, 38, 70, 124, 73, 102, 1, 34, 98]], [[125, 98, 42, 88, 104, 85, 117, 175, 82], [95, 84, 53, 89, 128, 100, 113, 101, 45], [75, 79, 123, 47, 51, 128, 81, 171, 1], [57, 17, 5, 71, 102, 57, 53, 41, 49], [38, 33, 13, 121, 57, 73, 26, 1, 85], [41, 10, 67, 138, 77, 110, 90, 47, 114], [115, 21, 2, 10, 102, 255, 166, 23, 6], [101, 29, 16, 10, 85, 128, 101, 196, 26], [57, 18, 10, 102, 102, 213, 34, 20, 43], [117, 20, 15, 36, 163, 128, 68, 1, 26]], [[102, 61, 71, 37, 34, 53, 31, 243, 192], [69, 60, 71, 38, 73, 119, 28, 222, 37], [68, 45, 128, 34, 1, 47, 11, 245, 171], [62, 17, 19, 70, 146, 85, 55, 62, 70], [37, 43, 37, 154, 100, 163, 85, 160, 1], [63, 9, 92, 136, 28, 64, 32, 201, 85], [75, 15, 9, 9, 64, 255, 184, 119, 16], [86, 6, 28, 5, 64, 255, 25, 248, 1], [56, 8, 17, 132, 137, 255, 55, 116, 128], [58, 15, 20, 82, 135, 57, 26, 121, 40]], [[164, 50, 31, 137, 154, 133, 25, 35, 218], [51, 103, 44, 131, 131, 123, 31, 6, 158], [86, 40, 64, 135, 148, 224, 45, 183, 128], [22, 26, 17, 131, 240, 154, 14, 1, 209], [45, 16, 21, 91, 64, 222, 7, 1, 197], [56, 21, 39, 155, 60, 138, 23, 102, 213], [83, 12, 13, 54, 192, 255, 68, 47, 28], [85, 26, 85, 85, 128, 128, 32, 146, 171], [18, 11, 7, 63, 144, 171, 4, 4, 246], [35, 27, 10, 146, 174, 171, 12, 26, 128]], [[190, 80, 35, 99, 180, 80, 126, 54, 45], [85, 126, 47, 87, 176, 51, 41, 20, 32], [101, 75, 128, 139, 118, 146, 116, 128, 85], [56, 41, 15, 176, 236, 85, 37, 9, 62], [71, 30, 17, 119, 118, 255, 17, 18, 138], [101, 38, 60, 138, 55, 70, 43, 26, 142], [146, 36, 19, 30, 171, 255, 97, 27, 20], [138, 45, 61, 62, 219, 1, 81, 188, 64], [32, 41, 20, 117, 151, 142, 20, 21, 163], [112, 19, 12, 61, 195, 128, 48, 4, 24]]], Zu = [[[[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[176, 246, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 241, 252, 255, 255, 255, 255, 255, 255, 255, 255], [249, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 244, 252, 255, 255, 255, 255, 255, 255, 255, 255], [234, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 246, 254, 255, 255, 255, 255, 255, 255, 255, 255], [239, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 254, 255, 255, 255, 255, 255, 255], [250, 255, 254, 255, 254, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[217, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [225, 252, 241, 253, 255, 255, 254, 255, 255, 255, 255], [234, 250, 241, 250, 253, 255, 253, 254, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [238, 253, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [249, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 255, 255, 255, 255, 255, 255, 255, 255, 255], [247, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [252, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[186, 251, 250, 255, 255, 255, 255, 255, 255, 255, 255], [234, 251, 244, 254, 255, 255, 255, 255, 255, 255, 255], [251, 251, 243, 253, 254, 255, 254, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [236, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 253, 253, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[248, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [250, 254, 252, 254, 255, 255, 255, 255, 255, 255, 255], [248, 254, 249, 253, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [246, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 254, 251, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 252, 255, 255, 255, 255, 255, 255, 255, 255], [248, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [245, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 252, 255, 255, 255, 255, 255, 255, 255, 255, 255], [249, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]]], $u = [0, 1, 2, 3, 6, 4, 5, 6, 6, 6, 6, 6, 6, 6, 6, 7, 0], wr = [], On = [], sr = [], Qu = 1, Os = 2, Ar = [], bn = [];
    st("UpsampleRgbLinePair", re, 3), st("UpsampleBgrLinePair", Le, 3), st("UpsampleRgbaLinePair", kn, 4), st("UpsampleBgraLinePair", Re, 4), st("UpsampleArgbLinePair", Ye, 4), st("UpsampleRgba4444LinePair", Me, 2), st("UpsampleRgb565LinePair", Se, 2);
    var tc = R.UpsampleRgbLinePair, ec = R.UpsampleBgrLinePair, Ms = R.UpsampleRgbaLinePair, Bs = R.UpsampleBgraLinePair, Es = R.UpsampleArgbLinePair, qs = R.UpsampleRgba4444LinePair, nc = R.UpsampleRgb565LinePair, qa = 16, Da = 1 << qa - 1, Qi = -227, Vo = 482, Ds = 6, rc = (256 << Ds) - 1, Rs = 0, ic = o(256), ac = o(256), oc = o(256), sc = o(256), uc = o(Vo - Qi), cc = o(Vo - Qi);
    nr("YuvToRgbRow", re, 3), nr("YuvToBgrRow", Le, 3), nr("YuvToRgbaRow", kn, 4), nr("YuvToBgraRow", Re, 4), nr("YuvToArgbRow", Ye, 4), nr("YuvToRgba4444Row", Me, 2), nr("YuvToRgb565Row", Se, 2);
    var Ts = [0, 4, 8, 12, 128, 132, 136, 140, 256, 260, 264, 268, 384, 388, 392, 396], Ra = [0, 2, 8], lc = [8, 7, 6, 4, 4, 2, 2, 2, 1, 1, 1, 1], hc = 1;
    this.WebPDecodeRGBA = function(t, r, c, p, m) {
      var y = Oa, w = new ai(), L = new An();
      w.ba = L, L.S = y, L.width = [L.width], L.height = [L.height];
      var x = L.width, k = L.height, U = new $n();
      if (U == null || t == null)
        var K = 2;
      else
        e(U != null), K = si(t, r, c, U.width, U.height, U.Pd, U.Qd, U.format, null);
      if (K != 0 ? x = 0 : (x != null && (x[0] = U.width[0]), k != null && (k[0] = U.height[0]), x = 1), x) {
        L.width = L.width[0], L.height = L.height[0], p != null && (p[0] = L.width), m != null && (m[0] = L.height);
        t: {
          if (p = new $r(), (m = new Ri()).data = t, m.w = r, m.ha = c, m.kd = 1, r = [0], e(m != null), ((t = si(m.data, m.w, m.ha, null, null, null, r, null, m)) == 0 || t == 7) && r[0] && (t = 4), (r = t) == 0) {
            if (e(w != null), p.data = m.data, p.w = m.w + m.offset, p.ha = m.ha - m.offset, p.put = Tn, p.ac = He, p.bc = zn, p.ma = w, m.xa) {
              if ((t = dn()) == null) {
                w = 1;
                break t;
              }
              if (function(Z, G) {
                var vt = [0], it = [0], H = [0];
                e:
                  for (; ; ) {
                    if (Z == null)
                      return 0;
                    if (G == null)
                      return Z.a = 2, 0;
                    if (Z.l = G, Z.a = 0, $(Z.m, G.data, G.w, G.ha), !Tt(Z.m, vt, it, H)) {
                      Z.a = 3;
                      break e;
                    }
                    if (Z.xb = Os, G.width = vt[0], G.height = it[0], !Wn(vt[0], it[0], 1, Z, null))
                      break e;
                    return 1;
                  }
                return e(Z.a != 0), 0;
              }(t, p)) {
                if (p = (r = ui(p.width, p.height, w.Oa, w.ba)) == 0) {
                  e: {
                    p = t;
                    n:
                      for (; ; ) {
                        if (p == null) {
                          p = 0;
                          break e;
                        }
                        if (e(p.s.yc != null), e(p.s.Ya != null), e(0 < p.s.Wb), e((c = p.l) != null), e((m = c.ma) != null), p.xb != 0) {
                          if (p.ca = m.ba, p.tb = m.tb, e(p.ca != null), !Vi(m.Oa, c, Ma)) {
                            p.a = 2;
                            break n;
                          }
                          if (!Mr(p, c.width) || c.da)
                            break n;
                          if ((c.da || ue(p.ca.S)) && J(), 11 > p.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), p.ca.f.kb.F != null && J()), p.Pb && 0 < p.s.ua && p.s.vb.X == null && !Ut(p.s.vb, p.s.Wa.Xa)) {
                            p.a = 1;
                            break n;
                          }
                          p.xb = 0;
                        }
                        if (!Sn(p, p.V, p.Ba, p.c, p.i, c.o, Gr))
                          break n;
                        m.Dc = p.Ma, p = 1;
                        break e;
                      }
                    e(p.a != 0), p = 0;
                  }
                  p = !p;
                }
                p && (r = t.a);
              } else
                r = t.a;
            } else {
              if ((t = new mo()) == null) {
                w = 1;
                break t;
              }
              if (t.Fa = m.na, t.P = m.P, t.qc = m.Sa, pa(t, p)) {
                if ((r = ui(p.width, p.height, w.Oa, w.ba)) == 0) {
                  if (t.Aa = 0, c = w.Oa, e((m = t) != null), c != null) {
                    if (0 < (x = 0 > (x = c.Md) ? 0 : 100 < x ? 255 : 255 * x / 100)) {
                      for (k = U = 0; 4 > k; ++k)
                        12 > (K = m.pb[k]).lc && (K.ia = x * lc[0 > K.lc ? 0 : K.lc] >> 3), U |= K.ia;
                      U && (alert("todo:VP8InitRandom"), m.ia = 1);
                    }
                    m.Ga = c.Id, 100 < m.Ga ? m.Ga = 100 : 0 > m.Ga && (m.Ga = 0);
                  }
                  vo(t, p) || (r = t.a);
                }
              } else
                r = t.a;
            }
            r == 0 && w.Oa != null && w.Oa.fd && (r = Gi(w.ba));
          }
          w = r;
        }
        y = w != 0 ? null : 11 > y ? L.f.RGBA.eb : L.f.kb.y;
      } else
        y = null;
      return y;
    };
    var zs = [3, 4, 3, 4, 4, 2, 2, 4, 4, 4, 2, 1, 1];
  };
  function g(R, gt) {
    for (var pt = "", F = 0; F < 4; F++)
      pt += String.fromCharCode(R[gt++]);
    return pt;
  }
  function b(R, gt) {
    return (R[gt + 0] << 0 | R[gt + 1] << 8 | R[gt + 2] << 16) >>> 0;
  }
  function N(R, gt) {
    return (R[gt + 0] << 0 | R[gt + 1] << 8 | R[gt + 2] << 16 | R[gt + 3] << 24) >>> 0;
  }
  new f();
  var S = [0], d = [0], O = [], I = new f(), q = i, _ = function(R, gt) {
    var pt = {}, F = 0, P = !1, z = 0, D = 0;
    if (pt.frames = [], !/** @license
       * Copyright (c) 2017 Dominik Homberger
      Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
      The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
      https://webpjs.appspot.com
      WebPRiffParser dominikhlbg@gmail.com
      */
    function(j, B, W, Y) {
      for (var Q = 0; Q < Y; Q++)
        if (j[B + Q] != W.charCodeAt(Q))
          return !0;
      return !1;
    }(R, gt, "RIFF", 4)) {
      var at, nt;
      for (N(R, gt += 4), gt += 8; gt < R.length; ) {
        var lt = g(R, gt), $ = N(R, gt += 4);
        gt += 4;
        var ft = $ + (1 & $);
        switch (lt) {
          case "VP8 ":
          case "VP8L":
            pt.frames[F] === void 0 && (pt.frames[F] = {}), (A = pt.frames[F]).src_off = P ? D : gt - 8, A.src_size = z + $ + 8, F++, P && (P = !1, z = 0, D = 0);
            break;
          case "VP8X":
            (A = pt.header = {}).feature_flags = R[gt];
            var ht = gt + 4;
            A.canvas_width = 1 + b(R, ht), ht += 3, A.canvas_height = 1 + b(R, ht), ht += 3;
            break;
          case "ALPH":
            P = !0, z = ft + 8, D = gt - 8;
            break;
          case "ANIM":
            (A = pt.header).bgcolor = N(R, gt), ht = gt + 4, A.loop_count = (at = R)[(nt = ht) + 0] << 0 | at[nt + 1] << 8, ht += 2;
            break;
          case "ANMF":
            var kt, A;
            (A = pt.frames[F] = {}).offset_x = 2 * b(R, gt), gt += 3, A.offset_y = 2 * b(R, gt), gt += 3, A.width = 1 + b(R, gt), gt += 3, A.height = 1 + b(R, gt), gt += 3, A.duration = b(R, gt), gt += 3, kt = R[gt++], A.dispose = 1 & kt, A.blend = kt >> 1 & 1;
        }
        lt != "ANMF" && (gt += ft);
      }
      return pt;
    }
  }(q, 0);
  _.response = q, _.rgbaoutput = !0, _.dataurl = !1;
  var M = _.header ? _.header : null, X = _.frames ? _.frames : null;
  if (M) {
    M.loop_counter = M.loop_count, S = [M.canvas_height], d = [M.canvas_width];
    for (var ot = 0; ot < X.length && X[ot].blend != 0; ot++)
      ;
  }
  var ct = X[0], yt = I.WebPDecodeRGBA(q, ct.src_off, ct.src_size, d, S);
  ct.rgba = yt, ct.imgwidth = d[0], ct.imgheight = S[0];
  for (var tt = 0; tt < d[0] * S[0] * 4; tt++)
    O[tt] = yt[tt];
  return this.width = d, this.height = S, this.data = O, this;
}
(function(i) {
  var e = function() {
    return typeof ds == "function";
  }, n = function(S, d, O, I) {
    var q = 4, _ = l;
    switch (I) {
      case i.image_compression.FAST:
        q = 1, _ = o;
        break;
      case i.image_compression.MEDIUM:
        q = 6, _ = h;
        break;
      case i.image_compression.SLOW:
        q = 9, _ = f;
    }
    S = a(S, d, O, _);
    var M = ds(S, { level: q });
    return i.__addimage__.arrayBufferToBinaryString(M);
  }, a = function(S, d, O, I) {
    for (var q, _, M, X = S.length / d, ot = new Uint8Array(S.length + X), ct = b(), yt = 0; yt < X; yt += 1) {
      if (M = yt * d, q = S.subarray(M, M + d), I)
        ot.set(I(q, O, _), M + yt);
      else {
        for (var tt, R = ct.length, gt = []; tt < R; tt += 1)
          gt[tt] = ct[tt](q, O, _);
        var pt = N(gt.concat());
        ot.set(gt[pt], M + yt);
      }
      _ = q;
    }
    return ot;
  }, u = function(S) {
    var d = Array.apply([], S);
    return d.unshift(0), d;
  }, o = function(S, d) {
    var O, I = [], q = S.length;
    I[0] = 1;
    for (var _ = 0; _ < q; _ += 1)
      O = S[_ - d] || 0, I[_ + 1] = S[_] - O + 256 & 255;
    return I;
  }, l = function(S, d, O) {
    var I, q = [], _ = S.length;
    q[0] = 2;
    for (var M = 0; M < _; M += 1)
      I = O && O[M] || 0, q[M + 1] = S[M] - I + 256 & 255;
    return q;
  }, h = function(S, d, O) {
    var I, q, _ = [], M = S.length;
    _[0] = 3;
    for (var X = 0; X < M; X += 1)
      I = S[X - d] || 0, q = O && O[X] || 0, _[X + 1] = S[X] + 256 - (I + q >>> 1) & 255;
    return _;
  }, f = function(S, d, O) {
    var I, q, _, M, X = [], ot = S.length;
    X[0] = 4;
    for (var ct = 0; ct < ot; ct += 1)
      I = S[ct - d] || 0, q = O && O[ct] || 0, _ = O && O[ct - d] || 0, M = g(I, q, _), X[ct + 1] = S[ct] - M + 256 & 255;
    return X;
  }, g = function(S, d, O) {
    if (S === d && d === O)
      return S;
    var I = Math.abs(d - O), q = Math.abs(S - O), _ = Math.abs(S + d - O - O);
    return I <= q && I <= _ ? S : q <= _ ? d : O;
  }, b = function() {
    return [u, o, l, h, f];
  }, N = function(S) {
    var d = S.map(function(O) {
      return O.reduce(function(I, q) {
        return I + Math.abs(q);
      }, 0);
    });
    return d.indexOf(Math.min.apply(null, d));
  };
  i.processPNG = function(S, d, O, I) {
    var q, _, M, X, ot, ct, yt, tt, R, gt, pt, F, P, z, D, at = this.decode.FLATE_DECODE, nt = "";
    if (this.__addimage__.isArrayBuffer(S) && (S = new Uint8Array(S)), this.__addimage__.isArrayBufferView(S)) {
      if (S = (M = new rl(S)).imgData, _ = M.bits, q = M.colorSpace, ot = M.colors, [4, 6].indexOf(M.colorType) !== -1) {
        if (M.bits === 8) {
          R = (tt = M.pixelBitlength == 32 ? new Uint32Array(M.decodePixels().buffer) : M.pixelBitlength == 16 ? new Uint16Array(M.decodePixels().buffer) : new Uint8Array(M.decodePixels().buffer)).length, pt = new Uint8Array(R * M.colors), gt = new Uint8Array(R);
          var lt, $ = M.pixelBitlength - M.bits;
          for (z = 0, D = 0; z < R; z++) {
            for (P = tt[z], lt = 0; lt < $; )
              pt[D++] = P >>> lt & 255, lt += M.bits;
            gt[z] = P >>> lt & 255;
          }
        }
        if (M.bits === 16) {
          R = (tt = new Uint32Array(M.decodePixels().buffer)).length, pt = new Uint8Array(R * (32 / M.pixelBitlength) * M.colors), gt = new Uint8Array(R * (32 / M.pixelBitlength)), F = M.colors > 1, z = 0, D = 0;
          for (var ft = 0; z < R; )
            P = tt[z++], pt[D++] = P >>> 0 & 255, F && (pt[D++] = P >>> 16 & 255, P = tt[z++], pt[D++] = P >>> 0 & 255), gt[ft++] = P >>> 16 & 255;
          _ = 8;
        }
        I !== i.image_compression.NONE && e() ? (S = n(pt, M.width * M.colors, M.colors, I), yt = n(gt, M.width, 1, I)) : (S = pt, yt = gt, at = void 0);
      }
      if (M.colorType === 3 && (q = this.color_spaces.INDEXED, ct = M.palette, M.transparency.indexed)) {
        var ht = M.transparency.indexed, kt = 0;
        for (z = 0, R = ht.length; z < R; ++z)
          kt += ht[z];
        if ((kt /= 255) === R - 1 && ht.indexOf(0) !== -1)
          X = [ht.indexOf(0)];
        else if (kt !== R) {
          for (tt = M.decodePixels(), gt = new Uint8Array(tt.length), z = 0, R = tt.length; z < R; z++)
            gt[z] = ht[tt[z]];
          yt = n(gt, M.width, 1);
        }
      }
      var A = function(j) {
        var B;
        switch (j) {
          case i.image_compression.FAST:
            B = 11;
            break;
          case i.image_compression.MEDIUM:
            B = 13;
            break;
          case i.image_compression.SLOW:
            B = 14;
            break;
          default:
            B = 12;
        }
        return B;
      }(I);
      return at === this.decode.FLATE_DECODE && (nt = "/Predictor " + A + " "), nt += "/Colors " + ot + " /BitsPerComponent " + _ + " /Columns " + M.width, (this.__addimage__.isArrayBuffer(S) || this.__addimage__.isArrayBufferView(S)) && (S = this.__addimage__.arrayBufferToBinaryString(S)), (yt && this.__addimage__.isArrayBuffer(yt) || this.__addimage__.isArrayBufferView(yt)) && (yt = this.__addimage__.arrayBufferToBinaryString(yt)), { alias: O, data: S, index: d, filter: at, decodeParameters: nt, transparency: X, palette: ct, sMask: yt, predictor: A, width: M.width, height: M.height, bitsPerComponent: _, colorSpace: q };
    }
  };
})(zt.API), function(i) {
  i.processGIF89A = function(e, n, a, u) {
    var o = new il(e), l = o.width, h = o.height, f = [];
    o.decodeAndBlitFrameRGBA(0, f);
    var g = { data: f, width: l, height: h }, b = new cs(100).encode(g, 100);
    return i.processJPEG.call(this, b, n, a, u);
  }, i.processGIF87A = i.processGIF89A;
}(zt.API), En.prototype.parseHeader = function() {
  if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.bitPP === 16 && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
    var i = this.colors === 0 ? 1 << this.bitPP : this.colors;
    this.palette = new Array(i);
    for (var e = 0; e < i; e++) {
      var n = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), u = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0);
      this.palette[e] = { red: u, green: a, blue: n, quad: o };
    }
  }
  this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, En.prototype.parseBGR = function() {
  this.pos = this.offset;
  try {
    var i = "bit" + this.bitPP, e = this.width * this.height * 4;
    this.data = new Uint8Array(e), this[i]();
  } catch (n) {
    ve.log("bit decode error:" + n);
  }
}, En.prototype.bit1 = function() {
  var i, e = Math.ceil(this.width / 8), n = e % 4;
  for (i = this.height - 1; i >= 0; i--) {
    for (var a = this.bottom_up ? i : this.height - 1 - i, u = 0; u < e; u++)
      for (var o = this.datav.getUint8(this.pos++, !0), l = a * this.width * 4 + 8 * u * 4, h = 0; h < 8 && 8 * u + h < this.width; h++) {
        var f = this.palette[o >> 7 - h & 1];
        this.data[l + 4 * h] = f.blue, this.data[l + 4 * h + 1] = f.green, this.data[l + 4 * h + 2] = f.red, this.data[l + 4 * h + 3] = 255;
      }
    n !== 0 && (this.pos += 4 - n);
  }
}, En.prototype.bit4 = function() {
  for (var i = Math.ceil(this.width / 2), e = i % 4, n = this.height - 1; n >= 0; n--) {
    for (var a = this.bottom_up ? n : this.height - 1 - n, u = 0; u < i; u++) {
      var o = this.datav.getUint8(this.pos++, !0), l = a * this.width * 4 + 2 * u * 4, h = o >> 4, f = 15 & o, g = this.palette[h];
      if (this.data[l] = g.blue, this.data[l + 1] = g.green, this.data[l + 2] = g.red, this.data[l + 3] = 255, 2 * u + 1 >= this.width)
        break;
      g = this.palette[f], this.data[l + 4] = g.blue, this.data[l + 4 + 1] = g.green, this.data[l + 4 + 2] = g.red, this.data[l + 4 + 3] = 255;
    }
    e !== 0 && (this.pos += 4 - e);
  }
}, En.prototype.bit8 = function() {
  for (var i = this.width % 4, e = this.height - 1; e >= 0; e--) {
    for (var n = this.bottom_up ? e : this.height - 1 - e, a = 0; a < this.width; a++) {
      var u = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 4 * a;
      if (u < this.palette.length) {
        var l = this.palette[u];
        this.data[o] = l.red, this.data[o + 1] = l.green, this.data[o + 2] = l.blue, this.data[o + 3] = 255;
      } else
        this.data[o] = 255, this.data[o + 1] = 255, this.data[o + 2] = 255, this.data[o + 3] = 255;
    }
    i !== 0 && (this.pos += 4 - i);
  }
}, En.prototype.bit15 = function() {
  for (var i = this.width % 3, e = parseInt("11111", 2), n = this.height - 1; n >= 0; n--) {
    for (var a = this.bottom_up ? n : this.height - 1 - n, u = 0; u < this.width; u++) {
      var o = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var l = (o & e) / e * 255 | 0, h = (o >> 5 & e) / e * 255 | 0, f = (o >> 10 & e) / e * 255 | 0, g = o >> 15 ? 255 : 0, b = a * this.width * 4 + 4 * u;
      this.data[b] = f, this.data[b + 1] = h, this.data[b + 2] = l, this.data[b + 3] = g;
    }
    this.pos += i;
  }
}, En.prototype.bit16 = function() {
  for (var i = this.width % 3, e = parseInt("11111", 2), n = parseInt("111111", 2), a = this.height - 1; a >= 0; a--) {
    for (var u = this.bottom_up ? a : this.height - 1 - a, o = 0; o < this.width; o++) {
      var l = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var h = (l & e) / e * 255 | 0, f = (l >> 5 & n) / n * 255 | 0, g = (l >> 11) / e * 255 | 0, b = u * this.width * 4 + 4 * o;
      this.data[b] = g, this.data[b + 1] = f, this.data[b + 2] = h, this.data[b + 3] = 255;
    }
    this.pos += i;
  }
}, En.prototype.bit24 = function() {
  for (var i = this.height - 1; i >= 0; i--) {
    for (var e = this.bottom_up ? i : this.height - 1 - i, n = 0; n < this.width; n++) {
      var a = this.datav.getUint8(this.pos++, !0), u = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), l = e * this.width * 4 + 4 * n;
      this.data[l] = o, this.data[l + 1] = u, this.data[l + 2] = a, this.data[l + 3] = 255;
    }
    this.pos += this.width % 4;
  }
}, En.prototype.bit32 = function() {
  for (var i = this.height - 1; i >= 0; i--)
    for (var e = this.bottom_up ? i : this.height - 1 - i, n = 0; n < this.width; n++) {
      var a = this.datav.getUint8(this.pos++, !0), u = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), l = this.datav.getUint8(this.pos++, !0), h = e * this.width * 4 + 4 * n;
      this.data[h] = o, this.data[h + 1] = u, this.data[h + 2] = a, this.data[h + 3] = l;
    }
}, En.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(i) {
  i.processBMP = function(e, n, a, u) {
    var o = new En(e, !1), l = o.width, h = o.height, f = { data: o.getData(), width: l, height: h }, g = new cs(100).encode(f, 100);
    return i.processJPEG.call(this, g, n, a, u);
  };
}(zt.API), Au.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(i) {
  i.processWEBP = function(e, n, a, u) {
    var o = new Au(e, !1), l = o.width, h = o.height, f = { data: o.getData(), width: l, height: h }, g = new cs(100).encode(f, 100);
    return i.processJPEG.call(this, g, n, a, u);
  };
}(zt.API), zt.API.processRGBA = function(i, e, n) {
  for (var a = i.data, u = a.length, o = new Uint8Array(u / 4 * 3), l = new Uint8Array(u / 4), h = 0, f = 0, g = 0; g < u; g += 4) {
    var b = a[g], N = a[g + 1], S = a[g + 2], d = a[g + 3];
    o[h++] = b, o[h++] = N, o[h++] = S, l[f++] = d;
  }
  var O = this.__addimage__.arrayBufferToBinaryString(o);
  return { alpha: this.__addimage__.arrayBufferToBinaryString(l), data: O, index: e, alias: n, colorSpace: "DeviceRGB", bitsPerComponent: 8, width: i.width, height: i.height };
}, zt.API.setLanguage = function(i) {
  return this.internal.languageSettings === void 0 && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), { af: "Afrikaans", sq: "Albanian", ar: "Arabic (Standard)", "ar-DZ": "Arabic (Algeria)", "ar-BH": "Arabic (Bahrain)", "ar-EG": "Arabic (Egypt)", "ar-IQ": "Arabic (Iraq)", "ar-JO": "Arabic (Jordan)", "ar-KW": "Arabic (Kuwait)", "ar-LB": "Arabic (Lebanon)", "ar-LY": "Arabic (Libya)", "ar-MA": "Arabic (Morocco)", "ar-OM": "Arabic (Oman)", "ar-QA": "Arabic (Qatar)", "ar-SA": "Arabic (Saudi Arabia)", "ar-SY": "Arabic (Syria)", "ar-TN": "Arabic (Tunisia)", "ar-AE": "Arabic (U.A.E.)", "ar-YE": "Arabic (Yemen)", an: "Aragonese", hy: "Armenian", as: "Assamese", ast: "Asturian", az: "Azerbaijani", eu: "Basque", be: "Belarusian", bn: "Bengali", bs: "Bosnian", br: "Breton", bg: "Bulgarian", my: "Burmese", ca: "Catalan", ch: "Chamorro", ce: "Chechen", zh: "Chinese", "zh-HK": "Chinese (Hong Kong)", "zh-CN": "Chinese (PRC)", "zh-SG": "Chinese (Singapore)", "zh-TW": "Chinese (Taiwan)", cv: "Chuvash", co: "Corsican", cr: "Cree", hr: "Croatian", cs: "Czech", da: "Danish", nl: "Dutch (Standard)", "nl-BE": "Dutch (Belgian)", en: "English", "en-AU": "English (Australia)", "en-BZ": "English (Belize)", "en-CA": "English (Canada)", "en-IE": "English (Ireland)", "en-JM": "English (Jamaica)", "en-NZ": "English (New Zealand)", "en-PH": "English (Philippines)", "en-ZA": "English (South Africa)", "en-TT": "English (Trinidad & Tobago)", "en-GB": "English (United Kingdom)", "en-US": "English (United States)", "en-ZW": "English (Zimbabwe)", eo: "Esperanto", et: "Estonian", fo: "Faeroese", fj: "Fijian", fi: "Finnish", fr: "French (Standard)", "fr-BE": "French (Belgium)", "fr-CA": "French (Canada)", "fr-FR": "French (France)", "fr-LU": "French (Luxembourg)", "fr-MC": "French (Monaco)", "fr-CH": "French (Switzerland)", fy: "Frisian", fur: "Friulian", gd: "Gaelic (Scots)", "gd-IE": "Gaelic (Irish)", gl: "Galacian", ka: "Georgian", de: "German (Standard)", "de-AT": "German (Austria)", "de-DE": "German (Germany)", "de-LI": "German (Liechtenstein)", "de-LU": "German (Luxembourg)", "de-CH": "German (Switzerland)", el: "Greek", gu: "Gujurati", ht: "Haitian", he: "Hebrew", hi: "Hindi", hu: "Hungarian", is: "Icelandic", id: "Indonesian", iu: "Inuktitut", ga: "Irish", it: "Italian (Standard)", "it-CH": "Italian (Switzerland)", ja: "Japanese", kn: "Kannada", ks: "Kashmiri", kk: "Kazakh", km: "Khmer", ky: "Kirghiz", tlh: "Klingon", ko: "Korean", "ko-KP": "Korean (North Korea)", "ko-KR": "Korean (South Korea)", la: "Latin", lv: "Latvian", lt: "Lithuanian", lb: "Luxembourgish", mk: "North Macedonia", ms: "Malay", ml: "Malayalam", mt: "Maltese", mi: "Maori", mr: "Marathi", mo: "Moldavian", nv: "Navajo", ng: "Ndonga", ne: "Nepali", no: "Norwegian", nb: "Norwegian (Bokmal)", nn: "Norwegian (Nynorsk)", oc: "Occitan", or: "Oriya", om: "Oromo", fa: "Persian", "fa-IR": "Persian/Iran", pl: "Polish", pt: "Portuguese", "pt-BR": "Portuguese (Brazil)", pa: "Punjabi", "pa-IN": "Punjabi (India)", "pa-PK": "Punjabi (Pakistan)", qu: "Quechua", rm: "Rhaeto-Romanic", ro: "Romanian", "ro-MO": "Romanian (Moldavia)", ru: "Russian", "ru-MO": "Russian (Moldavia)", sz: "Sami (Lappish)", sg: "Sango", sa: "Sanskrit", sc: "Sardinian", sd: "Sindhi", si: "Singhalese", sr: "Serbian", sk: "Slovak", sl: "Slovenian", so: "Somani", sb: "Sorbian", es: "Spanish", "es-AR": "Spanish (Argentina)", "es-BO": "Spanish (Bolivia)", "es-CL": "Spanish (Chile)", "es-CO": "Spanish (Colombia)", "es-CR": "Spanish (Costa Rica)", "es-DO": "Spanish (Dominican Republic)", "es-EC": "Spanish (Ecuador)", "es-SV": "Spanish (El Salvador)", "es-GT": "Spanish (Guatemala)", "es-HN": "Spanish (Honduras)", "es-MX": "Spanish (Mexico)", "es-NI": "Spanish (Nicaragua)", "es-PA": "Spanish (Panama)", "es-PY": "Spanish (Paraguay)", "es-PE": "Spanish (Peru)", "es-PR": "Spanish (Puerto Rico)", "es-ES": "Spanish (Spain)", "es-UY": "Spanish (Uruguay)", "es-VE": "Spanish (Venezuela)", sx: "Sutu", sw: "Swahili", sv: "Swedish", "sv-FI": "Swedish (Finland)", "sv-SV": "Swedish (Sweden)", ta: "Tamil", tt: "Tatar", te: "Teluga", th: "Thai", tig: "Tigre", ts: "Tsonga", tn: "Tswana", tr: "Turkish", tk: "Turkmen", uk: "Ukrainian", hsb: "Upper Sorbian", ur: "Urdu", ve: "Venda", vi: "Vietnamese", vo: "Volapuk", wa: "Walloon", cy: "Welsh", xh: "Xhosa", ji: "Yiddish", zu: "Zulu" }[i] !== void 0 && (this.internal.languageSettings.languageCode = i, this.internal.languageSettings.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
  }), this.internal.languageSettings.isSubscribed = !0)), this;
}, Ai = zt.API, Qa = Ai.getCharWidthsArray = function(i, e) {
  var n, a, u = (e = e || {}).font || this.internal.getFont(), o = e.fontSize || this.internal.getFontSize(), l = e.charSpace || this.internal.getCharSpace(), h = e.widths ? e.widths : u.metadata.Unicode.widths, f = h.fof ? h.fof : 1, g = e.kerning ? e.kerning : u.metadata.Unicode.kerning, b = g.fof ? g.fof : 1, N = e.doKerning !== !1, S = 0, d = i.length, O = 0, I = h[0] || f, q = [];
  for (n = 0; n < d; n++)
    a = i.charCodeAt(n), typeof u.metadata.widthOfString == "function" ? q.push((u.metadata.widthOfGlyph(u.metadata.characterToGlyph(a)) + l * (1e3 / o) || 0) / 1e3) : (S = N && fe(g[a]) === "object" && !isNaN(parseInt(g[a][O], 10)) ? g[a][O] / b : 0, q.push((h[a] || I) / f + S)), O = a;
  return q;
}, vu = Ai.getStringUnitWidth = function(i, e) {
  var n = (e = e || {}).fontSize || this.internal.getFontSize(), a = e.font || this.internal.getFont(), u = e.charSpace || this.internal.getCharSpace();
  return Ai.processArabic && (i = Ai.processArabic(i)), typeof a.metadata.widthOfString == "function" ? a.metadata.widthOfString(i, n, u) / n : Qa.apply(this, arguments).reduce(function(o, l) {
    return o + l;
  }, 0);
}, bu = function(i, e, n, a) {
  for (var u = [], o = 0, l = i.length, h = 0; o !== l && h + e[o] < n; )
    h += e[o], o++;
  u.push(i.slice(0, o));
  var f = o;
  for (h = 0; o !== l; )
    h + e[o] > a && (u.push(i.slice(f, o)), h = 0, f = o), h += e[o], o++;
  return f !== o && u.push(i.slice(f, o)), u;
}, yu = function(i, e, n) {
  n || (n = {});
  var a, u, o, l, h, f, g, b = [], N = [b], S = n.textIndent || 0, d = 0, O = 0, I = i.split(" "), q = Qa.apply(this, [" ", n])[0];
  if (f = n.lineIndent === -1 ? I[0].length + 2 : n.lineIndent || 0) {
    var _ = Array(f).join(" "), M = [];
    I.map(function(ot) {
      (ot = ot.split(/\s*\n/)).length > 1 ? M = M.concat(ot.map(function(ct, yt) {
        return (yt && ct.length ? `
` : "") + ct;
      })) : M.push(ot[0]);
    }), I = M, f = vu.apply(this, [_, n]);
  }
  for (o = 0, l = I.length; o < l; o++) {
    var X = 0;
    if (a = I[o], f && a[0] == `
` && (a = a.substr(1), X = 1), S + d + (O = (u = Qa.apply(this, [a, n])).reduce(function(ot, ct) {
      return ot + ct;
    }, 0)) > e || X) {
      if (O > e) {
        for (h = bu.apply(this, [a, u, e - (S + d), e]), b.push(h.shift()), b = [h.pop()]; h.length; )
          N.push([h.shift()]);
        O = u.slice(a.length - (b[0] ? b[0].length : 0)).reduce(function(ot, ct) {
          return ot + ct;
        }, 0);
      } else
        b = [a];
      N.push(b), S = O + f, d = q;
    } else
      b.push(a), S += d + O, d = q;
  }
  return g = f ? function(ot, ct) {
    return (ct ? _ : "") + ot.join(" ");
  } : function(ot) {
    return ot.join(" ");
  }, N.map(g);
}, Ai.splitTextToSize = function(i, e, n) {
  var a, u = (n = n || {}).fontSize || this.internal.getFontSize(), o = (function(b) {
    if (b.widths && b.kerning)
      return { widths: b.widths, kerning: b.kerning };
    var N = this.internal.getFont(b.fontName, b.fontStyle);
    return N.metadata.Unicode ? { widths: N.metadata.Unicode.widths || { 0: 1 }, kerning: N.metadata.Unicode.kerning || {} } : { font: N.metadata, fontSize: this.internal.getFontSize(), charSpace: this.internal.getCharSpace() };
  }).call(this, n);
  a = Array.isArray(i) ? i : String(i).split(/\r?\n/);
  var l = 1 * this.internal.scaleFactor * e / u;
  o.textIndent = n.textIndent ? 1 * n.textIndent * this.internal.scaleFactor / u : 0, o.lineIndent = n.lineIndent;
  var h, f, g = [];
  for (h = 0, f = a.length; h < f; h++)
    g = g.concat(yu.apply(this, [a[h], l, o]));
  return g;
}, function(i) {
  i.__fontmetrics__ = i.__fontmetrics__ || {};
  for (var e = "klmnopqrstuvwxyz", n = {}, a = {}, u = 0; u < e.length; u++)
    n[e[u]] = "0123456789abcdef"[u], a["0123456789abcdef"[u]] = e[u];
  var o = function(N) {
    return "0x" + parseInt(N, 10).toString(16);
  }, l = i.__fontmetrics__.compress = function(N) {
    var S, d, O, I, q = ["{"];
    for (var _ in N) {
      if (S = N[_], isNaN(parseInt(_, 10)) ? d = "'" + _ + "'" : (_ = parseInt(_, 10), d = (d = o(_).slice(2)).slice(0, -1) + a[d.slice(-1)]), typeof S == "number")
        S < 0 ? (O = o(S).slice(3), I = "-") : (O = o(S).slice(2), I = ""), O = I + O.slice(0, -1) + a[O.slice(-1)];
      else {
        if (fe(S) !== "object")
          throw new Error("Don't know what to do with value type " + fe(S) + ".");
        O = l(S);
      }
      q.push(d + O);
    }
    return q.push("}"), q.join("");
  }, h = i.__fontmetrics__.uncompress = function(N) {
    if (typeof N != "string")
      throw new Error("Invalid argument passed to uncompress.");
    for (var S, d, O, I, q = {}, _ = 1, M = q, X = [], ot = "", ct = "", yt = N.length - 1, tt = 1; tt < yt; tt += 1)
      (I = N[tt]) == "'" ? S ? (O = S.join(""), S = void 0) : S = [] : S ? S.push(I) : I == "{" ? (X.push([M, O]), M = {}, O = void 0) : I == "}" ? ((d = X.pop())[0][d[1]] = M, O = void 0, M = d[0]) : I == "-" ? _ = -1 : O === void 0 ? n.hasOwnProperty(I) ? (ot += n[I], O = parseInt(ot, 16) * _, _ = 1, ot = "") : ot += I : n.hasOwnProperty(I) ? (ct += n[I], M[O] = parseInt(ct, 16) * _, _ = 1, O = void 0, ct = "") : ct += I;
    return q;
  }, f = { codePages: ["WinAnsiEncoding"], WinAnsiEncoding: h("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}") }, g = { Unicode: { Courier: f, "Courier-Bold": f, "Courier-BoldOblique": f, "Courier-Oblique": f, Helvetica: f, "Helvetica-Bold": f, "Helvetica-BoldOblique": f, "Helvetica-Oblique": f, "Times-Roman": f, "Times-Bold": f, "Times-BoldItalic": f, "Times-Italic": f } }, b = { Unicode: { "Courier-Oblique": h("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-BoldItalic": h("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"), "Helvetica-Bold": h("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), Courier: h("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-BoldOblique": h("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Bold": h("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"), Symbol: h("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"), Helvetica: h("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"), "Helvetica-BoldOblique": h("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), ZapfDingbats: h("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-Bold": h("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Italic": h("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"), "Times-Roman": h("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"), "Helvetica-Oblique": h("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}") } };
  i.events.push(["addFont", function(N) {
    var S = N.font, d = b.Unicode[S.postScriptName];
    d && (S.metadata.Unicode = {}, S.metadata.Unicode.widths = d.widths, S.metadata.Unicode.kerning = d.kerning);
    var O = g.Unicode[S.postScriptName];
    O && (S.metadata.Unicode.encoding = O, S.encoding = O.codePages[0]);
  }]);
}(zt.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(i) {
  var e = function(n) {
    for (var a = n.length, u = new Uint8Array(a), o = 0; o < a; o++)
      u[o] = n.charCodeAt(o);
    return u;
  };
  i.API.events.push(["addFont", function(n) {
    var a = void 0, u = n.font, o = n.instance;
    if (!u.isStandardFont) {
      if (o === void 0)
        throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + u.postScriptName + "').");
      if (typeof (a = o.existsFileInVFS(u.postScriptName) === !1 ? o.loadFile(u.postScriptName) : o.getFileFromVFS(u.postScriptName)) != "string")
        throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + u.postScriptName + "').");
      (function(l, h) {
        h = /^\x00\x01\x00\x00/.test(h) ? e(h) : e(oa(h)), l.metadata = i.API.TTFFont.open(h), l.metadata.Unicode = l.metadata.Unicode || { encoding: {}, kerning: {}, widths: [] }, l.metadata.glyIdsUsed = [0];
      })(u, a);
    }
  }]);
}(zt), /** @license
 * Copyright (c) 2012 Willow Systems Corporation, https://github.com/willowsystems
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(i) {
  function e() {
    return (Ht.canvg ? Promise.resolve(Ht.canvg) : import("./index.es-BcIsAgCR.mjs")).catch(function(n) {
      return Promise.reject(new Error("Could not load canvg: " + n));
    }).then(function(n) {
      return n.default ? n.default : n;
    });
  }
  zt.API.addSvgAsImage = function(n, a, u, o, l, h, f, g) {
    if (isNaN(a) || isNaN(u))
      throw ve.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
    if (isNaN(o) || isNaN(l))
      throw ve.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
    var b = document.createElement("canvas");
    b.width = o, b.height = l;
    var N = b.getContext("2d");
    N.fillStyle = "#fff", N.fillRect(0, 0, b.width, b.height);
    var S = { ignoreMouse: !0, ignoreAnimation: !0, ignoreDimensions: !0 }, d = this;
    return e().then(function(O) {
      return O.fromString(N, n, S);
    }, function() {
      return Promise.reject(new Error("Could not load canvg."));
    }).then(function(O) {
      return O.render(S);
    }).then(function() {
      d.addImage(b.toDataURL("image/jpeg", 1), a, u, o, l, f, g);
    });
  };
}(), zt.API.putTotalPages = function(i) {
  var e, n = 0;
  parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(i, "g"), n = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(i, this.internal.getFont()), "g"), n = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
  for (var a = 1; a <= this.internal.getNumberOfPages(); a++)
    for (var u = 0; u < this.internal.pages[a].length; u++)
      this.internal.pages[a][u] = this.internal.pages[a][u].replace(e, n);
  return this;
}, zt.API.viewerPreferences = function(i, e) {
  var n;
  i = i || {}, e = e || !1;
  var a, u, o, l = { HideToolbar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideMenubar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideWindowUI: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, FitWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, CenterWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, DisplayDocTitle: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.4 }, NonFullScreenPageMode: { defaultValue: "UseNone", value: "UseNone", type: "name", explicitSet: !1, valueSet: ["UseNone", "UseOutlines", "UseThumbs", "UseOC"], pdfVersion: 1.3 }, Direction: { defaultValue: "L2R", value: "L2R", type: "name", explicitSet: !1, valueSet: ["L2R", "R2L"], pdfVersion: 1.3 }, ViewArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, ViewClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintScaling: { defaultValue: "AppDefault", value: "AppDefault", type: "name", explicitSet: !1, valueSet: ["AppDefault", "None"], pdfVersion: 1.6 }, Duplex: { defaultValue: "", value: "none", type: "name", explicitSet: !1, valueSet: ["Simplex", "DuplexFlipShortEdge", "DuplexFlipLongEdge", "none"], pdfVersion: 1.7 }, PickTrayByPDFSize: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.7 }, PrintPageRange: { defaultValue: "", value: "", type: "array", explicitSet: !1, valueSet: null, pdfVersion: 1.7 }, NumCopies: { defaultValue: 1, value: 1, type: "integer", explicitSet: !1, valueSet: null, pdfVersion: 1.7 } }, h = Object.keys(l), f = [], g = 0, b = 0, N = 0;
  function S(O, I) {
    var q, _ = !1;
    for (q = 0; q < O.length; q += 1)
      O[q] === I && (_ = !0);
    return _;
  }
  if (this.internal.viewerpreferences === void 0 && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(l)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, i === "reset" || e === !0) {
    var d = h.length;
    for (N = 0; N < d; N += 1)
      n[h[N]].value = n[h[N]].defaultValue, n[h[N]].explicitSet = !1;
  }
  if (fe(i) === "object") {
    for (u in i)
      if (o = i[u], S(h, u) && o !== void 0) {
        if (n[u].type === "boolean" && typeof o == "boolean")
          n[u].value = o;
        else if (n[u].type === "name" && S(n[u].valueSet, o))
          n[u].value = o;
        else if (n[u].type === "integer" && Number.isInteger(o))
          n[u].value = o;
        else if (n[u].type === "array") {
          for (g = 0; g < o.length; g += 1)
            if (a = !0, o[g].length === 1 && typeof o[g][0] == "number")
              f.push(String(o[g] - 1));
            else if (o[g].length > 1) {
              for (b = 0; b < o[g].length; b += 1)
                typeof o[g][b] != "number" && (a = !1);
              a === !0 && f.push([o[g][0] - 1, o[g][1] - 1].join(" "));
            }
          n[u].value = "[" + f.join(" ") + "]";
        } else
          n[u].value = n[u].defaultValue;
        n[u].explicitSet = !0;
      }
  }
  return this.internal.viewerpreferences.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    var O, I = [];
    for (O in n)
      n[O].explicitSet === !0 && (n[O].type === "name" ? I.push("/" + O + " /" + n[O].value) : I.push("/" + O + " " + n[O].value));
    I.length !== 0 && this.internal.write(`/ViewerPreferences
<<
` + I.join(`
`) + `
>>`);
  }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(i) {
  var e = function() {
    var a = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', u = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), o = unescape(encodeURIComponent(a)), l = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), h = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), f = unescape(encodeURIComponent("</x:xmpmeta>")), g = o.length + l.length + h.length + u.length + f.length;
    this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + g + " >>"), this.internal.write("stream"), this.internal.write(u + o + l + h + f), this.internal.write("endstream"), this.internal.write("endobj");
  }, n = function() {
    this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
  };
  i.addMetadata = function(a, u) {
    return this.internal.__metadata__ === void 0 && (this.internal.__metadata__ = { metadata: a, namespaceuri: u || "http://jspdf.default.namespaceuri/" }, this.internal.events.subscribe("putCatalog", n), this.internal.events.subscribe("postPutResources", e)), this;
  };
}(zt.API), function(i) {
  var e = i.API, n = e.pdfEscape16 = function(o, l) {
    for (var h, f = l.metadata.Unicode.widths, g = ["", "0", "00", "000", "0000"], b = [""], N = 0, S = o.length; N < S; ++N) {
      if (h = l.metadata.characterToGlyph(o.charCodeAt(N)), l.metadata.glyIdsUsed.push(h), l.metadata.toUnicode[h] = o.charCodeAt(N), f.indexOf(h) == -1 && (f.push(h), f.push([parseInt(l.metadata.widthOfGlyph(h), 10)])), h == "0")
        return b.join("");
      h = h.toString(16), b.push(g[4 - h.length], h);
    }
    return b.join("");
  }, a = function(o) {
    var l, h, f, g, b, N, S;
    for (b = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange`, f = [], N = 0, S = (h = Object.keys(o).sort(function(d, O) {
      return d - O;
    })).length; N < S; N++)
      l = h[N], f.length >= 100 && (b += `
` + f.length + ` beginbfchar
` + f.join(`
`) + `
endbfchar`, f = []), o[l] !== void 0 && o[l] !== null && typeof o[l].toString == "function" && (g = ("0000" + o[l].toString(16)).slice(-4), l = ("0000" + (+l).toString(16)).slice(-4), f.push("<" + l + "><" + g + ">"));
    return f.length && (b += `
` + f.length + ` beginbfchar
` + f.join(`
`) + `
endbfchar
`), b += `endcmap
CMapName currentdict /CMap defineresource pop
end
end`;
  };
  e.events.push(["putFont", function(o) {
    (function(l) {
      var h = l.font, f = l.out, g = l.newObject, b = l.putStream;
      if (h.metadata instanceof i.API.TTFFont && h.encoding === "Identity-H") {
        for (var N = h.metadata.Unicode.widths, S = h.metadata.subset.encode(h.metadata.glyIdsUsed, 1), d = "", O = 0; O < S.length; O++)
          d += String.fromCharCode(S[O]);
        var I = g();
        b({ data: d, addLength1: !0, objectId: I }), f("endobj");
        var q = g();
        b({ data: a(h.metadata.toUnicode), addLength1: !0, objectId: q }), f("endobj");
        var _ = g();
        f("<<"), f("/Type /FontDescriptor"), f("/FontName /" + Ni(h.fontName)), f("/FontFile2 " + I + " 0 R"), f("/FontBBox " + i.API.PDFObject.convert(h.metadata.bbox)), f("/Flags " + h.metadata.flags), f("/StemV " + h.metadata.stemV), f("/ItalicAngle " + h.metadata.italicAngle), f("/Ascent " + h.metadata.ascender), f("/Descent " + h.metadata.decender), f("/CapHeight " + h.metadata.capHeight), f(">>"), f("endobj");
        var M = g();
        f("<<"), f("/Type /Font"), f("/BaseFont /" + Ni(h.fontName)), f("/FontDescriptor " + _ + " 0 R"), f("/W " + i.API.PDFObject.convert(N)), f("/CIDToGIDMap /Identity"), f("/DW 1000"), f("/Subtype /CIDFontType2"), f("/CIDSystemInfo"), f("<<"), f("/Supplement 0"), f("/Registry (Adobe)"), f("/Ordering (" + h.encoding + ")"), f(">>"), f(">>"), f("endobj"), h.objectNumber = g(), f("<<"), f("/Type /Font"), f("/Subtype /Type0"), f("/ToUnicode " + q + " 0 R"), f("/BaseFont /" + Ni(h.fontName)), f("/Encoding /" + h.encoding), f("/DescendantFonts [" + M + " 0 R]"), f(">>"), f("endobj"), h.isAlreadyPutted = !0;
      }
    })(o);
  }]), e.events.push(["putFont", function(o) {
    (function(l) {
      var h = l.font, f = l.out, g = l.newObject, b = l.putStream;
      if (h.metadata instanceof i.API.TTFFont && h.encoding === "WinAnsiEncoding") {
        for (var N = h.metadata.rawData, S = "", d = 0; d < N.length; d++)
          S += String.fromCharCode(N[d]);
        var O = g();
        b({ data: S, addLength1: !0, objectId: O }), f("endobj");
        var I = g();
        b({ data: a(h.metadata.toUnicode), addLength1: !0, objectId: I }), f("endobj");
        var q = g();
        f("<<"), f("/Descent " + h.metadata.decender), f("/CapHeight " + h.metadata.capHeight), f("/StemV " + h.metadata.stemV), f("/Type /FontDescriptor"), f("/FontFile2 " + O + " 0 R"), f("/Flags 96"), f("/FontBBox " + i.API.PDFObject.convert(h.metadata.bbox)), f("/FontName /" + Ni(h.fontName)), f("/ItalicAngle " + h.metadata.italicAngle), f("/Ascent " + h.metadata.ascender), f(">>"), f("endobj"), h.objectNumber = g();
        for (var _ = 0; _ < h.metadata.hmtx.widths.length; _++)
          h.metadata.hmtx.widths[_] = parseInt(h.metadata.hmtx.widths[_] * (1e3 / h.metadata.head.unitsPerEm));
        f("<</Subtype/TrueType/Type/Font/ToUnicode " + I + " 0 R/BaseFont/" + Ni(h.fontName) + "/FontDescriptor " + q + " 0 R/Encoding/" + h.encoding + " /FirstChar 29 /LastChar 255 /Widths " + i.API.PDFObject.convert(h.metadata.hmtx.widths) + ">>"), f("endobj"), h.isAlreadyPutted = !0;
      }
    })(o);
  }]);
  var u = function(o) {
    var l, h = o.text || "", f = o.x, g = o.y, b = o.options || {}, N = o.mutex || {}, S = N.pdfEscape, d = N.activeFontKey, O = N.fonts, I = d, q = "", _ = 0, M = "", X = O[I].encoding;
    if (O[I].encoding !== "Identity-H")
      return { text: h, x: f, y: g, options: b, mutex: N };
    for (M = h, I = d, Array.isArray(h) && (M = h[0]), _ = 0; _ < M.length; _ += 1)
      O[I].metadata.hasOwnProperty("cmap") && (l = O[I].metadata.cmap.unicode.codeMap[M[_].charCodeAt(0)]), l || M[_].charCodeAt(0) < 256 && O[I].metadata.hasOwnProperty("Unicode") ? q += M[_] : q += "";
    var ot = "";
    return parseInt(I.slice(1)) < 14 || X === "WinAnsiEncoding" ? ot = S(q, I).split("").map(function(ct) {
      return ct.charCodeAt(0).toString(16);
    }).join("") : X === "Identity-H" && (ot = n(q, O[I])), N.isHex = !0, { text: ot, x: f, y: g, options: b, mutex: N };
  };
  e.events.push(["postProcessText", function(o) {
    var l = o.text || "", h = [], f = { text: l, x: o.x, y: o.y, options: o.options, mutex: o.mutex };
    if (Array.isArray(l)) {
      var g = 0;
      for (g = 0; g < l.length; g += 1)
        Array.isArray(l[g]) && l[g].length === 3 ? h.push([u(Object.assign({}, f, { text: l[g][0] })).text, l[g][1], l[g][2]]) : h.push(u(Object.assign({}, f, { text: l[g] })).text);
      o.text = h;
    } else
      o.text = u(Object.assign({}, f, { text: l })).text;
  }]);
}(zt), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(i) {
  var e = function() {
    return this.internal.vFS === void 0 && (this.internal.vFS = {}), !0;
  };
  i.existsFileInVFS = function(n) {
    return e.call(this), this.internal.vFS[n] !== void 0;
  }, i.addFileToVFS = function(n, a) {
    return e.call(this), this.internal.vFS[n] = a, this;
  }, i.getFileFromVFS = function(n) {
    return e.call(this), this.internal.vFS[n] !== void 0 ? this.internal.vFS[n] : null;
  };
}(zt.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */
function(i) {
  i.__bidiEngine__ = i.prototype.__bidiEngine__ = function(a) {
    var u, o, l, h, f, g, b, N = e, S = [[0, 3, 0, 1, 0, 0, 0], [0, 3, 0, 1, 2, 2, 0], [0, 3, 0, 17, 2, 0, 1], [0, 3, 5, 5, 4, 1, 0], [0, 3, 21, 21, 4, 0, 1], [0, 3, 5, 5, 4, 2, 0]], d = [[2, 0, 1, 1, 0, 1, 0], [2, 0, 1, 1, 0, 2, 0], [2, 0, 2, 1, 3, 2, 0], [2, 0, 2, 33, 3, 1, 1]], O = { L: 0, R: 1, EN: 2, AN: 3, N: 4, B: 5, S: 6 }, I = { 0: 0, 5: 1, 6: 2, 7: 3, 32: 4, 251: 5, 254: 6, 255: 7 }, q = ["(", ")", "(", "<", ">", "<", "[", "]", "[", "{", "}", "{", "«", "»", "«", "‹", "›", "‹", "⁅", "⁆", "⁅", "⁽", "⁾", "⁽", "₍", "₎", "₍", "≤", "≥", "≤", "〈", "〉", "〈", "﹙", "﹚", "﹙", "﹛", "﹜", "﹛", "﹝", "﹞", "﹝", "﹤", "﹥", "﹤"], _ = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), M = !1, X = 0;
    this.__bidiEngine__ = {};
    var ot = function(F) {
      var P = F.charCodeAt(), z = P >> 8, D = I[z];
      return D !== void 0 ? N[256 * D + (255 & P)] : z === 252 || z === 253 ? "AL" : _.test(z) ? "L" : z === 8 ? "R" : "N";
    }, ct = function(F) {
      for (var P, z = 0; z < F.length; z++) {
        if ((P = ot(F.charAt(z))) === "L")
          return !1;
        if (P === "R")
          return !0;
      }
      return !1;
    }, yt = function(F, P, z, D) {
      var at, nt, lt, $, ft = P[D];
      switch (ft) {
        case "L":
        case "R":
          M = !1;
          break;
        case "N":
        case "AN":
          break;
        case "EN":
          M && (ft = "AN");
          break;
        case "AL":
          M = !0, ft = "R";
          break;
        case "WS":
          ft = "N";
          break;
        case "CS":
          D < 1 || D + 1 >= P.length || (at = z[D - 1]) !== "EN" && at !== "AN" || (nt = P[D + 1]) !== "EN" && nt !== "AN" ? ft = "N" : M && (nt = "AN"), ft = nt === at ? nt : "N";
          break;
        case "ES":
          ft = (at = D > 0 ? z[D - 1] : "B") === "EN" && D + 1 < P.length && P[D + 1] === "EN" ? "EN" : "N";
          break;
        case "ET":
          if (D > 0 && z[D - 1] === "EN") {
            ft = "EN";
            break;
          }
          if (M) {
            ft = "N";
            break;
          }
          for (lt = D + 1, $ = P.length; lt < $ && P[lt] === "ET"; )
            lt++;
          ft = lt < $ && P[lt] === "EN" ? "EN" : "N";
          break;
        case "NSM":
          if (l && !h) {
            for ($ = P.length, lt = D + 1; lt < $ && P[lt] === "NSM"; )
              lt++;
            if (lt < $) {
              var ht = F[D], kt = ht >= 1425 && ht <= 2303 || ht === 64286;
              if (at = P[lt], kt && (at === "R" || at === "AL")) {
                ft = "R";
                break;
              }
            }
          }
          ft = D < 1 || (at = P[D - 1]) === "B" ? "N" : z[D - 1];
          break;
        case "B":
          M = !1, u = !0, ft = X;
          break;
        case "S":
          o = !0, ft = "N";
          break;
        case "LRE":
        case "RLE":
        case "LRO":
        case "RLO":
        case "PDF":
          M = !1;
          break;
        case "BN":
          ft = "N";
      }
      return ft;
    }, tt = function(F, P, z) {
      var D = F.split("");
      return z && R(D, z, { hiLevel: X }), D.reverse(), P && P.reverse(), D.join("");
    }, R = function(F, P, z) {
      var D, at, nt, lt, $, ft = -1, ht = F.length, kt = 0, A = [], j = X ? d : S, B = [];
      for (M = !1, u = !1, o = !1, at = 0; at < ht; at++)
        B[at] = ot(F[at]);
      for (nt = 0; nt < ht; nt++) {
        if ($ = kt, A[nt] = yt(F, B, A, nt), D = 240 & (kt = j[$][O[A[nt]]]), kt &= 15, P[nt] = lt = j[kt][5], D > 0)
          if (D === 16) {
            for (at = ft; at < nt; at++)
              P[at] = 1;
            ft = -1;
          } else
            ft = -1;
        if (j[kt][6])
          ft === -1 && (ft = nt);
        else if (ft > -1) {
          for (at = ft; at < nt; at++)
            P[at] = lt;
          ft = -1;
        }
        B[nt] === "B" && (P[nt] = 0), z.hiLevel |= lt;
      }
      o && function(W, Y, Q) {
        for (var et = 0; et < Q; et++)
          if (W[et] === "S") {
            Y[et] = X;
            for (var rt = et - 1; rt >= 0 && W[rt] === "WS"; rt--)
              Y[rt] = X;
          }
      }(B, P, ht);
    }, gt = function(F, P, z, D, at) {
      if (!(at.hiLevel < F)) {
        if (F === 1 && X === 1 && !u)
          return P.reverse(), void (z && z.reverse());
        for (var nt, lt, $, ft, ht = P.length, kt = 0; kt < ht; ) {
          if (D[kt] >= F) {
            for ($ = kt + 1; $ < ht && D[$] >= F; )
              $++;
            for (ft = kt, lt = $ - 1; ft < lt; ft++, lt--)
              nt = P[ft], P[ft] = P[lt], P[lt] = nt, z && (nt = z[ft], z[ft] = z[lt], z[lt] = nt);
            kt = $;
          }
          kt++;
        }
      }
    }, pt = function(F, P, z) {
      var D = F.split(""), at = { hiLevel: X };
      return z || (z = []), R(D, z, at), function(nt, lt, $) {
        if ($.hiLevel !== 0 && b)
          for (var ft, ht = 0; ht < nt.length; ht++)
            lt[ht] === 1 && (ft = q.indexOf(nt[ht])) >= 0 && (nt[ht] = q[ft + 1]);
      }(D, z, at), gt(2, D, P, z, at), gt(1, D, P, z, at), D.join("");
    };
    return this.__bidiEngine__.doBidiReorder = function(F, P, z) {
      if (function(at, nt) {
        if (nt)
          for (var lt = 0; lt < at.length; lt++)
            nt[lt] = lt;
        h === void 0 && (h = ct(at)), g === void 0 && (g = ct(at));
      }(F, P), l || !f || g)
        if (l && f && h ^ g)
          X = h ? 1 : 0, F = tt(F, P, z);
        else if (!l && f && g)
          X = h ? 1 : 0, F = pt(F, P, z), F = tt(F, P);
        else if (!l || h || f || g) {
          if (l && !f && h ^ g)
            F = tt(F, P), h ? (X = 0, F = pt(F, P, z)) : (X = 1, F = pt(F, P, z), F = tt(F, P));
          else if (l && h && !f && g)
            X = 1, F = pt(F, P, z), F = tt(F, P);
          else if (!l && !f && h ^ g) {
            var D = b;
            h ? (X = 1, F = pt(F, P, z), X = 0, b = !1, F = pt(F, P, z), b = D) : (X = 0, F = pt(F, P, z), F = tt(F, P), X = 1, b = !1, F = pt(F, P, z), b = D, F = tt(F, P));
          }
        } else
          X = 0, F = pt(F, P, z);
      else
        X = h ? 1 : 0, F = pt(F, P, z);
      return F;
    }, this.__bidiEngine__.setOptions = function(F) {
      F && (l = F.isInputVisual, f = F.isOutputVisual, h = F.isInputRtl, g = F.isOutputRtl, b = F.isSymmetricSwapping);
    }, this.__bidiEngine__.setOptions(a), this.__bidiEngine__;
  };
  var e = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "N", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "L", "N", "N", "BN", "N", "N", "ET", "ET", "EN", "EN", "N", "L", "N", "N", "N", "EN", "L", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "N", "N", "N", "N", "N", "ET", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "NSM", "R", "NSM", "NSM", "R", "NSM", "NSM", "R", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AN", "AN", "AN", "AN", "AN", "AN", "N", "N", "AL", "ET", "ET", "AL", "CS", "AL", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "N", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "R", "N", "N", "N", "N", "R", "N", "N", "N", "N", "N", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "BN", "BN", "BN", "L", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "B", "LRE", "RLE", "PDF", "LRO", "RLO", "CS", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "BN", "BN", "BN", "BN", "BN", "N", "LRI", "RLI", "FSI", "PDI", "BN", "BN", "BN", "BN", "BN", "BN", "EN", "L", "N", "N", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "L", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "R", "NSM", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "ES", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "R", "R", "R", "R", "R", "N", "R", "N", "R", "R", "N", "R", "R", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "CS", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "ET", "N", "N", "ES", "ES", "N", "N", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "BN", "N", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "N", "N", "N", "ET", "ET", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N"], n = new i.__bidiEngine__({ isInputVisual: !0 });
  i.API.events.push(["postProcessText", function(a) {
    var u = a.text, o = (a.x, a.y, a.options || {}), l = (a.mutex, o.lang, []);
    if (o.isInputVisual = typeof o.isInputVisual != "boolean" || o.isInputVisual, n.setOptions(o), Object.prototype.toString.call(u) === "[object Array]") {
      var h = 0;
      for (l = [], h = 0; h < u.length; h += 1)
        Object.prototype.toString.call(u[h]) === "[object Array]" ? l.push([n.doBidiReorder(u[h][0]), u[h][1], u[h][2]]) : l.push([n.doBidiReorder(u[h])]);
      a.text = l;
    } else
      a.text = n.doBidiReorder(u);
    n.setOptions({ isInputVisual: !0 });
  }]);
}(zt), zt.API.TTFFont = function() {
  function i(e) {
    var n;
    if (this.rawData = e, n = this.contents = new Cr(e), this.contents.pos = 4, n.readString(4) === "ttcf")
      throw new Error("TTCF not supported.");
    n.pos = 0, this.parse(), this.subset = new yl(this), this.registerTTF();
  }
  return i.open = function(e) {
    return new i(e);
  }, i.prototype.parse = function() {
    return this.directory = new al(this.contents), this.head = new sl(this), this.name = new fl(this), this.cmap = new Du(this), this.toUnicode = {}, this.hhea = new ul(this), this.maxp = new pl(this), this.hmtx = new dl(this), this.post = new ll(this), this.os2 = new cl(this), this.loca = new bl(this), this.glyf = new gl(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax];
  }, i.prototype.registerTTF = function() {
    var e, n, a, u, o;
    if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
      var l, h, f, g;
      for (g = [], l = 0, h = (f = this.bbox).length; l < h; l++)
        e = f[l], g.push(Math.round(e * this.scaleFactor));
      return g;
    }).call(this), this.stemV = 0, this.post.exists ? (a = 255 & (u = this.post.italic_angle), 32768 & (n = u >> 16) && (n = -(1 + (65535 ^ n))), this.italicAngle = +(n + "." + a)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = (o = this.familyClass) === 1 || o === 2 || o === 3 || o === 4 || o === 5 || o === 7, this.isScript = this.familyClass === 10, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), this.italicAngle !== 0 && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode)
      throw new Error("No unicode cmap for font");
  }, i.prototype.characterToGlyph = function(e) {
    var n;
    return ((n = this.cmap.unicode) != null ? n.codeMap[e] : void 0) || 0;
  }, i.prototype.widthOfGlyph = function(e) {
    var n;
    return n = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(e).advance * n;
  }, i.prototype.widthOfString = function(e, n, a) {
    var u, o, l, h;
    for (l = 0, o = 0, h = (e = "" + e).length; 0 <= h ? o < h : o > h; o = 0 <= h ? ++o : --o)
      u = e.charCodeAt(o), l += this.widthOfGlyph(this.characterToGlyph(u)) + a * (1e3 / n) || 0;
    return l * (n / 1e3);
  }, i.prototype.lineHeight = function(e, n) {
    var a;
    return n == null && (n = !1), a = n ? this.lineGap : 0, (this.ascender + a - this.decender) / 1e3 * e;
  }, i;
}();
var Dn, Cr = function() {
  function i(e) {
    this.data = e ?? [], this.pos = 0, this.length = this.data.length;
  }
  return i.prototype.readByte = function() {
    return this.data[this.pos++];
  }, i.prototype.writeByte = function(e) {
    return this.data[this.pos++] = e;
  }, i.prototype.readUInt32 = function() {
    return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
  }, i.prototype.writeUInt32 = function(e) {
    return this.writeByte(e >>> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e);
  }, i.prototype.readInt32 = function() {
    var e;
    return (e = this.readUInt32()) >= 2147483648 ? e - 4294967296 : e;
  }, i.prototype.writeInt32 = function(e) {
    return e < 0 && (e += 4294967296), this.writeUInt32(e);
  }, i.prototype.readUInt16 = function() {
    return this.readByte() << 8 | this.readByte();
  }, i.prototype.writeUInt16 = function(e) {
    return this.writeByte(e >> 8 & 255), this.writeByte(255 & e);
  }, i.prototype.readInt16 = function() {
    var e;
    return (e = this.readUInt16()) >= 32768 ? e - 65536 : e;
  }, i.prototype.writeInt16 = function(e) {
    return e < 0 && (e += 65536), this.writeUInt16(e);
  }, i.prototype.readString = function(e) {
    var n, a;
    for (a = [], n = 0; 0 <= e ? n < e : n > e; n = 0 <= e ? ++n : --n)
      a[n] = String.fromCharCode(this.readByte());
    return a.join("");
  }, i.prototype.writeString = function(e) {
    var n, a, u;
    for (u = [], n = 0, a = e.length; 0 <= a ? n < a : n > a; n = 0 <= a ? ++n : --n)
      u.push(this.writeByte(e.charCodeAt(n)));
    return u;
  }, i.prototype.readShort = function() {
    return this.readInt16();
  }, i.prototype.writeShort = function(e) {
    return this.writeInt16(e);
  }, i.prototype.readLongLong = function() {
    var e, n, a, u, o, l, h, f;
    return e = this.readByte(), n = this.readByte(), a = this.readByte(), u = this.readByte(), o = this.readByte(), l = this.readByte(), h = this.readByte(), f = this.readByte(), 128 & e ? -1 * (72057594037927940 * (255 ^ e) + 281474976710656 * (255 ^ n) + 1099511627776 * (255 ^ a) + 4294967296 * (255 ^ u) + 16777216 * (255 ^ o) + 65536 * (255 ^ l) + 256 * (255 ^ h) + (255 ^ f) + 1) : 72057594037927940 * e + 281474976710656 * n + 1099511627776 * a + 4294967296 * u + 16777216 * o + 65536 * l + 256 * h + f;
  }, i.prototype.writeLongLong = function(e) {
    var n, a;
    return n = Math.floor(e / 4294967296), a = 4294967295 & e, this.writeByte(n >> 24 & 255), this.writeByte(n >> 16 & 255), this.writeByte(n >> 8 & 255), this.writeByte(255 & n), this.writeByte(a >> 24 & 255), this.writeByte(a >> 16 & 255), this.writeByte(a >> 8 & 255), this.writeByte(255 & a);
  }, i.prototype.readInt = function() {
    return this.readInt32();
  }, i.prototype.writeInt = function(e) {
    return this.writeInt32(e);
  }, i.prototype.read = function(e) {
    var n, a;
    for (n = [], a = 0; 0 <= e ? a < e : a > e; a = 0 <= e ? ++a : --a)
      n.push(this.readByte());
    return n;
  }, i.prototype.write = function(e) {
    var n, a, u, o;
    for (o = [], a = 0, u = e.length; a < u; a++)
      n = e[a], o.push(this.writeByte(n));
    return o;
  }, i;
}(), al = function() {
  var i;
  function e(n) {
    var a, u, o;
    for (this.scalarType = n.readInt(), this.tableCount = n.readShort(), this.searchRange = n.readShort(), this.entrySelector = n.readShort(), this.rangeShift = n.readShort(), this.tables = {}, u = 0, o = this.tableCount; 0 <= o ? u < o : u > o; u = 0 <= o ? ++u : --u)
      a = { tag: n.readString(4), checksum: n.readInt(), offset: n.readInt(), length: n.readInt() }, this.tables[a.tag] = a;
  }
  return e.prototype.encode = function(n) {
    var a, u, o, l, h, f, g, b, N, S, d, O, I;
    for (I in d = Object.keys(n).length, f = Math.log(2), N = 16 * Math.floor(Math.log(d) / f), l = Math.floor(N / f), b = 16 * d - N, (u = new Cr()).writeInt(this.scalarType), u.writeShort(d), u.writeShort(N), u.writeShort(l), u.writeShort(b), o = 16 * d, g = u.pos + o, h = null, O = [], n)
      for (S = n[I], u.writeString(I), u.writeInt(i(S)), u.writeInt(g), u.writeInt(S.length), O = O.concat(S), I === "head" && (h = g), g += S.length; g % 4; )
        O.push(0), g++;
    return u.write(O), a = 2981146554 - i(u.data), u.pos = h + 8, u.writeUInt32(a), u.data;
  }, i = function(n) {
    var a, u, o, l;
    for (n = Ru.call(n); n.length % 4; )
      n.push(0);
    for (o = new Cr(n), u = 0, a = 0, l = n.length; a < l; a = a += 4)
      u += o.readUInt32();
    return 4294967295 & u;
  }, e;
}(), ol = {}.hasOwnProperty, Zn = function(i, e) {
  for (var n in e)
    ol.call(e, n) && (i[n] = e[n]);
  function a() {
    this.constructor = i;
  }
  return a.prototype = e.prototype, i.prototype = new a(), i.__super__ = e.prototype, i;
};
Dn = function() {
  function i(e) {
    var n;
    this.file = e, n = this.file.directory.tables[this.tag], this.exists = !!n, n && (this.offset = n.offset, this.length = n.length, this.parse(this.file.contents));
  }
  return i.prototype.parse = function() {
  }, i.prototype.encode = function() {
  }, i.prototype.raw = function() {
    return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
  }, i;
}();
var sl = function(i) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Zn(e, Dn), e.prototype.tag = "head", e.prototype.parse = function(n) {
    return n.pos = this.offset, this.version = n.readInt(), this.revision = n.readInt(), this.checkSumAdjustment = n.readInt(), this.magicNumber = n.readInt(), this.flags = n.readShort(), this.unitsPerEm = n.readShort(), this.created = n.readLongLong(), this.modified = n.readLongLong(), this.xMin = n.readShort(), this.yMin = n.readShort(), this.xMax = n.readShort(), this.yMax = n.readShort(), this.macStyle = n.readShort(), this.lowestRecPPEM = n.readShort(), this.fontDirectionHint = n.readShort(), this.indexToLocFormat = n.readShort(), this.glyphDataFormat = n.readShort();
  }, e.prototype.encode = function(n) {
    var a;
    return (a = new Cr()).writeInt(this.version), a.writeInt(this.revision), a.writeInt(this.checkSumAdjustment), a.writeInt(this.magicNumber), a.writeShort(this.flags), a.writeShort(this.unitsPerEm), a.writeLongLong(this.created), a.writeLongLong(this.modified), a.writeShort(this.xMin), a.writeShort(this.yMin), a.writeShort(this.xMax), a.writeShort(this.yMax), a.writeShort(this.macStyle), a.writeShort(this.lowestRecPPEM), a.writeShort(this.fontDirectionHint), a.writeShort(n), a.writeShort(this.glyphDataFormat), a.data;
  }, e;
}(), Lu = function() {
  function i(e, n) {
    var a, u, o, l, h, f, g, b, N, S, d, O, I, q, _, M, X;
    switch (this.platformID = e.readUInt16(), this.encodingID = e.readShort(), this.offset = n + e.readInt(), N = e.pos, e.pos = this.offset, this.format = e.readUInt16(), this.length = e.readUInt16(), this.language = e.readUInt16(), this.isUnicode = this.platformID === 3 && this.encodingID === 1 && this.format === 4 || this.platformID === 0 && this.format === 4, this.codeMap = {}, this.format) {
      case 0:
        for (f = 0; f < 256; ++f)
          this.codeMap[f] = e.readByte();
        break;
      case 4:
        for (d = e.readUInt16(), S = d / 2, e.pos += 6, o = function() {
          var ot, ct;
          for (ct = [], f = ot = 0; 0 <= S ? ot < S : ot > S; f = 0 <= S ? ++ot : --ot)
            ct.push(e.readUInt16());
          return ct;
        }(), e.pos += 2, I = function() {
          var ot, ct;
          for (ct = [], f = ot = 0; 0 <= S ? ot < S : ot > S; f = 0 <= S ? ++ot : --ot)
            ct.push(e.readUInt16());
          return ct;
        }(), g = function() {
          var ot, ct;
          for (ct = [], f = ot = 0; 0 <= S ? ot < S : ot > S; f = 0 <= S ? ++ot : --ot)
            ct.push(e.readUInt16());
          return ct;
        }(), b = function() {
          var ot, ct;
          for (ct = [], f = ot = 0; 0 <= S ? ot < S : ot > S; f = 0 <= S ? ++ot : --ot)
            ct.push(e.readUInt16());
          return ct;
        }(), u = (this.length - e.pos + this.offset) / 2, h = function() {
          var ot, ct;
          for (ct = [], f = ot = 0; 0 <= u ? ot < u : ot > u; f = 0 <= u ? ++ot : --ot)
            ct.push(e.readUInt16());
          return ct;
        }(), f = _ = 0, X = o.length; _ < X; f = ++_)
          for (q = o[f], a = M = O = I[f]; O <= q ? M <= q : M >= q; a = O <= q ? ++M : --M)
            b[f] === 0 ? l = a + g[f] : (l = h[b[f] / 2 + (a - O) - (S - f)] || 0) !== 0 && (l += g[f]), this.codeMap[a] = 65535 & l;
    }
    e.pos = N;
  }
  return i.encode = function(e, n) {
    var a, u, o, l, h, f, g, b, N, S, d, O, I, q, _, M, X, ot, ct, yt, tt, R, gt, pt, F, P, z, D, at, nt, lt, $, ft, ht, kt, A, j, B, W, Y, Q, et, rt, Nt, Lt, Ct;
    switch (D = new Cr(), l = Object.keys(e).sort(function(Mt, Ut) {
      return Mt - Ut;
    }), n) {
      case "macroman":
        for (I = 0, q = function() {
          var Mt = [];
          for (O = 0; O < 256; ++O)
            Mt.push(0);
          return Mt;
        }(), M = { 0: 0 }, o = {}, at = 0, ft = l.length; at < ft; at++)
          M[rt = e[u = l[at]]] == null && (M[rt] = ++I), o[u] = { old: e[u], new: M[e[u]] }, q[u] = M[e[u]];
        return D.writeUInt16(1), D.writeUInt16(0), D.writeUInt32(12), D.writeUInt16(0), D.writeUInt16(262), D.writeUInt16(0), D.write(q), { charMap: o, subtable: D.data, maxGlyphID: I + 1 };
      case "unicode":
        for (P = [], N = [], X = 0, M = {}, a = {}, _ = g = null, nt = 0, ht = l.length; nt < ht; nt++)
          M[ct = e[u = l[nt]]] == null && (M[ct] = ++X), a[u] = { old: ct, new: M[ct] }, h = M[ct] - u, _ != null && h === g || (_ && N.push(_), P.push(u), g = h), _ = u;
        for (_ && N.push(_), N.push(65535), P.push(65535), pt = 2 * (gt = P.length), R = 2 * Math.pow(Math.log(gt) / Math.LN2, 2), S = Math.log(R / 2) / Math.LN2, tt = 2 * gt - R, f = [], yt = [], d = [], O = lt = 0, kt = P.length; lt < kt; O = ++lt) {
          if (F = P[O], b = N[O], F === 65535) {
            f.push(0), yt.push(0);
            break;
          }
          if (F - (z = a[F].new) >= 32768)
            for (f.push(0), yt.push(2 * (d.length + gt - O)), u = $ = F; F <= b ? $ <= b : $ >= b; u = F <= b ? ++$ : --$)
              d.push(a[u].new);
          else
            f.push(z - F), yt.push(0);
        }
        for (D.writeUInt16(3), D.writeUInt16(1), D.writeUInt32(12), D.writeUInt16(4), D.writeUInt16(16 + 8 * gt + 2 * d.length), D.writeUInt16(0), D.writeUInt16(pt), D.writeUInt16(R), D.writeUInt16(S), D.writeUInt16(tt), Q = 0, A = N.length; Q < A; Q++)
          u = N[Q], D.writeUInt16(u);
        for (D.writeUInt16(0), et = 0, j = P.length; et < j; et++)
          u = P[et], D.writeUInt16(u);
        for (Nt = 0, B = f.length; Nt < B; Nt++)
          h = f[Nt], D.writeUInt16(h);
        for (Lt = 0, W = yt.length; Lt < W; Lt++)
          ot = yt[Lt], D.writeUInt16(ot);
        for (Ct = 0, Y = d.length; Ct < Y; Ct++)
          I = d[Ct], D.writeUInt16(I);
        return { charMap: a, subtable: D.data, maxGlyphID: X + 1 };
    }
  }, i;
}(), Du = function(i) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Zn(e, Dn), e.prototype.tag = "cmap", e.prototype.parse = function(n) {
    var a, u, o;
    for (n.pos = this.offset, this.version = n.readUInt16(), o = n.readUInt16(), this.tables = [], this.unicode = null, u = 0; 0 <= o ? u < o : u > o; u = 0 <= o ? ++u : --u)
      a = new Lu(n, this.offset), this.tables.push(a), a.isUnicode && this.unicode == null && (this.unicode = a);
    return !0;
  }, e.encode = function(n, a) {
    var u, o;
    return a == null && (a = "macroman"), u = Lu.encode(n, a), (o = new Cr()).writeUInt16(0), o.writeUInt16(1), u.table = o.data.concat(u.subtable), u;
  }, e;
}(), ul = function(i) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Zn(e, Dn), e.prototype.tag = "hhea", e.prototype.parse = function(n) {
    return n.pos = this.offset, this.version = n.readInt(), this.ascender = n.readShort(), this.decender = n.readShort(), this.lineGap = n.readShort(), this.advanceWidthMax = n.readShort(), this.minLeftSideBearing = n.readShort(), this.minRightSideBearing = n.readShort(), this.xMaxExtent = n.readShort(), this.caretSlopeRise = n.readShort(), this.caretSlopeRun = n.readShort(), this.caretOffset = n.readShort(), n.pos += 8, this.metricDataFormat = n.readShort(), this.numberOfMetrics = n.readUInt16();
  }, e;
}(), cl = function(i) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Zn(e, Dn), e.prototype.tag = "OS/2", e.prototype.parse = function(n) {
    if (n.pos = this.offset, this.version = n.readUInt16(), this.averageCharWidth = n.readShort(), this.weightClass = n.readUInt16(), this.widthClass = n.readUInt16(), this.type = n.readShort(), this.ySubscriptXSize = n.readShort(), this.ySubscriptYSize = n.readShort(), this.ySubscriptXOffset = n.readShort(), this.ySubscriptYOffset = n.readShort(), this.ySuperscriptXSize = n.readShort(), this.ySuperscriptYSize = n.readShort(), this.ySuperscriptXOffset = n.readShort(), this.ySuperscriptYOffset = n.readShort(), this.yStrikeoutSize = n.readShort(), this.yStrikeoutPosition = n.readShort(), this.familyClass = n.readShort(), this.panose = function() {
      var a, u;
      for (u = [], a = 0; a < 10; ++a)
        u.push(n.readByte());
      return u;
    }(), this.charRange = function() {
      var a, u;
      for (u = [], a = 0; a < 4; ++a)
        u.push(n.readInt());
      return u;
    }(), this.vendorID = n.readString(4), this.selection = n.readShort(), this.firstCharIndex = n.readShort(), this.lastCharIndex = n.readShort(), this.version > 0 && (this.ascent = n.readShort(), this.descent = n.readShort(), this.lineGap = n.readShort(), this.winAscent = n.readShort(), this.winDescent = n.readShort(), this.codePageRange = function() {
      var a, u;
      for (u = [], a = 0; a < 2; a = ++a)
        u.push(n.readInt());
      return u;
    }(), this.version > 1))
      return this.xHeight = n.readShort(), this.capHeight = n.readShort(), this.defaultChar = n.readShort(), this.breakChar = n.readShort(), this.maxContext = n.readShort();
  }, e;
}(), ll = function(i) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Zn(e, Dn), e.prototype.tag = "post", e.prototype.parse = function(n) {
    var a, u, o;
    switch (n.pos = this.offset, this.format = n.readInt(), this.italicAngle = n.readInt(), this.underlinePosition = n.readShort(), this.underlineThickness = n.readShort(), this.isFixedPitch = n.readInt(), this.minMemType42 = n.readInt(), this.maxMemType42 = n.readInt(), this.minMemType1 = n.readInt(), this.maxMemType1 = n.readInt(), this.format) {
      case 65536:
        break;
      case 131072:
        var l;
        for (u = n.readUInt16(), this.glyphNameIndex = [], l = 0; 0 <= u ? l < u : l > u; l = 0 <= u ? ++l : --l)
          this.glyphNameIndex.push(n.readUInt16());
        for (this.names = [], o = []; n.pos < this.offset + this.length; )
          a = n.readByte(), o.push(this.names.push(n.readString(a)));
        return o;
      case 151552:
        return u = n.readUInt16(), this.offsets = n.read(u);
      case 196608:
        break;
      case 262144:
        return this.map = (function() {
          var h, f, g;
          for (g = [], l = h = 0, f = this.file.maxp.numGlyphs; 0 <= f ? h < f : h > f; l = 0 <= f ? ++h : --h)
            g.push(n.readUInt32());
          return g;
        }).call(this);
    }
  }, e;
}(), hl = function(i, e) {
  this.raw = i, this.length = i.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
}, fl = function(i) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Zn(e, Dn), e.prototype.tag = "name", e.prototype.parse = function(n) {
    var a, u, o, l, h, f, g, b, N, S, d;
    for (n.pos = this.offset, n.readShort(), a = n.readShort(), f = n.readShort(), u = [], l = 0; 0 <= a ? l < a : l > a; l = 0 <= a ? ++l : --l)
      u.push({ platformID: n.readShort(), encodingID: n.readShort(), languageID: n.readShort(), nameID: n.readShort(), length: n.readShort(), offset: this.offset + f + n.readShort() });
    for (g = {}, l = N = 0, S = u.length; N < S; l = ++N)
      o = u[l], n.pos = o.offset, b = n.readString(o.length), h = new hl(b, o), g[d = o.nameID] == null && (g[d] = []), g[o.nameID].push(h);
    this.strings = g, this.copyright = g[0], this.fontFamily = g[1], this.fontSubfamily = g[2], this.uniqueSubfamily = g[3], this.fontName = g[4], this.version = g[5];
    try {
      this.postscriptName = g[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    } catch {
      this.postscriptName = g[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    }
    return this.trademark = g[7], this.manufacturer = g[8], this.designer = g[9], this.description = g[10], this.vendorUrl = g[11], this.designerUrl = g[12], this.license = g[13], this.licenseUrl = g[14], this.preferredFamily = g[15], this.preferredSubfamily = g[17], this.compatibleFull = g[18], this.sampleText = g[19];
  }, e;
}(), pl = function(i) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Zn(e, Dn), e.prototype.tag = "maxp", e.prototype.parse = function(n) {
    return n.pos = this.offset, this.version = n.readInt(), this.numGlyphs = n.readUInt16(), this.maxPoints = n.readUInt16(), this.maxContours = n.readUInt16(), this.maxCompositePoints = n.readUInt16(), this.maxComponentContours = n.readUInt16(), this.maxZones = n.readUInt16(), this.maxTwilightPoints = n.readUInt16(), this.maxStorage = n.readUInt16(), this.maxFunctionDefs = n.readUInt16(), this.maxInstructionDefs = n.readUInt16(), this.maxStackElements = n.readUInt16(), this.maxSizeOfInstructions = n.readUInt16(), this.maxComponentElements = n.readUInt16(), this.maxComponentDepth = n.readUInt16();
  }, e;
}(), dl = function(i) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Zn(e, Dn), e.prototype.tag = "hmtx", e.prototype.parse = function(n) {
    var a, u, o, l, h, f, g;
    for (n.pos = this.offset, this.metrics = [], a = 0, f = this.file.hhea.numberOfMetrics; 0 <= f ? a < f : a > f; a = 0 <= f ? ++a : --a)
      this.metrics.push({ advance: n.readUInt16(), lsb: n.readInt16() });
    for (o = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
      var b, N;
      for (N = [], a = b = 0; 0 <= o ? b < o : b > o; a = 0 <= o ? ++b : --b)
        N.push(n.readInt16());
      return N;
    }(), this.widths = (function() {
      var b, N, S, d;
      for (d = [], b = 0, N = (S = this.metrics).length; b < N; b++)
        l = S[b], d.push(l.advance);
      return d;
    }).call(this), u = this.widths[this.widths.length - 1], g = [], a = h = 0; 0 <= o ? h < o : h > o; a = 0 <= o ? ++h : --h)
      g.push(this.widths.push(u));
    return g;
  }, e.prototype.forGlyph = function(n) {
    return n in this.metrics ? this.metrics[n] : { advance: this.metrics[this.metrics.length - 1].advance, lsb: this.leftSideBearings[n - this.metrics.length] };
  }, e;
}(), Ru = [].slice, gl = function(i) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Zn(e, Dn), e.prototype.tag = "glyf", e.prototype.parse = function() {
    return this.cache = {};
  }, e.prototype.glyphFor = function(n) {
    var a, u, o, l, h, f, g, b, N, S;
    return n in this.cache ? this.cache[n] : (l = this.file.loca, a = this.file.contents, u = l.indexOf(n), (o = l.lengthOf(n)) === 0 ? this.cache[n] = null : (a.pos = this.offset + u, h = (f = new Cr(a.read(o))).readShort(), b = f.readShort(), S = f.readShort(), g = f.readShort(), N = f.readShort(), this.cache[n] = h === -1 ? new vl(f, b, S, g, N) : new ml(f, h, b, S, g, N), this.cache[n]));
  }, e.prototype.encode = function(n, a, u) {
    var o, l, h, f, g;
    for (h = [], l = [], f = 0, g = a.length; f < g; f++)
      o = n[a[f]], l.push(h.length), o && (h = h.concat(o.encode(u)));
    return l.push(h.length), { table: h, offsets: l };
  }, e;
}(), ml = function() {
  function i(e, n, a, u, o, l) {
    this.raw = e, this.numberOfContours = n, this.xMin = a, this.yMin = u, this.xMax = o, this.yMax = l, this.compound = !1;
  }
  return i.prototype.encode = function() {
    return this.raw.data;
  }, i;
}(), vl = function() {
  function i(e, n, a, u, o) {
    var l, h;
    for (this.raw = e, this.xMin = n, this.yMin = a, this.xMax = u, this.yMax = o, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], l = this.raw; h = l.readShort(), this.glyphOffsets.push(l.pos), this.glyphIDs.push(l.readUInt16()), 32 & h; )
      l.pos += 1 & h ? 4 : 2, 128 & h ? l.pos += 8 : 64 & h ? l.pos += 4 : 8 & h && (l.pos += 2);
  }
  return i.prototype.encode = function() {
    var e, n, a;
    for (n = new Cr(Ru.call(this.raw.data)), e = 0, a = this.glyphIDs.length; e < a; ++e)
      n.pos = this.glyphOffsets[e];
    return n.data;
  }, i;
}(), bl = function(i) {
  function e() {
    return e.__super__.constructor.apply(this, arguments);
  }
  return Zn(e, Dn), e.prototype.tag = "loca", e.prototype.parse = function(n) {
    var a, u;
    return n.pos = this.offset, a = this.file.head.indexToLocFormat, this.offsets = a === 0 ? (function() {
      var o, l;
      for (l = [], u = 0, o = this.length; u < o; u += 2)
        l.push(2 * n.readUInt16());
      return l;
    }).call(this) : (function() {
      var o, l;
      for (l = [], u = 0, o = this.length; u < o; u += 4)
        l.push(n.readUInt32());
      return l;
    }).call(this);
  }, e.prototype.indexOf = function(n) {
    return this.offsets[n];
  }, e.prototype.lengthOf = function(n) {
    return this.offsets[n + 1] - this.offsets[n];
  }, e.prototype.encode = function(n, a) {
    for (var u = new Uint32Array(this.offsets.length), o = 0, l = 0, h = 0; h < u.length; ++h)
      if (u[h] = o, l < a.length && a[l] == h) {
        ++l, u[h] = o;
        var f = this.offsets[h], g = this.offsets[h + 1] - f;
        g > 0 && (o += g);
      }
    for (var b = new Array(4 * u.length), N = 0; N < u.length; ++N)
      b[4 * N + 3] = 255 & u[N], b[4 * N + 2] = (65280 & u[N]) >> 8, b[4 * N + 1] = (16711680 & u[N]) >> 16, b[4 * N] = (4278190080 & u[N]) >> 24;
    return b;
  }, e;
}(), yl = function() {
  function i(e) {
    this.font = e, this.subset = {}, this.unicodes = {}, this.next = 33;
  }
  return i.prototype.generateCmap = function() {
    var e, n, a, u, o;
    for (n in u = this.font.cmap.tables[0].codeMap, e = {}, o = this.subset)
      a = o[n], e[n] = u[a];
    return e;
  }, i.prototype.glyphsFor = function(e) {
    var n, a, u, o, l, h, f;
    for (u = {}, l = 0, h = e.length; l < h; l++)
      u[o = e[l]] = this.font.glyf.glyphFor(o);
    for (o in n = [], u)
      (a = u[o]) != null && a.compound && n.push.apply(n, a.glyphIDs);
    if (n.length > 0)
      for (o in f = this.glyphsFor(n))
        a = f[o], u[o] = a;
    return u;
  }, i.prototype.encode = function(e, n) {
    var a, u, o, l, h, f, g, b, N, S, d, O, I, q, _;
    for (u in a = Du.encode(this.generateCmap(), "unicode"), l = this.glyphsFor(e), d = { 0: 0 }, _ = a.charMap)
      d[(f = _[u]).old] = f.new;
    for (O in S = a.maxGlyphID, l)
      O in d || (d[O] = S++);
    return b = function(M) {
      var X, ot;
      for (X in ot = {}, M)
        ot[M[X]] = X;
      return ot;
    }(d), N = Object.keys(b).sort(function(M, X) {
      return M - X;
    }), I = function() {
      var M, X, ot;
      for (ot = [], M = 0, X = N.length; M < X; M++)
        h = N[M], ot.push(b[h]);
      return ot;
    }(), o = this.font.glyf.encode(l, I, d), g = this.font.loca.encode(o.offsets, I), q = { cmap: this.font.cmap.raw(), glyf: o.table, loca: g, hmtx: this.font.hmtx.raw(), hhea: this.font.hhea.raw(), maxp: this.font.maxp.raw(), post: this.font.post.raw(), name: this.font.name.raw(), head: this.font.head.encode(n) }, this.font.os2.exists && (q["OS/2"] = this.font.os2.raw()), this.font.directory.encode(q);
  }, i;
}();
zt.API.PDFObject = function() {
  var i;
  function e() {
  }
  return i = function(n, a) {
    return (Array(a + 1).join("0") + n).slice(-a);
  }, e.convert = function(n) {
    var a, u, o, l;
    if (Array.isArray(n))
      return "[" + function() {
        var h, f, g;
        for (g = [], h = 0, f = n.length; h < f; h++)
          a = n[h], g.push(e.convert(a));
        return g;
      }().join(" ") + "]";
    if (typeof n == "string")
      return "/" + n;
    if (n != null && n.isString)
      return "(" + n + ")";
    if (n instanceof Date)
      return "(D:" + i(n.getUTCFullYear(), 4) + i(n.getUTCMonth(), 2) + i(n.getUTCDate(), 2) + i(n.getUTCHours(), 2) + i(n.getUTCMinutes(), 2) + i(n.getUTCSeconds(), 2) + "Z)";
    if ({}.toString.call(n) === "[object Object]") {
      for (u in o = ["<<"], n)
        l = n[u], o.push("/" + u + " " + e.convert(l));
      return o.push(">>"), o.join(`
`);
    }
    return "" + n;
  }, e;
}();
const Al = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zt
}, Symbol.toStringTag, { value: "Module" }));
export {
  fe as _,
  Al as p
};
//# sourceMappingURL=pdf-DOHeHzrp.mjs.map
